<template>
	<div id="app" :class="{ 'electricity-default': themeCode === 'default', 'electricity': themeCode === 'blue' }">
		<div id="map">
			<div class="map-view">
				<div id="allmap" style="width: 100%; height: 100%;"></div>
			</div>
			<div class="outline-header">
				<div class="outline-header-bg">
					<img v-if="themeCode === 'default'" src="../../assets/default/headerbg.png" alt="">
					<img v-else-if="themeCode === 'blue'" src="../../assets/electricity/headerbg.png" alt="">
				</div>
				<div class="outline-header-left">
					<div v-if="ImageUrl">
						<img :src="ImageUrl" alt="">
					</div>
				</div>
				<div class="outline-header-center">
					<div class="outline-header-center-top">
						<img :src="themeCode === 'default' ? require('../../assets/default/decorate_left.png') : require('../../assets/electricity/decorate_left.png')"
							alt="">
						<div class="outline-header-center-title">
							<!-- 逸慧家智慧用电与消防安全隐患预警系统 -->
							{{ TittleName }}
						</div>
						<img :src="themeCode === 'default' ? require('../../assets/default/decorate_rigth.png') : require('../../assets/electricity/decorate_rigth.png')"
							alt="">
					</div>
					<div class="outline-header-center-bottom" style="letter-spacing: 0px;">
						{{ TittleNameEN }}
					</div>
				</div>
				<div class="outline-header-right">
					<Dropdown v-if="GetMenulists.indexOf('0006') >= 0">
						<a href="javascript:void(0)">
							<img v-if="themeCode === 'default'" src="../../assets/default/home.png" alt="">
							<img v-else-if="themeCode === 'blue'" src="../../assets/electricity/home.png" alt="">
						</a>
						<DropdownMenu slot="list">
							<DropdownItem @click.native="getSettlementsHide()">{{
								$t('smartElectricity.smarElectricity.218347-0') }}</DropdownItem>
							<DropdownItem @click.native="getPlatformFeePercentHide()">{{
								$t('smartElectricity.smarElectricity.218347-1') }}</DropdownItem>
						</DropdownMenu>
					</Dropdown>
					<Dropdown
						v-if="GetMenulists.indexOf('0002') >= 0 || GetMenulists.indexOf('0005') >= 0 || GetMenulists.indexOf('0004') >= 0 || GetMenulists.indexOf('0003') >= 0">
						<a href="javascript:void(0)">
							<img v-if="themeCode === 'default'" src="../../assets/default/yonghu.png" alt="">
							<img v-else-if="themeCode === 'blue'" src="../../assets/electricity/yonghu.png" alt="">
						</a>
						<DropdownMenu slot="list" style="width:8vw;">
							<DropdownItem v-if="GetMenulists.indexOf('0003') >= 0" @click.native="userListHide(true, 121)">
								{{ $t('smartElectricity.smarElectricity.218347-2') }}</DropdownItem>
							<DropdownItem v-if="GetMenulists.indexOf('0002') >= 0" @click.native="userListHide(true, 2)">
								{{ $t('smartElectricity.smarElectricity.218347-3') }}</DropdownItem>
							<DropdownItem v-if="GetMenulists.indexOf('0005') >= 0" @click.native="userListHide(true, 3)">
								{{ $t('smartElectricity.smarElectricity.218347-4') }}</DropdownItem>
							<DropdownItem v-if="GetMenulists.indexOf('0004') >= 0" @click.native="userListHide(true, 4)">
								{{ $t('smartElectricity.smarElectricity.218347-5') }}</DropdownItem>
							<DropdownItem v-if="GetMenulists.indexOf('0003') >= 0" @click.native="userListHide(true, 5)">
								{{ $t('smartElectricity.smarElectricity.218347-6') }}</DropdownItem>
							<DropdownItem v-if="GetMenulists.indexOf('0003') >= 0" @click.native="userListHide(true, 135)">
								{{ $t('smartElectricity.smarElectricity.218347-7') }}</DropdownItem>
						</DropdownMenu>
					</Dropdown>
					<!-- 					<Tooltip v-if="GetMenulists.indexOf('0001') >= 0" :content="$t('smartElectricity.smarElectricity.218347-354')" placement="bottom-start">
						<img v-if="themeCode === 'default'" @click="userListHide(true, 110)" src="../../assets/default/xiaoqu.png" alt="">
						<img v-else-if="themeCode === 'blue'" @click="userListHide(true, 110)" src="../../assets/electricity/xiaoqu.png" alt="">
					</Tooltip> -->
					<img id="oneKeyImportBtn" @click="userListHide(true, 'YHJimport')"
						:src="themeCode === 'default' ? require('../../assets/default/import.png') : require('../../assets/electricity/import.png')"
						:alt="$t('smartElectricity.smarElectricity.218347-8')"
						:title="$t('smartElectricity.smarElectricity.218347-8')">
					<img v-if="PlayIndex" @click="StopSound"
						:src="themeCode === 'default' ? require('../../assets/default/yousheng.png') : require('../../assets/electricity/yousheng.png')"
						:alt="$t('smartElectricity.smarElectricity.218347-9')">
					<img v-else @click="PlaySound"
						:src="themeCode === 'default' ? require('../../assets/default/wusheng.png') : require('../../assets/electricity/wusheng.png')"
						:alt="$t('smartElectricity.smarElectricity.218347-9')">
					<img @click="goBack"
						:src="themeCode === 'default' ? require('../../assets/default/return.png') : require('../../assets/electricity/return.png')"
						:alt="$t('smartElectricity.smarElectricity.218347-10')">
					<!-- <img src="https://big.darongshu360.com/img/home.680e896d.png" alt="入口"> -->
				</div>
				<div class="outline-and"></div>
			</div>
			<div class="map-content">
				<div class="map-title">
					<div class="map-title-left">
						<div class="map-title-left-item cursor" @click="warningMessage(113)">
							<img
								src="data:image/png;base64,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">
							<p>{{ $t('smartElectricity.smarElectricity.218347-11') }}</p>
							<p class="map-title-left-item-p">
								<img
									src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAHCAYAAAAxrNxjAAAAbklEQVQYlXWPwQmAQAwER/1rC9eBb31oH9aibWgDaiGCBdiBjchJIAch4kLgkht2k6yLEadB292OPRiAS981cKeP3EAFsAGlljjK7AOOQGv6Bph8tACHdVA9QA+c4igxEumhtM4KVAIuesSfAjC/znsScg8XzwIAAAAASUVORK5CYII=">
								<span>
									<span>
										<span id="count_to_3149" class="count-to-count-text">{{ GetNavDatas.currentTenant}}</span>
										<span class="count-to-unit-text"></span>
									</span>
								</span>
								{{ $t('smartElectricity.smarElectricity.218347-12') }}
							</p>
						</div>
						<div class="map-title-left-item cursor" @click="warningMessage(114)">
							<img
								src="data:image/png;base64,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" />
							<p>{{ $t('smartElectricity.smarElectricity.218347-13') }}</p>
							<p class="map-title-left-item-p">
								<img
									src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAHCAYAAAAxrNxjAAAAbklEQVQYlXWPwQmAQAwER/1rC9eBP0E/9mEt2sbZgFqIYAF2YCOiBHIQIi4ELrlhN8meBq9B+83OPRiAU981cKWP3EAFsAKlljjK7AOOQGf6Fph8tAC7dVDdQA8c4igxEumhtM4CVALOesSfAhBfN9cPXaDdt/IAAAAASUVORK5CYII=" />
								<span>
									<span>
										<span id="count_to_3149" class="count-to-count-text">{{ GetNavDataYHJs.abDevice}}</span>
										<span class="count-to-unit-text"></span>
									</span>
								</span>
								{{ $t('smartElectricity.smarElectricity.218347-14') }}
							</p>
						</div>
						<div class="map-title-left-item cursor" @click="warningMessage(111)">
							<img
								src="data:image/png;base64,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" />
							<p>{{ $t('smartElectricity.smarElectricity.218347-15') }}</p>
							<p class="map-title-left-item-p">
								<img
									src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAHCAYAAAAxrNxjAAAAbUlEQVQYlX2P3Q1AQBCEP7yrQQe88qIPtdCGq4BCJArQgGhEIhMr2RwxySX782VnLmEnVmf97OcxWACb1SVwPIvUQRkwAbk9XdTsBfZA4/oaGGJrAYu/YDqBFlgFyka5lO9LylnJOvxA9wdhvADBNQ/YdRmxeAAAAABJRU5ErkJggg==" />
								<span>
									<span>
										<span id="count_to_3149" class="count-to-count-text">{{ GetNavDataYHJs.ZxDevice
										}}</span>
										<span class="count-to-unit-text"></span>
									</span>
								</span>
								{{ $t('smartElectricity.smarElectricity.218347-14') }}
							</p>
						</div>
						<div class="map-title-left-item cursor" @click="warningMessage(112)">
							<img
								src="data:image/png;base64,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" />
							<p>{{ $t('smartElectricity.smarElectricity.218347-16') }}</p>
							<p class="map-title-left-item-p">
								<img
									src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAHCAYAAAAxrNxjAAAAaUlEQVQYlXWP2wmAMAxFj49vXaFrqJs4i66hP/lUR3EOR5ELbSkRA4Hk5rQ3qcwMF3Nsr1JuHRSAPdY38KRBXUANcAJdTP0o7QMuwFj0A7B6UEAW3eMpgbKRZbZx6xxAL1DL64i/CMD2Au+rDGFJXPX9AAAAAElFTkSuQmCC" />
								<span>
									<span>
										<span id="count_to_3149" class="count-to-count-text">{{ GetNavDataYHJs.LxDevice
										}}</span>
										<span class="count-to-unit-text"></span>
									</span>
								</span>
								{{ $t('smartElectricity.smarElectricity.218347-14') }}
							</p>
						</div>
					</div>
					<div class="map-title-center">
						{{ currentTime }}
					</div>
					<div class="map-title-right">
						<Tooltip :content="$t('smartElectricity.smarElectricity.218347-17')" placement="bottom-start">
							<router-link :to="{ name: 'abnormal' }">
								<div class="map-title-right-item1">
									<img src="../../assets/report/report.png" alt="">
								</div>
							</router-link>
						</Tooltip>

						<div class="map-title-right-item" @click="warningMessage(107)">
							<img
								src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAFhElEQVRogeWa3U9cRRTAf3dZlg/5KAJasKG2QFttUqtWa2qrD8YH9d3ExHf/KJ+Nie/Gh8YHtTb9SLRpokWhVBMBEShfDZQusGb2nksvM+csd+FuNfpLNpAz986cMzPnzMyZG62eIy86gEGgDzgEdAKtQBGIgDLwEFgFloB5YBp4kEf7xUBSH075E8Aw0LPHmy3y6waOpOSLwF3g14MYtd8R6QVeBo5Jb+dBBbgH/AgsNNqQNuC8jEIjcaNzHVjP2kY9U+s48BZQCkryx3XU88C3wGSW2rOMSAG4ALwYlHh1yZR7Vv52yQgmnbUpPbwiU2dW/laCmnbzM3AV2A5K6jCkGXjXc06fduCk+Et7UFqbNfGLX+R/iz+AyxL5VGoZ4nryA+lhDReBzgAjQJNSXg9bwARwG9gw3nMj+KWMbIBliJtO78u6oHEUeF2MyRNnxA3gd6POKeArbZoVgkdjLhhGRBK1LjXACEeL1H3eCOvPiW4BWtQaNhzbPXtxD3+JZGHskcWy1XP2h7LoLcrPcvRRCRRXlKnkdJuRRfRxw97Ucs76oRJinYJv1zCiKL01IAEiC2VRaEpRNsE5+TeKwY+AL9IBwp9abyhGIP5gGdEPvAoM1WEE8uyQvNsflMYckbZ9SqLrDmlD+iQC+RyVofaJ5PlThvFZKUkdri7NL0ZlcfQZEZ2rpA15JXg0dj6tRyJpfCAo2T+urlOGk78m/uazo3NiSIf0vM9ZIzodT/dGjvRJ3VqHvhRIY50704aMKj3xlEQwn34jNAc0fXabtsvz1V/z5z8F5QaDhs8Mi05pItlV7DLE54QSDIqGcSpRzzM0Heqt/qJea4OgMqwsDQVj1z2cFHbIic639FjwShxis0emrVRU3TS3SRrN0paPdv5xB7WugjFNepUNYJSzc+/FgKJ0u+jmM1gw5uPhQBKv1vWsEwel2Tg+a3O0tyBD4/N0INErbTRam9qIdBfkAOSjyToCSePR2tR0q/qIttC0BRJd1mi0NjVZqWBsL7RdsSZrNFqbmqxknUfyIUoFnUjbeeRHQbbEPtq2WpPVpKntcQRP/18HWpuarFyUw44/vdaVPdZ6veF37pP3qDTH1UTlDdVL90DLa2myjaKkZ/w2VpTV/oHyXE26Jq7VKs6ClkJdCSSw4qbWciCG+4EkPpo+abQ2tXTqshuRuUAMfwaSuNJyPdNro6UEkcSTyjYtG5o7mpQNQ2YDCSwUJbUfFMh5OO2hFTljDwVPG5Q+vUFzf7w921qYpfLxGf1BnRnlrL5mjMh0UebhkucTSWb8tPfCVD0JhpbBIUrd8S5js7W1GlUyUpa2fO4pxi0nPuIYD16J05hbnmzTT8PUojI3Q2VlMf79pQ28yV0lzG6JTj5VfZJV0qUrz3nb5jWRn/RenJPopW3/d1H+6LSdrLWZNvx2UskPVxLjkhFZNdKUVi52Uq7O8mbeuEZwOtwKpLHOq3hH2R+Cx+IKbgbSuCfGxCHzwtU1pvgAooPWoTs6pw2Zl6nk85vhQxV5fqxWuj8DZanD1aUZMS46+EykZ4W/k7wm4dXfstyU7bOWbZyTeN+olKk2Ix6Jrjto1wouK/FOII2NvmQkBXbqSyWxO40k9mqGJDZi4HeGkV/vlcROuGhk5AuS9dPSR3kyLiMR3IMAd8TAQDGNq8aKvy23rVcM5zsoG1L3dcMIp9P3gbTGiJDx6u2spDjzuHpzYfdWjQ7a19Vbwn/iMjTBTb83gReCEq8uSdUclnRSlxiWdvY1OU/clx12luvpOzKdtKlWlyEJT/KDASTEZv5gQMtIWExK3P9XfsLxv/2oxif5zGlEOeNnZUm2G//IZ04ayYdnLinu8snJyp5sWdIfnrnDkNva5PPhGfA3Y4FSC8HNfCEAAAAASUVORK5CYII=">
							<img :src="themeCode === 'default' ? require('../../assets/default/bottom_arrow2.png') : require('../../assets/electricity/bottom_arrow2.png')"
								>

							<p>{{ $t('smartElectricity.smarElectricity.218347-18') }}</p>
							<p class="map-title-left-item-p">
								<span>
									<span>
										<span id="count_to_14" class="count-to-count-text">{{ todayAbCount }}</span>
										<span class="count-to-unit-text"></span>
									</span>
								</span>
								{{ $t('smartElectricity.smarElectricity.218347-19') }}
							</p>
						</div>
						<div class="map-title-right-item" @click="warningMessage(108)">
							<img
								src="data:image/png;base64,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" />
							<img :src="themeCode === 'default' ? require('../../assets/default/bottom_arrow2.png') : require('../../assets/electricity/bottom_arrow2.png')"
								alt="">
							<p>{{ $t('smartElectricity.smarElectricity.218347-20') }}</p>
							<p class="map-title-left-item-p">
								<span>
									<span>
										<span id="count_to_14" class="count-to-count-text">{{ GetNavDataYHJs.todayAbSolve
										}}</span>
										<span class="count-to-unit-text"></span>
									</span>
								</span>
								{{ $t('smartElectricity.smarElectricity.218347-19') }}
							</p>
						</div>
						<div class="map-title-right-item" @click="warningMessage(109)">
							<img src="../../assets/default/YiChuLi.png">
							<img :src="themeCode === 'default' ? require('../../assets/default/bottom_arrow2.png') : require('../../assets/electricity/bottom_arrow2.png')"
								alt="">
							<p>{{ $t('smartElectricity.smarElectricity.218347-21') }}</p>
							<p class="map-title-left-item-p">
								<span>
									<span>
										<span id="count_to_14" class="count-to-count-text">{{ GetNavDataYHJs.todayAbWeiSolve
										}}</span>
										<span class="count-to-unit-text"></span>
									</span>
								</span>
								{{ $t('smartElectricity.smarElectricity.218347-19') }}
							</p>
						</div>
					</div>
				</div>

				<div class="map-left" :class="{ 'hiddenLeft': !showIndex, 'hiddenLeftWd': showIndex }">

					<!-- <div class="map-left-tabs">
            <div class="map-left-tab" :class="{'tabActive': navIndex == 1}" @click="navTab(1)">企业</div>
            <div class="map-left-tab" :class="{'tabActive': navIndex == 2}" @click="navTab(2)">区域</div>
            <div class="map-left-tab" :class="{'tabActive': navIndex == 3}" @click="navTab(3)">设备</div>
          </div> -->

					<div class="map-left-content" v-if="navIndex == 1" id="menu-left">
						<div class="map-right-title">
							{{ $t('smartElectricity.smarElectricity.218347-22') }}
							<div class="map-right-info-device-date-extra" style="letter-spacing: 0px;" @click="refreshData">
								<img v-if="themeCode === 'default'" src="../../assets/default/update.png" alt="">
								<img v-else-if="themeCode === 'blue'" src="../../assets/electricity/update.png" alt="">
								{{ $t('smartElectricity.smarElectricity.218347-23') }}
							</div>
						</div>

						<div class="map-left-search">
							<img @click="GetRoshCommunityList"
								src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABaElEQVQ4jY2TsUtVYRjGf95Eu6DkxYi7uEaGQQqBNASB2tYkBNEYCEWLOLm1BgX+B4I4dsEhFGlpaXFQCgeXCKUQDAWxaBB/8cV79fPck90HHjjne9734fB8z+lQyXANeAhMALeAKvAF+AA0gM8UkQyC4+qaZ9hVv2bvB+qM2pXtnBo8UPdjcFV9rI6oN0ObU49Df1U0qKufQnyjXskHMibTXzE3mRs8jcMVtbdkMefLmH2vVpsG79QT9UnJQpED6pH6XR1OWgW4ARwCWy0Jt+IbsAn0A7WkJoOTdBnx3A4u5TOVcOwDrrexPAAMAT+AvabB2xCngN6WlfN4AXQDG1GwvyHWsgLNq1dLwkt8rv5Wf0bpzhXprrodJpvqtHpPHVUfqY2skbNqZ9Eg8Y76MRssYkedUl+rS80vLf5MPcAkcB+oR+LpiteBBWAfWIvAl4FnF5Um/TSXS84H88z+17x/8ba6qI79Ac8cMX/xveWyAAAAAElFTkSuQmCC"
								:alt="$t('smartElectricity.smarElectricity.218347-24')">
							<input @keyup.enter="GetRoshCommunityList" type="text" v-model="Cname"
								:placeholder="$t('smartElectricity.smarElectricity.218347-25')" />
						</div>
						<div class="map-left-list">
							<div class="map-left-list-society" v-if="GetRoshCommunityLists.length > 0">
								<div v-for="(item) in GetRoshCommunityLists" :key="item.Id">
									<div class="map-left-lists-society"
										:class="{ 'map-left-lists-society-selected': societyItem.Ccode != item.Ccode, 'map-left-lists-society-unselected': societyItem.Ccode == item.Ccode }"
										@click="getCommunity(item)">
										<div class="map-left-lists-society-img">
											<img src="../../assets/electricity/society.png" alt="">
										</div>
										<div class="map-left-lists-society-view">
											<div class="map-left-lists-society-view-name">
												<!-- {{item.CityName}} -->
												{{ item.Cname }}
											</div>
											<div class="map-left-lists-society-view-addr">
												{{ item.ProvinceName }}-{{ item.CityName }}
											</div>
										</div>
										<!-- <div class="map-left-lists-society-remove">
											<img v-if="GetMenulists.indexOf('0001') >= 0"
												@click.stop="addCommunity(item)" src="../../assets/electricity/add2.png"
												alt="">
										</div> -->
										<div class="map-left-lists-society-remove" style="margin-left: 2.4vw;">
											<img v-if="GetMenulists.indexOf('0001') >= 0"
												@click.stop="DeleteRoshCommunity(item)"
												src="../../assets/electricity/remove.png" alt="">
										</div>
										<!-- <div class="map-left-lists-society-remove">
											<img v-if="GetMenulists.indexOf('0001') >= 0"
												@click.stop="EditRoshCommunity(item)"
												src="../../assets/electricity/edit.png" alt="">
										</div> -->

										<div class="map-left-lists-society-arrow">
											<img src="../../assets/electricity/arrow.png" alt="">
										</div>

									</div>

									<div v-if="societyItem.Ccode == item.Ccode">
										<div v-for="(msg) in GetRoshVillageLists" :key="msg.Id">
											<div class="map-left-list-item" @click="UnfoldDatass(msg.Vcode, msg.Vname)">

												<div style="width: calc(100% - 1.5vw - 3.3vw - 1.05vw - 1.75vw);">
													<div class="map-left-list-item-name">
														{{ msg.Vname }}
													</div>
													<div class="map-left-list-item-addr">
														{{ msg.Vaddress }}
													</div>
												</div>

												<!-- <div v-if="GetMenulists.indexOf('0001') >= 0"
                        	@click.stop="addVillage(msg)"
                        	class="map-left-list-item-img-remove">
                        	<img class="mapLeftListItemImgAdder"
                        		src="../../assets/electricity/add2.png" />
                        </div> -->
												<div v-if="GetMenulists.indexOf('0001') >= 0"
													@click.stop="removeVillage(msg)" style="margin-left: 2.4vw;"
													class="map-left-list-item-img-remove">
													<img class="mapLeftListItemImgAdder"
														src="../../assets/electricity/remove.png" />
												</div>
												<!-- <div v-if="GetMenulists.indexOf('0001') >= 0"
                        	@click.stop="editVillage(msg)"
                        	class="map-left-list-item-img-remove">
                        	<img class="mapLeftListItemImgAdder"
                        		src="../../assets/electricity/edit.png" />
                        </div> -->

												<div @click.stop="mapParameters(msg, 'msg')" class="map-left-list-item-img">
													<img class="mapLeftListItemImgAdder"
														src="../../assets/electricity/addr.png" />
												</div>
												<div class="map-left-list-item-img"
													:class="{ 'mapLeftListItemImages': msg.Vcode != CommunityIdData }">
													<img class="mapLeftListItemImgArrow"
														:class="{ 'mapLeftListItemImg': msg.Vcode != CommunityIdData }"
														src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAZCAYAAAAv3j5gAAACTklEQVRIiYWWTW/UMBCGXyf2rpPdSgjasqWCE+JS9Yb4PYhDVRWJC1f+QVUJtSwrPm4gIQRnjqgXJH4Gy5YbiMMG8bHxGG27GzmTcfaVrMQTex7PJGNHfR47rJBqf1zJNyyBdMNyIcm5ZEMAUIKtkgRSkXsJ5iMAxWEcpNh1aZPsoWPPoJ7DQhB3pgSIBAqd8n4Fk1LHIbxJEVHEXmkJkqKYt4RdJVCYPgl4HlUsdSEkZX3uiBZ2txhDHCKlTopo2VTP+HwjK48BdH78Tg+ms6RYjCMGRQiBsMpYVEmmfbZuy0N4dOExu2LdUc/4fkt6a34TycghncR3rmblUAFr337p/XFh7ntAb9hyZFNvGYS/S7WMiANqqbTad6/1yhMAdlyYvcuWbm5mbmc8NQcecIO8HPWNz2Lzw9Rx1SYM8nOI+TI1dzetu5VpepFrej7I3e54avYAzNZteSQ4r0FjdVSJPE5//k0/DHK3YzUdl5Q8BvDPajrZyvHg+x/98FKXbjcmMkmgsDbwdWrebPXcbjelkSP17KxI38/t1/voWk1PlcL+WZF+ZPXUEE+dZ/e0fQEZOlLDSaFfLRcyKdK3JanDTkpPtvvuDl/gqk0VbM/yJqVH5PFyUujXPO+TQr+7sTYzJqF7QPqJza1pfvDxbz9hn3jC6i3coREUKrHCrUF1MJg7AJvUBuLOG+Kp44MI8WqXYLxV0rHzI+iLlS5Eznfy2lWKqHEMtxzREkx61vqOFJssLaDhMNYPI4r9aLRBYs4btlUfg/Q+2iSPA/AfICz0+VfaygcAAAAASUVORK5CYII="
														alt="">
												</div>

											</div>
											<div class="map-left-list-item-down" v-if="CommunityIdData == msg.Vcode">
												<div class="map-left-list-item-down-item" v-for="(list) in GetSVillageLists"
													:key="list.Id" @click.stop="UnfoldZVillage(list)">
													<!--  @click="Unfold(list.Scode, list.Sname)" -->
													<!-- <div class="map-left-list-item-down-item-l-img">
														<img src="../../assets/electricity/room.png" alt="">GetZVillageList
													</div> -->
													<div class="jiedao"
														:class="[GetSVillageItem.Scode == list.Scode ? 'jiedao-selected' : 'jiedao-unselected']">
														<div class="map-left-list-item-down-item-view"
															style="margin-left: 1vw;flex: 1;">
															{{ list.Sname }}
														</div>
														<!-- <div class="map-left-list-item-down-item-edit">
															<img class="mapLeftListItemImgAdder" @click.stop="addHamlet(list)"
																src="../../assets/electricity/add2.png" />
														</div> -->
														<div class="map-left-list-item-down-item-edit">
															<img @click.stop="removeRoshSVillage(list)"
																src="../../assets/electricity/remove.png" alt="">
														</div>
														<!-- <div class="map-left-list-item-down-item-edit">
															<img @click.stop="EditRoshSVillage(list)"
																src="../../assets/electricity/edit.png" alt="">
														</div> -->
														<div @click.stop="mapParameters(list, 'list')"
															class="map-left-list-item-down-item-edit1">
															<img class="mapLeftListItemImgAdder"
																src="../../assets/electricity/addr.png" />
														</div>
														<div class="map-left-list-item-down-item-r-img">
															<img src="data:image/png;base64,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"
																alt="">
														</div>
													</div>

													<div class="cunzhuang1" v-if="GetSVillageItem.Scode === list.Scode"
														@click.stop="">
														<div v-for="lisk in GetZVillageLists" :key="lisk.Id">
															<div class="cunzhuang" @click="UnfoldVillage(lisk)"
																:class="[ZVillageCode == lisk.Zcode ? 'cunzhuang-selected' : 'cunzhuang-unselected']">
																<div class="map-left-list-item-down-item-view"
																	style="margin-left: 1vw;flex: 1;">
																	{{ lisk.Zname }}
																</div>
																<!--                                <div class="map-left-list-item-down-item-edit2">
                                	<img @click.stop="AddRoshRoom(list.Scode, list)"
                                		src="../../assets/electricity/add2.png" alt="">
                                </div> -->
																<div class="map-left-list-item-down-item-edit2">
																	<img @click.stop="removeZVillage(lisk)"
																		src="../../assets/electricity/remove.png" alt="">
																</div>
																<!-- <div class="map-left-list-item-down-item-edit2">
																	<img @click.stop="EditRoshZVillage(lisk)"
																		src="../../assets/electricity/edit.png" alt="">
																</div> -->
																<div @click.stop="mapParameters(lisk, 'lisk')"
																	class="map-left-list-item-down-item-edit2">
																	<img class="mapLeftListItemImgAdder"
																		src="../../assets/electricity/addr.png" />
																</div>
																<!-- 																<div class="map-left-list-item-down-item-r-img">
																	<img src="data:image/png;base64,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"
																		alt="">
																</div> -->
															</div>
															<!-- 															<div class="map-left-list-item-down" v-if="ZVillageCode == lisk.Zcode" style="margin-bottom: 0px;">
																<div class="map-left-list-item-down-item yonghu"
																	@click.stop="AddRoshRoom(list.Scode, list)">
																	<div class="map-left-list-item-down-item-l-img">
																		<img src="../../assets/electricity/add.png" alt="">
																	</div>
																	<div class="map-left-list-item-down-item-view map-left-list-item-down-item-view1">
																		{{ $t('smartElectricity.smarElectricity.218347-203') }}
																	</div>
																	<div class="map-left-list-item-down-item-edit"></div>
																	<div class="map-left-list-item-down-item-r-img">
																		<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAKQ2lDQ1BJQ0MgcHJvZmlsZQAAeNqdU3dYk/cWPt/3ZQ9WQtjwsZdsgQAiI6wIyBBZohCSAGGEEBJAxYWIClYUFRGcSFXEgtUKSJ2I4qAouGdBiohai1VcOO4f3Ke1fXrv7e371/u855zn/M55zw+AERImkeaiagA5UoU8Otgfj09IxMm9gAIVSOAEIBDmy8JnBcUAAPADeXh+dLA//AGvbwACAHDVLiQSx+H/g7pQJlcAIJEA4CIS5wsBkFIAyC5UyBQAyBgAsFOzZAoAlAAAbHl8QiIAqg0A7PRJPgUA2KmT3BcA2KIcqQgAjQEAmShHJAJAuwBgVYFSLALAwgCgrEAiLgTArgGAWbYyRwKAvQUAdo5YkA9AYACAmUIszAAgOAIAQx4TzQMgTAOgMNK/4KlfcIW4SAEAwMuVzZdL0jMUuJXQGnfy8ODiIeLCbLFCYRcpEGYJ5CKcl5sjE0jnA0zODAAAGvnRwf44P5Dn5uTh5mbnbO/0xaL+a/BvIj4h8d/+vIwCBAAQTs/v2l/l5dYDcMcBsHW/a6lbANpWAGjf+V0z2wmgWgrQevmLeTj8QB6eoVDIPB0cCgsL7SViob0w44s+/zPhb+CLfvb8QB7+23rwAHGaQJmtwKOD/XFhbnauUo7nywRCMW735yP+x4V//Y4p0eI0sVwsFYrxWIm4UCJNx3m5UpFEIcmV4hLpfzLxH5b9CZN3DQCshk/ATrYHtctswH7uAQKLDljSdgBAfvMtjBoLkQAQZzQyefcAAJO/+Y9AKwEAzZek4wAAvOgYXKiUF0zGCAAARKCBKrBBBwzBFKzADpzBHbzAFwJhBkRADCTAPBBCBuSAHAqhGJZBGVTAOtgEtbADGqARmuEQtMExOA3n4BJcgetwFwZgGJ7CGLyGCQRByAgTYSE6iBFijtgizggXmY4EImFINJKApCDpiBRRIsXIcqQCqUJqkV1II/ItchQ5jVxA+pDbyCAyivyKvEcxlIGyUQPUAnVAuagfGorGoHPRdDQPXYCWomvRGrQePYC2oqfRS+h1dAB9io5jgNExDmaM2WFcjIdFYIlYGibHFmPlWDVWjzVjHVg3dhUbwJ5h7wgkAouAE+wIXoQQwmyCkJBHWExYQ6gl7CO0EroIVwmDhDHCJyKTqE+0JXoS+cR4YjqxkFhGrCbuIR4hniVeJw4TX5NIJA7JkuROCiElkDJJC0lrSNtILaRTpD7SEGmcTCbrkG3J3uQIsoCsIJeRt5APkE+S+8nD5LcUOsWI4kwJoiRSpJQSSjVlP+UEpZ8yQpmgqlHNqZ7UCKqIOp9aSW2gdlAvU4epEzR1miXNmxZDy6Qto9XQmmlnafdoL+l0ugndgx5Fl9CX0mvoB+nn6YP0dwwNhg2Dx0hiKBlrGXsZpxi3GS+ZTKYF05eZyFQw1zIbmWeYD5hvVVgq9ip8FZHKEpU6lVaVfpXnqlRVc1U/1XmqC1SrVQ+rXlZ9pkZVs1DjqQnUFqvVqR1Vu6k2rs5Sd1KPUM9RX6O+X/2C+mMNsoaFRqCGSKNUY7fGGY0hFsYyZfFYQtZyVgPrLGuYTWJbsvnsTHYF+xt2L3tMU0NzqmasZpFmneZxzQEOxrHg8DnZnErOIc4NznstAy0/LbHWaq1mrX6tN9p62r7aYu1y7Rbt69rvdXCdQJ0snfU6bTr3dQm6NrpRuoW623XP6j7TY+t56Qn1yvUO6d3RR/Vt9KP1F+rv1u/RHzcwNAg2kBlsMThj8MyQY+hrmGm40fCE4agRy2i6kcRoo9FJoye4Ju6HZ+M1eBc+ZqxvHGKsNN5l3Gs8YWJpMtukxKTF5L4pzZRrmma60bTTdMzMyCzcrNisyeyOOdWca55hvtm82/yNhaVFnMVKizaLx5balnzLBZZNlvesmFY+VnlW9VbXrEnWXOss623WV2xQG1ebDJs6m8u2qK2brcR2m23fFOIUjynSKfVTbtox7PzsCuya7AbtOfZh9iX2bfbPHcwcEh3WO3Q7fHJ0dcx2bHC866ThNMOpxKnD6VdnG2ehc53zNRemS5DLEpd2lxdTbaeKp26fesuV5RruutK10/Wjm7ub3K3ZbdTdzD3Ffav7TS6bG8ldwz3vQfTw91jicczjnaebp8LzkOcvXnZeWV77vR5Ps5wmntYwbcjbxFvgvct7YDo+PWX6zukDPsY+Ap96n4e+pr4i3z2+I37Wfpl+B/ye+zv6y/2P+L/hefIW8U4FYAHBAeUBvYEagbMDawMfBJkEpQc1BY0FuwYvDD4VQgwJDVkfcpNvwBfyG/ljM9xnLJrRFcoInRVaG/owzCZMHtYRjobPCN8Qfm+m+UzpzLYIiOBHbIi4H2kZmRf5fRQpKjKqLupRtFN0cXT3LNas5Fn7Z72O8Y+pjLk722q2cnZnrGpsUmxj7Ju4gLiquIF4h/hF8ZcSdBMkCe2J5MTYxD2J43MC52yaM5zkmlSWdGOu5dyiuRfm6c7Lnnc8WTVZkHw4hZgSl7I/5YMgQlAvGE/lp25NHRPyhJuFT0W+oo2iUbG3uEo8kuadVpX2ON07fUP6aIZPRnXGMwlPUit5kRmSuSPzTVZE1t6sz9lx2S05lJyUnKNSDWmWtCvXMLcot09mKyuTDeR55m3KG5OHyvfkI/lz89sVbIVM0aO0Uq5QDhZML6greFsYW3i4SL1IWtQz32b+6vkjC4IWfL2QsFC4sLPYuHhZ8eAiv0W7FiOLUxd3LjFdUrpkeGnw0n3LaMuylv1Q4lhSVfJqedzyjlKD0qWlQyuCVzSVqZTJy26u9Fq5YxVhlWRV72qX1VtWfyoXlV+scKyorviwRrjm4ldOX9V89Xlt2treSrfK7etI66Trbqz3Wb+vSr1qQdXQhvANrRvxjeUbX21K3nShemr1js20zcrNAzVhNe1bzLas2/KhNqP2ep1/XctW/a2rt77ZJtrWv913e/MOgx0VO97vlOy8tSt4V2u9RX31btLugt2PGmIbur/mft24R3dPxZ6Pe6V7B/ZF7+tqdG9s3K+/v7IJbVI2jR5IOnDlm4Bv2pvtmne1cFoqDsJB5cEn36Z8e+NQ6KHOw9zDzd+Zf7f1COtIeSvSOr91rC2jbaA9ob3v6IyjnR1eHUe+t/9+7zHjY3XHNY9XnqCdKD3x+eSCk+OnZKeenU4/PdSZ3Hn3TPyZa11RXb1nQ8+ePxd07ky3X/fJ897nj13wvHD0Ivdi2yW3S609rj1HfnD94UivW2/rZffL7Vc8rnT0Tes70e/Tf/pqwNVz1/jXLl2feb3vxuwbt24m3Ry4Jbr1+Hb27Rd3Cu5M3F16j3iv/L7a/eoH+g/qf7T+sWXAbeD4YMBgz8NZD+8OCYee/pT/04fh0kfMR9UjRiONj50fHxsNGr3yZM6T4aeypxPPyn5W/3nrc6vn3/3i+0vPWPzY8Av5i8+/rnmp83Lvq6mvOscjxx+8znk98ab8rc7bfe+477rfx70fmSj8QP5Q89H6Y8en0E/3Pud8/vwv94Tz+4A5JREAAAAZdEVYdFNvZnR3YXJlAEFkb2JlIEltYWdlUmVhZHlxyWU8AAADJmlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDUgNzkuMTYzNDk5LCAyMDE4LzA4LzEzLTE2OjQwOjIyICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxOSAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MkU4MzhGQzJCRTVGMTFFOTg5NEU5NzUyMjQ0RkRCRTEiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MkU4MzhGQzNCRTVGMTFFOTg5NEU5NzUyMjQ0RkRCRTEiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoyRTgzOEZDMEJFNUYxMUU5ODk0RTk3NTIyNDRGREJFMSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoyRTgzOEZDMUJFNUYxMUU5ODk0RTk3NTIyNDRGREJFMSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PlEa1yEAAACXSURBVHjaYvj//z8DEg4C4pdAHIgmjhUzMaACHSAWA+J5QOzKQAhgMbHjPwR8BWI3fDbjkiDKAHx+ImgAoUDBawADEaHaBMR/gfgLEPsDMSMpmkWA+AXUBTuBmJlYzRJAfA6q8RAQCxPrbJDG80gaBYj1M0GNuDQTpRGbZiViNWLTPAmqcT8hjdg0iwJxPzR6CEYjQIABALOcl5pytvbaAAAAAElFTkSuQmCC"
																			alt="">
																	</div>
																</div>
																<div class="map-left-list-item-down-item yonghu"
																	v-for="(data) in GetRoshRoomLists" :key="data.Id"
																	@click.stop="deviceDetail(data)">
																	<div class="map-left-list-item-down-item-l-img">
																		<img src="../../assets/electricity/room.png" alt="">
																	</div>
																	<div class="map-left-list-item-down-item-view map-left-list-item-down-item-view1">
																		{{data.RoomName}}
																	</div>
																	<div class="map-left-list-item-down-item-edit">
																		<img @click.stop="EditRoshRoom(data)"
																			src="../../assets/electricity/edit.png" alt="">
																	</div>
																	<div class="map-left-list-item-down-item-r-img">
																		<img src="data:image/png;base64,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"
																			alt="">
																	</div>
																</div>
															</div> -->
														</div>
														<div v-if="GetZVillageLists.length == 0"
															class="map-right-group-list-none2">{{
																$t('smartElectricity.smarElectricity.218347-26') }}</div>

													</div>

												</div>
												<div v-if="GetSVillageLists.length == 0" class="map-right-group-list-none3">
													{{ $t('smartElectricity.smarElectricity.218347-26') }}</div>
											</div>
										</div>
										<div v-if="GetRoshVillageLists.length == 0" class="map-right-group-list-none1">
											{{ $t('smartElectricity.smarElectricity.218347-27') }}</div>
									</div>

								</div>
							</div>
							<div class="map-right-group-list-none" v-else>{{
								$t('smartElectricity.smarElectricity.218347-28') }}</div>
						</div>
						<Spin size="large" fix v-if="!GetRoshVillageListsMsg"></Spin>
					</div>

					<div class="map-left-content" v-if="navIndex == 2">
						<div class="map-left-search">
							<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABaElEQVQ4jY2TsUtVYRjGf95Eu6DkxYi7uEaGQQqBNASB2tYkBNEYCEWLOLm1BgX+B4I4dsEhFGlpaXFQCgeXCKUQDAWxaBB/8cV79fPck90HHjjne9734fB8z+lQyXANeAhMALeAKvAF+AA0gM8UkQyC4+qaZ9hVv2bvB+qM2pXtnBo8UPdjcFV9rI6oN0ObU49Df1U0qKufQnyjXskHMibTXzE3mRs8jcMVtbdkMefLmH2vVpsG79QT9UnJQpED6pH6XR1OWgW4ARwCWy0Jt+IbsAn0A7WkJoOTdBnx3A4u5TOVcOwDrrexPAAMAT+AvabB2xCngN6WlfN4AXQDG1GwvyHWsgLNq1dLwkt8rv5Wf0bpzhXprrodJpvqtHpPHVUfqY2skbNqZ9Eg8Y76MRssYkedUl+rS80vLf5MPcAkcB+oR+LpiteBBWAfWIvAl4FnF5Um/TSXS84H88z+17x/8ba6qI79Ac8cMX/xveWyAAAAAElFTkSuQmCC"
								:alt="$t('smartElectricity.smarElectricity.218347-24')">
							<input type="text" :placeholder="$t('smartElectricity.smarElectricity.218347-25')" />
						</div>
						<div class="map-left-list active">
							<div class="map-left-lists">
								<div class="map-left-list-item" v-for="item in 20" :key="item">
									<div class="map-left-list-item-report">{{
										$t('smartElectricity.smarElectricity.218347-29') }}</div>
									<div class="map-left-list-item-name">
										{{ $t('smartElectricity.smarElectricity.218347-30') }}{{ item }}
									</div>
									<div class="map-left-list-item-addr">
										{{ $t('smartElectricity.smarElectricity.218347-31') }}
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="map-left-content" v-if="navIndex == 3">
						<div class="map-left-search">
							<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABaElEQVQ4jY2TsUtVYRjGf95Eu6DkxYi7uEaGQQqBNASB2tYkBNEYCEWLOLm1BgX+B4I4dsEhFGlpaXFQCgeXCKUQDAWxaBB/8cV79fPck90HHjjne9734fB8z+lQyXANeAhMALeAKvAF+AA0gM8UkQyC4+qaZ9hVv2bvB+qM2pXtnBo8UPdjcFV9rI6oN0ObU49Df1U0qKufQnyjXskHMibTXzE3mRs8jcMVtbdkMefLmH2vVpsG79QT9UnJQpED6pH6XR1OWgW4ARwCWy0Jt+IbsAn0A7WkJoOTdBnx3A4u5TOVcOwDrrexPAAMAT+AvabB2xCngN6WlfN4AXQDG1GwvyHWsgLNq1dLwkt8rv5Wf0bpzhXprrodJpvqtHpPHVUfqY2skbNqZ9Eg8Y76MRssYkedUl+rS80vLf5MPcAkcB+oR+LpiteBBWAfWIvAl4FnF5Um/TSXS84H88z+17x/8ba6qI79Ac8cMX/xveWyAAAAAElFTkSuQmCC"
								:alt="$t('smartElectricity.smarElectricity.218347-24')">
							<input type="text" :placeholder="$t('smartElectricity.smarElectricity.218347-32')" />
						</div>
						<div class="map-left-list active">
							<div class="map-left-lists">
								<div class="map-left-list-item" v-for="item in 20" :key="item">
									<div class="map-left-list-item-state">
										<!-- <div class="ivu-tag1 ivu-tag-text">{{ $t('smartElectricity.smarElectricity.218347-52') }}</div> -->
										<div class="ivu-tag1 ivu-tag-green ivu-tag-text2">{{
											$t('smartElectricity.smarElectricity.218347-33') }}</div>
										<div class="ivu-tag1 ivu-tag-cyan ivu-tag-text1">{{
											$t('smartElectricity.smarElectricity.218347-34') }}</div>
										<!-- <div class="ivu-tag1 ivu-tag-orange ivu-tag-text3">报警</div> -->
									</div>
									<div class="map-left-list-item-name">
										{{ $t('smartElectricity.smarElectricity.218347-35') }}{{ item }}
									</div>
									<div class="map-left-list-item-addr">
										{{ $t('smartElectricity.smarElectricity.218347-36') }}{{ item }}
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-else-if="themeCode === 'default'" class="map-left-show" @click="showClick">
						<img v-if="showIndex" src="../../assets/default/rightIcon.png">
						<img v-else src="../../assets/default/rigth_arrow1.png">
					</div>
					<div v-if="themeCode === 'blue'" class="map-left-show" @click="showClick">
						<img v-if="showIndex"
							src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAKCAYAAABmBXS+AAAA2klEQVQYlU3QO0pEQRSE4W/EB4oI3iWYadCBhkZuQsWLaKIuQxBjQVAD8TVqm7gEt2AydyG9AB+MnKFnsKCDhv+cqjq94XBorKbtZvGAj5JTv2m7dZxPoKbtpvGIGRxhBX3cTFVgDi9YLDntViDjsuR021veG8zjCkvYxmoFrktOd7EkLO4RWWLDGt4jR8npbZw17AL4wm8dihf/iQI6wA9eS04D7OC0abv9MTVq17TdAp4DjuBN223UXGdh+/8EYRsNv3FSCzzhYnSCUMkpchxWaLPk9IljbP0BSF9JQRqYjp4AAAAASUVORK5CYII=">
						<img v-else
							src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAaCAYAAABCfffNAAACS0lEQVRIiY2WO2/UQBDHZx/OnXHuREMgIJKjgoYG0fIlKCgQFQUhUaTjg1AFhYhTKiRESQWfgYYG0dEQECgIEMW9nOwLOdxZ4/Hs+UZare1d/387M571ivdHDhgT9UdRC7GBuWlyT8WbYIHMYYEYIpa4bgIIdF2DcIBYT1cdECCgd0pQLFwCNQ6IRQUCUa8CB6GAGIx6QT2sLGBRTuZNEhA2j0CeCWUZriZx3HMr9rMmEagSLvoiDZHsdc2bK5m7BQBqo2Me9LrmsK1DWtzP3lezxoX3TFMicQ4kfYC3ifL765m7+fdEvYMAyaXUPluRoYVA2GOqV/GEK0TxdZi8dF4MWsoPMh2ufRkmWwCwejmzB6kObSZvtXLgwlXz7NtIv3ZevGhrv3cxdTeORsnDIp9rqX2aJeEcE6oKjEIoSCDQK+vlQZr4w7XUXf8+1tsCoHshtXs1BWIcZJGdiv950DaIYmc9BYCVBfPPjCtGrtDC1VV3T0m/O7Vy6+dEfdrsmOcAYP9MVb+m0AChe9AMYO9qGZ7kVu4cT9THzY4ZFB79ynV/bMQILYi2GoTbVcNGx9yXAnZPnHw8NPJzr2P2i8HjiX6UO5GjascRqERFRgbKrUIKuGO87P8Yqw/nW/42AJjfud7OnZgCgEMATyq+tOLPyO28uMBiNRCIeCB9OUdHfjbz3pMF0PwFAguMRjQn2F3PFCn9AtmEcxAMo2Bum4/B6PMSUvvRMGKxAwMnDrFwUUEOtOw9e5Cgq208Sy0JrkHwpMaz1NLjAPAPymb7CJi2SacAAAAASUVORK5CYII=">
					</div>
				</div>

				<div class="map-right" :class="{ 'hiddenRight': !showIndex2 }" v-if="navBackIndex != 0">
					<div class="map-right-title-iosn">
						<div class="map-right-title-iosn-left" @click="anWidth">

							<img v-if="!anWidthClick" class="ImgrightIcon"
								:src="require('../../assets/electricity/rightIcon.png')">
							<img v-else :src="require('../../assets/electricity/rigth_arrow.png')">
						</div>

					</div>
					<div class="map-right-group" v-if="navBackIndex == 1">
						<div class="map-right-title">{{ $t('smartElectricity.smarElectricity.218347-37') }}</div>
						<div class="map-right-group-name">
							<Poptip class="F-r" confirm :title="$t('smartElectricity.smarElectricity.218347-38')"
								placement="bottom-end" @on-ok="DeleteRoshRoom" @on-cancel="cancel">
								<div class="map-right-group-report">{{ $t('smartElectricity.smarElectricity.218347-39') }}
								</div>
							</Poptip>
							{{ roomDetails.RoomName }}
						</div>
						<div class="map-right-group-detail">
							<!-- @click="userListHide(true, 102)" -->
							<!-- <div class="map-right-group-report map-right-group-report-add-title" v-if="DeviceBtns.indexOf('add') >= 0" @click="userListHide(true, 106)">{{ $t('smartElectricity.smarElectricity.218347-40') }}</div> -->
							<div class="map-right-group-report map-right-group-report-add-title"
								v-if="DeviceBtns.indexOf('add') >= 0" @click="submit106()">{{
									$t('smartElectricity.smarElectricity.218347-40') }}</div>
							<img src="../../assets/electricity/community.png"
								:alt="$t('smartElectricity.smarElectricity.218347-41')">
							{{ ZVillageItem.Zname }}
						</div>
						<div class="map-right-group-detail">
							<img src="../../assets/electricity/tel.png"
								:alt="$t('smartElectricity.smarElectricity.218347-42')">
							{{ roomDetails.OwnerPhone }}
						</div>
						<div class="map-right-search">
							<img @click="GetUserDevicesPage"
								src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABaElEQVQ4jY2TsUtVYRjGf95Eu6DkxYi7uEaGQQqBNASB2tYkBNEYCEWLOLm1BgX+B4I4dsEhFGlpaXFQCgeXCKUQDAWxaBB/8cV79fPck90HHjjne9734fB8z+lQyXANeAhMALeAKvAF+AA0gM8UkQyC4+qaZ9hVv2bvB+qM2pXtnBo8UPdjcFV9rI6oN0ObU49Df1U0qKufQnyjXskHMibTXzE3mRs8jcMVtbdkMefLmH2vVpsG79QT9UnJQpED6pH6XR1OWgW4ARwCWy0Jt+IbsAn0A7WkJoOTdBnx3A4u5TOVcOwDrrexPAAMAT+AvabB2xCngN6WlfN4AXQDG1GwvyHWsgLNq1dLwkt8rv5Wf0bpzhXprrodJpvqtHpPHVUfqY2skbNqZ9Eg8Y76MRssYkedUl+rS80vLf5MPcAkcB+oR+LpiteBBWAfWIvAl4FnF5Um/TSXS84H88z+17x/8ba6qI79Ac8cMX/xveWyAAAAAElFTkSuQmCC"
								alt="">
							<input @keyup.enter="GetUserDevicesPage" type="text" v-model="DeviceCode" :placeholder="$t('smartElectricity.smarElectricity.218347-43')" />
						</div>

						<div class="map-right-group-list">
							<div class="map-right-group-lists" v-if="roomDeviceLists.length > 0">
								<div class="map-right-group-list-item" v-for="(item) in roomDeviceLists" :key="item.Id"
									@click="Back(2, item)">
									<div class="map-right-group-list-item-img "
										:class="{ 'mapRightRroupListItemImgColor': item.IsOnline, 'mapRightRroupListItemImgColor1': !item.IsOnline }">
										<img v-if="item.DeviceId == '6ee95d23-a802-4bd8-b823-19c0944ac5ab'"
											:src="item.IsOnline ? require('../../assets/electricity/weiduan.png') : require('../../assets/electricity/weiduan1.png')" />
										<img v-if="item.DeviceId == '4782d02c-0075-4105-9729-aa1b65bb250a'"
											:src="item.IsOnline ? require('../../assets/electricity/yangan.png') : require('../../assets/electricity/yangan1.png')" />
										<img v-if="item.DeviceId == '88f5c429-49b6-4a9f-a908-b2ee9c8cb857'"
											:src="item.IsOnline ? require('../../assets/electricity/qigan.png') : require('../../assets/electricity/qigan1.png')" />
										<img v-if="item.DeviceId == '7febbea4-0326-496d-9b71-5b058729cb42'"
											:src="item.IsOnline ? require('../../assets/electricity/chuanganqi.png') : require('../../assets/electricity/chuanganqi1.png')" />
									</div>
									<div class="map-right-group-list-item-name">{{ item.UserDeviceName }}</div>
									<img class="map-right-group-list-item-img1"
										src="data:image/png;base64,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"
										alt="">
								</div>
							</div>
							<div class="map-right-group-list-none" v-else>{{
								$t('smartElectricity.smarElectricity.218347-44') }}</div>
						</div>
						<Spin size="large" fix v-if="!roomDeviceListsMsg"></Spin>
					</div>

					<div class="map-right-info" v-if="navBackIndex == 2">
						<div class="map-right-title">
							<div class="map-right-title-extra" @click="Back(1)">
								<img v-if="themeCode === 'default'" src="../../assets/default/left_arrow1.png" alt="">
								<img v-else-if="themeCode === 'blue'"
									src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAA6UlEQVQokX3RvUrEQBSG4Wf9jTZ21t6F2IqKkBT2A4Klt2ChIGjlPQiSeAWxEfEe1kJrO7UQLCSpXBmcFd2E/WCYc4bv5fzMYDQamVRRtSs4xwfO6pB9ji0zPeY13GAHd3/NHaCo2nXcp3SrDtk47gJF1e4l8xB5HbLnTq9RcYa8bA7ysnnNy+Yk5tPOIC+bI5ziPfW+3DcbFmP1OSxhFl+I+QLmO/b0Hg3HeEv3sA7ZRW/vSb//UFRtwCWucViHrJkKJGgTV3jEfh2yl0ng33Bp79tYxW1RtRtTgQQ9YRcPsWhRtXEpP8I3FmBjdXeNcw8AAAAASUVORK5CYII="
									alt="">
								{{ $t('smartElectricity.smarElectricity.218347-10') }}
							</div>
							{{ $t('smartElectricity.smarElectricity.218347-45') }}
						</div>
						<div class="map-right-group-name" :title="roomDetails.Vname + '·' + roomDetails.RoomName">
							{{ roomDetails.Vname }} · {{ roomDetails.RoomName }}</div>
						<div class="map-right-group-detail">
							<img src="../../assets/electricity/device.png" alt="">
							{{ $t('smartElectricity.smarElectricity.218347-46') }}{{ DeviceDetails.UserDeviceName }}
						</div>
						<div class="map-right-group-detail">
							<img src="../../assets/electricity/coding.png" alt="" style="padding: 0 0.1vw;">
							{{ $t('smartElectricity.smarElectricity.218347-47') }}{{ DeviceDetails.DeviceCode }}
						</div>
						<div class="map-right-group-detail"
							v-if="DeviceDetails.DeviceId == '6ee95d23-a802-4bd8-b823-19c0944ac5ab'">
							<img src="../../assets/electricity/client.png" alt="">
							{{ $t('smartElectricity.smarElectricity.218347-48') }}{{ DeviceDetails.SwitchStatus == 1 ?
								$t('smartElectricity.smarElectricity.218347-49') :
								$t('smartElectricity.smarElectricity.218347-50') }}
						</div>
						<div class="map-right-group-detail" v-else>
							<img src="../../assets/electricity/client.png" alt="">
							{{ $t('smartElectricity.smarElectricity.218347-51') }}{{ DeviceDetails.IsOnline ?
								$t('smartElectricity.smarElectricity.218347-33') :
								$t('smartElectricity.smarElectricity.218347-52') }}
						</div>
						<div class="map-right-group-detail" :title="DeviceDetails.Address">
							<img src="../../assets/electricity/community.png"
								:alt="$t('smartElectricity.smarElectricity.218347-41')">
							{{ $t('smartElectricity.smarElectricity.218347-53') }}{{ DeviceDetails.Address }}
						</div>
						<div class="map-right-group-detail">
							<img src="../../assets/electricity/tel.png" alt="">
							{{ $t('smartElectricity.smarElectricity.218347-54') }}{{ DeviceDetails.ContactsPhone ?
								DeviceDetails.ContactsPhone : $t('smartElectricity.smarElectricity.218347-55') }}
						</div>

						<div class="map-right-group-btn">

							<Poptip confirm :title="$t('smartElectricity.smarElectricity.218347-56')" placement="top-start"
								offset='0' @on-ok="Device_YanGan_Silence" @on-cancel="cancel">
								<div class="map-right-group-btn-item mute" v-if="DeviceBtns.indexOf('slience') >= 0">
									<p>{{ $t('smartElectricity.smarElectricity.218347-57') }}</p>
								</div>
							</Poptip>

							<div class="map-right-group-btn-item reset" :class="{ 'allowed': !callState }"
								@click="InitDeviceRead(DeviceDetails.DeviceCode, DeviceDetails.Id)"
								v-if="DeviceBtns.indexOf('read') >= 0">
								<p>{{ $t('smartElectricity.smarElectricity.218347-58') }}</p>
							</div>

							<Poptip confirm :title="$t('smartElectricity.smarElectricity.218347-59')" :disabled="!saveState"
								placement="top-start" offset='0' @on-ok="VerifyPassword(1)" @on-cancel="cancel">
								<div class="map-right-group-btn-item open"
									v-if="DeviceBtns.indexOf('open') >= 0 && DeviceDetails.SwitchStatus != 2">
									<p>{{ $t('smartElectricity.smarElectricity.218347-50') }}</p>
								</div>
							</Poptip>

							<Poptip confirm :title="$t('smartElectricity.smarElectricity.218347-60')" :disabled="!saveState"
								placement="top-start" offset='0' @on-ok="VerifyPassword(1)" @on-cancel="cancel">
								<div class="map-right-group-btn-item close"
									v-if="DeviceBtns.indexOf('close') >= 0 && DeviceDetails.SwitchStatus != 1">
									<p>{{ $t('smartElectricity.smarElectricity.218347-49') }}</p>
								</div>
							</Poptip>

							<Poptip confirm :title="$t('smartElectricity.smarElectricity.218347-61')" :disabled="!saveState"
								placement="top-start" offset='0' @on-ok="VerifyPassword(2)" @on-cancel="cancel">
								<div class="map-right-group-btn-item close" v-if="DeviceBtns.indexOf('closeFa') >= 0">
									<p>{{ $t('smartElectricity.smarElectricity.218347-62') }}</p>
								</div>
							</Poptip>

							<div class="map-right-group-btn-item probe"
								v-if="DeviceDetails.DeviceId == '88f5c429-49b6-4a9f-a908-b2ee9c8cb857' && DeviceDetails.DeviceItemId != '881a191a-e3da-4bea-867a-69988dbf1fef' && DeviceDetails.DeviceItemId != '147df81e-3f30-49b7-8894-f0b5794d917f' && DeviceDetails.DeviceItemId != 'c5307581-ff30-4115-87c0-52ac83bbd1cc'"
								@click="GetQtcgqTtItemList(DeviceDetails.DeviceCode)">
								<p>{{ $t('smartElectricity.smarElectricity.218347-63') }}</p>
							</div>

							<div class="map-right-group-btn-item sim" v-if="DeviceBtns.indexOf('edit') >= 0"
								@click="userListHide(true, 103)">
								<p>{{ $t('smartElectricity.smarElectricity.218347-64') }}</p>
							</div>

							<Poptip confirm :title="$t('smartElectricity.smarElectricity.218347-65')" placement="top-end"
								offset='-20' @on-ok="ok" @on-cancel="cancel">
								<div class="map-right-group-btn-item set" v-if="DeviceBtns.indexOf('del') >= 0">
									<p>{{ $t('smartElectricity.smarElectricity.218347-66') }}</p>
								</div>
							</Poptip>
							<div class="map-right-group-btn-item clock" @click="GetSZ_ModbusV3(DeviceDetails.DeviceCode)"
								v-if="DeviceDetails.DeviceItemId == '0b4550c8-bbaa-43bb-9bf4-d8f6cd02766c' && DeviceDetails.DeviceXY == '3.0'">
								<p>{{ $t('smartElectricity.smarElectricity.218347-67') }}</p>
							</div>
							<div class="map-right-group-btn-item setup"
								@click="userListHide(true, passWordIndex ? 105 : 104)">
								<p>{{ $t('smartElectricity.smarElectricity.218347-68') }}</p>
							</div>
							<div class="map-right-group-btn-item update" @click="update_ModbusV3(DeviceDetails.DeviceCode)"
								v-if="DeviceDetails.DeviceItemId == '0b4550c8-bbaa-43bb-9bf4-d8f6cd02766c' && DeviceDetails.DeviceXY == '3.0'">
								<p>{{ $t('smartElectricity.smarElectricity.218347-549') }}</p>
							</div>
						</div>

						<div class="map-right-info-device">
							<div class="map-right-info-device1">
								<div class="map-right-info-device-tab">
									<div class="map-right-info-device-tab-item" v-if="DeviceBtns.indexOf('state') >= 0"
										:class="{ 'navDeviceActive': navDeviceIndex == 1 }" @click="navDeviceTab(1)">{{
											$t('smartElectricity.smarElectricity.218347-69') }}
									</div>
									<div class="map-right-info-device-tab-item"
										v-if="DeviceDetails.DeviceId == '6ee95d23-a802-4bd8-b823-19c0944ac5ab'"
										:class="{ 'navDeviceActive': navDeviceIndex == 2 }" @click="navDeviceTab(2)">{{
											$t('smartElectricity.smarElectricity.218347-70') }}
									</div>
									<div class="map-right-info-device-tab-item"
										:class="{ 'navDeviceActive': navDeviceIndex == 3 }" @click="navDeviceTab(3)">{{
											$t('smartElectricity.smarElectricity.218347-71') }}
									</div>
									<div class="map-right-info-device-tab-item" v-if="DeviceBtns.indexOf('Fazhi') >= 0"
										:class="{ 'navDeviceActive': navDeviceIndex == 4 }" @click="navDeviceTab(4)">{{
											$t('smartElectricity.smarElectricity.218347-72') }}
									</div>
								</div>

								<div class="Real-time-data-view" v-if="navDeviceIndex == 1">
									<template v-if="DeviceTypeClass != 8">
										<div class="map-right-info-device-date">
											<div class="map-right-info-device-date-extra"
												@click="DeviceParameterLook(DeviceDetails.DeviceCode)">
												<img v-if="themeCode === 'default'" src="../../assets/default/update.png"
													alt="">
												<img v-else-if="themeCode === 'blue'"
													src="../../assets/electricity/update.png" alt="">
												{{ $t('smartElectricity.smarElectricity.218347-23') }}
											</div>
											<div v-if="DeviceDetails.IsOnline" class="ivu-tag1 ivu-tag-green ivu-tag-text2">
												{{ $t('smartElectricity.smarElectricity.218347-33') }}</div>
											<div v-else class="ivu-tag1 ivu-tag-text">{{
												$t('smartElectricity.smarElectricity.218347-52') }}</div>
											<img src="../../assets/electricity/clock.png" alt="">
											{{ DeviceDetails.UpdateTime }}
										</div>
										<div class="map-right-device1-info">

											<template>

												<div class="map-right-info-device1-row"
													v-for="(item, index) in DeviceParameterLookLists" :key="index">
													<div class="map-right-info-device1-row-item">
														<p class="map-right-info-device1-row-item-p1">
															{{ item.ParamName }}：</p>
														<p class="map-right-info-device1-row-item-p2"
															:title="(item.ParamValue ? item.ParamValue : 0) + (item.ParamUnit ? item.ParamUnit : '')">
															<span>{{ item.ParamValue ? item.ParamValue :
																0 }}</span>{{ item.ParamUnit }}
														</p>
													</div>
												</div>

											</template>
										</div>
									</template>
									<template v-else>
										<div class="map-right-info-device-date">
											<div class="map-right-info-device-date-extra"
												@click="DeviceParameterLook_Zigbee(DeviceDetails.DeviceCode)">
												<img v-if="themeCode === 'default'" src="../../assets/default/update.png"
													alt="">
												<img v-else-if="themeCode === 'blue'"
													src="../../assets/electricity/update.png" alt="">
												{{ $t('smartElectricity.smarElectricity.218347-23') }}
											</div>
											<div v-if="DeviceDetails.IsOnline" class="ivu-tag1 ivu-tag-green ivu-tag-text2">
												{{ $t('smartElectricity.smarElectricity.218347-33') }}</div>
											<div v-else class="ivu-tag1 ivu-tag-text">{{
												$t('smartElectricity.smarElectricity.218347-52') }}</div>
											<img src="../../assets/electricity/clock.png" alt="">
											{{ DeviceDetails.UpdateTime }}
										</div>
										<div class="map-right-device1-info">

											<template>

												<div class="map-right-info-device1-row"
													v-if="DeviceInfoBaseModel.GongNengKaiGuanZhuangTai || DeviceInfoBaseModel.DianCiType">
													<div class="map-right-info-device1-row-item"
														v-if="DeviceInfoBaseModel.GongNengKaiGuanZhuangTai">
														<p class="map-right-info-device1-row-item-p1">{{
															$t('smartElectricity.smarElectricity.218347-73') }}</p>
														<p class="map-right-info-device1-row-item-p2">
															{{ DeviceInfoBaseModel.GongNengKaiGuanZhuangTai }}</p>
													</div>
													<div class="map-right-info-device1-row-item"
														v-if="DeviceInfoBaseModel.DianCiType">
														<p class="map-right-info-device1-row-item-p1">{{
															$t('smartElectricity.smarElectricity.218347-74') }}</p>
														<p class="map-right-info-device1-row-item-p2">
															{{ DeviceInfoBaseModel.DianCiType }}</p>
													</div>
												</div>
												<div class="map-right-info-device1-row"
													v-if="DeviceInfoBaseModel.DianCiDianLiangZhuangTai || DeviceInfoBaseModel.DianCiDianYa">
													<div class="map-right-info-device1-row-item"
														v-if="DeviceInfoBaseModel.DianCiDianLiangZhuangTai">
														<p class="map-right-info-device1-row-item-p1">{{
															$t('smartElectricity.smarElectricity.218347-75') }}</p>
														<p class="map-right-info-device1-row-item-p2">
															{{ DeviceInfoBaseModel.DianCiDianLiangZhuangTai }}</p>
													</div>
													<div class="map-right-info-device1-row-item"
														v-if="DeviceInfoBaseModel.DianCiDianYa">
														<p class="map-right-info-device1-row-item-p1">{{
															$t('smartElectricity.smarElectricity.218347-76') }}</p>
														<p class="map-right-info-device1-row-item-p2">
															{{ DeviceInfoBaseModel.DianCiDianYa }}</p>
													</div>
												</div>
												<div class="map-right-info-device1-row"
													v-if="DeviceInfoBaseModel.DaKaiGuanBi || DeviceInfoBaseModel.FangCai">
													<div class="map-right-info-device1-row-item"
														v-if="DeviceInfoBaseModel.DaKaiGuanBi">
														<p class="map-right-info-device1-row-item-p1">{{
															$t('smartElectricity.smarElectricity.218347-77') }}</p>
														<p class="map-right-info-device1-row-item-p2">
															{{ DeviceInfoBaseModel.DaKaiGuanBi }}</p>
													</div>
													<div class="map-right-info-device1-row-item"
														v-if="DeviceInfoBaseModel.FangCai">
														<p class="map-right-info-device1-row-item-p1">{{
															$t('smartElectricity.smarElectricity.218347-78') }}</p>
														<p class="map-right-info-device1-row-item-p2">
															{{ DeviceInfoBaseModel.FangCai }}</p>
													</div>
												</div>

												<div class="map-right-info-device1-row"
													v-if="DeviceInfoBaseModel.ShiDuZhi || DeviceInfoBaseModel.WenDuZhi">
													<div class="map-right-info-device1-row-item"
														v-if="DeviceInfoBaseModel.ShiDuZhi">
														<p class="map-right-info-device1-row-item-p1">{{
															$t('smartElectricity.smarElectricity.218347-79') }}</p>
														<p class="map-right-info-device1-row-item-p2">
															{{ DeviceInfoBaseModel.ShiDuZhi }}</p>
													</div>
													<div class="map-right-info-device1-row-item"
														v-if="DeviceInfoBaseModel.WenDuZhi">
														<p class="map-right-info-device1-row-item-p1">{{
															$t('smartElectricity.smarElectricity.218347-80') }}</p>
														<p class="map-right-info-device1-row-item-p2">
															{{ DeviceInfoBaseModel.WenDuZhi }}</p>
													</div>
												</div>
												<div class="map-right-info-device1-row"
													v-if="DeviceInfoBaseModel.baojingleixing || DeviceInfoBaseModel.fangcai">
													<div class="map-right-info-device1-row-item"
														v-if="DeviceInfoBaseModel.baojingleixing">
														<p class="map-right-info-device1-row-item-p1">{{
															$t('smartElectricity.smarElectricity.218347-77') }}</p>
														<p class="map-right-info-device1-row-item-p2">
															{{ DeviceInfoBaseModel.baojingleixing }}</p>
													</div>
													<div class="map-right-info-device1-row-item"
														v-if="DeviceInfoBaseModel.fangcai">
														<p class="map-right-info-device1-row-item-p1">{{
															$t('smartElectricity.smarElectricity.218347-78') }}</p>
														<p class="map-right-info-device1-row-item-p2">
															{{ DeviceInfoBaseModel.fangcai }}</p>
													</div>
												</div>
												<div class="map-right-info-device1-row"
													v-if="DeviceInfoBaseModel.CommandWenzi || DeviceInfoBaseModel.Commandma">
													<div class="map-right-info-device1-row-item"
														v-if="DeviceInfoBaseModel.CommandWenzi">
														<p class="map-right-info-device1-row-item-p1">{{
															$t('smartElectricity.smarElectricity.218347-77') }}</p>
														<p class="map-right-info-device1-row-item-p2">
															{{ DeviceInfoBaseModel.CommandWenzi }}</p>
													</div>
													<div class="map-right-info-device1-row-item"
														v-if="DeviceInfoBaseModel.Commandma">
														<p class="map-right-info-device1-row-item-p1">{{
															$t('smartElectricity.smarElectricity.218347-78') }}</p>
														<p class="map-right-info-device1-row-item-p2">
															{{ DeviceInfoBaseModel.Commandma }}</p>
													</div>
												</div>

												<template v-if="!DeviceInfoBaseModel.GongNengKaiGuanZhuangTai">
													<div class="map-right-info-device1-row">
														<div class="map-right-info-device1-row-item">
															<p class="map-right-info-device1-row-item-p1">{{
																$t('smartElectricity.smarElectricity.218347-81') }}</p>
															<p class="map-right-info-device1-row-item-p2">
																{{ DeviceDianCiModel.GongDianFangSi }}</p>
														</div>
														<div class="map-right-info-device1-row-item">
															<p class="map-right-info-device1-row-item-p1">{{
																$t('smartElectricity.smarElectricity.218347-82') }}</p>
															<p class="map-right-info-device1-row-item-p2">
																{{ DeviceDianCiModel.DianCiGongDian }}</p>
														</div>
													</div>
													<div class="map-right-info-device1-row">
														<div class="map-right-info-device1-row-item">
															<p class="map-right-info-device1-row-item-p1">{{
																$t('smartElectricity.smarElectricity.218347-83') }}</p>
															<p class="map-right-info-device1-row-item-p2">
																{{ DeviceDianCiModel.DianCiDianLiang }}</p>
														</div>
														<div class="map-right-info-device1-row-item">
															<p class="map-right-info-device1-row-item-p1">{{
																$t('smartElectricity.smarElectricity.218347-84') }}</p>
															<p class="map-right-info-device1-row-item-p2">
																{{ DeviceDianCiModel.DianCiDianYa }}{{
																	DeviceDianCiModel.DianYaDanWei }}
															</p>
														</div>
													</div>
													<div class="map-right-info-device1-row">
														<div class="map-right-info-device1-row-item">
															<p class="map-right-info-device1-row-item-p1">{{
																$t('smartElectricity.smarElectricity.218347-85') }}</p>
															<p class="map-right-info-device1-row-item-p2">
																{{ DeviceDianCiModel.DianCiDianLiangBaiFenBi }}</p>
														</div>
														<div class="map-right-info-device1-row-item">
															<p class="map-right-info-device1-row-item-p1">{{
																$t('smartElectricity.smarElectricity.218347-86') }}</p>
															<p class="map-right-info-device1-row-item-p2"
																:title="ZbDeviceModel.UpdateTime">
																{{ ZbDeviceModel.UpdateTime }}</p>
														</div>
													</div>
												</template>

												<div class="map-right-info-device1-row"
													v-if="DeviceInfoBaseModel.GongNengKaiGuanZhuangTai">
													<div class="map-right-info-device1-row-item">
														<p class="map-right-info-device1-row-item-p1">{{
															$t('smartElectricity.smarElectricity.218347-86') }}</p>
														<p class="map-right-info-device1-row-item-p2"
															:title="ZbDeviceModel.UpdateTime">
															{{ ZbDeviceModel.UpdateTime }}</p>
													</div>
												</div>

											</template>
										</div>
									</template>
								</div>

								<div class="map-right-device-chart" v-if="navDeviceIndex == 2">
									<div class="map-right-device-date">
										<DatePicker :open="open" :value="timeValue" :clearable="false" confirm type="date"
											@on-change="handleChange" @on-clear="handleClear" @on-ok="handleOk">
											<a href="javascript:void(0)" @click="handleClick">
												<Icon type="md-clipboard" />
												<template v-if="timeValue === ''">{{
													$t('smartElectricity.smarElectricity.218347-87') }}</template>
												<template v-else>{{ timeValue }}</template>
											</a>
										</DatePicker>
									</div>
									<div class="map-right-device-chart-box">
										<div class="map-right-device-chart-box-lists">
											<div class="ivu-tag3"
												:class="{ 'ivu-tag-green ivu-tag-text2': checkCode == 1, 'ivu-tag-text': checkCode != 1 }"
												@click="navDeviceCheckTab(1)">{{
													$t('smartElectricity.smarElectricity.218347-88') }}</div>
											<div class="ivu-tag3"
												:class="{ 'ivu-tag-green ivu-tag-text2': checkCode == 2, 'ivu-tag-text': checkCode != 2 }"
												@click="navDeviceCheckTab(2)">{{
													$t('smartElectricity.smarElectricity.218347-89') }}</div>
											<div class="ivu-tag3"
												:class="{ 'ivu-tag-green ivu-tag-text2': checkCode == 3, 'ivu-tag-text': checkCode != 3 }"
												@click="navDeviceCheckTab(3)">{{
													$t('smartElectricity.smarElectricity.218347-90') }}</div>
											<div class="ivu-tag3"
												:class="{ 'ivu-tag-green ivu-tag-text2': checkCode == 4, 'ivu-tag-text': checkCode != 4 }"
												@click="navDeviceCheckTab(4)">{{
													$t('smartElectricity.smarElectricity.218347-91') }}</div>
											<div class="ivu-tag3"
												:class="{ 'ivu-tag-green ivu-tag-text2': checkCode == 5, 'ivu-tag-text': checkCode != 5 }"
												@click="navDeviceCheckTab(5)">{{
													$t('smartElectricity.smarElectricity.218347-92') }}</div>
											<div class="ivu-tag3"
												:class="{ 'ivu-tag-green ivu-tag-text2': checkCode == 6, 'ivu-tag-text': checkCode != 6 }"
												@click="navDeviceCheckTab(6)">{{
													$t('smartElectricity.smarElectricity.218347-93') }}</div>
										</div>
										<div class="map-right-device-chart-box1" v-if="seriesMsg">
											<div id="myChart" style="width: 100%; height: 100%;"></div>
											<Spin size="large" fix v-if="seriesGetMsg"></Spin>
										</div>
										<div class="map-right-group-list-none" v-else>{{
											$t('smartElectricity.smarElectricity.218347-26') }}</div>
									</div>
								</div>

								<div class="map-right-device-history1" v-if="navDeviceIndex == 3">
									<div class="map-right-device-date">
										<DatePicker :open="open" :value="timeValue1" confirm type="date"
											@on-change="handleChange1" @on-clear="handleClear" @on-ok="handleOk">
											<a href="javascript:void(0)" @click="handleClick">
												<Icon type="md-clipboard" />
												<template v-if="timeValue1 === ''">{{
													$t('smartElectricity.smarElectricity.218347-87') }}</template>
												<template v-else>{{ timeValue1 }}</template>
											</a>
										</DatePicker>
									</div>
									<div class="map-right-device-history">
										<div class="map-right-device-history-lists"
											v-if="GetOneDeviceAbDataLists.length > 0">
											<div class="map-right-device-history-item"
												v-for="(item) in GetOneDeviceAbDataLists" :key="item.Id">
												<div class="map-right-device-history-item-time">{{ item.AbnormalTime }}
												</div>
												<div class="map-right-device-history-item-text" :title="item.AbnormalName">
													{{ item.AbnormalName }}</div>
												<div class="map-right-device-history-item-btn">
													<Dropdown trigger="click" style="margin-left: 1vw">
														<a href="javascript:void(0)">
															{{ $t('smartElectricity.smarElectricity.218347-94') }}
															<Icon type="ios-arrow-down"></Icon>
														</a>
														<DropdownMenu slot="list">
															<DropdownItem @click.native="SolveAbData(item.Id, 2)">{{
																$t('smartElectricity.smarElectricity.218347-95') }}
															</DropdownItem>
															<DropdownItem @click.native="SolveAbData(item.Id, 3)">{{
																$t('smartElectricity.smarElectricity.218347-96') }}
															</DropdownItem>
														</DropdownMenu>
													</Dropdown>
												</div>
											</div>
										</div>
										<div class="map-right-group-list-none" v-else>{{
											$t('smartElectricity.smarElectricity.218347-97') }}</div>
									</div>
								</div>

								<div class="map-right-device-set" v-if="navDeviceIndex == 4">
									<div class="map-right-device-set-lists">
										<Form :model="formThreshold" label-position="right">
											<template
												v-if="DeviceDetails.DeviceItemId == '0b4550c8-bbaa-43bb-9bf4-d8f6cd02766c'">
												<Collapse accordion>
													<!-- <Panel name="1">
                                短路保护
                                <div slot="content" style="width: 97%;">
                                  <FormItem label="短路跳闸定值" class="f12">
                                    <Input v-model="formThreshold.Duanlutiaozhadingzhi" placeholder="短路跳闸定值(0~100)">
                                    </Input>
                                  </FormItem>
                                  <FormItem label="短路告警定值" class="f12">
                                    <Input v-model="formThreshold.Duanlugaojingdingzhi" placeholder="短路告警定值(0~100)">
                                    </Input>
                                  </FormItem>
                                  <FormItem label="短路跳闸延迟" class="f12">
                                    <Input v-model="formThreshold.Duanlutiaozhayanshi" placeholder="短路跳闸延迟">
                                    <span slot="append">S</span>
                                    </Input>
                                  </FormItem>
                                  <FormItem label="短路告警延迟" class="f12">
                                    <Input v-model="formThreshold.Duanlugaojingyanshi" placeholder="短路告警延迟">
                                    <span slot="append">S</span>
                                    </Input>
                                  </FormItem>
                                  <FormItem label="短路告警投退" class="f12">
                                    <Select v-model="formThreshold.Duanlugaojingtoutui">
                                      <Option value="0">{{ $t('smartElectricity.smarElectricity.218347-104') }}</Option>
                                      <Option value="1">{{ $t('smartElectricity.smarElectricity.218347-105') }}</Option>
                                    </Select>
                                  </FormItem>
                                  <FormItem label="短路跳闸投退" class="f12">
                                    <Select v-model="formThreshold.Duanlutiaozhatoutui">
                                      <Option value="0">{{ $t('smartElectricity.smarElectricity.218347-104') }}</Option>
                                      <Option value="1">{{ $t('smartElectricity.smarElectricity.218347-105') }}</Option>
                                    </Select>
                                  </FormItem>
                                  <FormItem label="短路跳闸闭锁" class="f12">
                                    <Select v-model="formThreshold.Duanlutiaozhabisuo">
                                      <Option value="0">{{ $t('smartElectricity.smarElectricity.218347-104') }}</Option>
                                      <Option value="1">{{ $t('smartElectricity.smarElectricity.218347-105') }}</Option>
                                    </Select>
                                  </FormItem>
                                </div>
                            </Panel> -->
													<Panel name="2">
														{{ $t('smartElectricity.smarElectricity.218347-98') }}
														<div slot="content" style="width: 97%;">
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-99')"
																class="newf12">
																<Input v-model="formThreshold.Guoliutiaozhandingzhi" :placeholder="`${$t('smartElectricity.smarElectricity.218347-99')}(1-63)`">
																<span slot="append">A</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-100')"
																class="newf12">
																<Input v-model="formThreshold.Guoliugaojingdingzhi" :placeholder="$t('smartElectricity.smarElectricity.218347-100')">
																<span slot="append">A</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-101')"
																class="newf12">
																<Input v-model="formThreshold.Guoliutiaozhayanshi" :placeholder="$t('smartElectricity.smarElectricity.218347-101')">
																<span slot="append">S</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-102')"
																class="newf12">
																<Input v-model="formThreshold.Guoliugaojingyanshi" :placeholder="$t('smartElectricity.smarElectricity.218347-102')">
																<span slot="append">S</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-103')"
																class="newf12">
																<Select v-model="formThreshold.Guoliugaojingtoutui">
																	<Option value="0">{{
																		$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{
																		$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-106')"
																class="newf12">
																<Select v-model="formThreshold.Guoliutiaozhatoutui">
																	<Option value="0">{{
																		$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{
																		$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-107')"
																class="newf12">
																<Select v-model="formThreshold.Guoliutiaozhabisuo">
																	<Option value="0">{{
																		$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{
																		$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
														</div>
													</Panel>
													<Panel name="3">
														{{ $t('smartElectricity.smarElectricity.218347-108') }}
														<div slot="content" style="width: 97%;">
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-109')"
																class="newf12">
																<Input v-model="formThreshold.Guozaitiaozhadingzhi" :placeholder="$t('smartElectricity.smarElectricity.218347-109')">
																<span slot="append">W</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-110')"
																class="newf12">
																<Input v-model="formThreshold.Guozaigaojingdingzhi" :placeholder="$t('smartElectricity.smarElectricity.218347-110')">
																<span slot="append">W</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-111')"
																class="newf12">
																<Input v-model="formThreshold.Guozaitiaozhayanshi" :placeholder="$t('smartElectricity.smarElectricity.218347-111')">
																<span slot="append">S</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-112')"
																class="newf12">
																<Input v-model="formThreshold.Guozaigaojingyanshi" :placeholder="$t('smartElectricity.smarElectricity.218347-112')">
																<span slot="append">S</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-113')"
																class="newf12">
																<Select v-model="formThreshold.Guozaigaojingtoutui">
																	<Option value="0">{{
																		$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{
																		$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-114')"
																class="newf12">
																<Select v-model="formThreshold.Guozaitiaozhatoutui">
																	<Option value="0">{{
																		$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{
																		$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-115')"
																class="newf12">
																<Select v-model="formThreshold.Guozaitiaozhabisuo">
																	<Option value="0">{{
																		$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{
																		$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
														</div>
													</Panel>
													<Panel name="4">
														{{ $t('smartElectricity.smarElectricity.218347-116') }}
														<div slot="content" style="width: 97%;">
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-117')"
																class="newf12">
																<Input v-model="formThreshold.Loudiantiaozhadingzhi" :placeholder="$t('smartElectricity.smarElectricity.218347-117')">
																<span slot="append">mA</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-118')"
																class="newf12">
																<Input v-model="formThreshold.Loudiangaojingdingzhi" :placeholder="$t('smartElectricity.smarElectricity.218347-118')">
																<span slot="append">mA</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-119')"
																class="newf12">
																<Input v-model="formThreshold.Loudiantiaozhayanshi" :placeholder="$t('smartElectricity.smarElectricity.218347-119')">
																<span slot="append">S</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-120')"
																class="newf12">
																<Input v-model="formThreshold.Loudiangaojingyanshi" :placeholder="$t('smartElectricity.smarElectricity.218347-120')">
																<span slot="append">S</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-121')"
																class="newf12">
																<Select v-model="formThreshold.Loudiangaojingtoutui">
																	<Option value="0">{{
																		$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{
																		$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-122')"
																class="newf12">
																<Select v-model="formThreshold.Loudiantiaozhatoutui">
																	<Option value="0">{{
																		$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{
																		$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
														</div>
													</Panel>
													<Panel name="5">
														{{ $t('smartElectricity.smarElectricity.218347-123') }}
														<div slot="content" style="width: 97%;">
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-124')"
																class="newf12">
																<Input v-model="formThreshold.Guoyatiaozhadingzhi" :placeholder="$t('smartElectricity.smarElectricity.218347-124')">
																<span slot="append">V</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-125')"
																class="newf12">
																<Input v-model="formThreshold.Guoyagaojingdingzhi" :placeholder="$t('smartElectricity.smarElectricity.218347-125')">
																<span slot="append">V</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-126')"
																class="newf12">
																<Input v-model="formThreshold.Guoyatiaozhayanshi" :placeholder="$t('smartElectricity.smarElectricity.218347-126')">
																<span slot="append">S</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-127')"
																class="newf12">
																<Input v-model="formThreshold.Guoyagaojingyanshi" :placeholder="$t('smartElectricity.smarElectricity.218347-127')">
																<span slot="append">S</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-128')"
																class="newf12">
																<Select v-model="formThreshold.Guoyagaojingtoutui">
																	<Option value="0">{{
																		$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{
																		$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-129')"
																class="newf12">
																<Select v-model="formThreshold.Guoyatiaozhatoutui">
																	<Option value="0">{{
																		$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{
																		$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
														</div>
													</Panel>
													<Panel name="6">
														{{ $t('smartElectricity.smarElectricity.218347-130') }}
														<div slot="content" style="width: 97%;">
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-131')"
																class="newf12">
																<Input v-model="formThreshold.Qianyatiaozhadingzhi" :placeholder="$t('smartElectricity.smarElectricity.218347-131')">
																<span slot="append">V</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-132')"
																class="newf12">
																<Input v-model="formThreshold.Qianyagaojingdingzhi" :placeholder="$t('smartElectricity.smarElectricity.218347-132')">
																<span slot="append">V</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-133')"
																class="newf12">
																<Input v-model="formThreshold.Qianyatiaozhayanshi" :placeholder="$t('smartElectricity.smarElectricity.218347-133')">
																<span slot="append">S</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-134')"
																class="newf12">
																<Input v-model="formThreshold.Qianyagaojingyanshi" :placeholder="$t('smartElectricity.smarElectricity.218347-134')">
																<span slot="append">S</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-135')"
																class="newf12">
																<Select v-model="formThreshold.Qianyagaojingtoutui">
																	<Option value="0">{{
																		$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{
																		$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-136')"
																class="newf12">
																<Select v-model="formThreshold.Qianyatiaozhatoutui">
																	<Option value="0">{{
																		$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{
																		$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
														</div>
													</Panel>
													<Panel name="7">
														{{ $t('smartElectricity.smarElectricity.218347-137') }}
														<div slot="content" style="width: 97%;">
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-138')"
																class="newf12">
																<Input v-model="formThreshold.Guoyahuifuhezhadingzhi" :placeholder="$t('smartElectricity.smarElectricity.218347-138')">
																<span slot="append">V</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-139')"
																class="newf12">
																<Input v-model="formThreshold.Qianyahuifuhezhadingzhi" :placeholder="$t('smartElectricity.smarElectricity.218347-139')">
																<span slot="append">V</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-140')"
																class="newf12">
																<Input v-model="formThreshold.Guoyahuifuhezhayanshi" :placeholder="$t('smartElectricity.smarElectricity.218347-140')">
																<span slot="append">S</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-141')"
																class="newf12">
																<Input v-model="formThreshold.Qianyahuifuhezhayanshi" :placeholder="$t('smartElectricity.smarElectricity.218347-141')">
																<span slot="append">S</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-142')"
																class="newf12">
																<Select v-model="formThreshold.Guoyahuifuhezhatoutui">
																	<Option value="0">{{
																		$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{
																		$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-143')"
																class="newf12">
																<Select v-model="formThreshold.Qianyahuifuhezhatoutui">
																	<Option value="0">{{
																		$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{
																		$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
														</div>
													</Panel>
													<Panel name="8">
														{{ $t('smartElectricity.smarElectricity.218347-144') }}
														<div slot="content" style="width: 97%;">
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-145')"
																class="newf12">
																<Input v-model="formThreshold.Dianhutiaozhadingzhi" :placeholder="$t('smartElectricity.smarElectricity.218347-145')">
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-146')"
																class="newf12">
																<Input v-model="formThreshold.Dianhugaojingdingzhi" :placeholder="$t('smartElectricity.smarElectricity.218347-146')">
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-147')"
																class="newf12">
																<Input v-model="formThreshold.Dianhutiaozhayanshi" :placeholder="$t('smartElectricity.smarElectricity.218347-147')">
																<span slot="append">S</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-148')"
																class="newf12">
																<Input v-model="formThreshold.Dianhugaojingyanshi" :placeholder="$t('smartElectricity.smarElectricity.218347-148')">
																<span slot="append">S</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-149')"
																class="newf12">
																<Select v-model="formThreshold.Dianhugaojingtoutui">
																	<Option value="0">{{
																		$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{
																		$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-150')"
																class="newf12">
																<Select v-model="formThreshold.Dianhutiaozhatoutui">
																	<Option value="0">{{
																		$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{
																		$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
														</div>
													</Panel>
													<Panel name="9">
														{{ $t('smartElectricity.smarElectricity.218347-151') }}
														<div slot="content" style="width: 97%;">
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-152')"
																class="newf12">
																<Input v-model="formThreshold.Guowentiaozhadingzhi" :placeholder="$t('smartElectricity.smarElectricity.218347-152')">
																<span slot="append">℃</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-153')"
																class="newf12">
																<Input v-model="formThreshold.Guoweigaojingdingzhi" :placeholder="$t('smartElectricity.smarElectricity.218347-153')">
																<span slot="append">℃</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-154')"
																class="newf12">
																<Input v-model="formThreshold.Guowentiaozhayanshi" :placeholder="$t('smartElectricity.smarElectricity.218347-154')">
																<span slot="append">S</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-155')"
																class="newf12">
																<Input v-model="formThreshold.Guowengaojingyanshi" :placeholder="$t('smartElectricity.smarElectricity.218347-155')">
																<span slot="append">S</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-156')"
																class="newf12">
																<Select v-model="formThreshold.Guowengaojingtoutui">
																	<Option value="0">{{
																		$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{
																		$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-157')"
																class="newf12">
																<Select v-model="formThreshold.Guowentiaozhatoutui">
																	<Option value="0">{{
																		$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{
																		$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
														</div>
													</Panel>
													<!-- <Panel name="9" v-if="GetDeviceParameterModbusV3Struct.SanXiangBuPingHeng">
                                三相不平衡
                                <div slot="content" style="width: 97%;">
                                  <FormItem label="三相不平衡跳闸定值" class="newf12" v-if="GetDeviceParameterModbusV3Struct.SanXiangBuPingHeng.indexOf('Sanxiangbupinghengtiaozhadingzhi') > -1">
                                    <Input v-model="formThreshold.Sanxiangbupinghengtiaozhadingzhi" placeholder="三相不平衡跳闸定值">
                                      <span slot="append">V</span>
                                    </Input>
                                  </FormItem>
                                  <FormItem label="三相不平衡告警定值" class="newf12" v-if="GetDeviceParameterModbusV3Struct.SanXiangBuPingHeng.indexOf('Sanxiangbupinghenggaojingdingzhi') > -1">
                                    <Input v-model="formThreshold.Sanxiangbupinghenggaojingdingzhi" placeholder="三相不平衡告警定值">
                                      <span slot="append">V</span>
                                    </Input>
                                  </FormItem>
                                  <FormItem label="三相不平衡跳闸延时" class="newf12" v-if="GetDeviceParameterModbusV3Struct.SanXiangBuPingHeng.indexOf('Sanxiangbupinghengtiaozhayanshi') > -1">
                                    <Input v-model="formThreshold.Sanxiangbupinghengtiaozhayanshi" placeholder="三相不平衡跳闸延时">
                                    <span slot="append">S</span>
                                    </Input>
                                  </FormItem>
                                  <FormItem label="三相不平衡告警延时" class="newf12" v-if="GetDeviceParameterModbusV3Struct.SanXiangBuPingHeng.indexOf('Sanxiangbupinghenggaojingyanshi') > -1">
                                    <Input v-model="formThreshold.Sanxiangbupinghenggaojingyanshi" placeholder="三相不平衡告警延时">
                                    <span slot="append">S</span>
                                    </Input>
                                  </FormItem>
                                  <FormItem label="三相不平衡告警投退" class="newf12" v-if="GetDeviceParameterModbusV3Struct.SanXiangBuPingHeng.indexOf('Sanxiangbupinghenggaojingtoutui') > -1">
                                    <Select v-model="formThreshold.Sanxiangbupinghenggaojingtoutui">
                                      <Option value="0">{{ $t('smartElectricity.smarElectricity.218347-104') }}</Option>
                                      <Option value="1">{{ $t('smartElectricity.smarElectricity.218347-105') }}</Option>
                                    </Select>
                                  </FormItem>
                                  <FormItem label="三相不平衡跳闸投退" class="newf12" v-if="GetDeviceParameterModbusV3Struct.SanXiangBuPingHeng.indexOf('Sanxiangbupinghengtiaozhatoutui') > -1">
                                    <Select v-model="formThreshold.Sanxiangbupinghengtiaozhatoutui">
                                      <Option value="0">{{ $t('smartElectricity.smarElectricity.218347-104') }}</Option>
                                      <Option value="1">{{ $t('smartElectricity.smarElectricity.218347-105') }}</Option>
                                    </Select>
                                  </FormItem>
                                </div>
                            </Panel> -->
													<Panel name="10">
														{{ $t('smartElectricity.smarElectricity.218347-158') }}
														<div slot="content" style="width: 97%;">
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-159')"
																class="newf12">
																<Input v-model="formThreshold.Quexiangtiaozhadingzhi" :placeholder="$t('smartElectricity.smarElectricity.218347-159')">
																<span slot="append">V</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-160')"
																class="newf12">
																<Input v-model="formThreshold.Quexianggaojingdingzhi" :placeholder="$t('smartElectricity.smarElectricity.218347-160')">
																<span slot="append">V</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-161')"
																class="newf12">
																<Input v-model="formThreshold.Quexiangtiaozhayanshi" :placeholder="$t('smartElectricity.smarElectricity.218347-161')">
																<span slot="append">S</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-162')"
																class="newf12">
																<Input v-model="formThreshold.Quexianggaojingyanshi" :placeholder="$t('smartElectricity.smarElectricity.218347-162')">
																<span slot="append">S</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-163')"
																class="newf12">
																<Select v-model="formThreshold.Quexianggaojingtoutui">
																	<Option value="0">{{
																		$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{
																		$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-164')"
																class="newf12">
																<Select v-model="formThreshold.Quexiangtiaozhatoutui">
																	<Option value="0">{{
																		$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{
																		$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
														</div>
													</Panel>
													<Panel name="11">
														{{ $t('smartElectricity.smarElectricity.218347-165') }}
														<div slot="content" style="width: 97%;">
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-166')"
																class="newf12">
																<Input v-model="formThreshold.Bisuoshijian" :placeholder="$t('smartElectricity.smarElectricity.218347-166')">
																<span slot="append">S</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-167')"
																class="newf12">
																<Input v-model="formThreshold.Dongzuocishu" :placeholder="$t('smartElectricity.smarElectricity.218347-167')">
																<span slot="append">{{
																	$t('smartElectricity.smarElectricity.218347-19')
																}}</span>
																</Input>
															</FormItem>
														</div>
													</Panel>
													<!-- <Panel name="11" v-if="GetDeviceParameterModbusV3Struct.SiYaTiaoZa">
                                失压保护
                                <div slot="content" style="width: 97%;">
                                  <FormItem label="失压跳闸定值" class="newf12" v-if="GetDeviceParameterModbusV3Struct.SiYaTiaoZa.indexOf('Shiyatiaozhadingzhi') > -1">
                                    <Input v-model="formThreshold.Shiyatiaozhadingzhi" placeholder="失压跳闸定值">
                                    <span slot="append">V</span>
                                    </Input>
                                  </FormItem>
                                  <FormItem label="失压跳闸延迟" class="newf12" v-if="GetDeviceParameterModbusV3Struct.SiYaTiaoZa.indexOf('Shiyatiaozhayanshi') > -1">
                                    <Input v-model="formThreshold.Shiyatiaozhayanshi" placeholder="失压跳闸延迟">
                                    <span slot="append">S</span>
                                    </Input>
                                  </FormItem>
                                  <FormItem label="失压跳闸投退" class="newf12" v-if="GetDeviceParameterModbusV3Struct.SiYaTiaoZa.indexOf('Shiyatiaozhatoutui') > -1">
                                    <Select v-model="formThreshold.Shiyatiaozhatoutui">
                                      <Option value="0">{{ $t('smartElectricity.smarElectricity.218347-104') }}</Option>
                                      <Option value="1">{{ $t('smartElectricity.smarElectricity.218347-105') }}</Option>
                                    </Select>
                                  </FormItem>
                                </div>
                            </Panel>
                            <Panel name="12" v-if="GetDeviceParameterModbusV3Struct.YouYaHeZa">
                                有压保护
                                <div slot="content" style="width: 97%;">
                                  <FormItem label="有压合闸定值" class="newf12" v-if="GetDeviceParameterModbusV3Struct.YouYaHeZa.indexOf('Youyahezhadingzhi') > -1">
                                    <Input v-model="formThreshold.Youyahezhadingzhi" placeholder="有压合闸定值">
                                    <span slot="append">V</span>
                                    </Input>
                                  </FormItem>
                                  <FormItem label="有压合闸延迟" class="newf12" v-if="GetDeviceParameterModbusV3Struct.YouYaHeZa.indexOf('Youyahezhayanshi') > -1">
                                    <Input v-model="formThreshold.Youyahezhayanshi" placeholder="有压合闸延迟">
                                    <span slot="append">S</span>
                                    </Input>
                                  </FormItem>
                                  <FormItem label="有压合闸投退" class="newf12" v-if="GetDeviceParameterModbusV3Struct.YouYaHeZa.indexOf('Youyahezhatoutui') > -1">
                                    <Select v-model="formThreshold.Youyahezhatoutui">
                                      <Option value="0">{{ $t('smartElectricity.smarElectricity.218347-104') }}</Option>
                                      <Option value="1">{{ $t('smartElectricity.smarElectricity.218347-105') }}</Option>
                                    </Select>
                                  </FormItem>
                                </div>
                            </Panel>
                            <Panel name="13" v-if="GetDeviceParameterModbusV3Struct.QianFei">
                                欠费保护
                                <div slot="content" style="width: 97%;">
                                  <FormItem label="欠费跳闸定值" class="newf12" v-if="GetDeviceParameterModbusV3Struct.QianFei.indexOf('Qianfeitiaozhadingzhi') > -1">
                                    <Input v-model="formThreshold.Qianfeitiaozhadingzhi" placeholder="欠费跳闸定值">
                                    </Input>
                                  </FormItem>
                                  <FormItem label="欠费告警定值" class="newf12" v-if="GetDeviceParameterModbusV3Struct.QianFei.indexOf('Qianfeigaojingdingzhi') > -1">
                                    <Input v-model="formThreshold.Qianfeigaojingdingzhi" placeholder="欠费告警定值">
                                    </Input>
                                  </FormItem>
                                  <FormItem label="欠费跳闸延迟" class="newf12" v-if="GetDeviceParameterModbusV3Struct.QianFei.indexOf('Qianfeitiaozhayanshi') > -1">
                                    <Input v-model="formThreshold.Qianfeitiaozhayanshi" placeholder="欠费跳闸延迟">
                                    <span slot="append">S</span>
                                    </Input>
                                  </FormItem>
                                  <FormItem label="欠费告警延迟" class="newf12" v-if="GetDeviceParameterModbusV3Struct.QianFei.indexOf('Qianfeigaojingyanshi') > -1">
                                    <Input v-model="formThreshold.Qianfeigaojingyanshi" placeholder="欠费告警延迟">
                                    <span slot="append">S</span>
                                    </Input>
                                  </FormItem>
                                  <FormItem label="欠费告警投退" class="newf12" v-if="GetDeviceParameterModbusV3Struct.QianFei.indexOf('Qianfeigaojingtoutui') > -1">
                                    <Select v-model="formThreshold.Qianfeigaojingtoutui">
                                      <Option value="0">{{ $t('smartElectricity.smarElectricity.218347-104') }}</Option>
                                      <Option value="1">{{ $t('smartElectricity.smarElectricity.218347-105') }}</Option>
                                    </Select>
                                  </FormItem>
                                  <FormItem label="欠费跳闸投退" class="newf12" v-if="GetDeviceParameterModbusV3Struct.QianFei.indexOf('Qianfeitiaozhatoutui') > -1">
                                    <Select v-model="formThreshold.Qianfeitiaozhatoutui">
                                      <Option value="0">{{ $t('smartElectricity.smarElectricity.218347-104') }}</Option>
                                      <Option value="1">{{ $t('smartElectricity.smarElectricity.218347-105') }}</Option>
                                    </Select>
                                  </FormItem>
                                </div>
                            </Panel>
                            <Panel name="14" v-if="GetDeviceParameterModbusV3Struct.ChongHeZa">
                                重合闸保护
                                <div slot="content" style="width: 97%;">
                                  <FormItem label="重合次数" class="newf12" v-if="GetDeviceParameterModbusV3Struct.ChongHeZa.indexOf('Chonghezhacishu') > -1">
                                    <Input v-model="formThreshold.Chonghezhacishu" placeholder="重合次数(0~5)">
                                      <span slot="append">{{ $t('smartElectricity.smarElectricity.218347-19') }}</span>
                                    </Input>
                                  </FormItem>
                                  <FormItem label="重合间隔1" class="newf12" v-if="GetDeviceParameterModbusV3Struct.ChongHeZa.indexOf('Chonghezhajiange1') > -1">
                                    <Input v-model="formThreshold.Chonghezhajiange1" placeholder="重合间隔1">
                                      <span slot="append">S</span>
                                    </Input>
                                  </FormItem>
                                  <FormItem label="重合间隔2" class="newf12" v-if="GetDeviceParameterModbusV3Struct.ChongHeZa.indexOf('Chonghezhajiange2') > -1">
                                    <Input v-model="formThreshold.Chonghezhajiange2" placeholder="重合间隔2">
                                      <span slot="append">S</span>
                                    </Input>
                                  </FormItem>
                                  <FormItem label="重合间隔3" class="newf12" v-if="GetDeviceParameterModbusV3Struct.ChongHeZa.indexOf('Chonghezhajiange3') > -1">
                                    <Input v-model="formThreshold.Chonghezhajiange3" placeholder="重合间隔3">
                                      <span slot="append">S</span>
                                    </Input>
                                  </FormItem>
                                  <FormItem label="重合间隔4" class="newf12" v-if="GetDeviceParameterModbusV3Struct.ChongHeZa.indexOf('Chonghezhajiange4') > -1">
                                    <Input v-model="formThreshold.Chonghezhajiange4" placeholder="重合间隔4">
                                      <span slot="append">S</span>
                                    </Input>
                                  </FormItem>
                                  <FormItem label="重合间隔5" class="newf12" v-if="GetDeviceParameterModbusV3Struct.ChongHeZa.indexOf('Chonghezhajiange5') > -1">
                                    <Input v-model="formThreshold.Chonghezhajiange5" placeholder="重合间隔5">
                                      <span slot="append">S</span>
                                    </Input>
                                  </FormItem>
                                  <FormItem label="复归时间" class="newf12" v-if="GetDeviceParameterModbusV3Struct.ChongHeZa.indexOf('Fuguishijian') > -1">
                                    <Input v-model="formThreshold.Fuguishijian" placeholder="复归时间">
                                    <span slot="append">S</span>
                                    </Input>
                                  </FormItem>
                                  <FormItem label="重合闸投退" class="newf12" v-if="GetDeviceParameterModbusV3Struct.ChongHeZa.indexOf('Chonghezhatoutui') > -1">
                                    <Select v-model="formThreshold.Chonghezhatoutui">
                                      <Option value="0">{{ $t('smartElectricity.smarElectricity.218347-104') }}</Option>
                                      <Option value="1">{{ $t('smartElectricity.smarElectricity.218347-105') }}</Option>
                                    </Select>
                                  </FormItem>
                                </div>
                            </Panel> -->
												</Collapse>
											</template>
											<template v-else>
												<Collapse accordion>
													<Panel name="2">
														{{ $t('smartElectricity.smarElectricity.218347-98') }}
														<div slot="content" style="width: 97%;">
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-99')"
																class="newf12">
																<Input v-model="formThreshold.GuoLiuTZDZ" :placeholder="$t('smartElectricity.smarElectricity.218347-99')">
																<span slot="append">A</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-100')"
																class="newf12">
																<Input v-model="formThreshold.GuoLiuGJDZ" :placeholder="$t('smartElectricity.smarElectricity.218347-100')">
																<span slot="append">A</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-101')"
																class="newf12">
																<Input v-model="formThreshold.GuoLiuTZYC" :placeholder="$t('smartElectricity.smarElectricity.218347-101')">
																<span slot="append">S</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-102')"
																class="newf12">
																<Input v-model="formThreshold.GuoLiuGJYC" :placeholder="$t('smartElectricity.smarElectricity.218347-102')">
																<span slot="append">S</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-103')"
																class="newf12">
																<Select v-model="formThreshold.GuoLiuGJTT">
																	<Option value="0">{{
																		$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{
																		$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-106')"
																class="newf12">
																<Select v-model="formThreshold.GuoLiuTZTT">
																	<Option value="0">{{
																		$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{
																		$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-107')"
																class="newf12">
																<Select v-model="formThreshold.GuoLiuTZBS">
																	<Option value="0">{{
																		$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{
																		$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
														</div>
													</Panel>
													<Panel name="3">
														{{ $t('smartElectricity.smarElectricity.218347-123') }}
														<div slot="content" style="width: 97%;">
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-124')"
																class="newf12">
																<Input v-model="formThreshold.GuoYaTZDZ" :placeholder="$t('smartElectricity.smarElectricity.218347-124')">
																<span slot="append">V</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-125')"
																class="newf12">
																<Input v-model="formThreshold.GuoYaGJDZ" :placeholder="$t('smartElectricity.smarElectricity.218347-125')">
																<span slot="append">V</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-126')"
																class="newf12">
																<Input v-model="formThreshold.GuoYaTZYC" :placeholder="$t('smartElectricity.smarElectricity.218347-126')">
																<span slot="append">S</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-127')"
																class="newf12">
																<Input v-model="formThreshold.GuoYaGJYC" :placeholder="$t('smartElectricity.smarElectricity.218347-127')">
																<span slot="append">S</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-168')"
																class="newf12">
																<Input v-model="formThreshold.sanXiangGyHffz" :placeholder="$t('smartElectricity.smarElectricity.218347-168')">
																<span slot="append">V</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-128')"
																class="newf12">
																<Select v-model="formThreshold.GuoYaGJTT">
																	<Option value="0">{{
																		$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{
																		$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-129')"
																class="newf12">
																<Select v-model="formThreshold.GuoYaTZTT">
																	<Option value="0">{{
																		$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{
																		$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
														</div>
													</Panel>
													<Panel name="4">
														{{ $t('smartElectricity.smarElectricity.218347-130') }}
														<div slot="content" style="width: 97%;">
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-131')"
																class="newf12">
																<Input v-model="formThreshold.QianYaTZDZ" :placeholder="$t('smartElectricity.smarElectricity.218347-131')">
																<span slot="append">V</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-132')"
																class="newf12">
																<Input v-model="formThreshold.QianYaGJDZ" :placeholder="$t('smartElectricity.smarElectricity.218347-132')">
																<span slot="append">V</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-133')"
																class="newf12">
																<Input v-model="formThreshold.QianYaTZYC" :placeholder="$t('smartElectricity.smarElectricity.218347-133')">
																<span slot="append">S</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-134')"
																class="newf12">
																<Input v-model="formThreshold.QianYaGJYC" :placeholder="$t('smartElectricity.smarElectricity.218347-134')">
																<span slot="append">S</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-169')"
																class="newf12">
																<Input v-model="formThreshold.sanXiangQyHffz" :placeholder="$t('smartElectricity.smarElectricity.218347-169')">
																<span slot="append">V</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-170')"
																class="newf12">
																<Input v-model="formThreshold.guoqianyaHfshijian" :placeholder="$t('smartElectricity.smarElectricity.218347-170')">
																<span slot="append">V</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-135')"
																class="newf12">
																<Select v-model="formThreshold.QianYaGJTT">
																	<Option value="0">{{
																		$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{
																		$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-136')"
																class="newf12">
																<Select v-model="formThreshold.QianYaTZTT">
																	<Option value="0">{{
																		$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{
																		$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
														</div>
													</Panel>
													<Panel name="5">
														{{ $t('smartElectricity.smarElectricity.218347-116') }}
														<div slot="content" style="width: 97%;">
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-117')"
																class="newf12">
																<Input v-model="formThreshold.LouDianTZDZ" :placeholder="$t('smartElectricity.smarElectricity.218347-117')">
																<span slot="append">mA</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-118')"
																class="newf12">
																<Input v-model="formThreshold.LouDianGJDZ" :placeholder="$t('smartElectricity.smarElectricity.218347-118')">
																<span slot="append">mA</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-119')"
																class="newf12">
																<Input v-model="formThreshold.LouDianTZYC" :placeholder="$t('smartElectricity.smarElectricity.218347-119')">
																<span slot="append">S</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-120')"
																class="newf12">
																<Input v-model="formThreshold.LouDianGJYC" :placeholder="$t('smartElectricity.smarElectricity.218347-120')">
																<span slot="append">S</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-121')"
																class="newf12">
																<Select v-model="formThreshold.LouDianGJTT">
																	<Option value="0">{{
																		$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{
																		$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-122')"
																class="newf12">
																<Select v-model="formThreshold.LouDianTZTT">
																	<Option value="0">{{
																		$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{
																		$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
														</div>
													</Panel>
													<Panel name="6">
														{{ $t('smartElectricity.smarElectricity.218347-151') }}
														<div slot="content" style="width: 97%;">
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-152')"
																class="newf12">
																<Input v-model="formThreshold.GuoWenTZDZ" :placeholder="$t('smartElectricity.smarElectricity.218347-152')">
																<span slot="append">℃</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-153')"
																class="newf12">
																<Input v-model="formThreshold.GuoWenGJDZ" :placeholder="$t('smartElectricity.smarElectricity.218347-153')">
																<span slot="append">℃</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-154')"
																class="newf12">
																<Input v-model="formThreshold.GuoWenTZYC" :placeholder="$t('smartElectricity.smarElectricity.218347-154')">
																<span slot="append">S</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-155')"
																class="newf12">
																<Input v-model="formThreshold.GuoWenGJYC" :placeholder="$t('smartElectricity.smarElectricity.218347-155')">
																<span slot="append">S</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-156')"
																class="newf12">
																<Select v-model="formThreshold.GuoWenGJTT">
																	<Option value="0">{{
																		$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{
																		$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-157')"
																class="newf12">
																<Select v-model="formThreshold.GuoWenTZTT">
																	<Option value="0">{{
																		$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{
																		$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
														</div>
													</Panel>
													<Panel name="7">
														{{ $t('smartElectricity.smarElectricity.218347-144') }}
														<div slot="content" style="width: 97%;">
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-145')"
																class="newf12">
																<Input v-model="formThreshold.DianHuTZDZ" :placeholder="$t('smartElectricity.smarElectricity.218347-145')">
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-146')"
																class="newf12">
																<Input v-model="formThreshold.DianHuGJDZ" :placeholder="$t('smartElectricity.smarElectricity.218347-146')">
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-147')"
																class="newf12">
																<Input v-model="formThreshold.DianHuTZYC" :placeholder="$t('smartElectricity.smarElectricity.218347-147')">
																<span slot="append">S</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-148')"
																class="newf12">
																<Input v-model="formThreshold.DianHuGJYC" :placeholder="$t('smartElectricity.smarElectricity.218347-148')">
																<span slot="append">S</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-149')"
																class="newf12">
																<Select v-model="formThreshold.DianHuGJTT">
																	<Option value="0">{{
																		$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{
																		$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-150')"
																class="newf12">
																<Select v-model="formThreshold.DianHuTZTT">
																	<Option value="0">{{
																		$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{
																		$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
														</div>
													</Panel>
													<Panel name="8">
														{{ $t('smartElectricity.smarElectricity.218347-108') }}
														<div slot="content" style="width: 97%;">
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-109')"
																class="newf12">
																<Input v-model="formThreshold.GuoZaiTZDZ" :placeholder="$t('smartElectricity.smarElectricity.218347-109')">
																<span slot="append">W</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-110')"
																class="newf12">
																<Input v-model="formThreshold.GuoZaiGJDZ" :placeholder="$t('smartElectricity.smarElectricity.218347-110')">
																<span slot="append">W</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-111')"
																class="newf12">
																<Input v-model="formThreshold.GuoZaiTZYC" :placeholder="$t('smartElectricity.smarElectricity.218347-111')">
																<span slot="append">S</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-112')"
																class="newf12">
																<Input v-model="formThreshold.GuoZaiGJYC" :placeholder="$t('smartElectricity.smarElectricity.218347-112')">
																<span slot="append">S</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-113')"
																class="newf12">
																<Select v-model="formThreshold.GuoZaiGJTT">
																	<Option value="0">{{$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-114')"
																class="newf12">
																<Select v-model="formThreshold.GuoZaiTZTT">
																	<Option value="0">{{
																		$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{
																		$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-115')"
																class="newf12">
																<Select v-model="formThreshold.GuoZaiTZBS">
																	<Option value="0">{{
																		$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{
																		$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
														</div>
													</Panel>
													<Panel name="9">
														{{ $t('smartElectricity.smarElectricity.218347-158') }}
														<div slot="content" style="width: 97%;">
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-159')"
																class="newf12">
																<Input v-model="formThreshold.QueXiangTZDZ" :placeholder="$t('smartElectricity.smarElectricity.218347-159')">
																<span slot="append">V</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-160')"
																class="newf12">
																<Input v-model="formThreshold.QueXiangGJDZ" :placeholder="$t('smartElectricity.smarElectricity.218347-160')">
																<span slot="append">V</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-161')"
																class="newf12">
																<Input v-model="formThreshold.QueXiangTZYC" :placeholder="$t('smartElectricity.smarElectricity.218347-161')">
																<span slot="append">S</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-162')"
																class="newf12">
																<Input v-model="formThreshold.QueXiangGJYC" :placeholder="$t('smartElectricity.smarElectricity.218347-162')">
																<span slot="append">S</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-163')"
																class="newf12">
																<Select v-model="formThreshold.QueXiangGJTT">
																	<Option value="0">{{
																		$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{
																		$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-164')"
																class="newf12">
																<Select v-model="formThreshold.QueXiangTZTT">
																	<Option value="0">{{
																		$t('smartElectricity.smarElectricity.218347-104') }}
																	</Option>
																	<Option value="1">{{
																		$t('smartElectricity.smarElectricity.218347-105') }}
																	</Option>
																</Select>
															</FormItem>
														</div>
													</Panel>
													<Panel name="10">
														{{ $t('smartElectricity.smarElectricity.218347-171') }}
														<div slot="content" style="width: 97%;">
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-172')"
																class="newf12">
																<Input v-model="formThreshold.DianLiangCCJG"  :placeholder="$t('smartElectricity.smarElectricity.218347-172')">
																<span slot="append">min</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-173')"
																class="newf12">
																<Input v-model="formThreshold.LiJiCCDLFZ" :placeholder="$t('smartElectricity.smarElectricity.218347-173')">
																<span slot="append">kwh</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-174')"
																class="newf12">
																<Input v-model="formThreshold.JianGeDianLiangCCFZ" :placeholder="$t('smartElectricity.smarElectricity.218347-174')">
																<span slot="append">kwh</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-175')"
																class="newf12">
																<Input v-model="formThreshold.DianLiang"
																	:placeholder="$t('smartElectricity.smarElectricity.218347-175')">
																<span slot="append">kwh</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-176')"
																class="newf12">
																<Input v-model="formThreshold.SJCQZDCS" :placeholder="$t('smartElectricity.smarElectricity.218347-176')">
																<span slot="append">{{
																	$t('smartElectricity.smarElectricity.218347-19')
																}}</span>
																</Input>
															</FormItem>
															<FormItem
																:label="$t('smartElectricity.smarElectricity.218347-177')"
																class="newf12">
																<Input v-model="formThreshold.XTYCCQCS" :placeholder="$t('smartElectricity.smarElectricity.218347-177')">
																<span slot="append">{{
																	$t('smartElectricity.smarElectricity.218347-19')
																}}</span>
																</Input>
															</FormItem>
														</div>
													</Panel>
												</Collapse>
											</template>
										</Form>
									</div>

									<Col span="24"
										style="position: absolute; bottom: 1vw; left: 0; display: flex; justify-content: center;">
									<Button type="primary" style="font-size: 0.6vw; margin-right: 0.5vw;"
										@click="setThreshold">{{ $t('smartElectricity.smarElectricity.218347-178')
										}}</Button>
									<template v-if="DeviceDetails.DeviceItemId == '0b4550c8-bbaa-43bb-9bf4-d8f6cd02766c'">
										<Button type="success" style="font-size: 0.6vw;" @click="DeviceRWByType">{{
											$t('smartElectricity.smarElectricity.218347-179') }}</Button>
									</template>
									<template v-else>
										<Button type="success" style="font-size: 0.6vw; margin-right: 0.5vw;"
											@click="DeviceRWByType(1)">{{ $t('smartElectricity.smarElectricity.218347-179')
											}}1</Button>
										<Button type="success" style="font-size: 0.6vw;" @click="DeviceRWByType(2)">{{
											$t('smartElectricity.smarElectricity.218347-179') }}2</Button>
									</template>
									</Col>
								</div>
							</div>
						</div>
						<Spin size="large" fix v-if="!DeviceDetailsMsg"></Spin>
					</div>

					<div class="map-right-show" @click="navShouRight">
						<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAKCAYAAABmBXS+AAAA4klEQVQYlU3QMUoDQRjF8V+CxsZm9wgeYARbKw8hyi4xImKjlW0Ez2CpoI0ZEAux8hSC7DbiJaawsIhKZMIm+OBj5mP+37w3o6ial6JqtmazWd6PiqqZFFUzyP2i+njGXVm3m3jCCm7Lus3rXP0Uww2uELGRYtjHOu7Lul3LUC9fl1XW7TFOUeMdj/jE2RLqwAoX2MUHHjDNmf5r2mXK9dv1gyVU1u0Ql9hLMTSY4Aej+Qs6m3HOk2J4K+s22+SzgxTDV6+omiOc47ALfI1VDFMM2W7+Tzs4STG8YhvfeWABwB+velPcmJqgsgAAAABJRU5ErkJggg=="
							alt="">
					</div>
				</div>

				<div class="map-bottom" :class="{ 'hiddenBottom': !showIndex1, 'shaky': jitterMsg }">
					<div class="map-bottom-title">
						{{ $t('smartElectricity.smarElectricity.218347-182') }}
					</div>
					<div class="map-bottom-content">
						<div class="map-bottom-content-tab">
							<!-- <div class="map-bottom-content-tab-item">区域</div> -->
							<div class="map-bottom-content-tab-item">{{ $t('smartElectricity.smarElectricity.218347-183') }}
							</div>
							<div class="map-bottom-content-tab-item">{{ $t('smartElectricity.smarElectricity.218347-184') }}
							</div>
							<div class="map-bottom-content-tab-item">{{ $t('smartElectricity.smarElectricity.218347-185') }}
							</div>
							<div class="map-bottom-content-tab-item">{{ $t('smartElectricity.smarElectricity.218347-186') }}
							</div>
							<div class="map-bottom-content-tab-item">{{ $t('smartElectricity.smarElectricity.218347-187') }}
							</div>
							<div class="map-bottom-content-tab-item">{{ $t('smartElectricity.smarElectricity.218347-188') }}
							</div>
							<div class="map-bottom-content-tab-item tabHandle">{{
								$t('smartElectricity.smarElectricity.218347-189') }}</div>
						</div>
						<div class="map-bottom-list" id="wrapper">
							<div id="content" class="map-bottom-lists" v-if="GetAbDataLists.length > 0">
								<div class="map-bottom-list-item" v-for="(item, index) in GetAbDataLists" :key="index">
									<!-- <div class="map-bottom-list-item-group">{{item.Unit}}</div> -->
									<div class="map-bottom-list-item-device">{{ item.UserDeviceName }}</div>
									<div class="map-bottom-list-item-addr">{{ item.DeviceCode }}</div>
									<div class="map-bottom-list-item-addr">{{ item.OwnerName }}</div>
									<div class="map-bottom-list-item-addr" :title="item.AddressDetail">
										{{ item.AddressDetail }}</div>
									<div class="map-bottom-list-item-date">{{ item.AbnormalTime }}</div>
									<div class="map-bottom-list-item-type">{{ item.AbnormalName }}</div>
									<div class="map-bottom-list-item-handle">
										<div class="ivu-dropdown">

											<div class="" style="margin-top: 0.1vw;">
												<div class="map-bottom-list-item-handle-btn">
													<Dropdown trigger="click">
														<a href="javascript:void(0)">
															{{ $t('smartElectricity.smarElectricity.218347-94') }}
															<Icon type="md-arrow-dropdown" style="margin-left: 0.5vw;" />
														</a>
														<DropdownMenu slot="list" style="width: 5vw;">
															<DropdownItem @click.native="SolveAbData(item.Id, 2)">{{
																$t('smartElectricity.smarElectricity.218347-95') }}
															</DropdownItem>
															<DropdownItem @click.native="SolveAbData(item.Id, 3)">{{
																$t('smartElectricity.smarElectricity.218347-96') }}
															</DropdownItem>
														</DropdownMenu>
													</Dropdown>

												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div id="fakeContent" class="map-bottom-lists">
								<div class="map-bottom-list-item" v-for="(item, index) in GetAbDataLists" :key="index">
									<!-- <div class="map-bottom-list-item-group">{{item.Unit}}</div> -->
									<div class="map-bottom-list-item-device">{{ item.UserDeviceName }}</div>
									<div class="map-bottom-list-item-addr">{{ item.DeviceCode }}</div>
									<div class="map-bottom-list-item-addr">{{ item.OwnerName }}</div>
									<div class="map-bottom-list-item-addr" :title="item.AddressDetail">
										{{ item.AddressDetail }}</div>
									<div class="map-bottom-list-item-date">{{ item.AbnormalTime }}</div>
									<div class="map-bottom-list-item-type">{{ item.AbnormalName }}</div>
									<div class="map-bottom-list-item-handle">
										<div class="ivu-dropdown">

											<div class="" style="margin-top: 0.1vw;">
												<div class="map-bottom-list-item-handle-btn">
													<Dropdown trigger="click" style="width: 5vw;">
														<a href="javascript:void(0)">
															{{ $t('smartElectricity.smarElectricity.218347-94') }}
															<Icon type="md-arrow-dropdown" style="margin-left: 0.5vw;" />
														</a>
														<DropdownMenu slot="list" style="width: 5vw;">
															<DropdownItem @click.native="SolveAbData(item.Id, 2)">{{
																$t('smartElectricity.smarElectricity.218347-95') }}
															</DropdownItem>
															<DropdownItem @click.native="SolveAbData(item.Id, 3)">{{
																$t('smartElectricity.smarElectricity.218347-96') }}
															</DropdownItem>
														</DropdownMenu>
													</Dropdown>

												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="map-right-group-list-none" v-if="GetAbDataLists.length == 0">{{
								$t('smartElectricity.smarElectricity.218347-190') }}</div>
						</div>
					</div>
					<Spin size="large" fix v-if="!GetAbDataListsMsg"></Spin>
					<div class="map-bottom-show" @click="navShouButtom">
						<img v-if="showIndex1"
							:src="themeCode === 'default' ? require('../../assets/default/bottom_arrow.png') : require('../../assets/electricity/bottom_arrow.png')">
						<img v-else
							:src="themeCode === 'default' ? require('../../assets/default/top_arrow1.png') : require('../../assets/electricity/top_arrow1.png')">
					</div>
					<div class="map-bottom-back-img" @click="submit107()">
						{{ $t('smartElectricity.smarElectricity.218347-191') }}
						<!-- <img v-if="themeCode === 'default'" src="../../assets/default/rigth_arrow.png" alt=""> -->
						<img
							src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAaCAYAAABCfffNAAACS0lEQVRIiY2WO2/UQBDHZx/OnXHuREMgIJKjgoYG0fIlKCgQFQUhUaTjg1AFhYhTKiRESQWfgYYG0dEQECgIEMW9nOwLOdxZ4/Hs+UZare1d/387M571ivdHDhgT9UdRC7GBuWlyT8WbYIHMYYEYIpa4bgIIdF2DcIBYT1cdECCgd0pQLFwCNQ6IRQUCUa8CB6GAGIx6QT2sLGBRTuZNEhA2j0CeCWUZriZx3HMr9rMmEagSLvoiDZHsdc2bK5m7BQBqo2Me9LrmsK1DWtzP3lezxoX3TFMicQ4kfYC3ifL765m7+fdEvYMAyaXUPluRoYVA2GOqV/GEK0TxdZi8dF4MWsoPMh2ufRkmWwCwejmzB6kObSZvtXLgwlXz7NtIv3ZevGhrv3cxdTeORsnDIp9rqX2aJeEcE6oKjEIoSCDQK+vlQZr4w7XUXf8+1tsCoHshtXs1BWIcZJGdiv950DaIYmc9BYCVBfPPjCtGrtDC1VV3T0m/O7Vy6+dEfdrsmOcAYP9MVb+m0AChe9AMYO9qGZ7kVu4cT9THzY4ZFB79ynV/bMQILYi2GoTbVcNGx9yXAnZPnHw8NPJzr2P2i8HjiX6UO5GjascRqERFRgbKrUIKuGO87P8Yqw/nW/42AJjfud7OnZgCgEMATyq+tOLPyO28uMBiNRCIeCB9OUdHfjbz3pMF0PwFAguMRjQn2F3PFCn9AtmEcxAMo2Bum4/B6PMSUvvRMGKxAwMnDrFwUUEOtOw9e5Cgq208Sy0JrkHwpMaz1NLjAPAPymb7CJi2SacAAAAASUVORK5CYII=">
					</div>
				</div>

				<div class="map-top" :class="{ 'hiddenTop': !userListHideIndex }" id="map-top">

					<div class="add-community-view" v-if="userListHideMsg == 1">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-192') }}
						</div>
						<div class="add-community-view-input-div">
							<div class="add-community-view-input-div-lists">
								<Form :model="formCommunity" label-position="right">
									<Col span="24">
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-193')" class="f12"
										style="margin-right: 10%;">
										<Input v-model="formCommunity.Vname"
											:placeholder="$t('smartElectricity.smarElectricity.218347-194')"></Input>
									</FormItem>
									</Col>
									</Col>

									<Row>
										<Col span="8">
										<div class="f12 ivu-form-item">
											<div style="width: 4.25vw; text-align: right; float: left;">
												<p class="f12-label" style="line-height: 1.7vw;">{{$t('smartElectricity.smarElectricity.218347-195') }}</p>
											</div>
											<div class="ivu-form-item-content"
												style="margin-left: 5vw; overflow: hidden; margin-right:1.8vw;">
												<div
													class="ivu-input-wrapper ivu-input-wrapper-default ivu-input-type-text">
													<input type="text" id="suggestId" name="address_detail"
														:placeholder="$t('smartElectricity.smarElectricity.218347-41')"
														class="input_style ivu-input ivu-input-default">
													<div id="allmap1" style="width: 0px; height: 0px;"></div>
												</div>
											</div>
										</div>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-196')" class="f12"
											style="margin-right: 10%;">
											<Input disabled v-model="userlocation.lng"
												:placeholder="$t('smartElectricity.smarElectricity.218347-196')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-197')" class="f12"
											style="margin-right: 10%;">
											<Input disabled v-model="userlocation.lat"
												:placeholder="$t('smartElectricity.smarElectricity.218347-197')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-198')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formCommunity.Remarks"
												:placeholder="$t('smartElectricity.smarElectricity.218347-199')"></Input>
										</FormItem>
										</Col>
									</Row>

								</Form>
							</div>
							<Col span="24" style="position: absolute; bottom: 0.75vw; left: 6vw;">
							<Button type="primary" style="font-size: 0.6vw;" @click="AddRoshVillage">{{
								$t('smartElectricity.smarElectricity.218347-200') }}</Button>
							<Button style="font-size: 0.6vw; margin-left: 0.5vw;" @click="userListHide(false)">{{
								$t('smartElectricity.smarElectricity.218347-201') }}</Button>
							</Col>
						</div>
					</div>

					<div class="user-view" v-if="userListHideMsg == 2">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-202') }}
						</div>
						<div class="user-view-add">
							<div @click="addModel(6)" class="ivu-tag2 ivu-tag-green ivu-tag-text2">{{
								$t('smartElectricity.smarElectricity.218347-203') }}</div>
						</div>
						<div class="user-lists">
							<div class="map-top-content-tab">
								<div class="map-top-content-tab-item">{{ $t('smartElectricity.smarElectricity.218347-204')
								}}</div>
								<div class="map-top-content-tab-item">{{ $t('smartElectricity.smarElectricity.218347-205')
								}}</div>
								<div class="map-top-content-tab-item">{{ $t('smartElectricity.smarElectricity.218347-206')
								}}</div>
								<div class="map-top-content-tab-item">{{ $t('smartElectricity.smarElectricity.218347-207')
								}}</div>
								<div class="map-top-content-tab-item">{{ $t('smartElectricity.smarElectricity.218347-208')
								}}</div>
								<div class="map-top-content-tab-item tabHandle1">{{
									$t('smartElectricity.smarElectricity.218347-189') }}</div>
							</div>
							<div class="user-top-list">
								<div class="user-top-lists" v-if="LoaderUserLists.length > 0">
									<div class="map-top-list-item" v-for="(item) in LoaderUserLists" :key="item.Id">
										<div class="map-top-list-item-group">{{ item.LoginCode }}</div>
										<div class="map-top-list-item-device">{{ item.Phone }}</div>
										<div class="map-top-list-item-addr">{{ item.Email }}</div>
										<div class="map-top-list-item-date">{{ item.Address }}</div>
										<div class="map-top-list-item-type">{{ item.IsAdmin == 1 ?
											$t('smartElectricity.smarElectricity.218347-209') :
											$t('smartElectricity.smarElectricity.218347-210') }}</div>
										<div class="map-top-list-item-handle">
											<div class="ivu-tag2 ivu-tag-cyan ivu-tag-text1"
												@click="addModel(userListHideMsg + 8, item)">{{
													$t('smartElectricity.smarElectricity.218347-64') }}</div>
											<div class="ivu-tag2 ivu-tag-orange ivu-tag-text3" @click="DeleteUser(item.Id)">
												{{ $t('smartElectricity.smarElectricity.218347-66') }}</div>
										</div>
									</div>
								</div>
								<div class="map-right-group-list-none" v-else>{{
									$t('smartElectricity.smarElectricity.218347-211') }}</div>
							</div>
							<div class="user-top-list-page">
								<Page :total="UserTotalCount" @on-change="userChange" @on-page-size-change="userSizeChange"
									size="small" show-elevator show-sizer show-total placement="top" />
							</div>
						</div>
						<Spin size="large" fix v-if="!LoaderUserListsMsg"></Spin>
					</div>

					<div class="user-view" v-if="userListHideMsg == 3">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-212') }}
						</div>
						<div class="user-view-add">
							<div @click="addModel(userListHideMsg + 4)" class="ivu-tag2 ivu-tag-green ivu-tag-text2">
								{{ $t('smartElectricity.smarElectricity.218347-213') }}</div>
						</div>
						<div class="user-lists">
							<div class="map-top-content-tab">
								<div class="map-top-content-tab-item">{{ $t('smartElectricity.smarElectricity.218347-214')
								}}</div>
								<div class="map-top-content-tab-item">{{ $t('smartElectricity.smarElectricity.218347-215')
								}}</div>
								<div class="map-top-content-tab-item">{{ $t('smartElectricity.smarElectricity.218347-216')
								}}</div>
								<div class="map-top-content-tab-item">{{ $t('smartElectricity.smarElectricity.218347-217')
								}}</div>
								<div class="map-top-content-tab-item">{{ $t('smartElectricity.smarElectricity.218347-198')
								}}</div>
								<div class="map-top-content-tab-item tabHandle1">{{
									$t('smartElectricity.smarElectricity.218347-189') }}</div>
							</div>
							<div class="user-top-list">
								<div class="user-top-lists" v-if="GetDepartlists.length > 0">
									<div class="map-top-list-item" v-for="(item) in GetDepartlists" :key="item.Id">
										<div class="map-top-list-item-group">{{ item.DepartmentCode }}</div>
										<div class="map-top-list-item-device">{{ item.DepartmentName }}</div>
										<div class="map-top-list-item-addr">{{ item.CreateUser }}</div>
										<div class="map-top-list-item-date">{{ item.CreateDate }}</div>
										<div class="map-top-list-item-type">{{ item.Remarks }}</div>
										<div class="map-top-list-item-handle">
											<div class="ivu-tag2 ivu-tag-text4"
												@click="addModel(userListHideMsg + 16, item)">{{
													$t('smartElectricity.smarElectricity.218347-218') }}</div>
											<div class="ivu-tag2 ivu-tag-green ivu-tag-text2"
												@click="addModel(userListHideMsg + 12, item)">{{
													$t('smartElectricity.smarElectricity.218347-219') }}</div>
											<div class="ivu-tag2 ivu-tag-cyan ivu-tag-text1"
												@click="addModel(userListHideMsg + 8, item)">{{
													$t('smartElectricity.smarElectricity.218347-64') }}</div>
											<div class="ivu-tag2 ivu-tag-orange ivu-tag-text3"
												@click="DeleteDepartment(item.Id, item.DepartmentCode)">{{
													$t('smartElectricity.smarElectricity.218347-66') }}</div>
										</div>
									</div>
								</div>
								<div class="map-right-group-list-none" v-else>{{
									$t('smartElectricity.smarElectricity.218347-220') }}</div>
							</div>
							<div class="user-top-list-page">
								<Page :total="DepartTotalCount" @on-change="departChange"
									@on-page-size-change="departSizeChange" size="small" show-elevator show-sizer show-total
									placement="top" />
							</div>
						</div>
						<Spin size="large" fix v-if="!GetDepartlistsMsg"></Spin>
					</div>

					<div class="user-view" v-if="userListHideMsg == 4">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-221') }}
						</div>
						<div class="user-view-add">
							<div @click="addModel(userListHideMsg + 4)" class="ivu-tag2 ivu-tag-green ivu-tag-text2">
								{{ $t('smartElectricity.smarElectricity.218347-222') }}</div>
						</div>
						<div class="user-lists">
							<div class="map-top-content-tab">
								<div class="map-top-content-tab-item">{{ $t('smartElectricity.smarElectricity.218347-223')
								}}</div>
								<div class="map-top-content-tab-item">{{ $t('smartElectricity.smarElectricity.218347-224')
								}}</div>
								<div class="map-top-content-tab-item">{{ $t('smartElectricity.smarElectricity.218347-225')
								}}</div>
								<div class="map-top-content-tab-item">{{ $t('smartElectricity.smarElectricity.218347-41') }}
								</div>
								<div class="map-top-content-tab-item">{{ $t('smartElectricity.smarElectricity.218347-217')
								}}</div>
								<div class="map-top-content-tab-item tabHandle1">{{
									$t('smartElectricity.smarElectricity.218347-189') }}</div>
							</div>
							<div class="user-top-list">
								<div class="user-top-lists" v-if="GetCompanylists.length > 0">
									<div class="map-top-list-item" v-for="(item) in GetCompanylists" :key="item.Id">
										<div class="map-top-list-item-group">{{ item.CompanyCode }}</div>
										<div class="map-top-list-item-device">{{ item.CompanyName }}</div>
										<div class="map-top-list-item-addr">{{ item.Phone }}</div>
										<div class="map-top-list-item-date">{{ item.Address }}</div>
										<div class="map-top-list-item-type">{{ item.CreateDate }}</div>
										<div class="map-top-list-item-handle">
											<div class="ivu-tag2 ivu-tag-cyan ivu-tag-text1"
												@click="addModel(userListHideMsg + 8, item)">{{
													$t('smartElectricity.smarElectricity.218347-64') }}</div>
											<div class="ivu-tag2 ivu-tag-orange ivu-tag-text3"
												@click="DeleteCompany(item.Id)">{{
													$t('smartElectricity.smarElectricity.218347-66') }}</div>
										</div>
									</div>
								</div>
								<div class="map-right-group-list-none" v-else>{{
									$t('smartElectricity.smarElectricity.218347-226') }}</div>
							</div>
							<div class="user-top-list-page">
								<Page :total="CompanyTotalCount" @on-change="companyChange"
									@on-page-size-change="companySizeChange" size="small" show-elevator show-sizer
									show-total placement="top" />
							</div>
						</div>
						<Spin size="large" fix v-if="!GetCompanylistsMsg"></Spin>
					</div>


					<div class="user-view" v-if="userListHideMsg == 135">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-7') }}
						</div>
						<div class="user-view-add">
							<div @click="addModel(136)" class="ivu-tag2 ivu-tag-green ivu-tag-text2">
								{{ $t('smartElectricity.smarElectricity.218347-227') }}</div>
						</div>
						<div class="user-lists">
							<div class="map-top-content-tab">
								<div class="map-top-content-tab-item">{{ $t('smartElectricity.smarElectricity.218347-228')
								}}</div>
								<div class="map-top-content-tab-item">{{ $t('smartElectricity.smarElectricity.218347-229')
								}}</div>
								<div class="map-top-content-tab-item">{{ $t('smartElectricity.smarElectricity.218347-189')
								}}</div>
							</div>
							<div class="user-top-list">
								<div class="user-top-lists" v-if="GetbusinessMoneylists.length > 0">
									<div id="money" class="map-top-list-item" v-for="(item) in GetbusinessMoneylists"
										:key="item.Id">
										<div class="map-top-list-item-group">{{ item.BuyType == 1 ?
											$t('smartElectricity.smarElectricity.218347-230') : (item.BuyType == 2
												? $t('smartElectricity.smarElectricity.218347-231') : (item.BuyType == 3 ?
													$t('smartElectricity.smarElectricity.218347-232') : item.BuyType)) }}</div>
										<div class="map-top-list-item-device" style="margin-left: 1.3vw;">{{ item.BuyPrice
										}}{{ $t('smartElectricity.smarElectricity.218347-233') }}
										</div>
										<div class="map-top-list-item-handle">
											<div class="ivu-tag2 ivu-tag-cyan ivu-tag-text1"
												@click="ModifybusinessMoney(188, item)">{{
													$t('smartElectricity.smarElectricity.218347-64') }}</div>
											<div class="ivu-tag2 ivu-tag-orange ivu-tag-text3"
												@click="DeletebusinessMoney(item.Id)">{{
													$t('smartElectricity.smarElectricity.218347-66') }}</div>
										</div>
									</div>
								</div>
								<div class="map-right-group-list-none" v-else>{{
									$t('smartElectricity.smarElectricity.218347-226') }}</div>
							</div>
							<div class="user-top-list-page">
								<Page :total="BusinessMoneyTotalCount" @on-change="BusinessMoneyChange"
									@on-page-size-change="BusinessMoneySizeChange" size="small" show-elevator show-sizer
									show-total placement="top" />
							</div>
						</div>
						<Spin size="large" fix v-if="!GetBusinessMoneyMsg"></Spin>
					</div>

					<div class="add-user-view" v-if="userListHideMsg == 136">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-234') }}
						</div>
						<div class="add-community-view-input-div">
							<div class="add-community-view-input-div-lists">
								<Form :model="Merchants" label-position="right">
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-235')" class="f12"
										style="margin-right: 10%;">
										<Select v-model="Merchants.BuyType">
											<Option value="1">{{ $t('smartElectricity.smarElectricity.218347-230') }}
											</Option>
											<Option value="2">{{ $t('smartElectricity.smarElectricity.218347-231') }}
											</Option>
											<Option value="3">{{ $t('smartElectricity.smarElectricity.218347-232') }}
											</Option>
										</Select>
									</FormItem>
									</Col>

									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-229')" class="f12"
										style="margin-right: 10%;">
										<Input v-model="Merchants.BuyPrice"
											:placeholder="$t('smartElectricity.smarElectricity.218347-236')"></Input>
									</FormItem>
									</Col>
								</Form>
							</div>
							<Col span="24" style="position: absolute; bottom: 0.75vw; left: 6vw;">
							<Button type="primary" style="font-size: 0.6vw;" @click="submit136()">{{
								$t('smartElectricity.smarElectricity.218347-237') }}</Button>
							<Button style="font-size: 0.6vw; margin-left: 0.5vw;" @click="cancel136()">{{
								$t('smartElectricity.smarElectricity.218347-238') }}</Button>
							</Col>
						</div>
					</div>

					<div class="add-user-view" v-if="userListHideMsg == 188">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-239') }}
						</div>
						<div class="add-community-view-input-div">
							<div class="add-community-view-input-div-lists">
								<Form :model="MerchantsData" label-position="right">
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-235')" class="f12"
										style="margin-right: 10%;">
										<!-- 	<Select v-model="MerchantsData.BuyType">
											<Option value="1">买一个月</Option>
											<Option value="2">买一个季</Option>
											<Option value="3" >买一个年</Option>
										</Select> -->
										<Select v-model="MerchantsData.BuyType">
											<Option v-for="(item, index) in MerchantscityList" :key="index"
												:value="item.value">{{ item.label }}</Option>
										</Select>
									</FormItem>
									</Col>

									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-229')" class="f12"
										style="margin-right: 10%;">
										<Input v-model="MerchantsData.BuyPrice"
											:placeholder="$t('smartElectricity.smarElectricity.218347-236')"></Input>
									</FormItem>
									</Col>
								</Form>
							</div>
							<Col span="24" style="position: absolute; bottom: 0.75vw; left: 6vw;">
							<Button type="primary" style="font-size: 0.6vw;" @click="EditMerchantFeeTemplate()">{{
								$t('smartElectricity.smarElectricity.218347-237') }}</Button>
							<!-- <Button style="font-size: 0.6vw; margin-left: 0.5vw;" @click="cancel136()">{{ $t('smartElectricity.smarElectricity.218347-238') }}</Button> -->
							</Col>
						</div>
					</div>


					<div class="user-view" v-if="userListHideMsg == 5">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-240') }}
						</div>
						<div class="user-view-add">
							<div @click="addModel(userListHideMsg + 4)" class="ivu-tag2 ivu-tag-green ivu-tag-text2">
								{{ $t('smartElectricity.smarElectricity.218347-241') }}</div>
						</div>
						<div class="user-lists">
							<div class="map-top-content-tab">
								<div class="map-top-content-tab-item">{{ $t('smartElectricity.smarElectricity.218347-242')
								}}</div>
								<div class="map-top-content-tab-item">{{ $t('smartElectricity.smarElectricity.218347-243')
								}}</div>
								<div class="map-top-content-tab-item">{{ $t('smartElectricity.smarElectricity.218347-216')
								}}</div>
								<div class="map-top-content-tab-item">{{ $t('smartElectricity.smarElectricity.218347-217')
								}}</div>
								<div class="map-top-content-tab-item">{{ $t('smartElectricity.smarElectricity.218347-198')
								}}</div>
								<div class="map-top-content-tab-item tabHandle1">{{
									$t('smartElectricity.smarElectricity.218347-189') }}</div>
							</div>
							<div class="user-top-list">
								<div class="user-top-lists" v-if="GetSysGroupLists.length > 0">
									<div class="map-top-list-item" v-for="(item) in GetSysGroupLists" :key="item.Id">
										<div class="map-top-list-item-group">{{ item.GroupCode }}</div>
										<div class="map-top-list-item-device">{{ item.GroupName }}</div>
										<div class="map-top-list-item-addr">{{ item.CreateUser }}</div>
										<div class="map-top-list-item-date">{{ item.CreateDate }}</div>
										<div class="map-top-list-item-type">{{ item.Remarks }}</div>
										<div class="map-top-list-item-handle">
											<div class="ivu-tag2 ivu-tag-cyan ivu-tag-text1"
												@click="addModel(userListHideMsg + 8, item)">{{
													$t('smartElectricity.smarElectricity.218347-64') }}</div>
											<div class="ivu-tag2 ivu-tag-orange ivu-tag-text3"
												@click="DeleteGroup(item.Id)">{{
													$t('smartElectricity.smarElectricity.218347-66') }}</div>
										</div>
									</div>
								</div>
								<div class="map-right-group-list-none" v-else>{{
									$t('smartElectricity.smarElectricity.218347-244') }}</div>
							</div>
							<div class="user-top-list-page">
								<Page :total="GroupTotalCount" @on-change="groupChange"
									@on-page-size-change="groupSizeChange" size="small" show-elevator show-sizer show-total
									placement="top" />
							</div>
						</div>
						<Spin size="large" fix v-if="!GetSysGroupListsMsg"></Spin>
					</div>

					<div class="add-user-view" v-if="userListHideMsg == 6">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-203') }}
						</div>

						<div class="add-community-view-input-div">
							<div class="add-community-view-input-div-lists">
								<Form :model="formUser" label-position="right">
									<Row>
										<Col span="8" v-if="AdminIndex">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-245')" class="f12"
											style="margin-right: 10%;">
											<Select v-model="formUser.GroupCode" @on-change="changeGroupCode">
												<Option v-for="(item) in GroupCodeLists" :key="item.Id"
													:value="item.GroupCode">{{ item.GroupName }}</Option>
											</Select>
										</FormItem>
										</Col>
										<Col span="8" v-if="AdminIndex">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-246')" class="f12"
											style="margin-right: 10%;">
											<Select v-model="formUser.CompanyCode" @on-change="changeCompanyCode">
												<Option v-for="(item) in CompanyCodes" :key="item.Id"
													:value="item.CompanyCode">{{ item.CompanyName }}</Option>
											</Select>
										</FormItem>
										</Col>
										<Col span="8">
										<template v-if="AdminIndex">
											<FormItem :label="$t('smartElectricity.smarElectricity.218347-247')" class="f12"
												style="margin-right: 10%;">
												<Select v-model="formUser.DepartmentCode">
													<Option v-for="(item) in DepartmentCodes" :key="item.Id"
														:value="item.DepartmentCode">{{ item.DepartmentName }}</Option>
												</Select>
											</FormItem>
										</template>
										<template v-else>
											<FormItem :label="$t('smartElectricity.smarElectricity.218347-247')" class="f12"
												style="margin-right: 10%;">
												<Select v-model="formUser.DepartmentCode">
													<Option v-for="(item) in DepartmentCodeLists" :key="item.Id"
														:value="item.DepartmentCode">{{ item.DepartmentName }}</Option>
												</Select>
											</FormItem>
										</template>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-248')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formUser.EmployeeNumber"
												:placeholder="$t('smartElectricity.smarElectricity.218347-249')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-204')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formUser.LoginCode"
												:placeholder="$t('smartElectricity.smarElectricity.218347-250')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-251')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formUser.LoginPassword"
												:placeholder="$t('smartElectricity.smarElectricity.218347-252')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-208')" class="f12"
											style="margin-right: 10%;">
											<Select v-model="formUser.IsAdmin">
												<Option value="1">{{ $t('smartElectricity.smarElectricity.218347-209') }}
												</Option>
												<Option value="0">{{ $t('smartElectricity.smarElectricity.218347-210') }}
												</Option>
											</Select>
										</FormItem>
										</Col>
										<Col span="8" v-if="AdminIndex">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-253')" class="f12"
											style="margin-right: 10%;">
											<Select v-model="formUser.IsAccounting">
												<Option v-for="(item) in AccountList" :key="item.IsAccounting"
													:value="item.IsAccounting">{{ item.AccountName }}</Option>
											</Select>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-254')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formUser.IdentityNo"
												:placeholder="$t('smartElectricity.smarElectricity.218347-255')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-256')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formUser.Name"
												:placeholder="$t('smartElectricity.smarElectricity.218347-257')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-205')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formUser.Phone"
												:placeholder="$t('smartElectricity.smarElectricity.218347-258')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-259')" class="f12"
											style="margin-right: 10%;">
											<Select v-model="formUser.Sex">
												<Option value="0">{{ $t('smartElectricity.smarElectricity.218347-260') }}
												</Option>
												<Option value="1">{{ $t('smartElectricity.smarElectricity.218347-261') }}
												</Option>
												<Option value="2">{{ $t('smartElectricity.smarElectricity.218347-262') }}
												</Option>
											</Select>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-206')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formUser.Email"
												:placeholder="$t('smartElectricity.smarElectricity.218347-263')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-207')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formUser.Address"
												:placeholder="$t('smartElectricity.smarElectricity.218347-264')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-265')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formUser.Birthday"
												:placeholder="$t('smartElectricity.smarElectricity.218347-266')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-267')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formUser.Education"
												:placeholder="$t('smartElectricity.smarElectricity.218347-268')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-198')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formUser.Remarks"
												:placeholder="$t('smartElectricity.smarElectricity.218347-199')"></Input>
										</FormItem>
										</Col>
									</Row>
								</Form>
							</div>
							<Col span="24" style="position: absolute; bottom: 0.75vw; left: 6vw;">
							<Button type="primary" style="font-size: 0.6vw;" @click="submit6">{{
								$t('smartElectricity.smarElectricity.218347-237') }}</Button>
							<Button style="font-size: 0.6vw; margin-left: 0.5vw;" @click="cancel6">{{
								$t('smartElectricity.smarElectricity.218347-238') }}</Button>
							</Col>
						</div>
					</div>

					<div class="add-user-view" v-if="userListHideMsg == 7">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-213') }}
						</div>

						<div class="add-community-view-input-div">
							<div class="add-community-view-input-div-lists">
								<Form :model="formDepart" label-position="right">
									<Row>
										<Col span="8" v-if="GroupCodeLists.length > 0 && AdminIndex">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-245')" class="f12"
											style="margin-right: 10%;">
											<Select v-model="formDepart.GroupCode" @on-change="changeGroupCode">
												<Option v-for="(item) in GroupCodeLists" :key="item.Id"
													:value="item.GroupCode">{{ item.GroupName }}</Option>
											</Select>
										</FormItem>
										</Col>
										<Col span="8" v-if="CompanyCodeLists.length > 0 && AdminIndex">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-246')" class="f12"
											style="margin-right: 10%;">
											<Select v-model="formDepart.CompanyCode">
												<Option v-for="(item) in CompanyCodeLists" :key="item.Id"
													:value="item.CompanyCode">{{ item.CompanyName }}</Option>
											</Select>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-214')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formDepart.DepartmentCode"
												:placeholder="$t('smartElectricity.smarElectricity.218347-269')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-215')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formDepart.DepartmentName"
												:placeholder="$t('smartElectricity.smarElectricity.218347-270')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-198')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formDepart.Remarks"
												:placeholder="$t('smartElectricity.smarElectricity.218347-199')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-271')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formDepart.TittleName"
												:placeholder="$t('smartElectricity.smarElectricity.218347-272')"></Input>
										</FormItem>
										</Col>
									</Row>
								</Form>
							</div>
							<Col span="24" style="position: absolute; bottom: 0.75vw; left: 6vw;">
							<Button type="primary" style="font-size: 0.6vw;" @click="submit7()">{{
								$t('smartElectricity.smarElectricity.218347-237') }}</Button>
							<Button style="font-size: 0.6vw; margin-left: 0.5vw;" @click="cancel7()">{{
								$t('smartElectricity.smarElectricity.218347-238') }}</Button>
							</Col>
						</div>
					</div>

					<div class="add-user-view" v-if="userListHideMsg == 8">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-222') }}
						</div>
						<div class="add-community-view-input-div">
							<div class="add-community-view-input-div-lists">
								<Form :model="formCompany1" label-position="right">
									<Row>
										<Col span="8" v-if="GroupCodeLists.length > 0">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-245')" class="f12"
											style="margin-right: 10%;">
											<Select v-model="formCompany1.GroupCode">
												<Option v-for="(item) in GroupCodeLists" :key="item.Id"
													:value="item.GroupCode">{{ item.GroupName }}</Option>
											</Select>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-223')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formCompany1.CompanyCode"
												:placeholder="$t('smartElectricity.smarElectricity.218347-273')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-224')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formCompany1.CompanyName"
												:placeholder="$t('smartElectricity.smarElectricity.218347-274')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-225')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formCompany1.Phone"
												:placeholder="$t('smartElectricity.smarElectricity.218347-275')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-276')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formCompany1.Bank"
												:placeholder="$t('smartElectricity.smarElectricity.218347-277')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-278')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formCompany1.BankNo"
												:placeholder="$t('smartElectricity.smarElectricity.218347-279')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-280')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formCompany1.License"
												:placeholder="$t('smartElectricity.smarElectricity.218347-281')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-41')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formCompany1.Address"
												:placeholder="$t('smartElectricity.smarElectricity.218347-282')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-283')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formCompany1.TittleName"
												:placeholder="$t('smartElectricity.smarElectricity.218347-284')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-285')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formCompany1.TittleNameEN"
												:placeholder="$t('smartElectricity.smarElectricity.218347-286')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-198')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formCompany1.Remarks"
												:placeholder="$t('smartElectricity.smarElectricity.218347-199')"></Input>
										</FormItem>
										</Col>
										<div>
											<Col span="8">
											<FormItem :label="$t('smartElectricity.smarElectricity.218347-287')" class="f12"
												style="margin-right: 10%;">

												<div class="demo-upload-list" v-for="(item, index) in uploadList"
													:key="index">
													<template>
														<img :src="item">
														<div class="demo-upload-list-cover">
															<Icon type="ios-trash-outline"
																@click.native="handleRemove(item)"></Icon>
														</div>
													</template>
												</div>
												<Upload v-if="uploadList.length == 0" ref="upload" :show-upload-list="false"
													:default-file-list="defaultList" :on-success="handleSuccess"
													:format="['jpg', 'jpeg', 'png']" :max-size="2048"
													:on-format-error="handleFormatError" :on-exceeded-size="handleMaxSize"
													:before-upload="handleBeforeUpload" :headers="headers" multiple
													type="drag" action="http://api.home.hxpwr.com/api/User/EImgUpload"
													style="display: inline-block;width:58px;">
													<div style="width: 58px;height:58px;line-height: 58px;">
														<Icon type="ios-camera" size="20"></Icon>
													</div>
												</Upload>

											</FormItem>
											</Col>
										</div>
									</Row>
								</Form>
							</div>
							<Col span="24" style="position: absolute; bottom: 0.75vw; left: 6vw;">
							<Button type="primary" style="font-size: 0.6vw;" @click="submit8()">{{
								$t('smartElectricity.smarElectricity.218347-237') }}</Button>
							<Button style="font-size: 0.6vw; margin-left: 0.5vw;" @click="cancel8()">{{
								$t('smartElectricity.smarElectricity.218347-238') }}</Button>
							</Col>
						</div>
					</div>

					<div class="add-user-view" v-if="userListHideMsg == 9">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-241') }}
						</div>

						<div class="add-community-view-input-div">
							<div class="add-community-view-input-div-lists">
								<Form :model="formGroup" label-position="right">
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-242')" class="f12"
										style="margin-right: 10%;">
										<Input v-model="formGroup.GroupCode"
											:placeholder="$t('smartElectricity.smarElectricity.218347-288')"></Input>
									</FormItem>
									</Col>
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-243')" class="f12"
										style="margin-right: 10%;">
										<Input v-model="formGroup.GroupName"
											:placeholder="$t('smartElectricity.smarElectricity.218347-289')"></Input>
									</FormItem>
									</Col>
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-198')" class="f12"
										style="margin-right: 10%;">
										<Input v-model="formGroup.Remarks"
											:placeholder="$t('smartElectricity.smarElectricity.218347-199')"></Input>
									</FormItem>
									</Col>
								</Form>
							</div>
							<Col span="24" style="position: absolute; bottom: 0.75vw; left: 6vw;">
							<Button type="primary" style="font-size: 0.6vw;" @click="submit9()">{{
								$t('smartElectricity.smarElectricity.218347-237') }}</Button>
							<Button style="font-size: 0.6vw; margin-left: 0.5vw;" @click="cancel9(formGroup)">{{
								$t('smartElectricity.smarElectricity.218347-238') }}</Button>
							</Col>
						</div>
					</div>

					<div class="add-user-view" v-if="userListHideMsg == 10">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-290') }}
						</div>

						<div class="add-community-view-input-div">
							<div class="add-community-view-input-div-lists">
								<Form :model="formUser" label-position="right">
									<Row>
										<Col span="8" v-if="AdminIndex">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-245')" class="f12"
											style="margin-right: 10%;">
											<Select v-model="formUser.GroupCode" @on-change="changeGroupCode">
												<Option v-for="(item) in GroupCodeLists" :key="item.Id"
													:value="item.GroupCode">{{ item.GroupName }}</Option>
											</Select>
										</FormItem>
										</Col>
										<Col span="8" v-if="AdminIndex">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-246')" class="f12"
											style="margin-right: 10%;">
											<Select v-model="formUser.CompanyCode" @on-change="changeCompanyCode">
												<Option v-for="(item) in CompanyCodes" :key="item.Id"
													:value="item.CompanyCode">{{ item.CompanyName }}</Option>
											</Select>
										</FormItem>
										</Col>
										<Col span="8">
										<template v-if="AdminIndex">
											<FormItem :label="$t('smartElectricity.smarElectricity.218347-247')" class="f12"
												style="margin-right: 10%;">
												<Select v-model="formUser.DepartmentCode">
													<Option v-for="(item) in DepartmentCodes" :key="item.Id"
														:value="item.DepartmentCode">{{ item.DepartmentName }}</Option>
												</Select>
											</FormItem>
										</template>
										<template v-else>
											<FormItem :label="$t('smartElectricity.smarElectricity.218347-247')" class="f12"
												style="margin-right: 10%;">
												<Select v-model="formUser.DepartmentCode">
													<Option v-for="(item) in DepartmentCodeLists" :key="item.Id"
														:value="item.DepartmentCode">{{ item.DepartmentName }}</Option>
												</Select>
											</FormItem>
										</template>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-248')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formUser.EmployeeNumber"
												:placeholder="$t('smartElectricity.smarElectricity.218347-249')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-204')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formUser.LoginCode"
												:placeholder="$t('smartElectricity.smarElectricity.218347-250')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-251')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formUser.LoginPassword"
												:placeholder="$t('smartElectricity.smarElectricity.218347-252')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-208')" class="f12"
											style="margin-right: 10%;">
											<Select v-model="formUser.IsAdmin">
												<Option value="1">{{ $t('smartElectricity.smarElectricity.218347-209') }}
												</Option>
												<Option value="0">{{ $t('smartElectricity.smarElectricity.218347-210') }}
												</Option>
											</Select>
										</FormItem>
										</Col>
										<Col span="8" v-if="AdminIndex">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-253')" class="f12"
											style="margin-right: 10%;">
											<Select v-model="formUser.IsAccounting">
												<Option v-for="(item) in AccountList" :key="item.IsAccounting"
													:value="item.IsAccounting">{{ item.AccountName }}</Option>
											</Select>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-254')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formUser.IdentityNo"
												:placeholder="$t('smartElectricity.smarElectricity.218347-255')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-256')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formUser.Name"
												:placeholder="$t('smartElectricity.smarElectricity.218347-257')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-205')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formUser.Phone"
												:placeholder="$t('smartElectricity.smarElectricity.218347-258')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-259')" class="f12"
											style="margin-right: 10%;">
											<Select v-model="formUser.Sex">
												<Option value="0">{{ $t('smartElectricity.smarElectricity.218347-260') }}
												</Option>
												<Option value="1">{{ $t('smartElectricity.smarElectricity.218347-261') }}
												</Option>
												<Option value="2">{{ $t('smartElectricity.smarElectricity.218347-262') }}
												</Option>
											</Select>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-206')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formUser.Email"
												:placeholder="$t('smartElectricity.smarElectricity.218347-263')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-207')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formUser.Address"
												:placeholder="$t('smartElectricity.smarElectricity.218347-264')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-265')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formUser.Birthday"
												:placeholder="$t('smartElectricity.smarElectricity.218347-266')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-267')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formUser.Education"
												:placeholder="$t('smartElectricity.smarElectricity.218347-268')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-198')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formUser.Remarks"
												:placeholder="$t('smartElectricity.smarElectricity.218347-199')"></Input>
										</FormItem>
										</Col>
									</Row>
								</Form>
							</div>
							<Col span="24" style="position: absolute; bottom: 0.75vw; left: 6vw;">
							<Button type="primary" style="font-size: 0.6vw;" @click="submit10">{{
								$t('smartElectricity.smarElectricity.218347-237') }}</Button>
							</Col>
						</div>
					</div>

					<div class="add-user-view" v-if="userListHideMsg == 11">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-291') }}
						</div>

						<div class="add-community-view-input-div">
							<div class="add-community-view-input-div-lists">
								<Form :model="formDepart" label-position="right">
									<Row>
										<Col span="8" v-if="GroupCodeLists.length > 0 && AdminIndex">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-245')" class="f12"
											style="margin-right: 10%;">
											<Select v-model="formDepart.GroupCode" @on-change="changeGroupCode">
												<Option v-for="(item) in GroupCodeLists" :key="item.Id"
													:value="item.GroupCode">{{ item.GroupName }}</Option>
											</Select>
										</FormItem>
										</Col>
										<Col span="8" v-if="CompanyCodeLists.length > 0 && AdminIndex">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-246')" class="f12"
											style="margin-right: 10%;">
											<Select v-model="formDepart.CompanyCode">
												<Option v-for="(item) in CompanyCodeLists" :key="item.Id"
													:value="item.CompanyCode">{{ item.CompanyName }}</Option>
											</Select>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-214')" class="f12"
											style="margin-right: 10%;">
											<Input disabled v-model="formDepart.DepartmentCode" :placeholder="$t('smartElectricity.smarElectricity.218347-269')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-215')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formDepart.DepartmentName"
												:placeholder="$t('smartElectricity.smarElectricity.218347-270')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-198')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formDepart.Remarks"
												:placeholder="$t('smartElectricity.smarElectricity.218347-199')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-271')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formDepart.TittleName"
												:placeholder="$t('smartElectricity.smarElectricity.218347-272')"></Input>
										</FormItem>
										</Col>
									</Row>
								</Form>
							</div>
							<Col span="24" style="position: absolute; bottom: 0.75vw; left: 6vw;">
							<Button type="primary" style="font-size: 0.6vw;" @click="submit11()">{{
								$t('smartElectricity.smarElectricity.218347-237') }}</Button>
							</Col>
						</div>
					</div>

					<div class="add-user-view" v-if="userListHideMsg == 12">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-292') }}
						</div>
						<div class="add-community-view-input-div">
							<div class="add-community-view-input-div-lists">
								<Form :model="formCompany" label-position="right">
									<Row>
										<Col span="8" v-if="GroupCodeLists.length > 0">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-245')" class="f12"
											style="margin-right: 10%;">
											<Select v-model="formCompany.GroupCode">
												<Option v-for="(item) in GroupCodeLists" :key="item.Id"
													:value="item.GroupCode">{{ item.GroupName }}</Option>
											</Select>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-223')" class="f12"
											style="margin-right: 10%;">
											<Input disabled v-model="formCompany.CompanyCode"
												:placeholder="$t('smartElectricity.smarElectricity.218347-273')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-224')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formCompany.CompanyName"
												:placeholder="$t('smartElectricity.smarElectricity.218347-274')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-225')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formCompany.Phone"
												:placeholder="$t('smartElectricity.smarElectricity.218347-275')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-276')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formCompany.Bank"
												:placeholder="$t('smartElectricity.smarElectricity.218347-277')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-278')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formCompany.BankNo"
												:placeholder="$t('smartElectricity.smarElectricity.218347-279')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-280')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formCompany.License"
												:placeholder="$t('smartElectricity.smarElectricity.218347-281')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-41')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formCompany.Address"
												:placeholder="$t('smartElectricity.smarElectricity.218347-282')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-283')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formCompany.TittleName"
												:placeholder="$t('smartElectricity.smarElectricity.218347-284')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-285')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formCompany.TittleNameEN"
												:placeholder="$t('smartElectricity.smarElectricity.218347-286')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-198')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formCompany.Remarks"
												:placeholder="$t('smartElectricity.smarElectricity.218347-199')"></Input>
										</FormItem>
										</Col>
										<div>
											<Col span="8">
											<FormItem :label="$t('smartElectricity.smarElectricity.218347-287')" class="f12"
												style="margin-right: 10%;">

												<div class="demo-upload-list" v-for="(item, index) in uploadList"
													:key="index">
													<template>
														<img :src="item">
														<div class="demo-upload-list-cover">
															<Icon type="ios-trash-outline"
																@click.native="handleRemove(item)"></Icon>
														</div>
													</template>
												</div>
												<Upload v-if="uploadList.length == 0" ref="upload" :show-upload-list="false"
													:default-file-list="defaultList" :on-success="handleSuccess"
													:format="['jpg', 'jpeg', 'png']" :max-size="2048"
													:on-format-error="handleFormatError" :on-exceeded-size="handleMaxSize"
													:before-upload="handleBeforeUpload" :headers="headers" multiple
													type="drag" action="http://api.home.hxpwr.com/api/User/EImgUpload"
													style="display: inline-block;width:58px;">
													<div style="width: 58px;height:58px;line-height: 58px;">
														<Icon type="ios-camera" size="20"></Icon>
													</div>
												</Upload>

											</FormItem>
											</Col>
										</div>
									</Row>
								</Form>
							</div>
							<Col span="24" style="position: absolute; bottom: 0.75vw; left: 6vw;">
							<Button type="primary" style="font-size: 0.6vw;" @click="submit12()">{{
								$t('smartElectricity.smarElectricity.218347-237') }}</Button>
							</Col>
						</div>
					</div>

					<div class="add-user-view" v-if="userListHideMsg == 13">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-293') }}
						</div>

						<div class="add-community-view-input-div">
							<div class="add-community-view-input-div-lists">
								<Form :model="formGroup" label-position="right">
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-242')" class="f12"
										style="margin-right: 10%;">
										<Input disabled v-model="formGroup.GroupCode"
											:placeholder="$t('smartElectricity.smarElectricity.218347-288')"></Input>
									</FormItem>
									</Col>
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-243')" class="f12"
										style="margin-right: 10%;">
										<Input v-model="formGroup.GroupName"
											:placeholder="$t('smartElectricity.smarElectricity.218347-289')"></Input>
									</FormItem>
									</Col>
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-198')" class="f12"
										style="margin-right: 10%;">
										<Input v-model="formGroup.Remarks"
											:placeholder="$t('smartElectricity.smarElectricity.218347-199')"></Input>
									</FormItem>
									</Col>
								</Form>
							</div>
							<Col span="24" style="position: absolute; bottom: 0.75vw; left: 6vw;">
							<Button type="primary" style="font-size: 0.6vw;" @click="submit13()">{{
								$t('smartElectricity.smarElectricity.218347-237') }}</Button>
							<!-- <Button style="font-size: 12px; margin-left: 10px;" @click="cancel13(formGroup)">{{ $t('smartElectricity.smarElectricity.218347-201') }}</Button> -->
							</Col>
						</div>
					</div>

					<div class="add-user-view" v-if="userListHideMsg == 15">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-294') }}
						</div>

						<div class="add-community-view-input-div">
							<div class="add-community-view-input-div-lists">
								<!-- <div class="add-community-view-input-depart-list">
                  <div class="add-community-view-input-depart-list-title">{{ $t('smartElectricity.smarElectricity.218347-294') }}</div>
                  <div>
                    <Checkbox @on-change="handleCheckCommunity(Communitylists[index])" v-for="(item, index) in Communitylists" :key="item.CommunityCode" v-model="Communitylists[index].Isopen">{{item.CommunityName}}</Checkbox>
                  </div>
                </div>
                <div class="add-community-view-input-depart-list">
                  <div class="add-community-view-input-depart-list-title">选择区域</div>
                  <div>
                    <Checkbox v-for="(item, index) in Communitylists" :key="item.CommunityCode" v-model="Communitylists[index].Isopen">{{item.CommunityName}}</Checkbox>
                  </div>
                </div> -->

								<Tree :data="CommunityDatas" show-checkbox></Tree>

							</div>
							<Col span="24" style="position: absolute; bottom: 0.75vw; left: 3.5vw;">
							<Button type="primary" style="font-size: 0.6vw;" @click="FenPeiVillage">{{
								$t('smartElectricity.smarElectricity.218347-237') }}</Button>
							<Button style="font-size: 0.6vw; margin-left: 0.5vw;"
								@click="userListHide(true, userListHideMsg - 12)">{{
									$t('smartElectricity.smarElectricity.218347-201') }}</Button>
							</Col>
						</div>
					</div>

					<div class="add-user-view" v-if="userListHideMsg == 19">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-295') }}
						</div>

						<div class="add-community-view-input-div">
							<div class="add-community-view-input-div-lists">
								<div class="add-community-view-input-depart-list">
									<div class="add-community-view-input-depart-list-title">{{
										$t('smartElectricity.smarElectricity.218347-296') }}</div>
									<div>
										<template v-for="(item, index) in GetViOrBtnOrUserDatas.btnlist">
											<Checkbox :key="item.Vcode" v-if="item.BtonType == 4"
												v-model="GetViOrBtnOrUserDatas.btnlist[index].Isopen">{{ item.BtonCnName }}
											</Checkbox>
										</template>

									</div>
								</div>
								<div class="add-community-view-input-depart-list">
									<div class="add-community-view-input-depart-list-title">{{
										$t('smartElectricity.smarElectricity.218347-297') }}</div>
									<div>
										<template v-for="(item, index) in GetViOrBtnOrUserDatas.btnlist">
											<Checkbox :key="item.Vcode" v-if="item.BtonType == 1"
												v-model="GetViOrBtnOrUserDatas.btnlist[index].Isopen">{{ item.BtonCnName }}
											</Checkbox>
										</template>
									</div>
								</div>
								<div class="add-community-view-input-depart-list">
									<div class="add-community-view-input-depart-list-title">{{
										$t('smartElectricity.smarElectricity.218347-298') }}</div>
									<div>
										<template v-for="(item, index) in GetViOrBtnOrUserDatas.btnlist">
											<Checkbox :key="item.Vcode" v-if="item.BtonType == 2"
												v-model="GetViOrBtnOrUserDatas.btnlist[index].Isopen">{{ item.BtonCnName }}
											</Checkbox>
										</template>
									</div>
								</div>
								<div class="add-community-view-input-depart-list">
									<div class="add-community-view-input-depart-list-title">{{
										$t('smartElectricity.smarElectricity.218347-299') }}</div>
									<div>
										<template v-for="(item, index) in GetViOrBtnOrUserDatas.btnlist">
											<Checkbox :key="item.Vcode" v-if="item.BtonType == 3"
												v-model="GetViOrBtnOrUserDatas.btnlist[index].Isopen">{{ item.BtonCnName }}
											</Checkbox>
										</template>
									</div>
								</div>
								<div class="add-community-view-input-depart-list">
									<div class="add-community-view-input-depart-list-title">{{
										$t('smartElectricity.smarElectricity.218347-300') }}</div>
									<div>
										<Checkbox v-for="(item, index) in GetViOrBtnOrUserDatas.menulist"
											:key="item.MenuCode" v-model="GetViOrBtnOrUserDatas.menulist[index].Isopen">
											{{ item.MenuName }}</Checkbox>
									</div>
								</div>
							</div>
							<Col span="24" style="position: absolute; bottom: 0.75vw; left: 3.5vw;">
							<Button type="primary" style="font-size: 0.6vw;" @click="QxFenPei">{{
								$t('smartElectricity.smarElectricity.218347-237') }}</Button>
							<Button style="font-size: 0.6vw; margin-left: 0.5vw;"
								@click="userListHide(true, userListHideMsg - 16)">{{
									$t('smartElectricity.smarElectricity.218347-201') }}</Button>
							</Col>
						</div>
					</div>

					<div class="add-user-view" v-if="userListHideMsg == 101">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-203') }}
						</div>

						<div class="add-community-view-input-div">
							<div class="add-community-view-input-div-lists">

								<Form :model="formRoom" label-position="right">
									<Row>
										<Col span="24">
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-301')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formRoom.OwnerPhone"
												:placeholder="$t('smartElectricity.smarElectricity.218347-302')"></Input>
										</FormItem>
										</Col>
										<Button type="primary" style="font-size: 0.6vw;margin-top: 0.1vw;"
											@click="submitGetOneUser(formRoom.OwnerPhone)">{{
												$t('smartElectricity.smarElectricity.218347-303') }}</Button>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-304')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formRoom.Zhuang"
												:placeholder="$t('smartElectricity.smarElectricity.218347-305')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-306')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formRoom.Unit"
												:placeholder="$t('smartElectricity.smarElectricity.218347-307')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-308')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formRoom.Floor"
												:placeholder="$t('smartElectricity.smarElectricity.218347-309')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-310')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formRoom.RoomNo"
												:placeholder="$t('smartElectricity.smarElectricity.218347-311')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-312')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formRoom.OwnerName"
												:placeholder="$t('smartElectricity.smarElectricity.218347-313')"></Input>
										</FormItem>
										</Col>
										<Col span="24">
										<Col span="8">
										<div class="f12 ivu-form-item">
											<div style="width: 4.25vw; text-align: right; float: left;">
												<p class="f12-label" style="line-height: 1.7vw;">{{
													$t('smartElectricity.smarElectricity.218347-195') }}</p>
											</div>
											<div class="ivu-form-item-content"
												style="margin-left: 5vw; overflow: hidden; margin-right:1.8vw;">
												<div
													class="ivu-input-wrapper ivu-input-wrapper-default ivu-input-type-text">
													<input type="text" id="suggestId" name="address_detail"
														:placeholder="$t('smartElectricity.smarElectricity.218347-41')"
														class="input_style ivu-input ivu-input-default">
													<div id="allmap1" style="width: 0px; height: 0px;"></div>
												</div>
											</div>
										</div>
										</Col>

										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-196')" class="f12"
											style="margin-right: 10%;">
											<Input disabled v-model="userlocation.lng"
												:placeholder="$t('smartElectricity.smarElectricity.218347-196')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-197')" class="f12"
											style="margin-right: 10%;">
											<Input disabled v-model="userlocation.lat"
												:placeholder="$t('smartElectricity.smarElectricity.218347-197')"></Input>
										</FormItem>
										</Col>

										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-186')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formRoom.AddressDetail"
												:placeholder="$t('smartElectricity.smarElectricity.218347-314')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-198')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formRoom.Remarks"
												:placeholder="$t('smartElectricity.smarElectricity.218347-199')"></Input>
										</FormItem>
										</Col>
									</Row>
								</Form>
							</div>
							<Col span="24" style="position: absolute; bottom: 0.75vw; left: 6vw;">
							<Button type="primary" style="font-size: 0.6vw;" @click="submit101()">{{
								$t('smartElectricity.smarElectricity.218347-237') }}</Button>
							<Button style="font-size: 0.6vw; margin-left: 0.5vw;" @click="userListHide(false)">{{
								$t('smartElectricity.smarElectricity.218347-201') }}</Button>
							</Col>
						</div>
					</div>

					<div class="add-user-view" v-show="userListHideMsg == 102">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-40') }}
						</div>

						<div class="add-community-view-input-div">
							<div class="add-community-view-input-div-lists">
								<Form :model="formDevices" label-position="right">
									<Row>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-315')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formDevices.DeviceCode"
												:placeholder="$t('smartElectricity.smarElectricity.218347-316')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-183')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formDevices.DeviceName"
												:placeholder="$t('smartElectricity.smarElectricity.218347-317')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-318')" class="f12"
											style="margin-right: 10%;">
											<DatePicker v-model="formDevices.InstallationTime" type="datetime" placeholder="请选择安装时间"
												style="width: 100%;"></DatePicker>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-320')" class="f12"
											style="margin-right: 10%;">
											<Select v-model="DeviceClass"
												:placeholder="$t('smartElectricity.smarElectricity.218347-321')">
												<Option value="1">{{ $t('smartElectricity.smarElectricity.218347-322') }}
												</Option>
												<Option value="2">{{ $t('smartElectricity.smarElectricity.218347-323') }}
												</Option>
												<Option value="3">{{ $t('smartElectricity.smarElectricity.218347-324') }}
												</Option>
											</Select>
										</FormItem>
										</Col>
										<Col span="8" v-if="GetParameterData7Lists.length > 0">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-325')" class="f12"
											style="margin-right: 10%;">
											<Select v-model="formDevices.ConnectDevice"
												:placeholder="$t('smartElectricity.smarElectricity.218347-326')">
												<Option v-for="(item) in GetParameterData7Lists" :key="item.parameterCode"
													:value="item.parameterCode">
													{{ item.parameterName }}</Option>
											</Select>
										</FormItem>
										</Col>
										<Col span="8"
											v-if="formDevices.DeviceClass == 1 && GetParameterData11Lists.length > 0">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-327')" class="f12"
											style="margin-right: 10%;">
											<Select v-model="formDevices.DeviceType"
												:placeholder="$t('smartElectricity.smarElectricity.218347-328')">
												<Option v-for="(item) in GetParameterData11Lists" :key="item.parameterCode"
													:value="item.parameterCode">
													{{ item.parameterName }}</Option>
											</Select>
										</FormItem>
										</Col>
										<Col span="8" v-if="GetParameterData1Lists.length > 0">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-329')" class="f12"
											style="margin-right: 10%;">
											<Select v-model="formDevices.ParameterCode"
												:placeholder="$t('smartElectricity.smarElectricity.218347-330')">
												<Option v-for="(item) in GetParameterData1Lists" :key="item.parameterCode"
													:value="item.parameterCode">
													{{ item.parameterName }}</Option>
											</Select>
										</FormItem>
										</Col>
										<Col span="8"
											v-if="formDevices.DeviceClass == 3 && GetRoomWDDeviceLists.length > 0">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-331')" class="f12"
											style="margin-right: 10%;">
											<Select v-model="formDevices.PDeviceCode"
												:placeholder="$t('smartElectricity.smarElectricity.218347-332')">
												<Option v-for="(item) in GetRoomWDDeviceLists" :key="item.Id"
													:value="item.DeviceCode">{{ item.DeviceName }}</Option>
											</Select>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-198')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="formDevices.Remarks"
												:placeholder="$t('smartElectricity.smarElectricity.218347-199')"></Input>
										</FormItem>
										</Col>
									</Row>
								</Form>
							</div>
							<Col span="24" style="position: absolute; bottom: 0.75vw; left: 6vw;">
							<Button type="primary" style="font-size: 0.6vw;" @click="submit102()">{{
								$t('smartElectricity.smarElectricity.218347-237') }}</Button>
							<Button style="font-size: 0.6vw; margin-left: 0.5vw;" @click="userListHide(false)">{{
								$t('smartElectricity.smarElectricity.218347-201') }}</Button>
							</Col>
						</div>
					</div>

					<div class="add-user-view" v-if="userListHideMsg == 103">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-333') }}
						</div>

						<div class="add-community-view-input-div">
							<div class="add-community-view-input-div-lists">
								<Form :model="formDevices" label-position="right">
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-315')" class="f12"
										style="margin-right: 10%;">
										<Input disabled v-model="formDevices.DeviceCode"
											:placeholder="$t('smartElectricity.smarElectricity.218347-316')"></Input>
									</FormItem>
									</Col>
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-183')" class="f12"
										style="margin-right: 10%;">
										<Input v-model="formDevices.UserDeviceName"
											:placeholder="$t('smartElectricity.smarElectricity.218347-317')"></Input>
									</FormItem>
									</Col>
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-334')" class="f12"
										style="margin-right: 10%;">
										<Input v-model="formDevices.ContactsName"
											:placeholder="$t('smartElectricity.smarElectricity.218347-335')"></Input>
									</FormItem>
									</Col>
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-225')" class="f12"
										style="margin-right: 10%;">
										<Input v-model="formDevices.ContactsPhone"
											:placeholder="$t('smartElectricity.smarElectricity.218347-275')"></Input>
									</FormItem>
									</Col>
									<Row>
										<Col span="8">
										<div class="f12 ivu-form-item">
											<div style="width: 4.25vw; text-align: right; float: left;">
												<p class="f12-label" style="line-height: 1.7vw;">{{
													$t('smartElectricity.smarElectricity.218347-195') }}</p>
											</div>
											<div class="ivu-form-item-content"
												style="margin-left: 5vw; overflow: hidden; margin-right:1.8vw;">
												<div
													class="ivu-input-wrapper ivu-input-wrapper-default ivu-input-type-text">
													<input @click="addressDetailClick()" type="text"
														v-show="address_detail_input" v-model="address_detail" :placeholder="$t('smartElectricity.smarElectricity.218347-41')"
														class="input_style ivu-input ivu-input-default ivu-input-default-suggest-class">
													<input type="text" v-show="!address_detail_input" id="suggestId"
														name="address_detail"
														:placeholder="$t('smartElectricity.smarElectricity.218347-41')"
														class="input_style ivu-input ivu-input-default ivu-input-default-suggest-class">
													<div id="allmap1" style="width: 0px; height: 0px;"></div>
												</div>
											</div>
										</div>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-196')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="userlocation.lng"
												:placeholder="$t('smartElectricity.smarElectricity.218347-196')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-197')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="userlocation.lat"
												:placeholder="$t('smartElectricity.smarElectricity.218347-197')"></Input>
										</FormItem>
										</Col>
									</Row>
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-186')" class="f12"
										style="margin-right: 10%;">
										<Input v-model="formDevices.AddressDetail"
											:placeholder="$t('smartElectricity.smarElectricity.218347-314')"></Input>
									</FormItem>
									</Col>
								</Form>
							</div>
							<Col span="24" style="position: absolute; bottom: 0.75vw; left: 6vw;">
							<Button type="primary" style="font-size: 0.6vw;" @click="submit103()">{{
								$t('smartElectricity.smarElectricity.218347-237') }}</Button>
							<Button style="font-size: 0.6vw; margin-left: 0.5vw;" @click="userListHide(false)">{{
								$t('smartElectricity.smarElectricity.218347-201') }}</Button>
							</Col>
						</div>
					</div>

					<div class="add-user-view" v-if="userListHideMsg == 104">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-336') }}
						</div>

						<div class="add-community-view-input-div">
							<div class="add-community-view-input-div-lists">
								<Form :model="formPassWord" label-position="right">
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-68')" class="f12"
										style="margin-right: 10%;">
										<Input v-model="formPassWord.password"
											:placeholder="$t('smartElectricity.smarElectricity.218347-337')"></Input>
									</FormItem>
									</Col>
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-338')" class="f12"
										style="margin-right: 10%;">
										<Input v-model="formPassWord.ConfirmPassword"
											:placeholder="$t('smartElectricity.smarElectricity.218347-339')"></Input>
									</FormItem>
									</Col>
								</Form>
							</div>
							<Col span="24" style="position: absolute; bottom: 0.75vw; left: 6vw;">
							<Button type="primary" style="font-size: 0.6vw;" @click="submit104()">{{
								$t('smartElectricity.smarElectricity.218347-237') }}</Button>
							<Button style="font-size: 0.6vw; margin-left: 0.5vw;" @click="userListHide(false)">{{
								$t('smartElectricity.smarElectricity.218347-201') }}</Button>
							</Col>
						</div>
					</div>

					<div class="add-user-view" v-if="userListHideMsg == 105">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-340') }}
						</div>

						<div class="add-community-view-input-div">
							<div class="add-community-view-input-div-lists">
								<Form :model="formPassWord1" label-position="right">
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-341')" class="f12"
										style="margin-right: 10%;">
										<Input v-model="formPassWord1.OldPassword"
											:placeholder="$t('smartElectricity.smarElectricity.218347-337')"></Input>
									</FormItem>
									</Col>
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-342')" class="f12"
										style="margin-right: 10%;">
										<Input v-model="formPassWord1.NewPassword"
											:placeholder="$t('smartElectricity.smarElectricity.218347-337')"></Input>
									</FormItem>
									</Col>
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-338')" class="f12"
										style="margin-right: 10%;">
										<Input v-model="formPassWord1.ConfirmPassword"
											:placeholder="$t('smartElectricity.smarElectricity.218347-339')"></Input>
									</FormItem>
									</Col>
								</Form>
							</div>
							<Col span="24" style="position: absolute; bottom: 0.75vw; left: 6vw;">
							<Button type="primary" style="font-size: 0.6vw;" @click="submit105()">{{
								$t('smartElectricity.smarElectricity.218347-237') }}</Button>
							<Button style="font-size: 0.6vw; margin-left: 0.5vw;" @click="userListHide(false)">{{
								$t('smartElectricity.smarElectricity.218347-201') }}</Button>
							</Col>
						</div>
					</div>

					<div class="add-user-view" v-if="userListHideMsg == 106">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-343') }}
						</div>

						<div class="add-community-view-input-div">
							<div class="add-community-view-input-div-lists">
								<Form :model="formDevicesItem" label-position="right">
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-344')" class="f12"
										style="margin-right: 10%;">
										<Input v-model="formDevicesItem.mobile"
											:placeholder="$t('smartElectricity.smarElectricity.218347-345')"></Input>
									</FormItem>
									</Col>
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-184')" class="f12"
										style="margin-right: 10%;">
										<Input v-model="formDevicesItem.deviceCode"
											:placeholder="$t('smartElectricity.smarElectricity.218347-346')"></Input>
									</FormItem>
									</Col>
								</Form>
							</div>
							<Col span="24" style="position: absolute; bottom: 0.75vw; left: 6vw;">
							<Button type="primary" style="font-size: 0.6vw;" @click="submit106()">{{
								$t('smartElectricity.smarElectricity.218347-303') }}</Button>
							<Button style="font-size: 0.6vw; margin-left: 0.5vw;" @click="userListHide(false)">{{
								$t('smartElectricity.smarElectricity.218347-201') }}</Button>
							</Col>
						</div>
					</div>

					<div class="add-user-view" v-if="userListHideMsg == 107">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-347') }}
						</div>

						<div class="user-lists">
							<div class="map-top-content-tab">
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-183') }}</div>
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-184') }}</div>
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-185') }}</div>
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-186') }}</div>
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-348') }}</div>
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-349') }}</div>
								<div class="map-top-content-tab-item-yichang tabHandle1">{{
									$t('smartElectricity.smarElectricity.218347-189') }}</div>
							</div>
							<div class="user-top-list">
								<div class="user-top-lists" v-if="PageListWith3CodeLists.length > 0">
									<div class="map-top-list-item map-top-list-item-yichang"
										v-for="(item, index) in PageListWith3CodeLists" :key="index">
										<div class="map-top-list-item-group">{{ item.UserDeviceName }}</div>
										<div class="map-top-list-item-device">{{ item.DeviceCode }}</div>
										<div class="map-top-list-item-device">{{ item.OwnerName }}</div>
										<div class="map-top-list-item-device" :title="item.AddressDetail">
											{{ item.AddressDetail }}</div>
										<div class="map-top-list-item-addr">{{ item.AbnormalTime }}</div>
										<div class="map-top-list-item-date" style="color: #f03613 !important;">
											{{ item.AbnormalName }}</div>
										<div class="map-top-list-item-handle">
											<div class="ivu-dropdown">

												<div class="" style="margin-top: 0.1vw;">
													<div class="map-bottom-list-item-handle-btn">
														<Dropdown trigger="click" style="width: 5vw;">
															<a href="javascript:void(0)">
																{{ $t('smartElectricity.smarElectricity.218347-94') }}
																<Icon type="md-arrow-dropdown"
																	style="margin-left: 0.5vw;" />
															</a>
															<DropdownMenu slot="list" style="width: 5vw;">
																<DropdownItem @click.native="SolveAbData(item.Id, 2)">{{
																	$t('smartElectricity.smarElectricity.218347-95') }}
																</DropdownItem>
																<DropdownItem @click.native="SolveAbData(item.Id, 3)">{{
																	$t('smartElectricity.smarElectricity.218347-96') }}
																</DropdownItem>
															</DropdownMenu>
														</Dropdown>

													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="map-right-group-list-none" v-else>{{
									$t('smartElectricity.smarElectricity.218347-350') }}</div>
							</div>
							<div class="user-top-list-page">
								<Page :total="PageListWith3CodeTotalCount" :current="PageListWith3CodePageIndex"
									:page-size="PageListWith3CodePageSize" @on-change="PageListWith3CodeChange"
									@on-page-size-change="PageListWith3CodeSizeChange" size="small" show-elevator show-sizer
									show-total placement="top" />
							</div>
						</div>
						<Spin size="large" fix v-if="!GetDepartlistsMsg"></Spin>
					</div>

					<div class="add-user-view" v-if="userListHideMsg == 108">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-20') }}
						</div>
						<div class="user-view-add2">

							<div class="map-right-group-report" @click="pstateSwitch(2)"
								:class="{ 'pstate-color': pstateType == 2, 'pstate-color1': pstateType != 2 }">{{
									$t('smartElectricity.smarElectricity.218347-351') }}</div>
							<div class="map-right-group-report" @click="pstateSwitch(3)"
								:class="{ 'pstate-color': pstateType == 3, 'pstate-color1': pstateType != 3 }">{{
									$t('smartElectricity.smarElectricity.218347-96') }}</div>
							<DatePicker v-model="startendDate" type="daterange" show-week-numbers placement="bottom-end" :placeholder="$t('smartElectricity.smarElectricity.218347-352')" style="width: 200px">
							</DatePicker>
							<Button type="primary" @click="startendDateClick">{{
								$t('smartElectricity.smarElectricity.218347-24') }}</Button>

						</div>
						<div class="user-lists">
							<div class="map-top-content-tab">
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-183') }}</div>
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-184') }}</div>
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-185') }}</div>
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-186') }}</div>
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-348') }}</div>
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-349') }}</div>
								<div class="map-top-content-tab-item-yichang tabHandle1">{{
									$t('smartElectricity.smarElectricity.218347-353') }}</div>
							</div>
							<div class="user-top-list">
								<div class="user-top-lists" v-if="PageListWith3CodeLists.length > 0">
									<div class="map-top-list-item map-top-list-item-yichang"
										v-for="(item, index) in PageListWith3CodeLists" :key="index">
										<div class="map-top-list-item-group">{{ item.UserDeviceName }}</div>
										<div class="map-top-list-item-device">{{ item.DeviceCode }}</div>
										<div class="map-top-list-item-device">{{ item.OwnerName }}</div>
										<div class="map-top-list-item-device" :title="item.AddressDetail">
											{{ item.AddressDetail }}</div>
										<div class="map-top-list-item-addr">{{ item.AbnormalTime }}</div>
										<div class="map-top-list-item-date" style="color: #f03613 !important;">
											{{ item.AbnormalName }}</div>
										<div class="map-top-list-item-handle">
											{{ pstateType == 2 ? $t('smartElectricity.smarElectricity.218347-351') :
												$t('smartElectricity.smarElectricity.218347-96') }}
										</div>
									</div>
								</div>
								<div class="map-right-group-list-none" v-else>{{
									$t('smartElectricity.smarElectricity.218347-350') }}</div>
							</div>
							<div class="user-top-list-page">
								<Page :total="PageListWith3CodeTotalCount" :current="PageListWith3CodePageIndex"
									:page-size="PageListWith3CodePageSize" @on-change="PageListWith3CodeChange1"
									@on-page-size-change="PageListWith3CodeSizeChange1" size="small" show-elevator
									show-sizer show-total placement="top" />
							</div>
						</div>
						<Spin size="large" fix v-if="!GetDepartlistsMsg"></Spin>
					</div>

					<div class="add-user-view" v-if="userListHideMsg == 109">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-21') }}
						</div>

						<div class="user-lists">
							<div class="map-top-content-tab">
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-183') }}</div>
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-184') }}</div>
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-348') }}</div>
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-349') }}</div>
								<div class="map-top-content-tab-item-yichang tabHandle1">{{
									$t('smartElectricity.smarElectricity.218347-189') }}</div>
							</div>
							<div class="user-top-list">
								<div class="user-top-lists" v-if="PageListWith3CodeLists.length > 0">
									<div class="map-top-list-item map-top-list-item-yichang"
										v-for="(item, index) in PageListWith3CodeLists" :key="index">
										<div class="map-top-list-item-group">{{ item.UserDeviceName }}</div>
										<div class="map-top-list-item-device">{{ item.DeviceCode }}</div>
										<div class="map-top-list-item-addr">{{ item.AbnormalTime }}</div>
										<div class="map-top-list-item-date" style="color: #f03613 !important;">
											{{ item.AbnormalName }}</div>
										<div class="map-top-list-item-handle">
											<div class="ivu-dropdown">

												<div class="" style="margin-top: 0.1vw;">
													<div class="map-bottom-list-item-handle-btn">
														<Dropdown trigger="click" style="width: 5vw;">
															<a href="javascript:void(0)">
																{{ $t('smartElectricity.smarElectricity.218347-94') }}
																<Icon type="md-arrow-dropdown"
																	style="margin-left: 0.5vw;" />
															</a>
															<DropdownMenu slot="list" style="width: 5vw;">
																<DropdownItem @click.native="SolveAbData(item.Id, 2, 109)">
																	{{ $t('smartElectricity.smarElectricity.218347-95') }}
																</DropdownItem>
																<DropdownItem @click.native="SolveAbData(item.Id, 3, 109)">
																	{{ $t('smartElectricity.smarElectricity.218347-96') }}
																</DropdownItem>
															</DropdownMenu>
														</Dropdown>

													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="map-right-group-list-none" v-else>{{
									$t('smartElectricity.smarElectricity.218347-350') }}</div>
							</div>
							<div class="user-top-list-page">
								<Page :total="PageListWith3CodeTotalCount" :current="PageListWith3CodePageIndex"
									:page-size="PageListWith3CodePageSize" @on-change="PageListWith3CodeChange1"
									@on-page-size-change="PageListWith3CodeSizeChange1" size="small" show-elevator
									show-sizer show-total placement="top" />
							</div>
						</div>
						<Spin size="large" fix v-if="!GetDepartlistsMsg"></Spin>
					</div>

					<div class="add-user-view" v-if="userListHideMsg == 'YHJimport'">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-8') }}
						</div>
						<div class="add-community-view-input-div">
							<div class="add-community-view-input-div-lists">
								<Form :model="formImport" label-position="right">
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-344')" class="f12"
										style="margin-right: 10%;">
										<Input v-model="formImport.mobile"
											:placeholder="$t('smartElectricity.smarElectricity.218347-345')"></Input>
									</FormItem>
									</Col>
								</Form>
							</div>
							<Col span="24" style="position: absolute; bottom: 0.75vw; left: 6vw;">
							<Button type="primary" style="font-size: 0.6vw;" @click="YHJimport">{{
								$t('smartElectricity.smarElectricity.218347-200') }}</Button>
							<Button style="font-size: 0.6vw; margin-left: 0.5vw;" @click="userListHide(false)">{{
								$t('smartElectricity.smarElectricity.218347-201') }}</Button>
							</Col>
						</div>
					</div>

					<div class="add-community-view" v-if="userListHideMsg == 110">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-354') }}
						</div>
						<div class="add-community-view-input-div">
							<div class="add-community-view-input-div-lists">
								<Form :model="formSociety" label-position="right">
									<Col span="24">
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-186')" class="f12"
										style="margin-right: 10%;">
										<Input v-model="formSociety.Cname"
											:placeholder="$t('smartElectricity.smarElectricity.218347-314')"></Input>
									</FormItem>
									</Col>
									</Col>
									<Col span="24">

									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-355')" class="f12"
										style="margin-right: 10%;">
										<Select v-model="formSociety.Province"
											:placeholder="$t('smartElectricity.smarElectricity.218347-356')"
											@on-change="changeProvince">
											<Option v-for="(item) in provinceArr" :key="item.id" :value="item.id">{{
												item.name }}</Option>
										</Select>
									</FormItem>
									</Col>
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-219')" class="f12"
										style="margin-right: 10%;">
										<Select v-model="formSociety.City"
											:placeholder="$t('smartElectricity.smarElectricity.218347-357')"
											@on-change="changeCity">
											<Option v-for="(item) in citiesArr" :key="item.id" :value="item.id">
												{{ item.name }}</Option>
										</Select>
									</FormItem>
									</Col>

									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-198')" class="f12"
										style="margin-right: 10%;">
										<Input v-model="formSociety.Remarks"
											:placeholder="$t('smartElectricity.smarElectricity.218347-199')"></Input>
									</FormItem>
									</Col>
									<!-- <Col span="8" v-show="false">
                  <FormItem label="区县" class="f12" style="margin-right: 10%;">
                    <Select v-model="formSociety.County" placeholder="请选择区县">
                      <Option v-for="(item,index) in countyArr" :key="item.id" :value="item.id">{{ item.name }}</Option>
                    </Select>
                  </FormItem>
                  </Col> -->

									</Col>

									<Col span="24">
									<!-- <Col span="8">
                  <div class="f12 ivu-form-item">
                    <div style="width: 4.25vw; text-align: right; float: left;">
                      <p class="f12-label" style="line-height: 1.7vw;">{{ $t('smartElectricity.smarElectricity.218347-195') }}</p>
                    </div>
                    <div class="ivu-form-item-content" style="margin-left: 5vw; overflow: hidden; margin-right:1.8vw;">
                      <div class="ivu-input-wrapper ivu-input-wrapper-default ivu-input-type-text">
                        <input type="text" id="suggestId" name="address_detail" :placeholder="$t('smartElectricity.smarElectricity.218347-41')" class="input_style ivu-input ivu-input-default">
                        <div id="allmap1" style="width: 0px; height: 0px;"></div>
                      </div>
                    </div>
                  </div>
                  </Col>
                  <Col span="8">
                  <FormItem :label="$t('smartElectricity.smarElectricity.218347-196')" class="f12" style="margin-right: 10%;">
                    <Input disabled v-model="userlocation.lng" :placeholder="$t('smartElectricity.smarElectricity.218347-196')"></Input>
                  </FormItem>
                  </Col>
                  <Col span="8">
                  <FormItem :label="$t('smartElectricity.smarElectricity.218347-197')" class="f12" style="margin-right: 10%;">
                    <Input disabled v-model="userlocation.lat" :placeholder="$t('smartElectricity.smarElectricity.218347-197')"></Input>
                  </FormItem>
                  </Col> -->

									</Col>
								</Form>
							</div>
							<Col span="24" style="position: absolute; bottom: 0.75vw; left: 6vw;">
							<Button type="primary" style="font-size: 0.6vw;" @click="AddRoshCommunity">{{
								$t('smartElectricity.smarElectricity.218347-200') }}</Button>
							<Button style="font-size: 0.6vw; margin-left: 0.5vw;" @click="userListHide(false)">{{
								$t('smartElectricity.smarElectricity.218347-201') }}</Button>
							</Col>
						</div>
					</div>

					<div class="add-user-view" v-if="userListHideMsg == 111">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-358') }}
						</div>

						<div class="user-lists">
							<div class="map-top-content-tab">
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-183') }}</div>
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-184') }}</div>
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-312') }}</div>
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-359') }}</div>
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-360') }}</div>
								<div class="map-top-content-tab-item-yichang tabHandle1">{{
									$t('smartElectricity.smarElectricity.218347-361') }}</div>
							</div>
							<div class="user-top-list">
								<div class="user-top-lists" v-if="DeviceLists.length > 0">
									<div class="map-top-list-item map-top-list-item-yichang" v-for="(item) in DeviceLists"
										:key="item.Id">
										<div class="map-top-list-item-group">{{ item.UserDeviceName }}</div>
										<div class="map-top-list-item-device">{{ item.DeviceCode }}</div>
										<div class="map-top-list-item-device">{{ item.UserName }}</div>
										<div class="map-top-list-item-addr" :title="item.AddressDetail">
											{{ item.AddressDetail }}</div>
										<div class="map-top-list-item-date">{{ item.UpdateTime }}</div>
										<div class="map-top-list-item-handle">
											{{ item.SwitchStatus == 1 ? $t('smartElectricity.smarElectricity.218347-49') :
												item.SwitchStatus == 2 ? $t('smartElectricity.smarElectricity.218347-50') : '--'
											}}
										</div>
									</div>
								</div>
								<div class="map-right-group-list-none" v-else>{{
									$t('smartElectricity.smarElectricity.218347-350') }}</div>
							</div>
							<div class="user-top-list-page">
								<Page :total="DeviceTotal" :current="PageListWith3CodePageIndex"
									:page-size="PageListWith3CodePageSize" @on-change="PageListWith3CodeChange2"
									@on-page-size-change="PageListWith3CodeSizeChange2" size="small" show-elevator
									show-sizer show-total placement="top" />
							</div>
						</div>
						<Spin size="large" fix v-if="!GetDepartlistsMsg"></Spin>
					</div>

					<div class="add-user-view" v-if="userListHideMsg == 112">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-362') }}
						</div>

						<div class="user-lists">
							<div class="map-top-content-tab">
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-183') }}</div>
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-184') }}</div>
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-312') }}</div>
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-359') }}</div>
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-360') }}</div>
								<div class="map-top-content-tab-item-yichang tabHandle1">{{
									$t('smartElectricity.smarElectricity.218347-361') }}</div>
							</div>
							<div class="user-top-list">
								<div class="user-top-lists" v-if="DeviceLists.length > 0">
									<div class="map-top-list-item map-top-list-item-yichang" v-for="(item) in DeviceLists"
										:key="item.Id">
										<div class="map-top-list-item-group">{{ item.UserDeviceName }}</div>
										<div class="map-top-list-item-device">{{ item.DeviceCode }}</div>
										<div class="map-top-list-item-device">{{ item.UserName }}</div>
										<div class="map-top-list-item-addr" :title="item.AddressDetail">
											{{ item.AddressDetail }}</div>
										<div class="map-top-list-item-date">{{ item.UpdateTime }}</div>
										<div class="map-top-list-item-handle">
											{{ item.SwitchStatus == 1 ? $t('smartElectricity.smarElectricity.218347-49') :
												item.SwitchStatus == 2 ? $t('smartElectricity.smarElectricity.218347-50') : '--'
											}}
										</div>
									</div>
								</div>
								<div class="map-right-group-list-none" v-else>{{
									$t('smartElectricity.smarElectricity.218347-350') }}</div>
							</div>
							<div class="user-top-list-page">
								<Page :total="DeviceTotal" :current="PageListWith3CodePageIndex"
									:page-size="PageListWith3CodePageSize" @on-change="PageListWith3CodeChange2"
									@on-page-size-change="PageListWith3CodeSizeChange2" size="small" show-elevator
									show-sizer show-total placement="top" />
							</div>
						</div>
						<Spin size="large" fix v-if="!GetDepartlistsMsg"></Spin>
					</div>

					<div class="add-user-view" v-if="userListHideMsg == 113">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-202') }}
						</div>

						<div class="user-lists">
							<div class="map-top-content-tab">
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-363') }}</div>
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-364') }}</div>
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-312') }}</div>
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-225') }}</div>
								<div class="map-top-content-tab-item-yichang tabHandle1">{{
									$t('smartElectricity.smarElectricity.218347-365') }}</div>
							</div>
							<div class="user-top-list">
								<div class="user-top-lists" v-if="GetRoshRoomAllLists.length > 0">
									<div class="map-top-list-item map-top-list-item-yichang"
										v-for="(item) in GetRoshRoomAllLists" :key="item.Id">
										<div class="map-top-list-item-group">{{ item.Vname }}</div>
										<!-- <div class="map-top-list-item-device">{{`${item.Zhuang}{{ $t('smartElectricity.smarElectricity.218347-304') }}-${item.Unit}{{ $t('smartElectricity.smarElectricity.218347-306') }}-${item.Floor}{{ $t('smartElectricity.smarElectricity.218347-496') }}{item.RoomNo}用户`}}</div> -->
										<div class="map-top-list-item-device">{{ item.AddressDetail }}</div>
										<div class="map-top-list-item-addr">{{ item.OwnerName }}</div>
										<div class="map-top-list-item-date">{{ item.OwnerPhone }}</div>
										<div class="map-top-list-item-handle">{{ item.CreateDate }}</div>
									</div>
								</div>
								<div class="map-right-group-list-none" v-else>{{
									$t('smartElectricity.smarElectricity.218347-211') }}</div>
							</div>
							<div class="user-top-list-page">
								<Page :total="GetRoshRoomAllTotal" :current="PageListWith3CodePageIndex"
									:page-size="PageListWith3CodePageSize" @on-change="PageListWith3CodeChange3"
									@on-page-size-change="PageListWith3CodeSizeChange3" size="small" show-elevator
									show-sizer show-total placement="top" />
							</div>
						</div>
						<Spin size="large" fix v-if="!GetDepartlistsMsg"></Spin>
					</div>

					<div class="add-user-view" v-if="userListHideMsg == 'RoshRoomList'">
						<div class="map-bottom-title">
							{{ ZVillageItem.Zname }}
						</div>

						<div class="user-lists">
							<div class="map-top-content-tab">
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-364') }}</div>
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-366') }}</div>
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-225') }}</div>
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-367') }}</div>
								<div class="map-top-content-tab-item-yichang tabHandle1">{{
									$t('smartElectricity.smarElectricity.218347-189') }}</div>
							</div>
							<div class="user-top-list">
								<div class="user-top-lists" v-if="GetRoshRoomLists.length > 0">
									<div class="map-top-list-item map-top-list-item-yichang"
										v-for="(item) in GetRoshRoomLists" :key="item.Id" @click="deviceDetail(item)">
										<div class="map-top-list-item-group">{{ item.RoomAddress }}</div>
										<div class="map-top-list-item-addr">{{ item.RoomName }}</div>
										<div class="map-top-list-item-date">{{ item.OwnerPhone }}</div>
										<div class="map-top-list-item-date">{{ item.RoomNo }}</div>
										<div class="map-top-list-item-handle">
											<div class="ivu-tag2 ivu-tag-cyan ivu-tag-text1" @click="EditRoshRoom(item)">{{
												$t('smartElectricity.smarElectricity.218347-368') }}
											</div>
										</div>
									</div>
								</div>
								<div class="map-right-group-list-none" v-else>{{
									$t('smartElectricity.smarElectricity.218347-211') }}</div>
							</div>
							<div class="user-top-list-page">
								<Page :total="GetRoshRoomTotal" :current="RoshRoomIndex" :page-size="RoshRoomPageSize"
									@on-change="RoshRoomChange" @on-page-size-change="RoshRoomSizeChange" size="small"
									show-elevator show-sizer show-total placement="top" />
							</div>
						</div>
						<Spin size="large" fix v-if="!GetDepartlistsMsg"></Spin>
					</div>

					<div class="add-user-view" v-if="userListHideMsg == 114">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-369') }}
						</div>
						<div class="user-lists">
							<div class="map-top-content-tab">
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-183') }}</div>
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-184') }}</div>
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-312') }}</div>
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-359') }}</div>
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-370') }}</div>
								<div class="map-top-content-tab-item-yichang tabHandle1">{{
									$t('smartElectricity.smarElectricity.218347-361') }}</div>
							</div>
							<div class="user-top-list" style="height: calc(100% - 0.4vw);">
								<div class="user-top-lists" v-if="DeviceCountList.length > 0">
									<div class="map-top-list-item map-top-list-item-yichang"
										v-for="(item) in DeviceCountList" :key="item.Id">
										<div class="map-top-list-item-group">{{ item.UserDeviceName }}</div>
										<div class="map-top-list-item-device">{{ item.DeviceCode }}</div>
										<div class="map-top-list-item-device">{{ item.UserName }}</div>
										<div class="map-top-list-item-addr">{{ item.Address }}</div>
										<div class="map-top-list-item-date">{{ item.IsOnline ?
											$t('smartElectricity.smarElectricity.218347-33') :
											$t('smartElectricity.smarElectricity.218347-52') }}</div>
										<div class="map-top-list-item-handle">
											{{ item.SwitchStatus == 1 ? $t('smartElectricity.smarElectricity.218347-49') :
												item.SwitchStatus == 2 ? $t('smartElectricity.smarElectricity.218347-50') : '--'
											}}
										</div>
									</div>
								</div>
								<div class="map-right-group-list-none" v-else>{{
									$t('smartElectricity.smarElectricity.218347-350') }}</div>
							</div>
						</div>
					</div>

					<div class="add-user-view" v-if="userListHideMsg == 115">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-371') }}
						</div>
						<div class="user-view-add1">
							<div class="map-right-group-report" @click="getSettlements(-1)"
								:class="{ 'pstate-color': stateIndex == -1, 'pstate-color1': stateIndex != -1 }">{{
									$t('smartElectricity.smarElectricity.218347-372') }}</div>
							<div class="map-right-group-report" @click="getSettlements(1)"
								:class="{ 'pstate-color': stateIndex == 1, 'pstate-color1': stateIndex != 1 }">{{
									$t('smartElectricity.smarElectricity.218347-373') }}</div>
							<div class="map-right-group-report" @click="getSettlements(0)"
								:class="{ 'pstate-color': stateIndex == 0, 'pstate-color1': stateIndex != 0 }">{{
									$t('smartElectricity.smarElectricity.218347-374') }}</div>
						</div>
						<div class="user-lists">
							<div class="map-top-content-tab">
								<div class="tabHandle3">{{ $t('smartElectricity.smarElectricity.218347-375') }}</div>
								<div class="map-top-content-tab-item-caiwu" v-show="stateIndex == 1">{{
									$t('smartElectricity.smarElectricity.218347-376') }}</div>
								<div class="map-top-content-tab-item-caiwu" v-show="stateIndex == 1">{{
									$t('smartElectricity.smarElectricity.218347-377') }}</div>
								<div class="map-top-content-tab-item-caiwu" v-show="stateIndex == 1">{{
									$t('smartElectricity.smarElectricity.218347-378') }}</div>
								<div class="map-top-content-tab-item-caiwu" v-show="stateIndex == 0">{{
									$t('smartElectricity.smarElectricity.218347-366') }}</div>
								<div class="map-top-content-tab-item-caiwu" v-show="stateIndex != -1">{{
									$t('smartElectricity.smarElectricity.218347-344') }}</div>
								<div class="map-top-content-tab-item-caiwu">{{
									$t('smartElectricity.smarElectricity.218347-379') }}</div>
								<div class="map-top-content-tab-item-caiwu"
									:title="$t('smartElectricity.smarElectricity.218347-380')">{{
										$t('smartElectricity.smarElectricity.218347-380') }}</div>
								<div class="map-top-content-tab-item-caiwu">{{
									$t('smartElectricity.smarElectricity.218347-381') }}</div>
								<div class="map-top-content-tab-item-caiwu">{{
									$t('smartElectricity.smarElectricity.218347-382') }}</div>
								<div class="map-top-content-tab-item-caiwu" v-show="stateIndex != 0">{{
									$t('smartElectricity.smarElectricity.218347-198') }}</div>
								<div class="map-top-content-tab-item-caiwu" v-show="stateIndex != -1">{{
									$t('smartElectricity.smarElectricity.218347-189') }}</div>
							</div>
							<div class="user-top-list">
								<div class="user-top-lists" v-if="settlementLists.length > 0">
									<div class="map-top-list-item1" v-for="(item) in settlementLists" :key="item.Id">
										<div class="map-top-list-item-caiwu-handle3">{{ item.SettlementOrderCode }}</div>
										<div class="map-top-list-item-caiwu" v-show="stateIndex == 1">{{ item.BankName }}
										</div>
										<div class="map-top-list-item-caiwu" v-show="stateIndex == 1">{{ item.CardNo }}
										</div>
										<div class="map-top-list-item-caiwu" v-show="stateIndex == 1">{{ item.RealName }}
										</div>
										<div class="map-top-list-item-caiwu" v-show="stateIndex == 0">{{ item.UserName }}
										</div>
										<div class="map-top-list-item-caiwu" v-show="stateIndex != -1">{{ item.MobilePhone
										}}
										</div>
										<div class="map-top-list-item-caiwu">{{ item.SettlementAmount }}</div>
										<div class="map-top-list-item-caiwu">
											{{ (item.PlatformFeePercent * 100) }}%</div>
										<div class="map-top-list-item-caiwu">{{ item.PlatformFeeAmount }}</div>
										<div class="map-top-list-item-caiwu">{{ item.SettlementAmountFinal }}</div>
										<div class="map-top-list-item-caiwu" :title="item.Remark" v-show="stateIndex != 0">
											{{ item.Remark }}</div>
										<div class="map-top-list-item-caiwu" v-show="stateIndex != -1"
											style="text-overflow: unset; width: 10vw;">
											<div v-if="stateIndex == 0" class="ivu-tag2 ivu-tag-cyan ivu-tag-text1"
												@click="dealOneSettlementHand(item)">{{
													$t('smartElectricity.smarElectricity.218347-383') }}</div>
											<div class="ivu-tag2 ivu-tag-cyan ivu-tag-text2"
												@click="getUserSettlementOrderBillsHide(item)">{{
													$t('smartElectricity.smarElectricity.218347-384') }}</div>
											<div v-if="stateIndex == 0" class="ivu-tag2 ivu-tag-cyan ivu-tag-text1"
												@click="DealCancelSettlement(item)">{{
													$t('smartElectricity.smarElectricity.218347-385') }}</div>
										</div>
									</div>
								</div>
								<div class="map-right-group-list-none" v-else>{{
									$t('smartElectricity.smarElectricity.218347-386') }}</div>
							</div>
							<div class="user-top-list-page">
								<Page :total="settlementTotalCount" :current="settlementPageIndex"
									:page-size="settlementPageSize" @on-change="settlementIndexChange"
									@on-page-size-change="settlementSizeChange" size="small" show-elevator show-sizer
									show-total placement="top" />
							</div>
						</div>
					</div>

					<div class="add-user-view" v-if="userListHideMsg == 116">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-387') }}
						</div>
						<div class="add-community-view-input-div">
							<div class="add-community-view-input-div-lists">
								<Form label-position="right">
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-388')" class="f12">
										<Input v-model="platformFeePercent"
											:placeholder="$t('smartElectricity.smarElectricity.218347-389')">
										<span slot="append">%</span>
										</Input>
									</FormItem>
									</Col>
								</Form>
							</div>
							<Col span="24" style="position: absolute; bottom: 0.75vw; left: 6vw;">
							<Button type="primary" style="font-size: 0.6vw;" @click="submit116()">{{
								$t('smartElectricity.smarElectricity.218347-390') }}</Button>
							<Button style="font-size: 0.6vw; margin-left: 0.5vw;" @click="userListHide(false)">{{
								$t('smartElectricity.smarElectricity.218347-201') }}</Button>
							</Col>
						</div>
					</div>

					<div class="add-community-view" v-if="userListHideMsg == 117">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-391') }}
						</div>
						<div class="add-community-view-input-div">
							<div class="add-community-view-input-div-lists">
								<Form :model="editItem" label-position="right">
									<Col span="24">
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-186')" class="f12"
										style="margin-right: 10%;">
										<Input v-model="editItem.Cname"
											:placeholder="$t('smartElectricity.smarElectricity.218347-314')"></Input>
									</FormItem>
									</Col>
									</Col>
									<Col span="24">

									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-355')" class="f12"
										style="margin-right: 10%;">
										<Select v-model="editItem.ProvinceCode"
											:placeholder="$t('smartElectricity.smarElectricity.218347-356')"
											@on-change="changeProvince">
											<Option v-for="(item) in provinceArr" :key="item.id" :value="item.id">{{
												item.name }}</Option>
										</Select>
									</FormItem>
									</Col>
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-219')" class="f12"
										style="margin-right: 10%;">
										<Select v-model="editItem.CityCode"
											:placeholder="$t('smartElectricity.smarElectricity.218347-357')"
											@on-change="changeCity">
											<Option v-for="(item) in citiesArr" :key="item.id" :value="item.id">
												{{ item.name }}</Option>
										</Select>
									</FormItem>
									</Col>

									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-198')" class="f12"
										style="margin-right: 10%;">
										<Input v-model="editItem.Remarks"
											:placeholder="$t('smartElectricity.smarElectricity.218347-199')"></Input>
									</FormItem>
									</Col>

									</Col>

									<!-- <Col span="8">
									<FormItem label="区县" class="f12" style="margin-right: 10%;">
										<Select v-model="editItem.AreaCode" placeholder="请选择区县">
											<Option v-for="(item,index) in countyArr" :key="item.id" :value="item.id">
												{{ item.name }}</Option>
										</Select>
									</FormItem>
									</Col> -->

									<Col span="24">
									<!-- <Col span="8">
									<div class="f12 ivu-form-item">
										<div style="width: 4.25vw; text-align: right; float: left;">
											<p class="f12-label" style="line-height: 1.7vw;">{{ $t('smartElectricity.smarElectricity.218347-195') }}</p>
										</div>
										<div class="ivu-form-item-content"
											style="margin-left: 5vw; overflow: hidden; margin-right:1.8vw;">
											<div
												class="ivu-input-wrapper ivu-input-wrapper-default ivu-input-type-text">
												<input @click="addressDetailClick()" type="text"
													v-show="address_detail_input" v-model="address_detail"
:													placeholder="$t('smartElectricity.smarElectricity.218347-41')"
													class="input_style ivu-input ivu-input-default ivu-input-default-suggest-class">
												<input type="text" v-show="!address_detail_input" id="suggestId"
													name="address_detail" :placeholder="$t('smartElectricity.smarElectricity.218347-41')"
													class="input_style ivu-input ivu-input-default ivu-input-default-suggest-class">
												<div id="allmap1" style="width: 0px; height: 0px;"></div>
											</div>
										</div>
									</div>
									</Col>
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-196')" class="f12" style="margin-right: 10%;">
										<Input disabled v-model="userlocation.lng" :placeholder="$t('smartElectricity.smarElectricity.218347-196')"></Input>
									</FormItem>
									</Col>
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-197')" class="f12" style="margin-right: 10%;">
										<Input disabled v-model="userlocation.lat" :placeholder="$t('smartElectricity.smarElectricity.218347-197')"></Input>
									</FormItem>
									</Col> -->

									</Col>
								</Form>
							</div>
							<Col span="24" style="position: absolute; bottom: 0.75vw; left: 6vw;">
							<Button type="primary" style="font-size: 0.6vw;" @click="EditRoshCommunityAxios">{{
								$t('smartElectricity.smarElectricity.218347-390') }}</Button>
							<Button style="font-size: 0.6vw; margin-left: 0.5vw;" @click="userListHide(false)">{{
								$t('smartElectricity.smarElectricity.218347-201') }}</Button>
							</Col>
						</div>
					</div>

					<!-- 添加街道 addVillage-->
					<div class="add-community-view" v-if="userListHideMsg == 132">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-392') }}
						</div>
						<div class="add-community-view-input-div">
							<div class="add-community-view-input-div-lists">
								<Form :model="addRoshSVillageItem" label-position="right">
									<Col span="24">
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-393')" class="f12"
										style="margin-right: 10%;">
										<Input v-model="addRoshSVillageItem.Sname"
											:placeholder="$t('smartElectricity.smarElectricity.218347-394')"></Input>
									</FormItem>
									</Col>
									</Col>

									<Col span="24">
									<Col span="8">
									<div class="f12 ivu-form-item">
										<div style="width: 4.25vw; text-align: right; float: left;">
											<p class="f12-label" style="line-height: 1.7vw;">{{
												$t('smartElectricity.smarElectricity.218347-195') }}</p>
										</div>
										<div class="ivu-form-item-content"
											style="margin-left: 5vw; overflow: hidden; margin-right:1.8vw;">
											<div class="ivu-input-wrapper ivu-input-wrapper-default ivu-input-type-text">
												<input type="text" id="suggestId" name="address_detail"
													:placeholder="$t('smartElectricity.smarElectricity.218347-41')"
													class="input_style ivu-input ivu-input-default">
												<div id="allmap1" style="width: 0px; height: 0px;"></div>
											</div>
										</div>
									</div>
									</Col>

									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-196')" class="f12"
										style="margin-right: 10%;">
										<Input disabled v-model="userlocation.lng"
											:placeholder="$t('smartElectricity.smarElectricity.218347-196')"></Input>
									</FormItem>
									</Col>
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-197')" class="f12"
										style="margin-right: 10%;">
										<Input disabled v-model="userlocation.lat"
											:placeholder="$t('smartElectricity.smarElectricity.218347-197')"></Input>
									</FormItem>
									</Col>

									</Col>

									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-198')" class="f12"
										style="margin-right: 10%;">
										<Input v-model="addRoshSVillageItem.Remarks"
											:placeholder="$t('smartElectricity.smarElectricity.218347-199')"></Input>
									</FormItem>
									</Col>
								</Form>
							</div>
							<Col span="24" style="position: absolute; bottom: 0.75vw; left: 6vw;">
							<Button type="primary" style="font-size: 0.6vw;" @click="addRoshSVillageItemAxiso">{{
								$t('smartElectricity.smarElectricity.218347-200') }}</Button>
							<Button style="font-size: 0.6vw; margin-left: 0.5vw;" @click="userListHide(false)">{{
								$t('smartElectricity.smarElectricity.218347-201') }}</Button>
							</Col>
						</div>
					</div>


					<!-- {{ $t('smartElectricity.smarElectricity.218347-395') }} -->
					<div class="add-community-view" v-if="userListHideMsg == 133">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-395') }}
						</div>
						<div class="add-community-view-input-div">
							<div class="add-community-view-input-div-lists">
								<Form :model="EditRoshSVillageItem" label-position="right">
									<Col span="24">
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-396')" class="f12"
										style="margin-right: 10%;">
										<Input v-model="EditRoshSVillageItem.Sname"
											:placeholder="$t('smartElectricity.smarElectricity.218347-397')"></Input>
									</FormItem>
									</Col>
									</Col>

									<Col span="24">
									<Col span="8">
									<div class="f12 ivu-form-item">
										<div style="width: 4.25vw; text-align: right; float: left;">
											<p class="f12-label" style="line-height: 1.7vw;">{{
												$t('smartElectricity.smarElectricity.218347-195') }}</p>
										</div>
										<div class="ivu-form-item-content"
											style="margin-left: 5vw; overflow: hidden; margin-right:1.8vw;">
											<div class="ivu-input-wrapper ivu-input-wrapper-default ivu-input-type-text">
												<input @click="addressDetailClick()" type="text"
													v-show="address_detail_input" v-model="address_detail"
													:placeholder="$t('smartElectricity.smarElectricity.218347-41')"
													class="input_style ivu-input ivu-input-default ivu-input-default-suggest-class">
												<input type="text" v-show="!address_detail_input" id="suggestId"
													name="address_detail"
													:placeholder="$t('smartElectricity.smarElectricity.218347-41')"
													class="input_style ivu-input ivu-input-default ivu-input-default-suggest-class">
												<div id="allmap1" style="width: 0px; height: 0px;"></div>
											</div>
										</div>
									</div>
									</Col>
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-196')" class="f12"
										style="margin-right: 10%;">
										<Input disabled v-model="userlocation.lng"
											:placeholder="$t('smartElectricity.smarElectricity.218347-196')"></Input>
									</FormItem>
									</Col>
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-197')" class="f12"
										style="margin-right: 10%;">
										<Input disabled v-model="userlocation.lat"
											:placeholder="$t('smartElectricity.smarElectricity.218347-197')"></Input>
									</FormItem>
									</Col>
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-198')" class="f12"
										style="margin-right: 10%;">
										<Input v-model="EditRoshSVillageItem.Remarks"
											:placeholder="$t('smartElectricity.smarElectricity.218347-199')"></Input>
									</FormItem>
									</Col>
									</Col>
								</Form>
							</div>
							<Col span="24" style="position: absolute; bottom: 0.75vw; left: 6vw;">
							<Button type="primary" style="font-size: 0.6vw;" @click="EditRoshSVillageAxios">{{
								$t('smartElectricity.smarElectricity.218347-390') }}</Button>
							<Button style="font-size: 0.6vw; margin-left: 0.5vw;" @click="userListHide(false)">{{
								$t('smartElectricity.smarElectricity.218347-201') }}</Button>
							</Col>
						</div>
					</div>

					<!-- 添加村落 -->
					<div class="add-community-view" v-if="userListHideMsg == 134">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-398') }}
						</div>
						<div class="add-community-view-input-div">
							<div class="add-community-view-input-div-lists">
								<Form :model="villageForm" label-position="right">
									<Col span="24">
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-399')" class="f12"
										style="margin-right: 10%;">
										<Input v-model="villageForm.Zname"
											:placeholder="$t('smartElectricity.smarElectricity.218347-400')"></Input>
									</FormItem>
									</Col>
									</Col>

									<Col span="24">
									<Col span="8">
									<div class="f12 ivu-form-item">
										<div style="width: 4.25vw; text-align: right; float: left;">
											<p class="f12-label" style="line-height: 1.7vw;">{{
												$t('smartElectricity.smarElectricity.218347-195') }}</p>
										</div>
										<div class="ivu-form-item-content"
											style="margin-left: 5vw; overflow: hidden; margin-right:1.8vw;">
											<div class="ivu-input-wrapper ivu-input-wrapper-default ivu-input-type-text">
												<input type="text" id="suggestId" name="address_detail"
													:placeholder="$t('smartElectricity.smarElectricity.218347-41')"
													class="input_style ivu-input ivu-input-default">
												<div id="allmap1" style="width: 0px; height: 0px;"></div>
											</div>
										</div>
									</div>
									</Col>

									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-196')" class="f12"
										style="margin-right: 10%;">
										<Input disabled v-model="userlocation.lng"
											:placeholder="$t('smartElectricity.smarElectricity.218347-196')"></Input>
									</FormItem>
									</Col>
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-197')" class="f12"
										style="margin-right: 10%;">
										<Input disabled v-model="userlocation.lat"
											:placeholder="$t('smartElectricity.smarElectricity.218347-197')"></Input>
									</FormItem>
									</Col>

									</Col>

									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-198')" class="f12"
										style="margin-right: 10%;">
										<Input v-model="villageForm.Remarks"
											:placeholder="$t('smartElectricity.smarElectricity.218347-199')"></Input>
									</FormItem>
									</Col>
								</Form>
							</div>
							<Col span="24" style="position: absolute; bottom: 0.75vw; left: 6vw;">
							<Button type="primary" style="font-size: 0.6vw;" @click="addVillageAxiso()">{{
								$t('smartElectricity.smarElectricity.218347-200') }}</Button>
							<Button style="font-size: 0.6vw; margin-left: 0.5vw;" @click="userListHide(false)">{{
								$t('smartElectricity.smarElectricity.218347-201') }}</Button>
							</Col>
						</div>
					</div>

					<!-- {{ $t('smartElectricity.smarElectricity.218347-401') }} -->
					<div class="add-community-view" v-if="userListHideMsg == 130">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-401') }}
						</div>
						<div class="add-community-view-input-div">
							<div class="add-community-view-input-div-lists">
								<Form :model="ZVillageItem" label-position="right">
									<Col span="24">
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-399')" class="f12"
										style="margin-right: 10%;">
										<Input v-model="ZVillageItem.Zname"
											:placeholder="$t('smartElectricity.smarElectricity.218347-400')"></Input>
									</FormItem>
									</Col>
									</Col>

									<Col span="24">
									<Col span="8">
									<div class="f12 ivu-form-item">
										<div style="width: 4.25vw; text-align: right; float: left;">
											<p class="f12-label" style="line-height: 1.7vw;">{{
												$t('smartElectricity.smarElectricity.218347-195') }}</p>
										</div>
										<div class="ivu-form-item-content"
											style="margin-left: 5vw; overflow: hidden; margin-right:1.8vw;">
											<div class="ivu-input-wrapper ivu-input-wrapper-default ivu-input-type-text">
												<input @click="addressDetailClick()" type="text"
													v-show="address_detail_input" v-model="address_detail"
													:placeholder="$t('smartElectricity.smarElectricity.218347-41')"
													class="input_style ivu-input ivu-input-default ivu-input-default-suggest-class">
												<input type="text" v-show="!address_detail_input" id="suggestId"
													name="address_detail"
													:placeholder="$t('smartElectricity.smarElectricity.218347-41')"
													class="input_style ivu-input ivu-input-default ivu-input-default-suggest-class">
												<div id="allmap1" style="width: 0px; height: 0px;"></div>
											</div>
										</div>
									</div>
									</Col>
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-196')" class="f12"
										style="margin-right: 10%;">
										<Input disabled v-model="userlocation.lng"
											:placeholder="$t('smartElectricity.smarElectricity.218347-196')"></Input>
									</FormItem>
									</Col>
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-197')" class="f12"
										style="margin-right: 10%;">
										<Input disabled v-model="userlocation.lat"
											:placeholder="$t('smartElectricity.smarElectricity.218347-197')"></Input>
									</FormItem>
									</Col>
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-198')" class="f12"
										style="margin-right: 10%;">
										<Input v-model="ZVillageItem.Remarks"
											:placeholder="$t('smartElectricity.smarElectricity.218347-199')"></Input>
									</FormItem>
									</Col>
									</Col>
								</Form>
							</div>
							<Col span="24" style="position: absolute; bottom: 0.75vw; left: 6vw;">
							<Button type="primary" style="font-size: 0.6vw;" @click="EditRoshZVillageAxios">{{
								$t('smartElectricity.smarElectricity.218347-390') }}</Button>
							<Button style="font-size: 0.6vw; margin-left: 0.5vw;" @click="userListHide(false)">{{
								$t('smartElectricity.smarElectricity.218347-201') }}</Button>
							</Col>
						</div>
					</div>

					<div class="add-community-view" v-if="userListHideMsg == 118">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-402') }}
						</div>
						<div class="add-community-view-input-div">
							<div class="add-community-view-input-div-lists">
								<Form :model="editItem" label-position="right">
									<Col span="24">
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-193')" class="f12"
										style="margin-right: 10%;">
										<Input v-model="editItem.Vname"
											:placeholder="$t('smartElectricity.smarElectricity.218347-194')"></Input>
									</FormItem>
									</Col>
									</Col>

									<Col span="24">
									<Col span="8">
									<div class="f12 ivu-form-item">
										<div style="width: 4.25vw; text-align: right; float: left;">
											<p class="f12-label" style="line-height: 1.7vw;">{{
												$t('smartElectricity.smarElectricity.218347-195') }}</p>
										</div>
										<div class="ivu-form-item-content"
											style="margin-left: 5vw; overflow: hidden; margin-right:1.8vw;">
											<div class="ivu-input-wrapper ivu-input-wrapper-default ivu-input-type-text">
												<input @click="addressDetailClick()" type="text"
													v-show="address_detail_input" v-model="address_detail"
													:placeholder="$t('smartElectricity.smarElectricity.218347-41')"
													class="input_style ivu-input ivu-input-default ivu-input-default-suggest-class">
												<input type="text" v-show="!address_detail_input" id="suggestId"
													name="address_detail"
													:placeholder="$t('smartElectricity.smarElectricity.218347-41')"
													class="input_style ivu-input ivu-input-default ivu-input-default-suggest-class">
												<div id="allmap1" style="width: 0px; height: 0px;"></div>
											</div>
										</div>
									</div>
									</Col>
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-196')" class="f12"
										style="margin-right: 10%;">
										<Input disabled v-model="userlocation.lng"
											:placeholder="$t('smartElectricity.smarElectricity.218347-196')"></Input>
									</FormItem>
									</Col>
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-197')" class="f12"
										style="margin-right: 10%;">
										<Input disabled v-model="userlocation.lat"
											:placeholder="$t('smartElectricity.smarElectricity.218347-197')"></Input>
									</FormItem>
									</Col>
									<Col span="8">
									<FormItem :label="$t('smartElectricity.smarElectricity.218347-198')" class="f12"
										style="margin-right: 10%;">
										<Input v-model="editItem.Remarks"
											:placeholder="$t('smartElectricity.smarElectricity.218347-199')"></Input>
									</FormItem>
									</Col>
									</Col>
								</Form>
							</div>
							<Col span="24" style="position: absolute; bottom: 0.75vw; left: 6vw;">
							<Button type="primary" style="font-size: 0.6vw;" @click="EditRoshVillageAxios">{{
								$t('smartElectricity.smarElectricity.218347-390') }}</Button>
							<Button style="font-size: 0.6vw; margin-left: 0.5vw;" @click="userListHide(false)">{{
								$t('smartElectricity.smarElectricity.218347-201') }}</Button>
							</Col>
						</div>
					</div>

					<div class="add-user-view" v-if="userListHideMsg == 119">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-290') }}
						</div>

						<div class="add-community-view-input-div">
							<div class="add-community-view-input-div-lists">
								<Form :model="editItem" label-position="right">
									<Row>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-301')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="editItem.OwnerPhone"
												:placeholder="$t('smartElectricity.smarElectricity.218347-302')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-304')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="editItem.Zhuang"
												:placeholder="$t('smartElectricity.smarElectricity.218347-305')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-306')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="editItem.Unit"
												:placeholder="$t('smartElectricity.smarElectricity.218347-307')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-308')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="editItem.Floor"
												:placeholder="$t('smartElectricity.smarElectricity.218347-309')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-310')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="editItem.RoomNo"
												:placeholder="$t('smartElectricity.smarElectricity.218347-311')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-312')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="editItem.OwnerName"
												:placeholder="$t('smartElectricity.smarElectricity.218347-313')"></Input>
										</FormItem>
										</Col>
										<Col span="24">
										<Col span="8">
										<div class="f12 ivu-form-item">
											<div style="width: 4.25vw; text-align: right; float: left;">
												<p class="f12-label" style="line-height: 1.7vw;">{{
													$t('smartElectricity.smarElectricity.218347-195') }}</p>
											</div>
											<div class="ivu-form-item-content"
												style="margin-left: 5vw; overflow: hidden; margin-right:1.8vw;">
												<div
													class="ivu-input-wrapper ivu-input-wrapper-default ivu-input-type-text">
													<input @click="addressDetailClick()" type="text"
														v-show="address_detail_input" v-model="address_detail" :placeholder="$t('smartElectricity.smarElectricity.218347-41')"
														class="input_style ivu-input ivu-input-default ivu-input-default-suggest-class">
													<input type="text" v-show="!address_detail_input" id="suggestId"
														name="address_detail"
														:placeholder="$t('smartElectricity.smarElectricity.218347-41')"
														class="input_style ivu-input ivu-input-default ivu-input-default-suggest-class">
													<div id="allmap1" style="width: 0px; height: 0px;"></div>
												</div>
											</div>
										</div>
										</Col>

										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-196')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="userlocation.lng"
												:placeholder="$t('smartElectricity.smarElectricity.218347-196')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-197')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="userlocation.lat"
												:placeholder="$t('smartElectricity.smarElectricity.218347-197')"></Input>
										</FormItem>
										</Col>

										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-186')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="editItem.AddressDetail"
												:placeholder="$t('smartElectricity.smarElectricity.218347-314')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-198')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="editItem.Remarks"
												:placeholder="$t('smartElectricity.smarElectricity.218347-199')"></Input>
										</FormItem>
										</Col>
									</Row>
								</Form>
							</div>
							<Col span="24" style="position: absolute; bottom: 0.75vw; left: 6vw;">
							<Button type="primary" style="font-size: 0.6vw;" @click="EditRoshRoomAxios()">{{
								$t('smartElectricity.smarElectricity.218347-390') }}</Button>
							<Button style="font-size: 0.6vw; margin-left: 0.5vw;"
								@click="userListHide(true, 'RoshRoomList')">{{
									$t('smartElectricity.smarElectricity.218347-201') }}</Button>
							</Col>
						</div>
					</div>

					<div class="add-user-view" v-if="userListHideMsg == 120">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-403') }}
						</div>
						<div class="user-lists">
							<div class="map-top-content-tab">
								<div class="map-top-content-tab-item-yichang">{{$t('smartElectricity.smarElectricity.218347-404')}}</div>
								<div class="map-top-content-tab-item-yichang">{{$t('smartElectricity.smarElectricity.218347-405')}}</div>
								<div class="map-top-content-tab-item-yichang">{{$t('smartElectricity.smarElectricity.218347-406')}}</div>
								<div class="map-top-content-tab-item-yichang">IMEI</div>
								<div class="map-top-content-tab-item-yichang tabHandle1">{{$t('smartElectricity.smarElectricity.218347-407')}}</div>
							</div>
							<div class="user-top-list" style="height: calc(100% - 0.4vw);">
								<div class="user-top-lists" v-if="qtcgqTtItemLists.length > 0">
									<div class="map-top-list-item map-top-list-item-yichang"
										v-for="(item) in qtcgqTtItemLists" :key="item.Id">
										<div class="map-top-list-item-group">{{ item.TanTouName }}</div>
										<div class="map-top-list-item-device">{{ item.DangQianNdz }}</div>
										<div class="map-top-list-item-addr">{{ item.BaojingZt }}</div>
										<div class="map-top-list-item-date">{{ item.IMEI }}</div>
										<div class="map-top-list-item-handle">{{ item.CreateTime }}</div>
									</div>
								</div>
								<div class="map-right-group-list-none" v-else>{{
									$t('smartElectricity.smarElectricity.218347-408') }}</div>
							</div>
						</div>
						<Spin size="large" fix v-if="!qtcgqTtItemMsg"></Spin>
					</div>

					<div class="user-view" v-if="userListHideMsg == 121">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-409') }}
						</div>
						<div class="user-view-add1">
							<div @click="addModel(userListHideMsg + 16, {})" class="ivu-tag2 ivu-tag-green ivu-tag-text2">
								{{ $t('smartElectricity.smarElectricity.218347-410') }}</div>
						</div>
						<div class="user-lists">
							<div class="map-top-content-tab">
								<div class="map-top-content-tab-item">{{ $t('smartElectricity.smarElectricity.218347-411')}}</div>
								<div class="map-top-content-tab-item">{{ $t('smartElectricity.smarElectricity.218347-412')}}</div>
								<div class="map-top-content-tab-item">{{ $t('smartElectricity.smarElectricity.218347-413')}}</div>
								<div class="map-top-content-tab-item">{{ $t('smartElectricity.smarElectricity.218347-414')}}</div>
								<div class="map-top-content-tab-item">{{ $t('smartElectricity.smarElectricity.218347-415')}}</div>
								<div class="map-top-content-tab-item tabHandle1">{{$t('smartElectricity.smarElectricity.218347-189') }}</div>
							</div>
							<div class="user-top-list">
								<div class="user-top-lists" v-if="AuthModuleCodeLists.length > 0">
									<div class="map-top-list-item" v-for="(item) in AuthModuleCodeLists" :key="item.Id">
										<div class="map-top-list-item-group">{{ item.UserName }}</div>
										<div class="map-top-list-item-type">{{ item.MobilePhone }}</div>
										<div class="map-top-list-item-device" :title="item.AuthCode">{{ item.AuthCode }}
										</div>
										<div class="map-top-list-item-addr">
											{{ item.AuthType == 1 ? $t('smartElectricity.smarElectricity.218347-416') :
												item.AuthType == 2 ? $t('smartElectricity.smarElectricity.218347-417') :
													$t('smartElectricity.smarElectricity.218347-418') }}</div>
										<div class="map-top-list-item-date">{{ item.AuthModuleValues | modeCount }}</div>
										<div class="map-top-list-item-handle">
											<div class="ivu-tag2 ivu-tag-cyan ivu-tag-text1"
												@click="addModel(userListHideMsg + 16, item)">{{
													$t('smartElectricity.smarElectricity.218347-64') }}</div>
											<div class="ivu-tag2 ivu-tag-orange ivu-tag-text3"
												@click="DelOneAuthModuleCode(item.Id)">{{
													$t('smartElectricity.smarElectricity.218347-66') }}</div>
										</div>
									</div>
								</div>
								<div class="map-right-group-list-none" v-else>{{
									$t('smartElectricity.smarElectricity.218347-419') }}</div>
							</div>
							<div class="user-top-list-page">
								<Page :total="AuthModuleCodeTotalCount" @on-change="AuthModuleCodeIndexChange"
									@on-page-size-change="AuthModuleCodeSizeChange" size="small" show-elevator show-sizer
									show-total placement="top" />
							</div>
						</div>
						<Spin size="large" fix v-if="!LoaderUserListsMsg"></Spin>
					</div>

					<div class="user-view" v-if="userListHideMsg == 122">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-420') }}
						</div>
						<div class="add-community-view-input-div">
							<div class="add-community-view-input-div-lists">
								<Form label-position="right">
									<Row>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-421')" class="f12"
											style="margin-right: 10%;">
											<Input disabled v-model="ReplyTime"
												:placeholder="$t('smartElectricity.smarElectricity.218347-422')"></Input>
										</FormItem>
										</Col>
									</Row>
								</Form>
							</div>
							<Col span="24" style="position: absolute; bottom: 0.75vw; left: 6vw;">
							<Button type="primary" style="font-size: 0.6vw;" @click="SetSZ_ModbusV3">{{
								$t('smartElectricity.smarElectricity.218347-423') }}</Button>
							<Button type="success" style="font-size: 0.6vw; margin-left: 0.5vw;"
								@click="DeviceRWByTypeModbusV3">{{ $t('smartElectricity.smarElectricity.218347-424')
								}}</Button>
							</Col>
						</div>
					</div>

					<div class="add-user-view" v-if="userListHideMsg == 137">
						<div class="map-bottom-title">
							{{ AuthModelState == 1 ? $t('smartElectricity.smarElectricity.218347-410') :
								$t('smartElectricity.smarElectricity.218347-425') }}
						</div>

						<div class="add-community-view-input-div">
							<div class="add-community-view-input-div-lists">
								<Form :model="AuthModel" label-position="right">
									<Row>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-412')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="AuthModel.MobilePhone"
												:placeholder="$t('smartElectricity.smarElectricity.218347-426')"></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-414')" class="f12"
											style="margin-right: 10%;">
											<Select v-model="AuthModel.AuthType"
												:placeholder="$t('smartElectricity.smarElectricity.218347-427')">
												<Option value="1">{{ $t('smartElectricity.smarElectricity.218347-416') }}
												</Option>
												<Option value="2">{{ $t('smartElectricity.smarElectricity.218347-417') }}
												</Option>
												<Option value="3">{{ $t('smartElectricity.smarElectricity.218347-418') }}
												</Option>
											</Select>
										</FormItem>
										</Col>
									</Row>
									<Row>
										<Col span="8" v-show="AuthModel.AuthType == '2'">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-428')" class="f12"
											style="margin-right: 10%;">
											<DatePicker v-model="AuthModel.ValidDateTimeStart" type="date"
												style="width:11.9vw"
												:placeholder="$t('smartElectricity.smarElectricity.218347-429')">
											</DatePicker>
										</FormItem>
										</Col>
										<Col span="8" v-show="AuthModel.AuthType == '2'">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-430')" class="f12"
											style="margin-right: 10%;">
											<DatePicker v-model="AuthModel.ValidDateTimeEnd" type="date"
												style="width:11.9vw"
												:placeholder="$t('smartElectricity.smarElectricity.218347-431')">
											</DatePicker>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-415')" class="f12"
											style="margin-right: 10%;">
											<Input v-model="AuthModelTitle" readonly
												:placeholder="$t('smartElectricity.smarElectricity.218347-432')" search :enter-button="$t('smartElectricity.smarElectricity.218347-433')"
												@on-search="selectModule" />
											<!-- <Select v-model="AuthModel.AuthModules" disabled multiple :max-tag-count="2" :placeholder="$t('smartElectricity.smarElectricity.218347-432')">
                      <Option v-for="item in ModuleLists" :key="item.ModuleValue" :value="item.ModuleValue">{{item.ModuleName}}</Option>
                    </Select> -->
										</FormItem>
										</Col>
									</Row>
								</Form>
							</div>
							<Col span="24" style="position: absolute; bottom: 0.75vw; left: 6vw;">
							<Button type="primary" style="font-size: 0.6vw;" @click="setAuthModuleCode()">{{ AuthModelState
								== 1 ? $t('smartElectricity.smarElectricity.218347-434') :
								$t('smartElectricity.smarElectricity.218347-390') }}</Button>
							<Button style="font-size: 0.6vw; margin-left: 0.5vw;" @click="AuthModel = {}">{{
								$t('smartElectricity.smarElectricity.218347-238') }}</Button>
							</Col>
						</div>
					</div>

					<div class="add-user-view" v-if="userListHideMsg == 153">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-433') }}
						</div>

						<div class="add-community-view-input-div">
							<div class="add-community-view-input-div-lists module-view">
								<div class="module-view-left">
									<div class="module-view-left-lists">
										<div class="module-view-left-item"
											:class="{ 'module-view-left-item-select': ModuleIndex == item.ModuleType, 'module-view-left-item-select-off': ModuleIndex != item.ModuleType }"
											v-for="(item) in ModuleLists" :key="item.ModuleType"
											@click="UnfoldModule(item)">
											<div class="report-content-left-item-view">
												<div class="report-content-left-item-view-inco"
													@click="ModuleItemAll(item.Modules, item.ModuleType)">
													<img v-show="ModuleSelectedHeadLists.indexOf(item.ModuleType) >= 0"
														src="../../assets/electricity/select.png" alt="">
													<img v-show="ModuleSelectedHeadLists.indexOf(item.ModuleType) < 0"
														src="../../assets/electricity/cancel.png" alt="">
												</div>
												<div class="report-content-left-item-view-text">{{ item.ModuleTypeName }}
												</div>
											</div>
											<div class="report-content-left-item-img">
												<img src="../../assets/electricity/arrow.png" alt="">
											</div>
										</div>
									</div>
								</div>
								<div class="module-view-right">
									<div class="module-view-right-mode">
										<div class="module-select-item" v-for="(item) in ModuleItemList"
											:key="item.ModuleValue" @click="ModuleItemClick(item)">
											<div class="module-select-item-select">
												<img v-show="ModuleSelectedLists.indexOf(item.ModuleValue) >= 0"
													src="../../assets/electricity/select.png" alt="">
												<img v-show="ModuleSelectedLists.indexOf(item.ModuleValue) < 0"
													src="../../assets/electricity/cancel.png" alt="">
											</div>
											<div class="module-select-item-title">{{ item.ModuleName }}</div>
										</div>
									</div>
								</div>
							</div>
							<Col span="24" style="position: absolute; bottom: 0.75vw; left: 6vw;">
							<Button type="primary" style="font-size: 0.6vw;" @click="saveModule">{{
								$t('smartElectricity.smarElectricity.218347-390') }}</Button>
							</Col>
						</div>
					</div>

					<!-- 手机号检查导入设备视图 -->
					<div class="add-user-view" v-if="userListHideMsg == 90">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-40') }}
						</div>
						<div class="user-lists">
							<div class="map-top-content-tab">
								<div class="map-top-content-tab-add-device-item tabHandle2">
									<Checkbox :indeterminate="indeterminate" :value="checkAll"
										@click.prevent.native="handleCheckAll"></Checkbox>
								</div>
								<div class="map-top-content-tab-add-device-item">{{
									$t('smartElectricity.smarElectricity.218347-184') }}</div>
								<div class="map-top-content-tab-add-device-item">{{
									$t('smartElectricity.smarElectricity.218347-183') }}</div>
								<div class="map-top-content-tab-add-device-item">{{
									$t('smartElectricity.smarElectricity.218347-327') }}</div>
								<div class="map-top-content-tab-add-device-item">{{
									$t('smartElectricity.smarElectricity.218347-361') }}</div>
								<div class="map-top-content-tab-add-device-item">{{
									$t('smartElectricity.smarElectricity.218347-359') }}</div>
							</div>
							<div class="user-top-list">
								<div class="user-top-lists" v-if="GetDeviceList.length > 0">
									<div class="map-top-list-add-device-item" v-for="(item) in GetDeviceList"
										:key="item.Id">
										<div class="map-top-list-add-device-item-handle">
											<Checkbox v-model="item.single" @on-change="checkAllGroupChange(item)">
											</Checkbox>
										</div>
										<div class="map-top-list-item-group">{{ item.DeviceCode }}</div>
										<div class="map-top-list-item-device">{{ item.UserDeviceName }}</div>
										<div class="map-top-list-item-addr">{{ item.DeviceId | deviceType }}</div>
										<div class="map-top-list-item-date">{{ item.IsOnline ?
											$t('smartElectricity.smarElectricity.218347-33') :
											$t('smartElectricity.smarElectricity.218347-52') }}</div>
										<div class="map-top-list-item-addr" :title="item.Address">{{ item.Address }}</div>
									</div>
								</div>
								<div class="map-right-group-list-none" v-else>{{
									$t('smartElectricity.smarElectricity.218347-435') }}</div>
							</div>
							<Col span="24" style="position: absolute; bottom: 0.75vw; left: 6vw;">
							<Button type="primary" style="font-size: 0.6vw;" @click="submit90()">{{
								$t('smartElectricity.smarElectricity.218347-436') }}</Button>
							<Button style="font-size: 0.6vw; margin-left: 0.5vw;"
								@click="userListHide(true, fromImport ? 'YHJimport' : (userListHideMsg + 16))">{{
									$t('smartElectricity.smarElectricity.218347-10') }}</Button>
							</Col>
							<!-- <div class="user-top-list-page">
                <Page :total="CompanyTotalCount" @on-change="companyChange" @on-page-size-change="companySizeChange"
                  size="small" show-elevator show-sizer placement="top" />
              </div> -->
						</div>
					</div>

					<!-- 结算处理 -->
					<div class="add-user-view" v-if="userListHideMsg == 99">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-437') }}
						</div>
						<div class="add-community-view-input-div">
							<div class="add-community-view-input-div-lists">
								<Form label-position="right">
									<Row>
										<Col span="7">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-438')" class="f12">
											<Input v-model="settlementOrderCode" disabled></Input>
										</FormItem>
										</Col>
										<Col span="7">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-388')" class="f12">
											<Input v-model="platformFeePercent"
												:placeholder="$t('smartElectricity.smarElectricity.218347-439')">
											<span slot="append">%</span>
											</Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-440')" class="f12">
											<Select v-model="finAccountId"
												:placeholder="$t('smartElectricity.smarElectricity.218347-441')">
												<Option v-for="(item) in FinAccountLists" :key="item.Id" :value="item.Id"
													:label="item.BankName">
													<span>{{ item.BankName }}</span>
													<span style="float:right;color:#aaa">{{ item.CardNo }}</span>
												</Option>
											</Select>
										</FormItem>
										</Col>
										<Col span="7">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-379')" class="f12">
											<Input v-model="calSettlementAmount"
												:placeholder="$t('smartElectricity.smarElectricity.218347-199')" disabled>
											</Input>
										</FormItem>
										</Col>
										<Col span="7">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-381')" class="f12">
											<Input v-model="calPlatformFeeAmount" disabled></Input>
										</FormItem>
										</Col>
										<Col span="8">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-382')" class="f12">
											<Input v-model="calSettlementAmountFinal" disabled></Input>
										</FormItem>
										</Col>
										<Col span="7">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-198')" class="f12">
											<Input v-model="remark"
												:placeholder="$t('smartElectricity.smarElectricity.218347-199')">
											</Input>
										</FormItem>
										</Col>
									</Row>
								</Form>
							</div>
							<Col span="24" style="position: absolute; bottom: 0.75vw; left: 6vw;">
							<Button type="primary" style="font-size: 0.6vw;" @click="submit99()">{{
								$t('smartElectricity.smarElectricity.218347-383') }}</Button>
							<Button style="font-size: 0.6vw; margin-left: 0.5vw;" @click="getSettlementsHide">{{
								$t('smartElectricity.smarElectricity.218347-201') }}</Button>
							</Col>
						</div>
					</div>

					<!-- {{ $t('smartElectricity.smarElectricity.218347-442') }} -->
					<div class="add-user-view" v-if="userListHideMsg == 131">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-442') }}
							<span
								style="color: #54b4a8; font-size: 0.6vw; cursor: pointer; position: absolute; top: 0.5vw; right: 2.5vw;"
								@click="getSettlementsHide">{{ $t('smartElectricity.smarElectricity.218347-10') }}</span>
						</div>
						<div class="user-lists">
							<div class="map-top-content-tab">
								<div class="map-top-content-tab-item-details">{{
									$t('smartElectricity.smarElectricity.218347-443') }}</div>
								<div class="map-top-content-tab-item-details">{{
									$t('smartElectricity.smarElectricity.218347-184') }}</div>
								<div class="map-top-content-tab-item-details">{{
									$t('smartElectricity.smarElectricity.218347-366') }}</div>
								<div class="map-top-content-tab-item-details">{{
									$t('smartElectricity.smarElectricity.218347-344') }}</div>
								<div class="map-top-content-tab-item-details">{{
									$t('smartElectricity.smarElectricity.218347-444') }}</div>
								<div class="map-top-content-tab-item-details">{{
									$t('smartElectricity.smarElectricity.218347-445') }}</div>
								<div class="map-top-content-tab-item-details">{{
									$t('smartElectricity.smarElectricity.218347-198') }}</div>
							</div>
							<div class="user-top-list">
								<div class="user-top-lists" v-if="DeviceOrderBillLists.length > 0">
									<div class=" map-top-list-item-details" v-for="(item) in DeviceOrderBillLists"
										:key="item.Id">
										<div class="map-top-list-item-group">{{ item.OrderCode }}</div>
										<div class="map-top-list-item-group">{{ item.DeviceCode }}</div>
										<div class="map-top-list-item-group">{{ item.UserName }}</div>
										<div class="map-top-list-item-group">{{ item.MobilePhone }}</div>
										<div class="map-top-list-item-date">{{ item.ReceiptAmount }}</div>
										<div class="map-top-list-item-date">{{ item.PayTime }}</div>
										<div class="map-top-list-item-group">{{ item.Remark }}</div>
									</div>
								</div>
								<div class="map-right-group-list-none" v-else>{{
									$t('smartElectricity.smarElectricity.218347-446') }}</div>
							</div>
							<div class="user-top-list-page">
								<Page :total="OrderBillTotalCount" :current="OrderBillPageIndex"
									:page-size="OrderBillPageSize" @on-change="OrderBillIndexChange"
									@on-page-size-change="OrderBillSizeChange" size="small" show-elevator show-sizer
									show-total placement="top" />
							</div>
						</div>
					</div>



					<div class="map-top-hide-img" @click="userListHide(false)"
						v-if="userListHideMsg <= 5 || userListHideMsg >= 101 && userListHideMsg <= 135 && userListHideMsg != 119 || userListHideMsg == 'RoshRoomList' || userListHideMsg == 'YHJimport'">
						<!-- <img v-if="themeCode === 'default'" src="../../assets/default/top_arrow.png" alt=""> -->
						<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAZCAYAAAAv3j5gAAACTklEQVRIiYWWTW/UMBCGXyf2rpPdSgjasqWCE+JS9Yb4PYhDVRWJC1f+QVUJtSwrPm4gIQRnjqgXJH4Gy5YbiMMG8bHxGG27GzmTcfaVrMQTex7PJGNHfR47rJBqf1zJNyyBdMNyIcm5ZEMAUIKtkgRSkXsJ5iMAxWEcpNh1aZPsoWPPoJ7DQhB3pgSIBAqd8n4Fk1LHIbxJEVHEXmkJkqKYt4RdJVCYPgl4HlUsdSEkZX3uiBZ2txhDHCKlTopo2VTP+HwjK48BdH78Tg+ms6RYjCMGRQiBsMpYVEmmfbZuy0N4dOExu2LdUc/4fkt6a34TycghncR3rmblUAFr337p/XFh7ntAb9hyZFNvGYS/S7WMiANqqbTad6/1yhMAdlyYvcuWbm5mbmc8NQcecIO8HPWNz2Lzw9Rx1SYM8nOI+TI1dzetu5VpepFrej7I3e54avYAzNZteSQ4r0FjdVSJPE5//k0/DHK3YzUdl5Q8BvDPajrZyvHg+x/98FKXbjcmMkmgsDbwdWrebPXcbjelkSP17KxI38/t1/voWk1PlcL+WZF+ZPXUEE+dZ/e0fQEZOlLDSaFfLRcyKdK3JanDTkpPtvvuDl/gqk0VbM/yJqVH5PFyUujXPO+TQr+7sTYzJqF7QPqJza1pfvDxbz9hn3jC6i3coREUKrHCrUF1MJg7AJvUBuLOG+Kp44MI8WqXYLxV0rHzI+iLlS5Eznfy2lWKqHEMtxzREkx61vqOFJssLaDhMNYPI4r9aLRBYs4btlUfg/Q+2iSPA/AfICz0+VfaygcAAAAASUVORK5CYII="
							alt="">
					</div>
					<div class="map-top-back-img"
						@click="userListHide(true, userListHideMsg == 188 ? 135 : userListHideMsg == 119 ? 'RoshRoomList' : userListHideMsg == 136 ? 135 : userListHideMsg <= 9 ? userListHideMsg - 4 : userListHideMsg <= 13 ? userListHideMsg - 8 : userListHideMsg <= 17 ? userListHideMsg - 12 : userListHideMsg == 90 ? (fromImport ? 'YHJimport' : 'RoshRoomList') : (userListHideMsg <= 100 && userListHideMsg >= 84) ? userListHideMsg + 16 : userListHideMsg - 16)"
						v-else>
						<img v-if="themeCode === 'default'" src="../../assets/default/left_arrow1.png" alt="">
						<img v-else-if="themeCode === 'blue'"
							src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAA6UlEQVQokX3RvUrEQBSG4Wf9jTZ21t6F2IqKkBT2A4Klt2ChIGjlPQiSeAWxEfEe1kJrO7UQLCSpXBmcFd2E/WCYc4bv5fzMYDQamVRRtSs4xwfO6pB9ji0zPeY13GAHd3/NHaCo2nXcp3SrDtk47gJF1e4l8xB5HbLnTq9RcYa8bA7ysnnNy+Yk5tPOIC+bI5ziPfW+3DcbFmP1OSxhFl+I+QLmO/b0Hg3HeEv3sA7ZRW/vSb//UFRtwCWucViHrJkKJGgTV3jEfh2yl0ng33Bp79tYxW1RtRtTgQQ9YRcPsWhRtXEpP8I3FmBjdXeNcw8AAAAASUVORK5CYII="
							alt="">
						{{ $t('smartElectricity.smarElectricity.218347-10') }}
					</div>

				</div>

				<div class="map-top-full" :class="{ 'hiddenTopFull': !showIndex3 }">
					<div class="add-user-view">
						<div class="map-bottom-title">
							{{ $t('smartElectricity.smarElectricity.218347-347') }}
						</div>

						<div class="user-lists">
							<div class="map-top-content-tab">
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-183') }}</div>
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-184') }}</div>
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-185') }}</div>
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-186') }}</div>
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-348') }}</div>
								<div class="map-top-content-tab-item-yichang">{{
									$t('smartElectricity.smarElectricity.218347-349') }}</div>
								<div class="map-top-content-tab-item-yichang tabHandle1">{{
									$t('smartElectricity.smarElectricity.218347-189') }}</div>
							</div>
							<div class="user-top-list">
								<div class="user-top-lists" v-if="PageListWith3CodeLists.length > 0">
									<div class="map-top-list-item map-top-list-item-yichang"
										v-for="(item, index) in PageListWith3CodeLists" :key="index">
										<div class="map-top-list-item-group">{{ item.UserDeviceName }}</div>
										<div class="map-top-list-item-device">{{ item.DeviceCode }}</div>
										<div class="map-top-list-item-device">{{ item.OwnerName }}</div>
										<div class="map-top-list-item-device" :title="item.AddressDetail">
											{{ item.AddressDetail }}</div>
										<div class="map-top-list-item-addr">{{ item.AbnormalTime }}</div>
										<div class="map-top-list-item-date" style="color: #f03613 !important;">
											{{ item.AbnormalName }}</div>
										<div class="map-top-list-item-handle">
											<div class="ivu-dropdown">

												<div class="" style="margin-top: 0.1vw;">
													<div class="map-bottom-list-item-handle-btn">
														<Dropdown trigger="click" style="width: 5vw;">
															<a href="javascript:void(0)">
																{{ $t('smartElectricity.smarElectricity.218347-94') }}
																<Icon type="md-arrow-dropdown"
																	style="margin-left: 0.5vw;" />
															</a>
															<DropdownMenu slot="list" style="width: 5vw; color:#fff;">
																<DropdownItem @click.native="SolveAbData(item.Id, 2)">{{
																	$t('smartElectricity.smarElectricity.218347-95') }}
																</DropdownItem>
																<DropdownItem @click.native="SolveAbData(item.Id, 3)">{{
																	$t('smartElectricity.smarElectricity.218347-96') }}
																</DropdownItem>
															</DropdownMenu>
														</Dropdown>

													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="map-right-group-list-none" v-else>{{
									$t('smartElectricity.smarElectricity.218347-350') }}</div>
							</div>
							<div class="user-top-list-page">
								<Page :total="PageListWith3CodeTotalCount" :current="PageListWith3CodePageIndex"
									:page-size="PageListWith3CodePageSize" @on-change="PageListWith3CodeChange"
									@on-page-size-change="PageListWith3CodeSizeChange" size="small" show-elevator show-sizer
									show-total placement="top" />
							</div>
						</div>
						<Spin size="large" fix v-if="!GetDepartlistsMsg"></Spin>
					</div>
					<div class="map-top-hide-img" @click="hideClick">
						<!-- <img v-if="themeCode === 'default'" src="../../assets/default/top_arrow.png" alt=""> -->
						<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAZCAYAAAAv3j5gAAACTklEQVRIiYWWTW/UMBCGXyf2rpPdSgjasqWCE+JS9Yb4PYhDVRWJC1f+QVUJtSwrPm4gIQRnjqgXJH4Gy5YbiMMG8bHxGG27GzmTcfaVrMQTex7PJGNHfR47rJBqf1zJNyyBdMNyIcm5ZEMAUIKtkgRSkXsJ5iMAxWEcpNh1aZPsoWPPoJ7DQhB3pgSIBAqd8n4Fk1LHIbxJEVHEXmkJkqKYt4RdJVCYPgl4HlUsdSEkZX3uiBZ2txhDHCKlTopo2VTP+HwjK48BdH78Tg+ms6RYjCMGRQiBsMpYVEmmfbZuy0N4dOExu2LdUc/4fkt6a34TycghncR3rmblUAFr337p/XFh7ntAb9hyZFNvGYS/S7WMiANqqbTad6/1yhMAdlyYvcuWbm5mbmc8NQcecIO8HPWNz2Lzw9Rx1SYM8nOI+TI1dzetu5VpepFrej7I3e54avYAzNZteSQ4r0FjdVSJPE5//k0/DHK3YzUdl5Q8BvDPajrZyvHg+x/98FKXbjcmMkmgsDbwdWrebPXcbjelkSP17KxI38/t1/voWk1PlcL+WZF+ZPXUEE+dZ/e0fQEZOlLDSaFfLRcyKdK3JanDTkpPtvvuDl/gqk0VbM/yJqVH5PFyUujXPO+TQr+7sTYzJqF7QPqJza1pfvDxbz9hn3jC6i3coREUKrHCrUF1MJg7AJvUBuLOG+Kp44MI8WqXYLxV0rHzI+iLlS5Eznfy2lWKqHEMtxzREkx61vqOFJssLaDhMNYPI4r9aLRBYs4btlUfg/Q+2iSPA/AfICz0+VfaygcAAAAASUVORK5CYII="
							alt="">
					</div>
				</div>

			</div>
		</div>

		<!-- <Spin fix v-if="spinMsg" style="z-index: 100000;">
        <Icon type="ios-loading" size=30 class="demo-spin-icon-load"></Icon>
        <div style="font-size: 16px; line-height: 40px; color: #fca006;">{{spinTitle}}</div>
    </Spin> -->

		<div class="spin-view" v-if="spinMsg">
			<div class="spin-loading">
				<div class="loader">
					<div class="outer1"></div>
					<div class="middle"></div>
					<div class="inner"></div>
					<div class="loader-title">{{ spinTitle }}</div>
				</div>
			</div>
		</div>

		<audio id="Play" loop="true">
			<source src="../../assets/electricity/bj.wav" />
		</audio>

		<div class="alarm-popup" :class="{ 'alarm-popup-display': alarmState, 'alarm-popup-hide': !alarmState }">
			<div class="alarm-header">
				<div class="alarm-header-inco">
					<img src="../../assets/home/alarm.png" alt="">
				</div>
				<div class="alarm-header-text">{{ $t('smartElectricity.smarElectricity.218347-447') }}</div>
			</div>
			<div class="alarm-details">
				<div class="alarm-details-title">{{ $t('smartElectricity.smarElectricity.218347-448') }}</div>
				<div class="alarm-details-text" @click="submit107">
					{{ $t('smartElectricity.smarElectricity.218347-449',
						[deviceAlarm.UserDeviceName, deviceAlarm.AbnormalTime, deviceAlarm.AbnormalName]) }}
				</div>
			</div>
			<div class="alarm-operat">
				<div class="alarm-operat-btn2"
					@click="ProcessUserDeviceAbnormalDeviceCode(deviceAlarm.DeviceCode, deviceAlarm.AbnormalTime, 2)">{{
						$t('smartElectricity.smarElectricity.218347-95') }}
				</div>
				<div class="alarm-operat-btn3"
					@click="ProcessUserDeviceAbnormalDeviceCode(deviceAlarm.DeviceCode, deviceAlarm.AbnormalTime, 3)">{{
						$t('smartElectricity.smarElectricity.218347-96') }}
				</div>
				<div class="alarm-operat-btn1" @click="submit107">{{ $t('smartElectricity.smarElectricity.218347-450') }}
				</div>
			</div>
			<div class="alarm-down" @click="alarmState = false">
				<img src="../../assets/home/remove.png" alt="">
			</div>
		</div>

		<div class="outline-view1" v-if="doubleState" @click="doubleState = false">
			<div class="outline-top1" @click.stop="">
				<dv-border-box-11 backgroundColor="rgba(7,22,55, 0.9)"
					:title="$t('smartElectricity.smarElectricity.218347-45')">
					<div class="outline-remove" @click="doubleState = false">
						<img src="../../assets/home/remove.png" alt="">
					</div>
					<div class="outline-mode">
						<div class="add-community-view-input-div">
							<div class="add-community-view-input-div-lists">
								<Form label-position="right">
									<Row>
										<Col span="6">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-184')" class="f12"
											style="margin-right: 10%;margin-left: 8%;">
											<Input disabled v-model="markerDeviceCode"
												:placeholder="$t('smartElectricity.smarElectricity.218347-451')"></Input>
										</FormItem>
										</Col>
										<Col span="6">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-452')" class="f12"
											style="margin-right: 10%;margin-left: 8%;">
											<Input disabled v-model="cmmModel.Cname"
												:placeholder="$t('smartElectricity.smarElectricity.218347-451')"></Input>
										</FormItem>
										</Col>
										<Col span="6">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-453')" class="f12"
											style="margin-right: 10%;margin-left: 8%;">
											<Input disabled v-model="cmmModel.ProvinceName"
												:placeholder="$t('smartElectricity.smarElectricity.218347-451')"></Input>
										</FormItem>
										</Col>
										<Col span="6">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-454')" class="f12"
											style="margin-right: 10%;margin-left: 8%;">
											<Input disabled v-model="cmmModel.CityName"
												:placeholder="$t('smartElectricity.smarElectricity.218347-451')"></Input>
										</FormItem>
										</Col>
										<Col span="6">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-455')" class="f12"
											style="margin-right: 10%;margin-left: 8%;">
											<Input disabled v-model="cmmModel.AreaName"
												:placeholder="$t('smartElectricity.smarElectricity.218347-451')"></Input>
										</FormItem>
										</Col>
										<Col span="6">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-363')" class="f12"
											style="margin-right: 10%;margin-left: 8%;">
											<Input disabled v-model="villModel.Vname"
												:placeholder="$t('smartElectricity.smarElectricity.218347-451')"></Input>
										</FormItem>
										</Col>
										<Col span="6">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-41')" class="f12"
											style="margin-right: 10%;margin-left: 8%;">
											<Input disabled v-model="villModel.Address"
												:placeholder="$t('smartElectricity.smarElectricity.218347-451')"></Input>
										</FormItem>
										</Col>
										<Col span="6">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-196')" class="f12"
											style="margin-right: 10%;margin-left: 8%;">
											<Input disabled v-model="villModel.Jd"
												:placeholder="$t('smartElectricity.smarElectricity.218347-451')"></Input>
										</FormItem>
										</Col>
										<Col span="6">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-197')" class="f12"
											style="margin-right: 10%;margin-left: 8%;">
											<Input disabled v-model="villModel.Wd"
												:placeholder="$t('smartElectricity.smarElectricity.218347-451')"></Input>
										</FormItem>
										</Col>
										<Col span="6">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-304')" class="f12"
											style="margin-right: 10%;margin-left: 8%;">
											<Input disabled v-model="roomModel.Zhuang"
												:placeholder="$t('smartElectricity.smarElectricity.218347-451')"></Input>
										</FormItem>
										</Col>
										<Col span="6">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-306')" class="f12"
											style="margin-right: 10%;margin-left: 8%;">
											<Input disabled v-model="roomModel.Unit"
												:placeholder="$t('smartElectricity.smarElectricity.218347-451')"></Input>
										</FormItem>
										</Col>
										<Col span="6">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-308')" class="f12"
											style="margin-right: 10%;margin-left: 8%;">
											<Input disabled v-model="roomModel.Floor"
												:placeholder="$t('smartElectricity.smarElectricity.218347-451')"></Input>
										</FormItem>
										</Col>
										<Col span="6">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-310')" class="f12"
											style="margin-right: 10%;margin-left: 8%;">
											<Input disabled v-model="roomModel.RoomNo"
												:placeholder="$t('smartElectricity.smarElectricity.218347-451')"></Input>
										</FormItem>
										</Col>
										<Col span="6">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-312')" class="f12"
											style="margin-right: 10%;margin-left: 8%;">
											<Input disabled v-model="roomModel.OwnerName"
												:placeholder="$t('smartElectricity.smarElectricity.218347-451')"></Input>
										</FormItem>
										</Col>
										<Col span="6">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-301')" class="f12"
											style="margin-right: 10%;margin-left: 8%;">
											<Input disabled v-model="roomModel.OwnerPhone"
												:placeholder="$t('smartElectricity.smarElectricity.218347-451')"></Input>
										</FormItem>
										</Col>
										<Col span="6">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-456')" class="f12"
											style="margin-right: 10%;margin-left: 8%;">
											<Input disabled v-model="elecFixModel.ElecName"
												:placeholder="$t('smartElectricity.smarElectricity.218347-451')"></Input>
										</FormItem>
										</Col>
										<Col span="6">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-457')" class="f12"
											style="margin-right: 10%;margin-left: 8%;">
											<Input disabled v-model="elecFixModel.ElecMobile"
												:placeholder="$t('smartElectricity.smarElectricity.218347-451')"></Input>
										</FormItem>
										</Col>
										<Col span="6">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-458')" class="f12"
											style="margin-right: 10%;margin-left: 8%;">
											<Input disabled v-model="elecFixModel.ElecIDCode"
												:placeholder="$t('smartElectricity.smarElectricity.218347-451')"></Input>
										</FormItem>
										</Col>
										<Col span="6">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-459')" class="f12"
											style="margin-right: 10%;margin-left: 8%;">
											<Input disabled v-model="elecFixModel.CanFixTime"
												:placeholder="$t('smartElectricity.smarElectricity.218347-451')"></Input>
										</FormItem>
										</Col>
										<Col span="6">
										<FormItem :label="$t('smartElectricity.smarElectricity.218347-460')" class="f12"
											style="margin-right: 10%;margin-left: 8%;">
											<Input disabled v-model="elecFixModel.Content"
												:placeholder="$t('smartElectricity.smarElectricity.218347-451')"></Input>
										</FormItem>
										</Col>
									</Row>
									<div v-for="(item, index) in   elecFixModel.ListIDCodePic  " :key="index">
										<Col span="6">
										<!-- <FormItem
											:label="'{{ $t('smartElectricity.smarElectricity.218347 - 461') }}(' + (index + 1) + ')'"
											class="f12" style="margin-right: 10%;margin-left: 8%;">
											<img :src=" item " alt="" style="width: 100%;">
										</FormItem> -->
										</Col>
									</div>
								</Form>
							</div>
							<Col span="24"
								style="position: absolute; bottom: 0.75vw; right: 2.5vw; display: flex; justify-content: flex-end;">
							<Button type="primary" style="font-size: 0.6vw;" @click="doubleState = false">{{
								$t('smartElectricity.smarElectricity.218347-462') }}</Button>
							</Col>
						</div>
					</div>
				</dv-border-box-11>
			</div>
		</div>
	</div>
</template>

<script>
import echarts from 'echarts'
import api from '../../api/request.js'
import Cookies from 'js-cookie'
import signalR from 'signalr'
import provinces from '../../api/provinces.js'
import jquery from 'jquery'
import i18n from '@/i18n'

export default {
	name: 'App',
	data() {
		return {

			spinMsg: false,
			spinTitle: '',
			Vname1Data: '',
			addRoshSVillageItem: {},
			CommunityIdData: '',
			EditRoshSVillageItem: {},
			addItem: {},
			timer: "", //定义一个定时器的变量
			currentTime: new Date(), // 获取当前时间

			showIndex: true, // 左边区块显示
			navIndex: 1, // 1，企业 2，区域 3，设备

			showIndex1: true, // 下边区块显示
			showIndex2: true, // 右边区块显示
			showIndex3: false, // 报警全屏区块展示

			navBackIndex: 0,
			map: {},
			GetbusinessMoneylists: [],   //商户费用列表
			BusinessMoneyTotalCount: 0,
			GetBusinessMoneyMsg: true,
			Merchants: {},   //添加费用列表
			MerchantsData: {
			},
			MoneyPageIndex: 1,
			MoneyPageSize: 10,
			MerchantscityList: [
				{
					value: 1,
					label: this.$t('smartElectricity.smarElectricity.218347-230')
				},
				{
					value: 2,
					label: this.$t('smartElectricity.smarElectricity.218347-231')
				},
				{
					value: 3,
					label: this.$t('smartElectricity.smarElectricity.218347-232')
				}
			],




			open: false,
			clearable: false,
			value3: '',
			formRight: {},
			navDeviceIndex: 1,
			userListHideIndex: false,
			userListHideMsg: 0,
			userEditListHideMsg: 0,

			CommunityId: '', // 区域id
			LoaderUserLists: [], // 用户列表
			LoaderUserListsMsg: true,
			GetSysGroupLists: [], // 集团列表
			GetSysGroupListsMsg: true,
			GetCompanylists: [], // 公司列表
			GetCompanylistsMsg: true,
			GetDepartlists: [], // 部门列表
			GetDepartlistsMsg: true,

			formUser: {}, // 用户提交
			formUser1: {}, // 用户提交
			UserPageIndex: 1,
			UserPageSize: 10,
			UserTotalCount: 0,
			GroupCodeLists: [], // 集团（不分页）
			CompanyCodeLists: [], // 公司（不分页）
			DepartmentCodeLists: [], // 部门（不分页）

			formGroup: {}, // 集团提交
			GroupPageIndex: 1,
			GroupPageSize: 10,
			GroupTotalCount: 0,

			formCompany: {}, // 公司提交
			formCompany1: {},
			CompanyPageIndex: 1,
			CompanyPageSize: 10,
			CompanyTotalCount: 0,

			formDepart: {}, // 部门提交
			formDepart1: {},
			DepartPageIndex: 1,
			DepartPageSize: 10,
			DepartTotalCount: 0,
			GetViOrBtnOrUserDatas: {},
			DepartmentCode: '',
			DepartmentItem: {},

			provinceArr: [], // 添加区域所需信息
			citiesArr: [],
			countyArr: [],
			formCommunity: {
				province: '',
				city: '',
				county: '',
			},
			formImport: {
				mobile: ''
			},
			formSociety: {
				Province: '',
				City: '',
				County: '',
			},
			address_detail: null, //详细地址
			userlocation: {
				lng: "",
				lat: ""
			},
			addressText: '',

			GetRoshVillageLists: [], // 区域列表
			GetRoshVillageListsMsg: false,
			Vname: '',
			Cname: '',
			GetSVillageLists: [],  //城镇列表
			GetRoshRoomLists: [], // 用户列表
			GetRoshRoomTotal: 0,
			RoshRoomIndex: 1,
			RoshRoomPageSize: 10,
			AddRoshRoomCode: '', // 区域编号 添加用户储存
			AddRoshRoomMsg: {}, // 区域详情 添加用户储存
			RoomCode: '', // 用户编号
			formRoom: {},
			Vname1: '',
			roomDetails: {}, // 用户详情
			formDevices: {}, // 添加设备提交
			DeviceClass: '', // 设备种类
			roomDeviceLists: [], // 设备列表
			roomDeviceListsMsg: false,
			DeviceDetails: {}, // 设备详情
			DeviceDetailsMsg: false,
			DeviceCode: '', // 检索设备时设备ID
			DeviceBtns: [], // 设备权限按钮
			formPassWord: {}, // 设置开关密码提交
			formPassWord1: {}, // 修改开关密码提交
			formDevicesItem: {}, // 导入设备
			passWordIndex: false,
			password: '',
			checkCode: 1, // 设备监测编码
			timeValue: '', // 设备监测日期
			timeValue1: '', // 报警日期
			GetAbDataLists: [], // 及时告警消息列表
			GetAbDataListsMsg: false,
			GetOneDeviceAbDataLists: [], // 单个设备异常数据列表
			GetNavDatas: {}, // 导航栏数据
			GetNavDataYHJs: {}, // 导航栏数据（yhj）
			formThreshold: {}, // 阈值
			GetDeviceRealValues: {}, // 设备实时状态（微断）
			GetSmokeDetails: {}, // 设备实时状态（烟感）
			GetQgDetails: {}, // 设备实时状态（气感）
			DeviceParameterLookLists: [], // 设备状态列表（yhj）
			currentRealTime: '',
			cityName: '', // 当前位置
			seriesMsg: false, // 图表是否为空
			seriesGetMsg: false, // 图表请求状态
			PlayIndex: false, // 播放按钮
			AdminIndex: false, // 是否超级管理员
			GetMenulists: [], // 菜单列表
			GetParameterData1Lists: [], // 获取参数列表 type 7连接设备 11设备类型 1设备通道
			GetParameterData7Lists: [],
			GetParameterData11Lists: [],
			GetRoomWDDeviceLists: [], // 用户下微断设备

			proxy: {}, // SignalR
			play: {},

			GetDeviceList: [], // 检索需要导入的设备列表
			DeviceIdList: [], // 选中的设备Id列表
			indeterminate: false,
			checkAll: false,

			DeviceTypeClass: 0, // 设备类型
			GetUserDeviceParamList: {}, // Zigbee设备状态
			DeviceInfoBaseModel: {},
			ZbDeviceModel: {},
			DeviceDianCiModel: {},
			GetDeviceParameterModbusV3Struct: {}, // V3阈值显示状态

			PageListWith3CodePageIndex: 1,
			PageListWith3CodePageSize: 10,
			PageListWith3CodeTotalCount: 0,
			PageListWith3CodeLists: [],
			PageListWith3CodeMsg: false,

			timerID: null,
			timertmpe: false,

			unfoldMsg: false,
			deviceMsg: true,
			jitterMsg: false,
			todayAbCount: 0,
			saveState: true,
			callState: true,

			operatMsg: false, // 延迟操作状态（分合闸，召测需延迟7s）

			CompanyCodes: [], // 根据集团编号检索的公司列表
			DepartmentCodes: [], // 根据集团编号,公司编号获取部门
			GetRoshCommunityLists: [], // 集团列表
			societyItem: {}, // 城市详情
			communityItem: {}, // 区域详情
			pstateType: 1, // 处理类型：1未处理，2已处理，3误报

			DeviceLists: [], // 在线、离线 列表
			DeviceTotal: 0,
			onlineState: 0,

			DeviceCountList: [],
			GetRoshRoomAllLists: [],
			GetRoshRoomAllTotal: 0,

			MapVillagelists: [], // 地图数据
			Communitylists: [], // 部门城市权限
			CommunityDatas: [], // 部门城市数据
			VillageLists: [], // 部门区域权限

			TittleName: '', // 中文title
			TittleNameEN: '', // 英文title
			ImageUrl: '',

			stateIndex: 0, // 0 待结算，1已结算，-1结算取消
			settlementPageIndex: 1,
			settlementPageSize: 10,
			settlementTotalCount: 0,
			settlementLists: [],
			platformFeePercent: '',
			settlementOrderCode: '',
			finAccountId: '',
			remark: '',
			inputRemark: '',
			calSettlementAmount: '',
			// DealOneSettlementVM: {},

			FinAccountLists: [],
			OrderBillPageIndex: 1,
			OrderBillPageSize: 10,
			OrderBillTotalCount: 0,
			DeviceOrderBillLists: [],

			AccountList: [{
				IsAccounting: 0,
				AccountName: this.$t('smartElectricity.smarElectricity.218347-463'),
			}, {
				IsAccounting: 1,
				AccountName: this.$t('smartElectricity.smarElectricity.218347-464'),
			}],

			editItem: {},
			address_detail_input: false,

			qtcgqTtItemLists: [], // 传感器探头列表
			qtcgqTtItemMsg: false, // 传感器加载动画

			AuthModuleCodeLists: [],
			AuthModuleCodePageIndex: 1,
			AuthModuleCodePageSize: 10,
			AuthModuleCodeTotalCount: 0,
			AuthModel: {},
			ModuleLists: [],
			AuthModelState: 1, // 1：添加，2：修改
			ModuleItemList: [], // 展开数据
			ModuleSelectedLists: [], // 选中的数据
			ModuleSelectedHeadLists: [], // 选中的类别
			ModuleIndex: 0, // 选中的类别
			AuthModelLists: [], // 保存选中
			AuthModelTitle: '', // title
			AuthModelValue: 0,
			anWidthClick: false,

			defaultList: [{
				'name': 'a42bdcc1178e62b4694c830f028db5c0',
				'url': 'https://o5wwk8baw.qnssl.com/a42bdcc1178e62b4694c830f028db5c0/avatar'
			},
			{
				'name': 'bc7521e033abdd1e92222d733590f104',
				'url': 'https://o5wwk8baw.qnssl.com/bc7521e033abdd1e92222d733590f104/avatar'
			}
			],
			imgName: '',
			visible: false,
			uploadList: [],
			headers: {
				"Authorization": Cookies.get('Token')
			},

			ReplyTime: this.$t('smartElectricity.smarElectricity.218347-451'), // 设备时钟

			canRun: true, // 节流状态

			alarmState: false, // 警报状态
			alarmTime: null, // 报警定时器
			deviceAlarm: {}, // 设备报警信息

			operatPassword: '', // 操作密码
			startendDate: '',

			villageSItem: {},
			villageForm: {},

			GetZVillageLists: [], // 村列表
			GetSVillageItem: {}, // 选中的乡镇
			ZVillageCode: '', // 村Code
			ZVillageItem: {}, // 选中的村

			themeCode: '',
			Zcode: '',
			Scode: '',
			Block: '',
			Floor: '',
			fromImport: 1, // 上个页面是否为一键导入

			markerDeviceCode: "",
			cmmModel: {}, // 城市信息
			villModel: {}, // 小区信息
			roomModel: {}, // 业主信息
			elecFixModel: {}, // 维修信息
			doubleState: false, // 设备详情弹框,
			uploadPassword: '', // 升级的操作密码
		}
	},
	filters: {
		deviceType: function (value) {
			if (!value) return ''
			switch (value) {
				case '6ee95d23-a802-4bd8-b823-19c0944ac5ab':
					return i18n.t('smartElectricity.smarElectricity.218347-331')
					break;
				case 'c1ce34cd-a623-45db-8025-3104efa35be5':
					return i18n.t('smartElectricity.smarElectricity.218347-465')
					break;
				case '4782d02c-0075-4105-9729-aa1b65bb250a':
					return i18n.t('smartElectricity.smarElectricity.218347-466')
					break;
				case '88f5c429-49b6-4a9f-a908-b2ee9c8cb857':
					return i18n.t('smartElectricity.smarElectricity.218347-467')
					break;
				case '7febbea4-0326-496d-9b71-5b058729cb42':
					return i18n.t('smartElectricity.smarElectricity.218347-468')
					break;
				default:
					return i18n.t('smartElectricity.smarElectricity.218347-469')
					break;
			}
		},
		modeCount(value) {
			let _this = this
			if (!value) return '';
			if (value == 99) {
				return _this.$t('smartElectricity.smarElectricity.218347-470');
			} else {
				let lists = value.split('|');
				return _this.$t('smartElectricity.smarElectricity.218347-471', [lists.length]);
			}
		},
	},
	created() {
		let _this = this; //声明一个变量指向Vue实例this，保证作用域一致

		_this.themeCode = _this.$store.getters.getThemeCode;

		_this.currentTime = _this.formDate(new Date());
		_this.timer = setInterval(function () {
			_this.currentTime = _this.formDate(new Date()); // 修改数据date
		}, 1000);

		// 获取位置
		_this.cityName = Cookies.get('cityName') ? Cookies.get('cityName') : _this.$t('smartElectricity.smarElectricity.218347-472');

		// 获取播放状态
		_this.PlayIndex = Cookies.get('PlayIndex') == 'true' ? true : false;

		// 判断用户是否为超级管理员
		_this.IsOrNOSuperAdmin();

	},
	mounted() {
		let _this = this; // 声明一个变量指向Vue实例this，保证作用域一致
		_this.timer = setInterval(() => {
			_this.date = new Date(); // 修改数据date
		}, 1000)
		_this.$nextTick(function () {
			_this.mapData();
		})

		// 加载城市列表
		_this.GetRoshCommunityList();

		// 加载区域地图列表
		_this.GetRoshVillageList();

		// 加载即时告警信息（旧接口）
		// _this.GetAbData();

		// 根据集团 公司 部门获取设备异常（yhj）
		_this.GetDeviceAbnormalPageListWith3Code();

		// 获取导航栏数据
		_this.GetNavData();

		// 获取导航栏数据（yhj）
		_this.GetNavDataYHJ();

		// 获取菜单列表
		_this.GetMenulist();

		if (this.$driver.isActivated) {
			let steps = [
				{
					element: "#oneKeyImportBtn",
					popover: {
						title: _this.$t('smartElectricity.smarElectricity.218347-8'),
						description: _this.$t('smartElectricity.smarElectricity.218347-473'),
						position: "left",
						className: 'robotLeft'
					},
					onNext: () => {
						this.$driver.preventMove();
						this.userListHide(true, 'YHJimport');
						this.$nextTick(() => {
							setTimeout(() => {
								this.$driver.moveNext();
							}, 800)
						})
					}
				},
				{
					element: "#map-top",
					popover: {
						title: _this.$t('smartElectricity.smarElectricity.218347-474'),
						description: _this.$t('smartElectricity.smarElectricity.218347-475'),
						position: "right",
						className: 'robotLeft'
					},
					onNext: () => {
						this.$driver.preventMove();
						this.YHJimport();
					}
				},
				{
					element: "#oneKeyImportBtn",
					popover: {
						title: _this.$t('smartElectricity.smarElectricity.218347-8'),
						description: _this.$t('smartElectricity.smarElectricity.218347-473'),
						position: "left",
						className: 'robotLeft'
					},
				},
				{
					element: "#map-top",
					popover: {
						title: _this.$t('smartElectricity.smarElectricity.218347-40'),
						description: _this.$t('smartElectricity.smarElectricity.218347-476'),
						position: "right",
						className: 'robotLeft'
					},
					onPrevious: () => {
						this.$driver.preventMove();
						this.$driver.movePrevious();
						this.$driver.movePrevious();
						this.userListHide(true, 'YHJimport');
					}
				},
				{
					element: "#menu-left",
					popover: {
						title: _this.$t('smartElectricity.smarElectricity.218347-477'),
						description: _this.$t('smartElectricity.smarElectricity.218347-478'),
						position: "right",
						className: 'robotRight'
					}
				},
			]
			this.$nextTick(() => {
				this.$driver.defineSteps(steps);
				this.$driver.start();
			})
		}
	},
	computed: {
		SignalRState() {
			let _this = this;
			return _this.$store.getters.getSignalRState;
		},
		DeviceStates() {
			let _this = this;
			return _this.$store.getters.getDeviceStates;
		},
		calPlatformFeeAmount() {
			return ((this.calSettlementAmount * 100) * (this.platformFeePercent * 100)) / 1000000;
		},
		calSettlementAmountFinal() {
			return (this.calSettlementAmount * 10000 - this.calPlatformFeeAmount * 10000) / 10000;
		}
	},

	watch: {
		SignalRState(value) {
			let _this = this;
			if (value) {

				if (_this.PlayIndex) {
					_this.play = document.getElementById('Play');
					_this.play.play();
				}
				// 加载即时告警信息
				_this.GetDeviceAbnormalPageListWith3Code();
				_this.GetDeviceAbnormalPageListWith3CodeListpage();
				// 获取导航栏数据
				_this.GetNavData();
				// 获取导航栏数据（yhj）
				_this.GetNavDataYHJ();

				// 出现异常抖3s
				_this.jitterMsg = true;
				setTimeout(() => {
					_this.jitterMsg = false
				}, 3000)

				_this.deviceAlarm = _this.$store.getters.getDeviceAlarm; // 报警详情
				_this.alarmClick();

			}
			_this.$store.dispatch("setSignalRState", false);
		},

		DeviceStates(data) {
			let _this = this;

			if (_this.DeviceDetails.DeviceCode == data.DeviceCode) {
				_this.DeviceDetails.UpdateTime = data.datetime;
				_this.DeviceDetails.IsOnline = data.devicestatus == 1 ? true : false;
				_this.DeviceDetails.SwitchStatus = data.kaiguanStatus == 1 ? 1 : 2;

				// 事件节流
				if (!_this.canRun) return;
				// 立即设置为false
				_this.canRun = false;

				_this.DeviceParameterLook(_this.DeviceDetails.DeviceCode)

				setTimeout(() => {
					_this.canRun = true;
				}, 5000);

			}

		},

		DeviceClass(value) {
			let _this = this;
			_this.formDevices.DeviceClass = value;
			_this.formDevices.ConnectDevice = '';
			_this.formDevices.DeviceType = '';
			_this.formDevices.PDeviceCode = '';
			if (value == 1) {
				_this.GetParameterData7(7)
			} else if (value == 2) {
				_this.GetParameterData7(9)
			} else {
				_this.GetParameterData7(10);
				// 根据用户唯一号获取微端设备
				_this.GetRoomWDDevice();
			}
		},
		PlayIndex(value) {
			let _this = this;
			if (value) {
				_this.play = document.getElementById('Play');
				_this.GetAbDeviceCount(); // 获取异常设备条数
			} else {
				_this.play = document.getElementById('Play');
				_this.play.pause();
			}
		},
	},

	methods: {
		anWidth() {
			let _this = this;
			_this.anWidthClick = !_this.anWidthClick;
			if (_this.anWidthClick) {
				_this.showIndex1 = false
				_this.userListHide(false);
			} else {
				_this.showIndex1 = true
				_this.userListHide(true);
			}
			_this.anWidthClick ? $('.map-right').addClass('map-right1') : $('.map-right1').removeClass('map-right1')
		},
		alarmClick() {
			let _this = this;
			_this.alarmState = true;
			if (_this.alarmState) {
				clearTimeout(_this.alarmTime);
				_this.alarmTime = setTimeout(() => {
					_this.alarmState = false;
				}, 5000);
			}
		},

		Carousel() {
			this.roll(50);
		},

		roll(t) {

			var content = document.getElementById("content");
			var fakeContent = document.getElementById("fakeContent");
			var wrapper = document.getElementById("wrapper");

			let _this = this;

			if (!content) {
				return;
			}

			// fakeContent.innerHTML = content.innerHTML;
			// 开始无滚动时设为0
			wrapper.scrollTop = 0;

			let timer = null;

			//鼠标事件绑定
			$('#wrapper').hover(function () {
				clearInterval(timer);
				timer = null
			}, function () {
				timer = setInterval(() => {
					_this.rollStart(wrapper, content)
				}, t);
			}).mouseout();

		},

		// 开始滚动函数
		rollStart(wrapper, content) {
			// 正常滚动不断给scrollTop的值+1,当滚动高度大于列表内容高度时恢复为0
			if (wrapper.scrollTop >= content.scrollHeight) {
				wrapper.scrollTop = 0;
			} else {
				wrapper.scrollTop++;
			}
		},

		// SignalR
		connectServer(value) {
			let _this = this;
			let conn = $.hubConnection("http://yhj.hxpwr.com/signalr/hubs", {
				useDefaultPath: false
			})
			_this.proxy = conn.createHubProxy("HomeHub");
			_this.proxy.on("SendBjCount", (data) => {
				if (data) {
					if (_this.PlayIndex) {
						_this.play = document.getElementById('Play');
						_this.play.play();
					}
					// 加载即时告警信息
					_this.GetDeviceAbnormalPageListWith3Code();
					_this.GetDeviceAbnormalPageListWith3CodeListpage();
					// 获取导航栏数据
					_this.GetNavData();
					// 获取导航栏数据（yhj）
					_this.GetNavDataYHJ();

					// 判断当前用户是否超级管理员
					_this.IsOrNOSuperAdmin();

					// 出现异常抖3s
					_this.jitterMsg = true;
					setTimeout(() => {
						_this.jitterMsg = false
					}, 3000)

				}
			})
			conn.start().done((data) => {
				_this.proxy.invoke("sendLogin", value).done((msg) => {
					console.log(_this.$t('smartElectricity.smarElectricity.218347-479'));
				});
			}).fail((data) => {
				console.log(_this.$t('smartElectricity.smarElectricity.218347-480'))
			});
		},

		// 展开数据
		unfoldData() {
			let _this = this;

			if (_this.GetRoshVillageLists.length > 0) {
				_this.deviceMsg = true;
				_this.Unfold(_this.GetRoshVillageLists[0].Vcode, _this.GetRoshVillageLists[0].Vname);
			}
		},

		GetAbDeviceCount() {
			let _this = this;
			_this.play = document.getElementById('Play');
			_this.play.pause();
		},
		// 判断当前用户是否超级管理员
		IsOrNOSuperAdmin() {
			let _this = this;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: 'api/User/IsOrNOSuperAdmin',
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Code == -1) {
					_this.AdminIndex = false;
				} else if (res.Code == 0) {
					_this.AdminIndex = true;
				}
				// 连接SignalR
				// _this.connectServer(res.Data);
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					if (err.data.Code == -9) {
						_this.$store.dispatch("setUserState", true);
					}
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},

		// 获取菜单列表
		GetMenulist() {
			let _this = this;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: 'api/User/GetMenulist',
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					_this.GetMenulists = [];

					res.Data.forEach(item => {
						_this.GetMenulists.push(item.MenuCode)
					})
				}
			}).catch(function (err) {
				// if (err.data.Code == -9 || err.data.Code == -1) {
				// 	_this.$router.push({
				// 		name: 'login'
				// 	})
				// }
			});
		},

		// 刷新数据
		refreshData() {
			let _this = this;
			_this.$nextTick(function () {
				_this.mapData();
			})
			// 加载区域地图列表
			_this.GetRoshVillageList();
			// 加载城市列表
			_this.Cname = '';
			_this.GetRoshCommunityList();
		},

		PlaySound() {
			this.PlayIndex = true;
			Cookies.set('PlayIndex', true);
		},

		StopSound() {
			this.PlayIndex = false;
			Cookies.set('PlayIndex', false);
		},

		drawLine(legends, xAxis, series) {

			// 基于准备好的dom，初始化echarts实例
			let myChart = echarts.init(document.getElementById('myChart'))
			// 绘制图表
			myChart.setOption({
				tooltip: {
					trigger: 'axis'
				},
				legend: {
					y: '0.5vw',
					textStyle: {
						color: '#ffffff',
					},
					data: legends
				},
				grid: {
					left: '3%',
					top: '17%',
					right: '4%',
					bottom: '10%',
					containLabel: true
				},
				xAxis: {
					type: 'category',
					boundaryGap: false,
					//设置轴线的属性
					axisLine: {
						lineStyle: {
							color: '#ffffff'
						}
					},
					data: xAxis
				},
				yAxis: {
					type: 'value',
					axisLine: {
						lineStyle: {
							color: '#ffffff'
						}
					}
				},
				dataZoom: {
					type: 'inside',
					start: 80,
					end: 100
				},
				series: series
			});
		},

		handleClick() {
			this.open = !this.open;
		},
		handleChange(date) {
			this.timeValue = date;
			if (this.checkCode <= 3) {
				this.GetDeviceCheckDataABCxiang(); // yhj监控ABC三相
			} else {
				this.GetDeviceCheckDatas(); // yhj监控其它值
			}
		},
		handleChange1(date) {
			this.timeValue1 = date;
			// this.GetOneDeviceAbData(); // 设备异常记录 旧接口
			this.GetDeviceAbnormalPageList(); // 设备异常记录（yhj）
		},
		handleClear() {
			this.open = false;
		},
		handleOk() {
			this.open = false;
		},

		showClick() {
			let _this = this;
			_this.showIndex = !_this.showIndex;
			_this.showIndex3 = false;
		},

		// 异常数据轮播插件
		Scrollcc(opt) {

			//参数初始化
			if (!opt) var opt = {};

			var _this = $('.map-bottom-lists').first();

			var lineH = _this.find(".map-bottom-list-item:first").height() + 5, //获取行高
				line = opt.line, //每次滚动的行数，默认为一屏，即父容器高度
				speed = opt.speed, //卷动速度，数值越大，速度越慢（毫秒）
				timer = opt.timer; //滚动的时间间隔（毫秒）
			if (line == 0) line = 1;

			var upHeight = 0 - line * lineH;

			//鼠标事件绑定
			_this.hover(function () {
				window.clearInterval(this.timerID);
			}, function () {
				this.timerID = window.setInterval(() => {
					_this.animate({
						marginTop: upHeight
					}, speed, function () {
						for (let i = 1; i <= line; i++) {
							_this.find(".map-bottom-list-item:first").appendTo(_this);
						}
						_this.css({
							marginTop: 0
						});
					});
				}, timer);
			}).mouseout();
		},

		// 导航切换
		navTab(index) {
			let _this = this;
			if (_this.navIndex != index) {
				_this.navIndex = index;
			}
		},

		navShouButtom() {
			let _this = this;
			_this.showIndex1 = !_this.showIndex1;
			_this.showIndex3 = false;

		},

		navShouRight() {
			let _this = this;
			// _this.showIndex2 = !_this.showIndex2;
			_this.showIndex2 = false;
			// setTimeout(() => {
			// 	_this.navBackIndex = 0;
			// }, 500)
		},


		// 隐藏表格
		userListHide(type, value, fromImport) {
			this.fromImport = fromImport;
			let _this = this;
			_this.userListHideIndex = type;

			if (value) {
				_this.userListHideMsg = value;
				_this.formDevices = {};
				if (value == 1 || value == 118 || value == 132 || value == 133 || value == 134 || value == 130 || value == 101 || value == 119) {
					_this.provinceArr = provinces()
					_this.$nextTick(function () {
						_this.initAllmap();
					})
				} else if (value == 110 || value == 117) {
					_this.provinceArr = provinces()
				} else if (value == 2) {
					// 加载用户列表
					_this.LoaderUserList();
				} else if (value == 5) {
					// 加载集团列表
					_this.GetSysGroupList();
				} else if (value == 135) {
					// 加载商户费用列表
					_this.GetMerchantFeeTemplateList();
				} else if (value == 4) {
					// 加载公司列表
					_this.GetCompanylist();
				} else if (value == 3) {
					// 加载部门列表
					_this.GetDepartlist();
				} else if (value == 102) {
					// 获取参数 type 7连接设备 11设备类型 1设备通道
					_this.GetParameterData1(1);
					// _this.GetParameterData7(7);
					_this.GetParameterData11(11);
				} else if (value == 103) {
					_this.$nextTick(function () {
						_this.initAllmap();
					})
					_this.formDevices = {
						..._this.DeviceDetails
					};
					console.log('123', _this.formDevices)
					_this.formDevices.DeviceClass = parseInt(_this.formDevices.DeviceClass) + '';
					// _this.address_detail = _this.formDevices.AddressDetail;
					_this.address_detail_input = true;
					_this.userlocation = {
						lng: _this.formDevices.Longitude,
						lat: _this.formDevices.Latitude,
					}
					if (_this.formDevices.DeviceClass == 1) {
						_this.GetParameterData7(7)
					} else if (_this.formDevices.DeviceClass == 2) {
						_this.GetParameterData7(9)
					} else {
						_this.GetParameterData7(10);
						// 根据用户唯一号获取微端设备
						_this.GetRoomWDDevice();
					}
					// 获取参数 type 7连接设备 11设备类型 1设备通道
					_this.GetParameterData1(1);
					_this.GetParameterData11(11);
				} else if (value == 121) {
					// 获取用户模块使用授权列表
					_this.getAuthModuleCodeList();
				}
			}
		},

		// 添加模块
		addModel(type, item) {
			let _this = this;
			_this.userListHideMsg = type;
			_this.formGroup = {};
			_this.formDepart = {};
			_this.formUser = {};
			if (type == 136) {
				_this.Merchants = {};
			}

			if (type == 13) {
				_this.formGroup = item
			} else if (type == 12) {
				_this.formCompany = item;
				if (item.ImageUrl) {
					let uploadList = [item.ImageUrl];
					_this.uploadList = uploadList;
				} else {
					_this.uploadList = [];
				}
				_this.GroupCodeList(); // 集团
			} else if (type == 11) {
				_this.formDepart = item
				_this.GroupCodeList(); // 集团
				_this.CompanyCodeList(); // 公司
				_this.changeGroupCode(_this.formDepart.GroupCode, true);
			} else if (type == 10) {
				_this.formUser = item
				// 修改用户需调用集团，公司，部门列表 且不分页，把页数设置足够大
				_this.GroupCodeList(); // 集团
				_this.CompanyCodeList(); // 公司
				_this.DepartmentCodeList(); // 部门

				_this.changeGroupCode(_this.formUser.GroupCode, true);
				_this.changeCompanyCode(_this.formUser.CompanyCode, true);
			} else if (type == 19 || type == 15) {
				if (type == 19) {
					// 编辑，新增获取部门信息
					_this.GetViOrBtnOrUserData(item);
				} else {
					_this.GetViOrBtnOrUserData_New(item);
				}
				_this.DepartmentCode = item.DepartmentCode;
				_this.DepartmentItem = item;
			} else if (type == 6) {
				// 添加用户需调用集团，公司，部门列表 且不分页，把页数设置足够大
				_this.GroupCodeList(); // 集团
				_this.CompanyCodeList(); // 公司
				_this.DepartmentCodeList(); // 部门
			} else if (type == 7) {
				_this.GroupCodeList(); // 集团
				_this.CompanyCodeList(); // 公司
			} else if (type == 8) {
				_this.GroupCodeList(); // 集团
			} else if (type == 137) {
				// _this.getModuleList(); // 获取模块
				_this.AuthModel = item;
				if (item.AuthType) {
					_this.AuthModel.AuthType = item.AuthType.toString();
					if (item.AuthModuleValues != 99) {
						if (item.AuthModuleValues) {
							let AuthModules = item.AuthModuleValues.split('|');
							_this.ModuleSelectedLists = AuthModules.map(Number);
							_this.AuthModelLists = _this.ModuleSelectedLists;
						} else {
							_this.ModuleSelectedLists = [];
							_this.AuthModelLists = [];
						}
					} else {
						_this.ModuleSelectedLists = [];
						_this.AuthModelLists = [];
					}
					_this.AuthModelTitle = item.AuthModuleValues == 99 ? _this.$t('smartElectricity.smarElectricity.218347-481') :
						_this.$t('smartElectricity.smarElectricity.218347-482', [_this.ModuleSelectedLists.length]);
					_this.AuthModelValue = item.AuthModuleValues == 99 ? 99 : 0;

					_this.AuthModelState = 2;
				} else {
					_this.AuthModelState = 1;
					_this.ModuleSelectedLists = [];
					_this.AuthModelLists = [];
					_this.AuthModelTitle = '';
					_this.AuthModelValue = 0;
					_this.ModuleSelectedHeadLists = [];
				}
			}
		},

		Back(index, item) {
			let _this = this;
			if (item) {
				// 获取一条设备数据（旧接口）
				// _this.GetRoshDeviceOne(item.DeviceCode);

				_this.$store.dispatch("setDeviceUnfold", `${item.DeviceCode}`);

				// 获取一台设备（yhj）
				_this.GetOneUserDevice(item.Id);

				let DeviceClass;

				switch (item.DeviceId) {
					case '6ee95d23-a802-4bd8-b823-19c0944ac5ab':
						DeviceClass = 1
						break;
					case 'c1ce34cd-a623-45db-8025-3104efa35be5':
						DeviceClass = 11
						break;
					case '4782d02c-0075-4105-9729-aa1b65bb250a':
						DeviceClass = 2
						break;
					// 气感
					case '88f5c429-49b6-4a9f-a908-b2ee9c8cb857':
						DeviceClass = 3
						break;
					case '7febbea4-0326-496d-9b71-5b058729cb42':
						DeviceClass = 8
						break;
					default:
						DeviceClass = 14
						break;
				}

				// 设备类型
				_this.DeviceTypeClass = DeviceClass;

				if (DeviceClass != 8) {

					// 设备获取按钮列表
					_this.GetDeviceBtn(DeviceClass);

					// 获取设备状态（yhj）
					_this.DeviceParameterLook(item.DeviceCode);

				} else {

					_this.navDeviceTab(1);
					_this.DeviceBtns = ["state", "edit", "del"];
					// 如果是燃气电磁阀
					if (item.DeviceItemId == '2f6fa7d9-8dea-4157-98be-01dd8cdd3527') {
						_this.DeviceBtns.push('closeFa');
					}
					_this.DeviceParameterLook_Zigbee(item.DeviceCode); // 获取Zigbee设备状态

				}



				/* // 获取状态（旧接口）
				if (DeviceClass == 1) {
				  // 获取设备实时值（微断设备）
				  _this.GetDeviceRealValue(item.DeviceCode);
				} else if (DeviceClass == 2) {
				  // 获取设备实时值（烟感设备）
				  _this.GetSmokeDetail(item.DeviceCode);
				} else if (DeviceClass == 3) {
				  // 获取设备实时值（气感设备）
				  _this.GetQgDetail(item.DeviceCode);
				}*/

			} else {
				_this.$store.dispatch("setDeviceUnfold", false);
				// 设备获取按钮列表
				_this.GetDeviceBtn(4);
				_this.navDeviceIndex = 0;
			}
			_this.navBackIndex = index;
		},

		// 数据导航栏
		navDeviceTab(index) {
			let _this = this;
			if (_this.navDeviceIndex != index) {
				_this.navDeviceIndex = index;
				if (_this.navDeviceIndex == 2) {
					// _this.DeviceCheck(); // 设备监控（旧接口）
					if (this.checkCode <= 3) {
						this.GetDeviceCheckDataABCxiang(); // yhj监控ABC三相
					} else {
						this.GetDeviceCheckDatas(); // yhj监控其它值
					}
				} else if (_this.navDeviceIndex == 3) {
					// _this.GetOneDeviceAbData(); // 设备异常记录 旧接口
					_this.GetDeviceAbnormalPageList(); // 设备异常记录（yhj）
				} else if (_this.navDeviceIndex == 4) {
					_this.GetThreshold();
				}
			}
		},

		/**
		 * ======================================区域接口模块==========================================
		 */
		// 加载城市列表
		GetRoshCommunityList() {
			let _this = this;
			_this.GetRoshVillageListsMsg = false;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/User/GetCommunitylist?Cname=${_this.Cname}`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				_this.GetRoshVillageListsMsg = true;
				if (res.Success) {
					_this.GetRoshCommunityLists = res.Data;
					//     _this.initMapData();

					setTimeout(() => {
						if (_this.unfoldMsg) {
							if (_this.GetRoshCommunityLists.length > 0) {
								_this.getCommunity(_this.GetRoshCommunityLists[0]);
							}
						}
					}, 100)

				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				_this.GetRoshVillageListsMsg = true;
			});
		},
		// 编辑城市展开
		EditRoshCommunity(row) {
			let _this = this;
			_this.editItem = {
				...row
			};

			_this.userListHide(true, 117);

			_this.address_detail = _this.editItem.Address;
			_this.address_detail_input = true;
			_this.userlocation = {
				lng: _this.editItem.Jd,
				lat: _this.editItem.Wd,
			}
			_this.provinceArr.forEach((item, index) => {
				if (item.id == _this.editItem.ProvinceCode) {
					_this.citiesArr = item.child;
					_this.citiesArr.forEach((msg, index) => {
						if (msg.id == _this.editItem.CityCode) {
							_this.countyArr = msg.child;
						}
					})
				}
			})
		},
		// 点击输入框
		addressDetailClick() {
			let _this = this;
			_this.address_detail_input = false;
			document.getElementById("suggestId").focus();
		},
		// 编辑城市保存
		EditRoshCommunityAxios() {
			let _this = this;
			let formSociety = {
				..._this.editItem
			};
			_this.provinceArr.forEach(item => {
				if (item.id == formSociety.ProvinceCode) {
					formSociety.ProvinceName = item.name;
					item.child.forEach(city => {
						if (city.id == formSociety.CityCode) {
							formSociety.CityName = city.name;
							city.child.forEach(county => {
								if (county.id == formSociety.AreaCode) {
									formSociety.AreaName = county.name;
								}
							})
						}
					})
				}
			})
			formSociety.Address = _this.addressText;
			formSociety.Vaddress = _this.addressText;
			formSociety.Jd = _this.userlocation.lng;
			formSociety.Wd = _this.userlocation.lat;

			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: 'api/User/EditRoshCommunity',
				data: formSociety,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					_this.$Message['success']({
						background: true,
						content: res.Message
					});
					// 加载城市列表
					_this.GetRoshCommunityList();
					_this.userListHide(false);

				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},

		// 删除城市
		DeleteRoshCommunity(item) {
			let _this = this;
			_this.$Modal.confirm({
				title: _this.$t('smartElectricity.smarElectricity.218347-483'),
				content: `<p>是否删除“${item.Cname}”</p>`,
				onOk: () => {

					api({
						//这里是你自己的请求方式、url和data参数
						method: 'post',
						url: 'api/User/DeleteRoshCommunity',
						data: item,
						//假设后台需要的是表单数据这里你就可以更改
						headers: {
							"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
							"Authorization": Cookies.get('Token')
						}
					}).then(function (res) {
						if (res.Success) {
							_this.unfoldMsg = true;
							_this.GetRoshCommunityList();
						} else {
							_this.$Message['error']({
								background: true,
								content: res.Message
							});
						}
					}).catch(function (err) {

					});
				},
				onCancel: () => {

				}
			});
		},
		//添加区域
		addCommunity(item) {
			let _this = this;
			_this.communityItem = item;
			_this.formCommunity = {};
			_this.userListHide(true, 1);
		},
		// 根据城市编号展示区域
		getCommunity(item, operating = false) {
			// 收起中间和右边框
			this.userListHide(false);
			this.navShouRight();
			let _this = this;
			if (_this.societyItem.Ccode == item.Ccode && !operating) {
				_this.societyItem = {};
				return;
			};

			// 根据集团 公司 部门获取设备异常（yhj）
			if (!operating) {
				_this.GetDeviceAbnormalPageListWith3Code('&Ccode=' + item.Ccode);
			}

			_this.societyItem = item;
			_this.GetRoshVillageLists = [];
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/User/GetVillagelist?Ccode=${item.Ccode}`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {

					// console.log(res);
					_this.GetRoshVillageLists = res.Data;
					if (_this.unfoldMsg) {
						_this.unfoldMsg = false;
						if (_this.GetRoshVillageLists.length > 0) {
							_this.deviceMsg = true;
							_this.UnfoldDatass(_this.GetRoshVillageLists[0].Vcode, _this.GetRoshVillageLists[0]
								.Vname);
						}
					}


				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) { });
		},
		// 加载区域地图列表
		GetRoshVillageList() {
			const { GroupCode, DepartmentCode, CompanyCode, IsAdmin } = JSON.parse(
				Cookies.get("AdminData")
			);
			let _this = this;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/CommElecDevice/GetUserDevicesPageV2`,
				params: {
					groupCode: GroupCode,
					companyCode: CompanyCode,
					departmentCode: DepartmentCode,
					isAdmin: IsAdmin,
					pageIndex: 1,
					pageSize: 1000,
				},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, "yhj").then(function (res) {
				if (res.Success) {

					_this.MapVillagelists = res.Data;
					_this.initMapData();

				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				// if (err.data.Code == -9 || err.data.Code == -1) {
				// 	_this.$router.push({
				// 		name: 'login'
				// 	})
				// }
			});
		},
		// 区域列表展开事件
		UnfoldDatass(id, Vname, type) {
			// 收起中间和右边框
			this.userListHide(false);
			this.navShouRight();
			let _this = this;
			if (_this.CommunityIdData == id && type != 'self') {
				_this.CommunityIdData = '';
				return;
			}
			if (type != 'self') {
				// 根据集团 公司 部门获取设备异常（yhj）
				_this.GetDeviceAbnormalPageListWith3Code('&Vcode=' + id);
			}
			_this.Vname1Data = Vname;
			_this.CommunityIdData = id;
			// _this.GetRoshRoomLists = [];
			// _this.GetRoshRoomList();

			_this.GetSVillageLists = [];
			_this.GetSVillageList();
		},
		//根据id检
		Unfold(id, Vname, type) {
			let _this = this;
			if (_this.CommunityId == id) {
				if (type != 'self') {
					_this.CommunityId = '';
					return;
				}
			}
			_this.Vname1 = Vname;
			_this.CommunityId = id;
			_this.GetRoshRoomLists = [];
			_this.GetRoshRoomList();
		},
		//获取乡镇参数
		GetSVillageList() {
			let _this = this;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/User/GetSVillageList?Vcode=${_this.CommunityIdData}`,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					_this.GetSVillageLists = res.Data;
					// if (_this.GetSVillageLists.length > 0) {
					// 	_this.UnfoldZVillage(_this.GetSVillageLists[0]);
					// }
				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 编辑区域展开
		editVillage(item) {
			let _this = this;
			_this.editItem = {
				...item
			};
			console.log(item, _this.$t('smartElectricity.smarElectricity.218347-485'))
			_this.userListHide(true, 118);

			_this.address_detail = _this.editItem.Address;
			_this.address_detail_input = true;
			_this.userlocation = {
				lng: _this.editItem.Jd,
				lat: _this.editItem.Wd,
			}
		},
		//添加街道展开
		addVillage(item) {
			let _this = this;
			_this.addItem = {
				...item
			};

			_this.addRoshSVillageItem = {};
			_this.userlocation = {};
			_this.userListHide(true, 132);


		},
		//添加乡镇
		addRoshSVillageItemAxiso() {
			let _this = this;
			let addRoshSVillageItem = {
				..._this.addRoshSVillageItem
			};
			_this.provinceArr.forEach(item => {
				if (item.id == addRoshSVillageItem.province) {
					addRoshSVillageItem.provinceName = item.name;
					item.child.forEach(city => {
						if (city.id == addRoshSVillageItem.city) {
							addRoshSVillageItem.cityName = city.name;
							city.child.forEach(county => {
								if (county.id == addRoshSVillageItem.county) {
									addRoshSVillageItem.countyName = county.name;
								}
							})
						}
					})
				}
			})
			let data = {
				Scode: "123456",
				Ccode: _this.addItem.Ccode,
				Vcode: _this.addItem.Vcode,
				Sname: addRoshSVillageItem.Sname,  //改为sname   2
				Saddress: _this.addressText,  //改为Saddress  1
				ProvinceCode: _this.addItem.ProvinceCode,
				ProvinceName: _this.addItem.ProvinceName,
				CityCode: _this.addItem.CityCode,
				CityName: _this.addItem.CityName,
				AreaCode: _this.addItem.AreaCode,
				AreaName: _this.addItem.AreaName,
				Address: _this.addItem.Address,
				Jd: _this.userlocation.lng,
				Wd: _this.userlocation.lat,
				Remarks: addRoshSVillageItem.Remarks,
				CompanyCode: _this.addItem.CompanyCode,
				DepartmentCode: _this.addItem.DepartmentCode,
				GroupCode: _this.addItem.GroupCode,
			}
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: 'api/User/AddRoshSVillage',
				data: data,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					_this.$Message['success']({
						background: true,
						content: res.Message
					});
					_this.getCommunity(_this.societyItem, true)

					_this.CommunityIdData = res.Data.Vcode;
					_this.addItem = [];
					_this.addRoshSVillageItem = {}
					_this.userlocation = {}
					_this.UnfoldDatass(res.Data.Vcode, res.Data.Vname)
					_this.addHamlet(res.Data)
					// 加载区域地图列表
					_this.GetRoshVillageList();
				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 编辑区域保存
		EditRoshVillageAxios() {
			let _this = this;
			let formSociety = {
				..._this.editItem
			};
			formSociety.Address = _this.addressText;
			formSociety.Vaddress = _this.addressText;
			formSociety.Jd = _this.userlocation.lng;
			formSociety.Wd = _this.userlocation.lat;

			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: 'api/User/EditRoshVillage',
				data: formSociety,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					_this.$Message['success']({
						background: true,
						content: res.Message
					});

					_this.getCommunity(_this.societyItem, true)
					// 加载区域地图列表
					_this.GetRoshVillageList();

					_this.userListHide(false);

					_this.roomDetails.Vname = formSociety.Vname;

				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		//删除街道
		removeRoshSVillage(item) {
			let _this = this;
			_this.$Modal.confirm({
				title: _this.$t('smartElectricity.smarElectricity.218347-483'),
				content: `<p>是否删除“${item.Sname}”</p>`,
				onOk: () => {
					api({
						//这里是你自己的请求方式、url和data参数
						method: 'post',
						url: 'api/User/DeleteRoshSVillage',
						data: item,
						//假设后台需要的是表单数据这里你就可以更改
						headers: {
							"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
							"Authorization": Cookies.get('Token')
						}
					}).then(function (res) {
						console.log(res, _this.$t('smartElectricity.smarElectricity.218347-486'))
						if (res.Success) {
							_this.unfoldMsg = true;
							_this.getCommunity(_this.societyItem, true)
							// 加载区域地图列表
							_this.GetRoshVillageList();
						} else {
							_this.$Message['error']({
								background: true,
								content: res.Message
							});
						}
					}).catch(function (err) {

					});
				},
				onCancel: () => {

				}
			});
		},
		// 删除区域
		removeVillage(item) {
			let _this = this;
			_this.$Modal.confirm({
				title: _this.$t('smartElectricity.smarElectricity.218347-483'),
				content: `<p>是否删除“${item.Vname}”</p>`,
				onOk: () => {

					api({
						//这里是你自己的请求方式、url和data参数
						method: 'post',
						url: 'api/User/DeleteRoshVillage',
						data: item,
						//假设后台需要的是表单数据这里你就可以更改
						headers: {
							"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
							"Authorization": Cookies.get('Token')
						}
					}).then(function (res) {
						if (res.Success) {
							_this.unfoldMsg = true;
							_this.getCommunity(_this.societyItem, true)
							// 加载区域地图列表
							_this.GetRoshVillageList();
						} else {
							_this.$Message['error']({
								background: true,
								content: res.Message
							});
						}
					}).catch(function (err) {

					});
				},
				onCancel: () => {

				}
			});
		},

		// 乡镇展开
		UnfoldZVillage(item, operate) {
			// 收起中间和右边框
			this.userListHide(false);
			this.navShouRight();
			if (item.Scode === this.GetSVillageItem.Scode && !operate) {
				this.GetSVillageItem = {}
				return;
			} else {
				this.GetSVillageItem = { ...item }
				this.GetZVillageList(item.Scode)
				// 根据集团 公司 部门获取设备异常（yhj）
				if (!operate) {
					this.GetDeviceAbnormalPageListWith3Code('&Scode=' + item.Scode);
				}
			}
			// if (this.GetSVillageItem.Scode) {
			// 	this.GetSVillageItem = {  }
			// } else {
			// 	this.GetSVillageItem = { ...item }
			// 	this.GetZVillageList(item.Scode)
			// }
		},

		// 添加村触发事件
		addHamlet(item) {
			this.villageSItem = { ...item }
			this.userListHide(true, 134);
		},

		// 添加村
		addVillageAxiso() {
			let _this = this;
			let villageForm = {
				..._this.villageForm
			};

			let data = {
				Scode: _this.villageSItem.Scode,
				Ccode: _this.villageSItem.Ccode,
				Vcode: _this.villageSItem.Vcode,
				Saddress: _this.villageSItem.Saddress,
				ProvinceCode: _this.villageSItem.ProvinceCode,
				ProvinceName: _this.villageSItem.ProvinceName,
				CityCode: _this.villageSItem.CityCode,
				CityName: _this.villageSItem.CityName,
				AreaCode: _this.villageSItem.AreaCode,
				AreaName: _this.villageSItem.AreaName,
				Address: _this.villageSItem.Address,
				Jd: _this.userlocation.lng,
				Wd: _this.userlocation.lat,
				CompanyCode: _this.villageSItem.CompanyCode,
				DepartmentCode: _this.villageSItem.DepartmentCode,
				GroupCode: _this.villageSItem.GroupCode,
				Zaddress: _this.addressText,
				...villageForm
			}

			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: 'api/User/AddRoshZVillage',
				data: data,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					_this.$Message['success']({
						background: true,
						content: res.Message
					});
					// _this.getCommunity(_this.societyItem, true)

					// _this.CommunityIdData = res.Data.Vcode;

					// _this.GetSVillageItem = { ..._this.villageSItem }
					_this.GetZVillageList(res.Data.Scode, false)

					_this.villageSItem = {}
					_this.villageForm = {}
					_this.userlocation = {}

					_this.AddRoshRoom(res.Data.Vcode, res.Data)
					// 加载区域地图列表
					_this.GetRoshVillageList();
				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},

		// 村展开
		UnfoldVillage(item, noShow) {
			this.Vname1 = item.Zname;
			this.ZVillageCode = item.Zcode
			this.ZVillageItem = { ...item }
			this.RoshRoomIndex = 1;
			this.GetRoshRoomList()
			if (!noShow) {
				this.warningMessage('RoshRoomList');
				// 根据集团 公司 部门获取设备异常（yhj）
				this.GetDeviceAbnormalPageListWith3Code('&Zcode=' + item.Zcode);
			}
		},

		// 获取村列表
		GetZVillageList(Scode, unfold = true) {
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/User/GetZVillageList?Scode=${Scode}`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then((res) => {
				if (res.Success) {
					this.GetZVillageLists = res.Data || []
					// if (this.GetZVillageLists.length > 0 && unfold) {
					// 	this.UnfoldVillage(this.GetZVillageLists[0]);
					// }
				} else {
					this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			});
		},

		//修改街道展开
		EditRoshZVillage(item) {
			let _this = this;
			console.log(item, _this.$t('smartElectricity.smarElectricity.218347-487'))
			_this.ZVillageItem = {
				...item
			};
			_this.userListHide(true, 130);


			_this.address_detail = _this.ZVillageItem.Zaddress;
			_this.address_detail_input = true;
			_this.userlocation = {
				lng: _this.ZVillageItem.Jd,
				lat: _this.ZVillageItem.Wd,
			}

		},

		// 保存修改村
		EditRoshZVillageAxios() {
			console.log(123);
			let _this = this;
			let ZVillageItem = {
				..._this.ZVillageItem
			};

			ZVillageItem.Saddress = _this.addressText;
			ZVillageItem.Jd = _this.userlocation.lng;
			ZVillageItem.Wd = _this.userlocation.lat;

			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: 'api/User/EditRoshZVillage',
				data: ZVillageItem,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					_this.$Message['success']({
						background: true,
						content: res.Message
					});

					// _this.GetSVillageItem = { ..._this.villageSItem }
					_this.GetZVillageList(ZVillageItem.Scode, false)
					// 加载区域地图列表
					// _this.GetRoshVillageList();

					_this.userListHide(false);

					// _this.roomDetails.Vname = formSociety.Vname;

				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},

		// 删除村
		removeZVillage(item) {
			let _this = this;
			_this.$Modal.confirm({
				title: _this.$t('smartElectricity.smarElectricity.218347-483'),
				content: `<p>是否删除“${item.Zname}”</p>`,
				onOk: () => {

					api({
						//这里是你自己的请求方式、url和data参数
						method: 'post',
						url: 'api/User/DeleteRoshZVillage',
						data: item,
						//假设后台需要的是表单数据这里你就可以更改
						headers: {
							"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
							"Authorization": Cookies.get('Token')
						}
					}).then(function (res) {
						if (res.Success) {
							_this.unfoldMsg = true;
							_this.GetZVillageList(item.Scode)
							// 加载区域地图列表
							_this.GetRoshVillageList();
						} else {
							_this.$Message['error']({
								background: true,
								content: res.Message
							});
						}
					}).catch(function (err) {

					});
				},
				onCancel: () => {

				}
			});
		},

		// 根据区域id检索用户
		GetRoshRoomList() {
			let _this = this;
			let data = {
				Scode: _this.CommunityId,
				Vcode: _this.CommunityIdData,
				Zcode: this.ZVillageCode,
				pageIndex: _this.RoshRoomIndex,
				pageSize: _this.RoshRoomPageSize
			}
			console.log(data, _this.$t('smartElectricity.smarElectricity.218347-488'))
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: 'api/User/GetRoshRoomList',
				data: data,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					console.log(res, _this.$t('smartElectricity.smarElectricity.218347-489'))
					_this.GetRoshRoomLists = res.Data;
					_this.GetRoshRoomTotal = res.TotalCount;

					// if (_this.deviceMsg) {
					// 	_this.deviceMsg = false;
					// 	if (_this.GetRoshRoomLists.length > 0) {
					// 		_this.deviceDetail(_this.GetRoshRoomLists[0]);
					// 	}

					// }

				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 添加用户
		AddRoshRoom(Vcode, msg) {
			let _this = this;
			_this.AddRoshRoomCode = Vcode;
			_this.AddRoshRoomMsg = msg;
			console.log(msg, _this.$t('smartElectricity.smarElectricity.218347-490'))
			_this.userListHide(true, 101);
		},
		// 添加用户提交
		submit101() {
			let _this = this;
			_this.formRoom.Vcode = _this.AddRoshRoomMsg.Vcode;
			_this.formRoom.Scode = _this.AddRoshRoomMsg.Scode;
			_this.formRoom.Ccode = _this.AddRoshRoomMsg.Ccode;
			_this.formRoom.Zcode = _this.ZVillageItem.Zcode
			_this.formRoom.GroupCode = _this.AddRoshRoomMsg.GroupCode;
			_this.formRoom.CompanyCode = _this.AddRoshRoomMsg.CompanyCode;
			_this.formRoom.DepartmentCode = _this.AddRoshRoomMsg.DepartmentCode;
			_this.formRoom.Jd = _this.userlocation.lng;
			_this.formRoom.Wd = _this.userlocation.lat;
			_this.formRoom.RoomAddress = _this.addressText;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: 'api/User/AddRoshRoom',
				data: _this.formRoom,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				console.log(res, _this.$t('smartElectricity.smarElectricity.218347-491'))
				if (res.Success) {
					_this.Unfold(_this.AddRoshRoomMsg.Scode, _this.AddRoshRoomMsg.Sname, 'self')
					// _this.GetRoshRoomList();
					_this.userListHide(false);
					_this.formRoom = {};
					// 获取导航栏数据
					_this.GetNavData();

					// 根据手机号获取逸慧家注册用户信息
					// _this.GetOneUser(res.Data.OwnerPhone);

				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},

		submitGetOneUser(mobile) {
			let _this = this;
			_this.GetOneUser(mobile);
		},

		// 根据手机号获取逸慧家注册用户信息
		GetOneUser(mobile) {
			let _this = this;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: 'api/CommElecDevice/GetOneUser?mobile=' + mobile,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				if (res.Success) {
					_this.formRoom = {
						..._this.formRoom,
						...res.Data
					};
				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},

		//修改街道展开
		EditRoshSVillage(item) {
			let _this = this;
			console.log(item, _this.$t('smartElectricity.smarElectricity.218347-492'))
			_this.EditRoshSVillageItem = {
				...item
			};
			_this.userListHide(true, 133);


			_this.address_detail = _this.EditRoshSVillageItem.Saddress;
			_this.address_detail_input = true;
			_this.userlocation = {
				lng: _this.EditRoshSVillageItem.Jd,
				lat: _this.EditRoshSVillageItem.Wd,
			}

		},
		// 编辑街道/乡镇保存
		EditRoshSVillageAxios() {
			let _this = this;
			let EditRoshSVillageItem = {
				..._this.EditRoshSVillageItem
			};

			EditRoshSVillageItem.Saddress = _this.addressText;
			EditRoshSVillageItem.Jd = _this.userlocation.lng;
			EditRoshSVillageItem.Wd = _this.userlocation.lat;
			console.log(EditRoshSVillageItem, _this.$t('smartElectricity.smarElectricity.218347-493'))
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: 'api/User/EditRoshSVillage',
				data: EditRoshSVillageItem,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					_this.$Message['success']({
						background: true,
						content: res.Message
					});
					_this.UnfoldDatass(_this.EditRoshSVillageItem.Vcode, _this.EditRoshSVillageItem.Vname, 'self')
					// 加载区域地图列表
					_this.GetRoshVillageList();

					_this.userListHide(false);

					// _this.roomDetails.Vname = formSociety.Vname;

				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 修改用户展开
		EditRoshRoom(item) {
			let _this = this;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: 'api/User/GetRoshRoomOne/' + item.Id,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					_this.editItem = res.Data;
					_this.address_detail = _this.editItem.RoomAddress;
					_this.address_detail_input = true;
					_this.userlocation = {
						lng: _this.editItem.Jd,
						lat: _this.editItem.Wd,
					}
				}
			}).catch(function (err) { });

			_this.userListHide(true, 119);
		},
		// 修改用户保存
		EditRoshRoomAxios() {
			let _this = this;
			let editItem = {
				..._this.editItem,
				Jd: _this.userlocation.lng,
				Wd: _this.userlocation.lat,
				RoomAddress: _this.addressText,
			};
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: 'api/User/EditRoshRoom',
				data: editItem,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					_this.GetRoshRoomList();
					// _this.userListHide(false);
					_this.userListHide(true, 'RoshRoomList');
					// 获取导航栏数据
					_this.GetNavData();
					_this.deviceDetail({
						Id: editItem.Id,
						OwnerPhone: editItem.OwnerPhone,
						RoomCode: editItem.RoomCode,
						RoomName: _this.$t('smartElectricity.smarElectricity.218347-497', [editItem.Zhuang, editItem.Unit, editItem.Floor, editItem.RoomNo])
					})

				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 删除用户（导航栏）
		removeRoom(item) {
			let _this = this;
			_this.$Modal.confirm({
				title: _this.$t('smartElectricity.smarElectricity.218347-483'),
				content: '<p>是否删除此用户？</p>',
				onOk: () => {
					// console.log(item);
					_this.DeleteRoshRoom(item);
				},
				onCancel: () => {

				}
			});
		},
		// 删除用户
		DeleteRoshRoom(item) {
			let _this = this;

			let IdList = _this.roomDeviceLists.map(item => {
				return item.Id;
			});

			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: 'api/User/DeleteRoshRoom',
				data: item ? item : _this.roomDetails,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					_this.$Message['success']({
						background: true,
						content: res.Message
					});
					// 刷新用户列表
					// _this.Unfold(_this.CommunityId ? _this.CommunityId : item.Vcode, _this.Vname1, 'self');
					_this.GetRoshRoomList()


					_this.showIndex2 = false;

					// _this.RemoveDevice3Code({
					// 	IdList: IdList,
					// 	GroupCode: "1",
					// 	CompanyCode: "1",
					// 	DepartmentCode: "1",
					// 	Unit: "1",
					// 	RoomNo: "1"
					// });

					// 获取导航栏数据
					_this.GetNavData();
					if (_this.userListHideMsg == 113) {
						_this.GetRoshRoomAll();
					}
				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 更新集团 公司 部门编号(yhj)
		RemoveDevice3Code(model) {
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: `api/CommElecDevice/UpdateDevice3Code`,
				data: model,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {

			});
		},
		// 加载区域检索地图数据
		initAllmap() {
			var th = this
			// 创建Map实例
			var map = new BMap.Map("allmap1");
			// 初始化地图,设置中心点坐标，
			var point = new BMap.Point(121.160724, 31.173277);
			// 创建点坐标，汉得公司的经纬度坐标
			map.centerAndZoom(new BMap.Point(121.160724, 31.173277), 15);
			map.enableScrollWheelZoom();

			//建立一个自动完成的对象
			var ac = new BMap.Autocomplete({
				"input": "suggestId",
				"location": map
			})

			var myValue
			//鼠标点击下拉列表后的事件
			ac.addEventListener("onconfirm", function (e) {
				var _value = e.item.value;
				myValue = _value.province + _value.city + _value.district + _value.street + _value.business;
				this.address_detail = myValue;
				setPlace();
			});

			function setPlace() {
				//清除地图上所有覆盖物
				map.clearOverlays();

				function myFun() {
					//获取第一个智能搜索的结果
					th.userlocation = local.getResults().getPoi(0).point;
					th.addressText = local.getResults().getPoi(0).title;
					map.centerAndZoom(new BMap.Point(120.58, 28.08), 18);
					//添加标注
					map.addOverlay(new BMap.Marker(th.userlocation));
				}

				//智能搜索
				var local = new BMap.LocalSearch(map, {
					onSearchComplete: myFun
				});
				local.search(myValue);

				//测试输出坐标（指的是输入框最后确定地点的经纬度）
				map.addEventListener("click", function (e) {
					//经度
					console.log(th.userlocation.lng);
					//维度
					console.log(th.userlocation.lat);
				})
			}
		},
		// 添加区域
		AddRoshVillage() {
			let _this = this;
			let formCommunity = {
				..._this.formCommunity
			};
			_this.provinceArr.forEach(item => {
				if (item.id == formCommunity.province) {
					formCommunity.provinceName = item.name;
					item.child.forEach(city => {
						if (city.id == formCommunity.city) {
							formCommunity.cityName = city.name;
							city.child.forEach(county => {
								if (county.id == formCommunity.county) {
									formCommunity.countyName = county.name;
								}
							})
						}
					})
				}
			})

			let data = {
				Ccode: _this.communityItem.Ccode,
				Vname: formCommunity.Vname,
				Vaddress: _this.addressText,
				ProvinceCode: _this.communityItem.ProvinceCode,
				ProvinceName: _this.communityItem.ProvinceName,
				CityCode: _this.communityItem.CityCode,
				CityName: _this.communityItem.CityName,
				AreaCode: _this.communityItem.AreaCode,
				AreaName: _this.communityItem.AreaName,
				Address: _this.addressText,
				Jd: _this.userlocation.lng,
				Wd: _this.userlocation.lat,
				Remarks: formCommunity.Remarks,
				CompanyCode: _this.communityItem.CompanyCode,
				DepartmentCode: _this.communityItem.DepartmentCode,
				GroupCode: _this.communityItem.GroupCode,
			}

			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: 'api/User/AddRoshVillage',
				data: data,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					_this.$Message['success']({
						background: true,
						content: res.Message
					});
					_this.getCommunity(_this.societyItem, true)
					// _this.CommunityIdData = res.Data.Vcode;
					_this.GetRoshRoomLists = [];
					_this.userlocation = {}

					console.log(res.Data.Vcode, res.Data.Vname, _this.$t('smartElectricity.smarElectricity.218347-499'))
					_this.addVillage(res.Data, res.Data.Vcode)
					// 加载区域地图列表
					_this.GetRoshVillageList();
				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 实现省市区联动
		changeProvince(val) {
			this.provinceArr.forEach(item => {
				if (val == item.id) {
					this.citiesArr = item.child
					this.formCommunity.county = ''
					this.countyArr = []
				}
			})
		},
		changeCity(val) {
			this.citiesArr.forEach(item => {
				if (val == item.id) {
					this.countyArr = item.child
				}
			})
		},
		// 点击用户展示设备列表
		deviceDetail(item) {
			let _this = this;
			_this.roomDetails = {
				...item
			}
			_this.roomDetails.Vname = _this.Vname1;
			_this.RoomCode = item.RoomCode;
			_this.Zcode = item.Zcode;
			_this.Scode = item.Scode;

			// 根据集团 公司 部门获取设备异常（yhj）
			_this.GetDeviceAbnormalPageListWith3Code('&RoomCode=' + item.RoomCode);

			// _this.GetRoomDevice(); // 原先的根据用户Id查询设备

			_this.GetUserDevicesPage(); // 新根据用户Id查询导入设备

			_this.showIndex2 = true;
			_this.navBackIndex = 1;

			// 设备获取按钮列表
			_this.GetDeviceBtn(4)
		},

		// 添加城市
		AddRoshCommunity() {
			let _this = this;
			let formSociety = {
				..._this.formSociety
			};
			_this.provinceArr.forEach(item => {
				if (item.id == formSociety.Province) {
					formSociety.ProvinceName = item.name;
					item.child.forEach(city => {
						if (city.id == formSociety.City) {
							formSociety.CityName = city.name;
							city.child.forEach(county => {
								if (county.id == formSociety.County) {
									formSociety.CountyName = county.name;
								}
							})
						}
					})
				}
			})

			let data = {
				Cname: formSociety.Cname,
				// Caddress: _this.addressText,
				ProvinceCode: formSociety.Province,
				ProvinceName: formSociety.ProvinceName,
				CityCode: formSociety.City,
				CityName: formSociety.CityName,
				AreaCode: formSociety.County,
				AreaName: formSociety.CountyName,
				// Address: _this.addressText,
				// Jd: _this.userlocation.lng,
				// Wd: _this.userlocation.lat,
				Address: formSociety.CityName,
				Jd: '120.25537447004918',
				Wd: '30.322760843944423',
				Remarks: formSociety.Remarks
			}

			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: 'api/User/AddRoshCommunity',
				data: data,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					_this.$Message['success']({
						background: true,
						content: res.Message
					});
					_this.formSociety = {}
					_this.addCommunity(res.Data);

					// 加载城市列表
					_this.GetRoshCommunityList();
					_this.communityItem = res.Data;
				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		/*============================================================================================*/

		/**
		 * ======================================设备接口模块==========================================
		 */
		// 根据用户唯一号获取设备
		GetRoomDevice() {
			let _this = this;
			_this.roomDeviceListsMsg = false;
			let data = {
				..._this.roomDetails
			};
			data.DeviceCode = _this.DeviceCode;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: 'api/Device/GetRoomDevice',
				data: data,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				_this.roomDeviceListsMsg = true;
				if (res.Success) {
					_this.roomDeviceLists = res.Data;
				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				_this.roomDeviceListsMsg = true;
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				} else {
					_this.$Message['error']({
						background: true,
						content: err.data.Message
					});
				}
			});
		},
		// 获取参数 type 7连接设备 11设备类型 1设备通道
		GetParameterData1(type) {
			let _this = this;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/Device/GetParameterData?type=${type}`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					_this.GetParameterData1Lists = res.Data;
				}
			}).catch(function (err) { });
		},
		GetParameterData7(type) {
			let _this = this;
			_this.GetParameterData7Lists = [];
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/Device/GetParameterData?type=${type}`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					_this.GetParameterData7Lists = res.Data;
				}
			}).catch(function (err) { });
		},
		GetParameterData11(type) {
			let _this = this;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/Device/GetParameterData?type=${type}`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					_this.GetParameterData11Lists = res.Data;
				}
			}).catch(function (err) { });
		},

		// 根据用户唯一号获取微端设备
		GetRoomWDDevice() {
			let _this = this;
			let data = {
				..._this.roomDetails
			};
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: 'api/Device/GetRoomWDDevice',
				data: data,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					_this.GetRoomWDDeviceLists = res.Data;
				}
			}).catch(function (err) { });
		},

		// 添加设备
		submit102() {
			let _this = this;
			let data = {
				..._this.formDevices
			};
			data.InstallationTime = _this.formDate(data.InstallationTime);
			data.RoomCode = _this.RoomCode;
			if (!data.DeviceCode) {
				_this.$Message['error']({
					background: true,
					content: _this.$t('smartElectricity.smarElectricity.218347-500')
				});
				return;
			}
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: 'api/Device/AddRoshDevice',
				data: data,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					_this.$Message['success']({
						background: true,
						content: res.Message
					});
					_this.GetRoomDevice(_this.roomDetails);
					_this.userListHide(false);
				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 一键导入
		YHJimport() {
			let _this = this;
			let data = {
				..._this.formImport
			};
			if (!data.mobile) {
				_this.$Message['error']({
					background: true,
					content: _this.$t('smartElectricity.smarElectricity.218347-501')
				});
				return;
			}

			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/User/ImportUserFromYhj?mobilephone=${data.mobile}`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					let tempData = JSON.parse(res.Data);
					console.log(tempData);
					// _this.RoomCode = tempData.RoomNo;
					// _this.Zcode = tempData.Zcode;
					// _this.Scode = tempData.Unit;
					// _this.Block = tempData.Block;
					// _this.Floor = tempData.Floor;

					_this.getCommunity({ Ccode: tempData.Block }, true);
					_this.UnfoldDatass(tempData.Floor, '', 'self');
					_this.UnfoldZVillage({ Scode: tempData.Unit }, true);
					_this.UnfoldVillage({ Zcode: tempData.Zcode, Zname: tempData.Zname }, true);

					// 获取用户名
					api({
						//这里是你自己的请求方式、url和data参数
						method: 'post',
						url: `api/User/GetRoshRoomAll`,
						data: {
							RoomCode: tempData.RoomNo
						},
						//假设后台需要的是表单数据这里你就可以更改
						headers: {
							"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
							"Authorization": Cookies.get('Token')
						}
					}).then(function (res) {
						if (res.Success) {
							let obj = res.Data[0];
							obj.RoomName = obj.OwnerName;
							_this.deviceDetail(obj);
						} else {
							_this.$Message['error']({
								background: true,
								content: res.Message
							});
						}
					});

					api({
						//这里是你自己的请求方式、url和data参数
						method: 'get',
						url: `api/CommElecDevice/GetUserDeviceModels?mobile=${data.mobile}`,
						data: {},
						//假设后台需要的是表单数据这里你就可以更改
						headers: {
							"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
							"Authorization": Cookies.get('Token')
						}
					}, 'yhj').then(function (res) {
						if (res.Success) {
							_this.GetDeviceList = res.Data;
							_this.DeviceIdList = [];
							_this.indeterminate = false;
							_this.checkAll = false;
							_this.userListHide(true, 90, 1);
							if (_this.$driver.isActivated) {
								_this.$nextTick(() => {
									setTimeout(() => {
										_this.$driver.moveNext();
										_this.$driver.moveNext();
									}, 100)
								})
							}
							// _this.refreshData();
						} else {
							_this.$Message['error']({
								background: true,
								content: res.Message
							});
						}
					});
				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			});

		},
		// 添加设备
		addDevice() {

		},
		// 导入设备（新）
		submit106() {
			let _this = this;
			// let data = {
			// 	..._this.formDevicesItem
			// };
			if (!_this.roomDetails.OwnerPhone) {
				_this.$Message['error']({
					background: true,
					content: _this.$t('smartElectricity.smarElectricity.218347-502')
				});
				return;
			}

			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/CommElecDevice/GetUserDeviceModels?mobile=${_this.roomDetails.OwnerPhone}`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				if (res.Success) {
					_this.GetDeviceList = res.Data;
					_this.DeviceIdList = [];
					_this.indeterminate = false;
					_this.checkAll = false;
					// _this.userListHide(true, _this.userListHideMsg - 16, 0);
					_this.userListHide(true, 90, 0);
				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			});

		},
		// 设备选中
		checkAllGroupChange(item) {
			let _this = this;
			if (item.single) {
				_this.DeviceIdList.push(item.Id);
			} else {
				_this.DeviceIdList.splice(_this.DeviceIdList.indexOf(item.Id), 1);
			}

			if (_this.DeviceIdList.length === _this.GetDeviceList.length) {
				_this.indeterminate = false;
				_this.checkAll = true;
			} else if (_this.DeviceIdList.length > 0) {
				_this.indeterminate = true;
				_this.checkAll = false;
			} else {
				_this.indeterminate = false;
				_this.checkAll = false;
			}

		},
		// 全选
		handleCheckAll() {
			let _this = this;
			if (_this.indeterminate) {
				_this.checkAll = false;
			} else {
				_this.checkAll = !_this.checkAll;
			}
			_this.indeterminate = false;

			_this.DeviceIdList = [];
			if (_this.checkAll) {
				_this.GetDeviceList.forEach(item => {
					item.single = true;
					_this.DeviceIdList.push(item.Id);
				})
			} else {
				_this.GetDeviceList.forEach(item => {
					item.single = false;
				})
			}
		},
		// 选中设备添加
		submit90() {
			let _this = this,
				AdminData = JSON.parse(Cookies.get('AdminData'));
			let data = {
				IdList: _this.DeviceIdList,
				GroupCode: AdminData.GroupCode,
				CompanyCode: AdminData.CompanyCode,
				DepartmentCode: AdminData.DepartmentCode,
				RoomNo: _this.RoomCode,
				Block: _this.societyItem.Ccode,
				// Block: _this.Block,//Ccode ,
				Floor: _this.CommunityIdData,
				// Floor: _this.Floor, //Vcode _this.societyItem.Ccode
				Zcode: _this.Zcode,
				Unit: _this.Scode,
			}

			if (data.IdList.length <= 0) {
				_this.$Message['error']({
					background: true,
					content: _this.$t('smartElectricity.smarElectricity.218347-503')
				});
				return;
			}

			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: `api/CommElecDevice/UpdateDevice3Code`,
				data: data,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				if (res.Success) {
					_this.$Message['success']({
						background: true,
						content: res.Message
					});
					// _this.userListHide(true, _this.userListHideMsg + 16);

					// 导入设备列表
					_this.GetUserDevicesPage();

					// 刷新异常列表
					_this.GetDeviceAbnormalPageListWith3Code();

					// 获取导航栏数据（yhj）
					_this.GetNavDataYHJ();
					if (_this.$driver.isActivated) {
						_this.$nextTick(() => {
							_this.$driver.moveNext();
						})
					}
				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			});
		},
		// 获取导入设备列表
		GetUserDevicesPage() {
			let _this = this,
				AdminData = JSON.parse(Cookies.get('AdminData'));
			_this.roomDeviceListsMsg = false;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/CommElecDevice/GetUserDevicesPage?isAdmin=${AdminData.IsAdmin}&groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&pageIndex=1&pageSize=100&deviceCode=${_this.DeviceCode}&unit=${_this.CommunityId}&roomNo=${_this.RoomCode}`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				_this.roomDeviceListsMsg = true;
				if (res.Success) {
					_this.roomDeviceLists = res.Data;
				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			});
		},
		// 展开更多报警信息
		submit107() {

			let _this = this;
			_this.GetDeviceAbnormalPageListWith3CodeListpage();
			// _this.userListHide(true, 107);

			_this.showIndex = false; // 左边区块显示
			_this.showIndex1 = false; // 下边区块显示
			_this.showIndex2 = false; // 右边区块显示
			_this.showIndex3 = true; // 展示中间区域

			_this.userListHide(false);

		},

		// 隐藏全屏弹窗
		hideClick() {
			let _this = this;
			_this.showIndex = true; // 左边区块显示
			_this.showIndex1 = true; // 下边区块显示
			_this.showIndex2 = true; // 右边区块显示
			_this.showIndex3 = false; // 展示中间区域
		},

		// title告警事件
		warningMessage(type) {
			let _this = this;
			_this.PageListWith3CodePageIndex = 1;
			_this.PageListWith3CodePageSize = 10;
			if (type == 107) {
				_this.submit107();
			} else if (type == 108) {
				_this.pstateType = 2;
				_this.GetDeviceAbnormalPages();
				_this.userListHide(true, 108);
			} else if (type == 109) {
				_this.pstateType = 1;
				_this.GetDeviceAbnormalPages();
				_this.userListHide(true, 109);
			} else if (type == 111) {
				_this.onlineState = 1;
				_this.getUserDevicesPages();
				_this.userListHide(true, 111);
			} else if (type == 112) {
				_this.onlineState = 0;
				_this.getUserDevicesPages();
				_this.userListHide(true, 112);
			} else if (type == 113) {
				_this.GetRoshRoomAll();
				_this.userListHide(true, 113);
			} else if (type == 114) {
				_this.GetCurrRoomAbDevices();
				_this.userListHide(true, 114);
			} else {
				_this.userListHide(true, type);
			}
		},

		// 切换已处理，误报
		pstateSwitch(pstateType) {
			let _this = this;

			if (_this.pstateType == pstateType) return;

			_this.PageListWith3CodePageIndex = 1;
			_this.PageListWith3CodePageSize = 10;
			_this.pstateType = pstateType;
			_this.GetDeviceAbnormalPages();
		},

		// 处理，误报起止搜索
		startendDateClick() {
			let [startDt, endDt] = this.startendDate
			if (startDt) {
				this.GetDeviceAbnormalPages(`&startDt=${this.getNowFormatDate(startDt)}&endDt=${this.getNowFormatDate(endDt)}`);
			} else {
				this.GetDeviceAbnormalPages();
			}
		},

		// 获取日期
		getNowFormatDate(date) {
			let seperator1 = "-";
			let year = date.getFullYear();
			let month = date.getMonth() + 1;
			let strDate = date.getDate();
			if (month >= 1 && month <= 9) {
				month = "0" + month;
			}
			if (strDate >= 0 && strDate <= 9) {
				strDate = "0" + strDate;
			}
			let currentdate = year + seperator1 + month + seperator1 + strDate;
			return currentdate;
		},

		// 加载导航栏用户列表
		GetRoshRoomAll() {
			let _this = this,
				AdminData = JSON.parse(Cookies.get('AdminData'));

			let data = {
				Status: 'A',
				GroupCode: AdminData.GroupCode,
				CompanyCode: AdminData.CompanyCode,
				DepartmentCode: AdminData.DepartmentCode,
				pageIndex: _this.PageListWith3CodePageIndex,
				pageSize: _this.PageListWith3CodePageSize
			}
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: 'api/User/GetRoshRoomAll',
				data: data,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				console.log(res, _this.$t('smartElectricity.smarElectricity.218347-504'))
				console.log(res.Data, 'resGetRoshRoomAllLists')
				if (res.Success) {
					_this.GetRoshRoomAllLists = res.Data;
					_this.GetRoshRoomAllTotal = res.TotalCount;
				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					})
				}
			}).catch(function (err) {

			});
		},
		PageListWith3CodeChange3(e) {
			let _this = this;
			_this.PageListWith3CodePageIndex = e;
			_this.GetRoshRoomAll()
		},
		PageListWith3CodeSizeChange3(e) {
			let _this = this;
			_this.PageListWith3CodePageIndex = 1;
			_this.PageListWith3CodePageSize = e;
			_this.GetRoshRoomAll()
		},
		RoshRoomChange(e) {
			let _this = this;
			_this.RoshRoomIndex = e;
			_this.GetRoshRoomList()
		},
		RoshRoomSizeChange(e) {
			let _this = this;
			_this.RoshRoomIndex = 1;
			_this.RoshRoomPageSize = e;
			_this.GetRoshRoomList();
		},

		// 获取告警设备列表
		GetCurrRoomAbDevices() {
			let _this = this,
				AdminData = JSON.parse(Cookies.get('AdminData'));

			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/CommElecDevice/GetCurrRoomAbDevices?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&isAdmin=${AdminData.IsAdmin}&pageIndex=1&pageSize=1000`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token') ? Cookies.get('Token') : ''
				}
			}, 'yhj').then(function (res) {

				_this.DeviceCountList = res.Data;

			})
		},

		// 根据集团 公司 部门编号 等条件查询设备列表
		getUserDevicesPages() {
			let _this = this,
				AdminData = JSON.parse(Cookies.get('AdminData'));
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/CommElecDevice/GetUserDevicesPage?isAdmin=${AdminData.IsAdmin}&groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&pageIndex=${_this.PageListWith3CodePageIndex}&pageSize=${_this.PageListWith3CodePageSize}&onlineState=${_this.onlineState}`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				if (res.Success) {
					_this.DeviceLists = res.Data;
					_this.DeviceTotal = res.TotalCount;
				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {

			});
		},
		PageListWith3CodeChange2(e) {
			let _this = this;
			_this.PageListWith3CodePageIndex = e;
			_this.getUserDevicesPages()
		},
		PageListWith3CodeSizeChange2(e) {
			let _this = this;
			_this.PageListWith3CodePageIndex = 1;
			_this.PageListWith3CodePageSize = e;
			_this.getUserDevicesPages()
		},

		// 更多报警信息（yhj）
		GetDeviceAbnormalPageListWith3CodeListpage() {
			let _this = this,
				AdminData = JSON.parse(Cookies.get('AdminData'));
			_this.PageListWith3CodeMsg = false;

			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/YhjStatic/GetDeviceAbnormalPageListWith3Code?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&pageIndex=${_this.PageListWith3CodePageIndex}&pageSize=${_this.PageListWith3CodePageSize}&pstate=1&isAdmin=${AdminData.IsAdmin}`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				_this.PageListWith3CodeMsg = true;
				if (res.Success) {

					_this.PageListWith3CodeTotalCount = res.TotalCount;
					_this.PageListWith3CodeLists = res.Data;

				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {
				_this.PageListWith3CodeMsg = true;
			});

		},
		PageListWith3CodeChange(e) {
			let _this = this;
			_this.PageListWith3CodePageIndex = e;
			_this.GetDeviceAbnormalPageListWith3CodeListpage()
		},
		PageListWith3CodeSizeChange(e) {
			let _this = this;
			_this.PageListWith3CodePageIndex = 1;
			_this.PageListWith3CodePageSize = e;
			_this.GetDeviceAbnormalPageListWith3CodeListpage()
		},

		// 已处理/未处理报警
		GetDeviceAbnormalPages(parameter = '') {
			let _this = this,
				AdminData = JSON.parse(Cookies.get('AdminData'));
			_this.PageListWith3CodeMsg = false;

			let parameterQuery = ''
			if (parameter) {
				parameterQuery = parameter
			} else {
				parameterQuery = `&startDt=${_this.getNowFormatDate(new Date())}`
			}

			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/YhjStatic/GetDeviceAbnormalPageListWith3Code?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&pageIndex=${_this.PageListWith3CodePageIndex}&pageSize=${_this.PageListWith3CodePageSize}&pstate=${_this.pstateType}${parameterQuery}&isAdmin=${AdminData.IsAdmin}`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				_this.PageListWith3CodeMsg = true;
				if (res.Success) {

					_this.PageListWith3CodeTotalCount = res.TotalCount;
					_this.PageListWith3CodeLists = res.Data;

				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {
				_this.PageListWith3CodeMsg = true;
			});
		},
		PageListWith3CodeChange1(e) {
			let _this = this;
			_this.PageListWith3CodePageIndex = e;
			let [startDt, endDt] = this.startendDate
			if (startDt) {
				this.GetDeviceAbnormalPages(`&startDt=${this.getNowFormatDate(startDt)}&endDt=${this.getNowFormatDate(endDt)}`);
			} else {
				this.GetDeviceAbnormalPages();
			}
		},
		PageListWith3CodeSizeChange1(e) {
			let _this = this;
			_this.PageListWith3CodePageIndex = 1;
			_this.PageListWith3CodePageSize = e;
			let [startDt, endDt] = this.startendDate
			if (startDt) {
				this.GetDeviceAbnormalPages(`&startDt=${this.getNowFormatDate(startDt)}&endDt=${this.getNowFormatDate(endDt)}`);
			} else {
				this.GetDeviceAbnormalPages();
			}
		},

		// 获取传感器探头
		GetQtcgqTtItemList(DeviceCode) {
			let _this = this;

			_this.userListHide(true, 120);

			_this.qtcgqTtItemMsg = false;

			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/YhjDevice/GetQtcgqTtItemList?deviceCode=${DeviceCode}`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				_this.qtcgqTtItemMsg = true;
				if (res.Success) {

					_this.qtcgqTtItemLists = res.Data;


				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {
				_this.qtcgqTtItemMsg = true;
			});

		},

		// 时间转换
		formDate(dateForm) {
			if (!dateForm) {
				return "";
			} else {
				var dateee = new Date(dateForm).toJSON();
				var date = new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(
					/\.[\d]{3}Z/, '');
				return date;
			}
		},
		// 获取一台设备（旧接口）
		GetRoshDeviceOne(DeviceCode) {
			let _this = this;
			_this.DeviceDetailsMsg = false;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: 'api/Device/GetRoshDeviceOne?deviceCode=' + DeviceCode,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				_this.DeviceDetailsMsg = true;
				if (res.Success) {
					_this.DeviceDetails = res.Data;
					// 检测是否有操作密码
					_this.GetPassWord();
				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				_this.DeviceDetailsMsg = true;
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 获取一台设备（yhj）
		GetOneUserDevice(Id) {
			let _this = this;
			_this.DeviceDetailsMsg = false;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/YhjDevice/GetOneUserDevice/${Id}`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				_this.DeviceDetailsMsg = true;
				if (res.Success) {
					_this.DeviceDetails = res.Data;
					var date = new Date();
					var year = date.getFullYear();
					var month = date.getMonth() + 1;
					var day = date.getDate();

					_this.timeValue = year + '-' + month + '-' + day;
					// 检测是否有操作密码timeValue
					_this.GetPassWord();

				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {
				_this.DeviceDetailsMsg = true;
			});
		},
		// 设备获取按钮列表
		GetDeviceBtn(btnType) {
			let _this = this;
			console.log(btnType, _this.$t('smartElectricity.smarElectricity.218347-505'))
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: 'api/Device/GetDeviceBtn?btnType=' + btnType,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					_this.DeviceBtns = [];
					res.Data.forEach(item => {
						_this.DeviceBtns.push(item.BtonEnName)
					})
					if (btnType != 4) {
						if (_this.DeviceBtns.indexOf('state') >= 0) {
							_this.navDeviceTab(1)
						} else {
							_this.navDeviceTab(2)
						}
					}

				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 编辑设备
		submit103() {
			let _this = this;
			_this.formDevices.UserId = _this.formDevices.User_Id;
			_this.formDevices.Longitude = _this.userlocation.lng;
			_this.formDevices.Latitude = _this.userlocation.lat;

			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: 'api/YhjDevice/UpdateUserDevice',
				data: _this.formDevices,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				if (res.Success) {
					_this.$Message['success']({
						background: true,
						content: res.Message
					});
					_this.GetUserDevicesPage();
					_this.GetOneUserDevice(_this.formDevices.Id);
					_this.userListHide(false);
				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {
				_this.$Message['error']({
					background: true,
					content: _this.$t('smartElectricity.smarElectricity.218347-506')
				});
			});
		},
		// 删除设备
		ok() {
			let _this = this;
			let data = {
				DeviceCodeList: [_this.DeviceDetails.DeviceCode]
			}
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: 'api/YhjDevice/DeleteUserDevice',
				data: data,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				if (res.Success) {
					_this.$Message['success']({
						background: true,
						content: res.Message
					});
					_this.GetUserDevicesPage();
					_this.Back(1);
				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {
				_this.$Message['error']({
					background: true,
					content: _this.$t('smartElectricity.smarElectricity.218347-506')
				});
			});
		},
		cancel() { },
		// 检测是否有操作密码
		GetPassWord() {
			let _this = this;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: 'api/User/GetPassWord',
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {

					// Code：0 不存在操作密码，Code：1 存在操作密码
					if (res.Code > 0) {
						_this.passWordIndex = true;
					} else {
						_this.passWordIndex = false;
					}

				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 设置操作密码提交
		submit104() {
			let _this = this;
			if (!_this.formPassWord.password) {
				_this.$Message['error']({
					background: true,
					content: _this.$t('smartElectricity.smarElectricity.218347-507')
				});
				return;
			}
			if (!_this.formPassWord.ConfirmPassword) {
				_this.$Message['error']({
					background: true,
					content: _this.$t('smartElectricity.smarElectricity.218347-339')
				});
				return;
			}
			if (_this.formPassWord.password != _this.formPassWord.ConfirmPassword) {
				_this.$Message['error']({
					background: true,
					content: _this.$t('smartElectricity.smarElectricity.218347-508')
				});
				return;
			}
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: 'api/User/InsertPassWord',
				data: _this.formPassWord,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					_this.$Message['success']({
						background: true,
						content: _this.$t('smartElectricity.smarElectricity.218347-509')
					});
					_this.GetPassWord();
					_this.userListHide(false);

				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});

		},
		// 修改操作密码
		submit105() {
			let _this = this;
			if (!_this.formPassWord1.OldPassword) {
				_this.$Message['error']({
					background: true,
					content: _this.$t('smartElectricity.smarElectricity.218347-510')
				});
				return;
			}
			if (!_this.formPassWord1.NewPassword) {
				_this.$Message['error']({
					background: true,
					content: _this.$t('smartElectricity.smarElectricity.218347-511')
				});
				return;
			}
			if (!_this.formPassWord1.ConfirmPassword) {
				_this.$Message['error']({
					background: true,
					content: _this.$t('smartElectricity.smarElectricity.218347-339')
				});
				return;
			}
			if (_this.formPassWord1.NewPassword != _this.formPassWord1.ConfirmPassword) {
				_this.$Message['error']({
					background: true,
					content: _this.$t('smartElectricity.smarElectricity.218347-508')
				});
				return;
			}
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: 'api/User/UpdatePassWord',
				data: _this.formPassWord1,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					_this.$Message['success']({
						background: true,
						content: _this.$t('smartElectricity.smarElectricity.218347-512')
					});
					_this.GetPassWord();
					_this.formPassWord1 = {};
					_this.userListHide(false);

				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 验证密码
		VerifyPassword(type) {
			let _this = this;
			if (!_this.saveState) {
				return;
			}
			// 存在操作密码
			if (this.passWordIndex) {
				this.$Modal.confirm({
					title: _this.$t('smartElectricity.smarElectricity.218347-513'),
					render: (h) => {
						return h('Input', {
							props: {
								value: this.value,
								autofocus: true,
								placeholder: _this.$t('smartElectricity.smarElectricity.218347-514')
							},
							on: {
								input: (val) => {
									this.operatPassword = val;
								}
							}
						})
					},
					onOk: () => {
						// 检查密码是否一致
						this.getVerifyPassword(type)
					}
				})
				return
			}
			if (type == 1) {
				// 分合闸（yhj）
				_this.SaveDeviceKGStatus();
			} else if (type == 2) {
				// 关阀
				_this.CloseRanQiDianCiFa();
			}
		},

		// 关闭燃气电磁阀/切断阀
		CloseRanQiDianCiFa() {
			let _this = this;
			if (_this.operatMsg) {
				_this.$Message['error']({
					background: true,
					content: _this.$t('smartElectricity.smarElectricity.218347-515')
				});
				return;
			}
			_this.spinMsg = true;
			_this.spinTitle = _this.$t('smartElectricity.smarElectricity.218347-516');
			_this.saveState = false;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: 'api/YhjDevice/CloseRanQiDianCiFa?deviceCode=' + _this.DeviceDetails.DeviceCode,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				_this.spinMsg = false;
				_this.spinTitle = '';
				_this.saveState = true;
				if (res.Success) {
					_this.getUserDevice();
					_this.$Notice.success({
						title: _this.$t('smartElectricity.smarElectricity.218347-483'),
						desc: res.Message
					});
					_this.operatMsg = true;
					setTimeout(() => {
						_this.operatMsg = false;
					}, 7000);
				} else {
					_this.$Notice.error({
						title: _this.$t('smartElectricity.smarElectricity.218347-483'),
						desc: res.Message
					});
				}
			}).catch(function (err) {
				_this.$Notice.error({
					title: _this.$t('smartElectricity.smarElectricity.218347-506'),
					desc: res.Message
				});
			});
		},

		// 检查密码是否一致
		getVerifyPassword(type) {
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: 'api/User/VerifyPassword',
				data: {
					password: this.operatPassword
				},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then((res) => {
				if (res.Success) {
					if (type == 1) {
						// 分合闸（yhj）
						this.SaveDeviceKGStatus();
					} else if (type == 2) {
						// 关阀
						this.CloseRanQiDianCiFa();
					}
				} else {
					this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			});
		},

		// 分合闸（yhj）
		SaveDeviceKGStatus() {
			let _this = this;

			if (_this.operatMsg) {
				_this.$Message['error']({
					background: true,
					content: _this.$t('smartElectricity.smarElectricity.218347-515')
				});
				return;
			}

			let data = {
				Id: _this.DeviceDetails.Id,
				SwitchStatus: _this.DeviceDetails.SwitchStatus == 2 ? 1 : 2,
			}
			// const msg = this.$Message.loading({
			//   content: '操作中...',
			//   duration: 0
			// });
			_this.spinMsg = true;
			_this.spinTitle = _this.$t('smartElectricity.smarElectricity.218347-516');

			_this.saveState = false;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: 'api/YhjDevice/SaveDeviceKGStatus',
				data: data,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				// setTimeout(msg, 10);
				_this.spinMsg = false;
				_this.spinTitle = '';

				_this.saveState = true;
				if (res.Success) {
					// _this.GetOneUserDevice(_this.DeviceDetails.Id);
					_this.DeviceDetails.SwitchStatus = _this.DeviceDetails.SwitchStatus == 2 ? 1 : 2;
					_this.$Notice.success({
						title: _this.$t('smartElectricity.smarElectricity.218347-483'),
						desc: res.Message
					});

					_this.operatMsg = true;
					setTimeout(() => {
						_this.operatMsg = false;
					}, 7000);

				} else {
					_this.$Notice.error({
						title: _this.$t('smartElectricity.smarElectricity.218347-483'),
						desc: res.Message
					});
				}
			}).catch(function (err) {
				// setTimeout(msg, 10);
				_this.$Notice.error({
					title: _this.$t('smartElectricity.smarElectricity.218347-506'),
					desc: res.Message
				});
			});
		},

		// 召测（旧接口）
		CallZhaoCe(DeviceCode) {
			let _this = this;
			const msg = this.$Message.loading({
				content: _this.$t('smartElectricity.smarElectricity.218347-517'),
				duration: 0
			});

			_this.callState = false;

			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: 'api/Device/CallZhaoCe?sn=' + DeviceCode,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				setTimeout(msg, 10);
				_this.callState = true;
				if (res.Success) {

					if (res.Code === 0) {
						_this.$Notice.success({
							title: _this.$t('smartElectricity.smarElectricity.218347-483'),
							desc: res.Message
						});
						_this.GetRoshDeviceOne(DeviceCode);
					} else {
						_this.$Notice.error({
							title: _this.$t('smartElectricity.smarElectricity.218347-483'),
							desc: res.Message
						});
					}


				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				_this.callState = true;
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 召测（yhj）
		InitDeviceRead(DeviceCode, Id) {
			let _this = this;

			if (_this.operatMsg) {
				_this.$Message['error']({
					background: true,
					content: _this.$t('smartElectricity.smarElectricity.218347-515')
				});
				return;
			}

			if (!_this.callState) {
				return;
			}

			// const msg = this.$Message.loading({
			//   content: _this.$t('smartElectricity.smarElectricity.218347-517'),
			//   duration: 0
			// });

			_this.spinMsg = true;
			_this.spinTitle = _this.$t('smartElectricity.smarElectricity.218347-518');

			_this.callState = false;

			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: 'api/YhjDevice/InitDeviceRead?deviceCode=' + DeviceCode,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				_this.callState = true;
				// setTimeout(msg, 10);

				_this.spinMsg = false;
				_this.spinTitle = '';

				if (res.Success) {

					if (res.Code === 0) {
						_this.$Notice.success({
							title: _this.$t('smartElectricity.smarElectricity.218347-483'),
							desc: res.Message
						});
						_this.GetOneUserDevice(Id);
					} else {
						_this.$Notice.error({
							title: _this.$t('smartElectricity.smarElectricity.218347-483'),
							desc: res.Message
						});
					}

					_this.operatMsg = true;
					setTimeout(() => {
						_this.operatMsg = false;
					}, 7000);

				} else {
					_this.callState = true;
					// setTimeout(msg, 10);
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {
				_this.$Message['error']({
					background: true,
					content: _this.$t('smartElectricity.smarElectricity.218347-506')
				});
			});
		},
		// 获取modbus v3 时钟，时钟设置时候显示
		GetSZ_ModbusV3(DeviceCode) {
			let _this = this;

			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/YhjDevice/GetSZ_ModbusV3?deviceCode=${DeviceCode}`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				if (res.Success) {

					_this.ReplyTime = res.Data.ReplyTime;

				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {

			});

			_this.userListHide(true, 122);

		},

		// 升级微断v3设备
		update_ModbusV3(DeviceCode) {
			let _this = this;
			this.$Modal.confirm({
				title: _this.$t('smartElectricity.smarElectricity.218347-513'),
				render: (h) => {
					return h('Input', {
						props: {
							value: this.value,
							autofocus: true,
							placeholder: _this.$t('smartElectricity.smarElectricity.218347-514')
						},
						on: {
							input: (val) => {
								this.uploadPassword = val;
							}
						}
					})
				},
				onOk: () => {
					 const msg = this.$Message.loading({
							content: _this.$t('smartElectricity.smarElectricity.218347-516'),
							duration: 0
						});
					api({
						//这里是你自己的请求方式、url和data参数
						method: 'get',
						url: `api/YhjDevice/UpWgMoZu?deviceCode=${DeviceCode}&pwd=${_this.uploadPassword}`,
						data: {},
						//假设后台需要的是表单数据这里你就可以更改
						headers: {
							"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
							"Authorization": Cookies.get('Token')
						}
					}, 'yhj').then(function (res) {
						setTimeout(msg, 10);
						if (res.Success) {
							_this.$Message['success']({
								background: true,
								content: _this.$t('smartElectricity.smarElectricity.218347-550')
							});

						} else {
							_this.$Message['error']({
								background: true,
								content: res.Message
							});
						}
					}).catch(function (err) {
					});
				}
			})
		},

		// 设置modbus v3 时钟
		SetSZ_ModbusV3() {
			let _this = this;

			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/YhjDevice/SetSZ_ModbusV3?deviceCode=${_this.DeviceDetails.DeviceCode}`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				if (res.Success) {

					_this.$Message['success']({
						background: true,
						content: res.Message
					});
					setTimeout(() => {
						_this.GetSZ_ModbusV3(_this.DeviceDetails.DeviceCode);
					}, 2000);

				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {

			});
		},

		// 读取时钟
		DeviceRWByTypeModbusV3() {
			let _this = this;

			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/YhjDevice/DeviceRWByType?deviceCode=${_this.DeviceDetails.DeviceCode}&zcType=28`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				if (res.Success) {

					_this.$Message['success']({
						background: true,
						content: res.Message
					});
					setTimeout(() => {
						_this.GetSZ_ModbusV3(_this.DeviceDetails.DeviceCode);
					}, 2000);

				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {

			});
		},

		// 烟感设备消音（旧接口）
		YGDeviceSlience(ParameterCode, DeviceCode) {
			let _this = this;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/Device/YGDeviceSlience?deviceCode=${DeviceCode}&parameterCode=${ParameterCode}`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {

					_this.$Message['success']({
						background: true,
						content: res.Message
					});

				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 烟感设备消音（yhj）
		Device_YanGan_Silence() {
			let _this = this;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/YhjDevice/Device_YanGan_Silence?deviceCode=${_this.DeviceDetails.DeviceCode}`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				if (res.Success) {

					_this.$Message['success']({
						background: true,
						content: res.Message
					});

				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {
				_this.$Message['error']({
					background: true,
					content: _this.$t('smartElectricity.smarElectricity.218347-506')
				});
			});
		},
		// 获取设备实时值（微断设备 旧）
		GetDeviceRealValue(DeviceCode) {
			let _this = this;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: 'api/Device/GetDeviceRealValue?deviceCode=' + DeviceCode,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					if (res.Data) {
						_this.GetDeviceRealValues = res.Data;
					} else {
						_this.GetDeviceRealValues = {};
					}

					_this.currentRealTime = _this.formDate(new Date());

				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 获取设备实时值（烟感设备 旧）
		GetSmokeDetail(DeviceCode) {
			let _this = this;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: 'api/Device/GetSmokeDetail?deviceCode=' + DeviceCode,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					if (res.Data) {
						_this.GetSmokeDetails = res.Data;
					} else {
						_this.GetSmokeDetails = {};
					}

					_this.currentRealTime = _this.formDate(new Date());

				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 获取设备实时值（气感设备 旧）
		GetQgDetail(DeviceCode) {
			let _this = this;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: 'api/Device/GetQgDetail?deviceCode=' + DeviceCode,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					if (res.Data) {
						_this.GetQgDetails = res.Data;
					} else {
						_this.GetQgDetails = {};
					}

					_this.currentRealTime = _this.formDate(new Date());

				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 获取设备状态（yhj）
		DeviceParameterLook(DeviceCode) {
			let _this = this;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: 'api/YhjDevice/DeviceParameterLook',
				data: {
					DeviceCode
				},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				if (res.Success) {

					if (res.Data[res.Data.length - 1].ParamCode == 'UpdateTime') {
						_this.DeviceDetails.UpdateTime = res.Data[res.Data.length - 1].ParamValue
					}

					// _this.DeviceParameterLookLists = _this.arrTrans(2, res.Data);
					_this.DeviceParameterLookLists = (res.Data || []);

					// _this.currentRealTime = _this.formDate(new Date());

				} else {
					_this.DeviceParameterLookLists = [];
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {
				_this.$Message['error']({
					background: true,
					content: _this.$t('smartElectricity.smarElectricity.218347-506')
				});
			});
		},
		// 获取Zigbee设备状态
		DeviceParameterLook_Zigbee(DeviceCode) {
			let _this = this;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: 'api/YhjDevice/DeviceParameterLook_Zigbee',
				data: {
					DeviceCode
				},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				if (res.Success) {

					_this.GetUserDeviceParamList = res.Data;


					if (!res.Data.ZbDeviceModel.DeviceInfoBaseModel) {
						_this.DeviceInfoBaseModel = {};
					} else {
						_this.DeviceInfoBaseModel = res.Data.ZbDeviceModel.DeviceInfoBaseModel;
					}


					_this.ZbDeviceModel = res.Data.ZbDeviceModel;
					_this.DeviceDianCiModel = res.Data.ZbDeviceModel.DeviceDianCiModel;

					if (!res.Data.ZbDeviceModel.DeviceDianCiModel) {
						_this.DeviceDianCiModel = {};
					}

					_this.DeviceDetails.UpdateTime = res.Data.ZbDeviceModel.UpdateTime

					_this.currentRealTime = _this.formDate(new Date());

				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {
				_this.$Message['error']({
					background: true,
					content: _this.$t('smartElectricity.smarElectricity.218347-506')
				});
			});
		},
		// 切换监测类型
		navDeviceCheckTab(checkCode) {
			let _this = this;
			if (_this.checkCode != checkCode) {
				_this.checkCode = checkCode;
				// _this.DeviceCheck(); // 旧接口

				if (_this.checkCode <= 3) {
					_this.GetDeviceCheckDataABCxiang(); // yhj监控ABC三相
				} else if (_this.checkCode == 6) {
					_this.GetDeviceCheckDatas(); // 漏电
				} else {
					_this.GetDeviceCheckDataGL(); // 功率
				}

			}
		},
		// 将一维数组转二维
		arrTrans(num, arr) {
			const newArr = [];
			while (arr.length > 0) {
				newArr.push(arr.splice(0, num));
			}
			return newArr;
		},
		// 设备监测（旧接口）
		DeviceCheck() {
			let _this = this;
			let data = {
				deviceCode: _this.DeviceDetails.DeviceCode,
				// deviceCode: '868163041426377',
				time: _this.timeValue,
				checkCode: _this.checkCode
			}
			_this.seriesGetMsg = true;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: 'api/Device/DeviceCheck',
				data: data,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {

					let legends = [],
						xAxis = [],
						series = [];
					xAxis = res.Data[0].name;
					res.Data.forEach((item, index) => {
						legends.push(item.checkCode);
						series.push({
							name: item.checkCode,
							type: 'line',
							smooth: true,
							data: item.value
						})
					})

					// 图表是否为空
					if (series[0].data.length > 0) {
						_this.seriesMsg = true;
						_this.seriesGetMsg = false;
						_this.$nextTick(function () {
							_this.drawLine(legends, xAxis, series);
						});
					} else {
						_this.seriesMsg = false;
						_this.seriesGetMsg = false;
					}

				} else {
					_this.seriesGetMsg = false;
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 设备监测（abc三项）（yhj）
		GetDeviceCheckDataABCxiang() {

			let _this = this;
			_this.seriesGetMsg = true;
			let checkCode = _this.checkCode == 1 ? 'Axiangdianya' : _this.checkCode == 2 ? 'Axiangdianliu' : _this
				.checkCode == 3 ? 'Axiangwendu' : _this.checkCode == 4 ? 'yggl' : 'wggl';
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/YhjStatic/GetDeviceCheckDataABCxiang?deviceCode=${_this.DeviceDetails.DeviceCode}&checkCode=${checkCode}&startDt=${_this.timeValue}&endDt=${_this.timeValue}`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				if (res.Success) {
					let legends = [],
						xAxis = [],
						series = [],
						arrTimes = [];

					let arrLists = res.Data;

					let listA = [];
					let listB = [];
					let listC = [];
					xAxis[0] = _this.$t('smartElectricity.smarElectricity.218347-519') + (_this.checkCode == 1 ? _this.$t('smartElectricity.smarElectricity.218347-88') : _this.checkCode == 2 ? _this.$t('smartElectricity.smarElectricity.218347-89') : _this.$t('smartElectricity.smarElectricity.218347-90'));
					xAxis[1] = _this.$t('smartElectricity.smarElectricity.218347-520') + (_this.checkCode == 1 ? _this.$t('smartElectricity.smarElectricity.218347-88') : _this.checkCode == 2 ? _this.$t('smartElectricity.smarElectricity.218347-89') : _this.$t('smartElectricity.smarElectricity.218347-90'));
					xAxis[2] = _this.$t('smartElectricity.smarElectricity.218347-521') + (_this.checkCode == 1 ? _this.$t('smartElectricity.smarElectricity.218347-88') : _this.checkCode == 2 ? _this.$t('smartElectricity.smarElectricity.218347-89') : _this.$t('smartElectricity.smarElectricity.218347-90'));

					arrLists.listA.forEach(arr => {
						listA.push(arr.CheckValue);
						arrTimes.push(arr.CreateDate);
					})

					arrLists.listB.forEach(arr => {
						listB.push(arr.CheckValue);
					})

					arrLists.listC.forEach(arr => {
						listC.push(arr.CheckValue);
					})

					for (let i = 0; i < 3; i++) {
						series.push({
							name: xAxis[i],
							type: 'line',
							smooth: true,
							data: i === 0 ? listA : i === 1 ? listB : listC,
							itemStyle: {
								normal: { //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
									color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: i === 0 ? 'rgba(150,207,29,0.3)' : i === 1 ?
											'rgba(0,136,212,0.3)' :
											'rgba(240,55,56,0.3)' // 0% 处的颜色
									}, {
										offset: 0.5,
										color: i === 0 ? 'rgba(150,207,29,0.1)' : i === 1 ?
											'rgba(0,136,212,0.1)' :
											'rgba(240,55,56,0.1)' // 100% 处的颜色
									}, {
										offset: 1,
										color: i === 0 ? 'rgba(150,207,29,0.0)' : i === 1 ?
											'rgba(0,136,212,0.0)' :
											'rgba(240,55,56,0.0)' // 100% 处的颜色
									}]), //背景渐变色
									lineStyle: { // 系列级个性化折线样式
										color: i === 0 ? 'rgba(150,207,29,1)' : i === 1 ?
											'rgba(0,136,212,1)' : 'rgba(240,55,56,1)'
									}
								},
								emphasis: {
									color: i === 0 ? 'rgba(150,207,29,1)' : i === 1 ?
										'rgba(0,136,212,1)' : 'rgba(240,55,56,1)'
								}
							}, //线条样式
							areaStyle: {
								normal: {}
							},
						})
					}

					// 图表是否为空
					if (series[0].data.length > 0) {
						_this.seriesMsg = true;
						_this.seriesGetMsg = false;
						_this.$nextTick(function () {
							let myChart = echarts.init(document.getElementById('myChart'));
							myChart.dispose();
							_this.drawLine(xAxis, arrTimes, series);
						});
					} else {
						_this.seriesMsg = false;
						_this.seriesGetMsg = false;
					}
				} else {
					_this.seriesGetMsg = false;
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {
				_this.seriesGetMsg = false;
				_this.$Message['error']({
					background: true,
					content: _this.$t('smartElectricity.smarElectricity.218347-506')
				});
			});

		},
		// 设备监控（功率）（yhj）
		GetDeviceCheckDataGL() {
			let _this = this;
			_this.seriesGetMsg = true;
			let checkCode = _this.checkCode == 1 ? 'Axiangdianya' : _this.checkCode == 2 ? 'Axiangdianliu' : _this
				.checkCode == 3 ? 'Axiangwendu' : _this.checkCode == 4 ? 'yggl' : 'wggl';
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/YhjStatic/GetDeviceCheckDataGL?deviceCode=${_this.DeviceDetails.DeviceCode}&checkCode=${checkCode}&startDt=${_this.timeValue}&endDt=${_this.timeValue}`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				if (res.Success) {
					let legends = [],
						xAxis = [],
						series = [],
						arrTimes = [];

					let arrLists = res.Data;

					let listA = [];
					let listB = [];
					let listC = [];
					let listTotal = [];

					xAxis[0] = _this.$t('smartElectricity.smarElectricity.218347-519');
					xAxis[1] = _this.$t('smartElectricity.smarElectricity.218347-520');
					xAxis[2] = _this.$t('smartElectricity.smarElectricity.218347-521');
					xAxis[3] = _this.$t('smartElectricity.smarElectricity.218347-522');

					arrLists.listA.forEach(arr => {
						listA.push(arr.CheckValue);
						arrTimes.push(arr.CreateDate);
					})

					arrLists.listB.forEach(arr => {
						listB.push(arr.CheckValue);
					})

					arrLists.listC.forEach(arr => {
						listC.push(arr.CheckValue);
					})

					arrLists.listTotal.forEach(arr => {
						listTotal.push(arr.CheckValue);
					})

					for (let i = 0; i < 4; i++) {
						series.push({
							name: xAxis[i],
							type: 'line',
							smooth: true,
							data: i === 0 ? listA : i === 1 ? listB : listC,
							itemStyle: {
								normal: { //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
									color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: i === 0 ? 'rgba(150,207,29,0.3)' : i === 1 ?
											'rgba(0,136,212,0.3)' : i === 2 ?
												'rgba(240,55,56,0.3)' :
												'rgba(16,75,154,0.3)' // 0% 处的颜色
									}, {
										offset: 0.5,
										color: i === 0 ? 'rgba(150,207,29,0.1)' : i === 1 ?
											'rgba(0,136,212,0.1)' : i === 2 ?
												'rgba(240,55,56,0.1)' :
												'rgba(16,75,154,0.1)' // 100% 处的颜色
									}, {
										offset: 1,
										color: i === 0 ? 'rgba(150,207,29,0.0)' : i === 1 ?
											'rgba(0,136,212,0.0)' : i === 2 ?
												'rgba(240,55,56,0.0)' :
												'rgba(16,75,154,0.0)' // 100% 处的颜色
									}]), //背景渐变色
									lineStyle: { // 系列级个性化折线样式
										color: i === 0 ? 'rgba(150,207,29,1)' : i === 1 ?
											'rgba(0,136,212,1)' : i === 2 ? 'rgba(240,55,56,1)' :
												'rgba(16,75,154,1)'
									}
								},
								emphasis: {
									color: i === 0 ? 'rgba(150,207,29,1)' : i === 1 ?
										'rgba(0,136,212,1)' : 'rgba(240,55,56,1)'
								}
							}, //线条样式
							areaStyle: {
								normal: {}
							},
						})
					}

					// 图表是否为空
					if (series[0].data.length > 0) {
						_this.seriesMsg = true;
						_this.seriesGetMsg = false;
						_this.$nextTick(function () {
							let myChart = echarts.init(document.getElementById('myChart'));
							myChart.dispose();
							_this.drawLine(xAxis, arrTimes, series);
						});
					} else {
						_this.seriesMsg = false;
						_this.seriesGetMsg = false;
					}
				} else {
					_this.seriesGetMsg = false;
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {
				_this.seriesGetMsg = false;
				_this.$Message['error']({
					background: true,
					content: _this.$t('smartElectricity.smarElectricity.218347-506')
				});
			});
		},
		// 设备监测（其它）
		GetDeviceCheckDatas() {
			let _this = this;
			_this.seriesGetMsg = true;
			let checkCode = 'Zongloudian';
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/YhjStatic/GetDeviceCheckDatas?deviceCode=${_this.DeviceDetails.DeviceCode}&checkCode=${checkCode}&startDt=${_this.timeValue}&endDt=${_this.timeValue}`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				if (res.Success) {
					let legends = [],
						xAxis = [],
						series = [],
						arrTimes = [];

					let arrLists = res.Data;

					let listA = [];
					let listB = [];
					let listC = [];
					xAxis[0] = _this.$t('smartElectricity.smarElectricity.218347-93');

					arrLists.forEach(arr => {
						listA.push(arr.CheckValue);
						arrTimes.push(arr.CreateDate);
					})

					series.push({
						name: xAxis[0],
						type: 'line',
						smooth: true,
						data: listA,
						itemStyle: {
							normal: { //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
									offset: 0,
									color: 'rgba(255,183,64,0.3)' // 0% 处的颜色
								}, {
									offset: 0.5,
									color: 'rgba(255,183,64,0.1)' // 100% 处的颜色
								}, {
									offset: 1,
									color: 'rgba(255,183,64,0.0)' // 100% 处的颜色
								}]), //背景渐变色
								lineStyle: { // 系列级个性化折线样式
									color: "rgb(255,183,64)"
								}
							},
							emphasis: {
								color: 'rgb(255,183,64)'
							}
						}, //线条样式
						areaStyle: {
							normal: {}
						},
					})
					// 图表是否为空
					if (series[0].data.length > 0) {
						_this.seriesMsg = true;
						_this.seriesGetMsg = false;
						_this.$nextTick(function () {
							let myChart = echarts.init(document.getElementById('myChart'));
							myChart.dispose();
							_this.drawLine(xAxis, arrTimes, series);
						});
					} else {
						_this.seriesMsg = false;
						_this.seriesGetMsg = false;
					}
				} else {
					_this.seriesGetMsg = false;
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {
				_this.seriesGetMsg = false;
				_this.$Message['error']({
					background: true,
					content: _this.$t('smartElectricity.smarElectricity.218347-506')
				});
			});
		},
		// 获取及时告警信息（旧接口）
		GetAbData() {
			let _this = this;
			_this.GetAbDataListsMsg = false;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: 'api/Device/GetAbData',
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				_this.GetAbDataListsMsg = true;
				if (res.Success) {

					_this.GetAbDataLists = res.Data;

				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				_this.GetAbDataListsMsg = true;
				// if (err.data.Code == -9 || err.data.Code == -1) {
				// 	_this.$router.push({
				// 		name: 'login'
				// 	})
				// }
			});
		},
		// 根据集团 公司 部门获取设备异常（yhj）
		GetDeviceAbnormalPageListWith3Code(type = '') {
			if (!Cookies.get('AdminData')) {
				return;
			}
			let _this = this,
				AdminData = JSON.parse(Cookies.get('AdminData'));
			_this.GetAbDataListsMsg = false;
			window.clearInterval(this.timerID);
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/YhjStatic/GetDeviceAbnormalPageListWith3Code?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&pageIndex=1&pageSize=15&pstate=1&isAdmin=${AdminData.IsAdmin}${type}`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				_this.GetAbDataListsMsg = true;
				if (res.Success) {

					_this.GetAbDataLists = res.Data;
					_this.todayAbCount = res.TotalCount;

					if (!_this.timertmpe && _this.GetAbDataLists.length) {
						_this.$nextTick(function () {
							_this.timertmpe = true;
							_this.Carousel();
						});
					}

					if (!_this.GetAbDataLists.length) {
						// _this.timertmpe = false;
					}


				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {
				_this.GetAbDataListsMsg = true;
			});
		},
		// 获取单个设备异常数据（旧接口）
		GetOneDeviceAbData() {
			let _this = this;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/Device/GetOneDeviceAbData?deviceCode=${'010203040507'}&date=${_this.timeValue1}`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {

					_this.GetOneDeviceAbDataLists = res.Data;

				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 根据设备编号获取异常（yhj）
		GetDeviceAbnormalPageList() {
			let _this = this;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/YhjStatic/GetDeviceAbnormalPageList?deviceCode=${_this.DeviceDetails.DeviceCode}&pageIndex=1&pageSize=100&startDt=${_this.timeValue1}&endDt=${_this.timeValue1}&pstate=1`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				if (res.Success) {

					_this.GetOneDeviceAbDataLists = res.Data;

				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 及时告警信息处理 type 1、处理 2、误报 （旧接口）
		SolveAbDataJiu(Id, type) {
			let _this = this;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/Device/SolveAbData/${Id}?type=${type}`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {

					_this.$Message['success']({
						background: true,
						content: res.Message
					});
					_this.GetAbData();
					// 获取导航栏数据
					_this.GetNavData();
					// 获取导航栏数据（yhj）
					_this.GetNavDataYHJ();

					if (_this.PlayIndex) {
						// 获取异常设备条数
						_this.GetAbDeviceCount();
					}

					_this.GetOneDeviceAbData();

				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 及时告警信息处理 type 2、处理 3、误报（yhj）
		SolveAbData(Id, type, state) {
			let _this = this,
				AdminData = JSON.parse(Cookies.get('AdminData'));
			_this.$Modal.confirm({
				title: _this.$t('smartElectricity.smarElectricity.218347-483'),
				content: `<p>是否对设备进行${type == 2 ? _this.$t('smartElectricity.smarElectricity.218347-95') : _this.$t('smartElectricity.smarElectricity.218347-96')}操作</p>`,
				onOk: () => {
					api({
						//这里是你自己的请求方式、url和data参数
						method: 'get',
						url: `api/YhjDevice/ProcessUserDeviceAbnormal?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&userDeviceAbnormal_Id=${Id}&pstate=${type}`,
						data: {},
						//假设后台需要的是表单数据这里你就可以更改
						headers: {
							"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
							"Authorization": Cookies.get('Token')
						}
					}, 'yhj').then(function (res) {
						if (res.Success) {
							_this.$Message['success']({
								background: true,
								content: res.Message
							});
							_this.GetNavDataYHJ();

							clearInterval(_this.timerID);

							// 根据集团 公司 部门获取设备异常（yhj）
							_this.GetDeviceAbnormalPageListWith3Code();

							if (_this.userListHideMsg == 108 || _this.userListHideMsg == 109) {
								_this.GetDeviceAbnormalPages();
							} else {
								_this.GetDeviceAbnormalPageList(); // 设备异常记录（yhj）
								_this.GetDeviceAbnormalPageListWith3CodeListpage(state ? _this
									.getNowFormatDate(new Date()) : '');
							}


						} else {
							_this.$Message['error']({
								background: true,
								content: res.Message
							});
						}
					}).catch(function (err) {
						// _this.$Message['error']({
						//   background: true,
						//   content: _this.$t('smartElectricity.smarElectricity.218347-506')
						// });
					});
				},
				onCancel: () => {

				}
			});

		},
		// 根据设备编号及时告警信息处理 pstate 2、处理 3、误报（yhj）
		ProcessUserDeviceAbnormalDeviceCode(deviceCode, abCreateTime, pstate) {
			let _this = this,
				AdminData = JSON.parse(Cookies.get('AdminData'));
			_this.$Modal.confirm({
				title: _this.$t('smartElectricity.smarElectricity.218347-483'),
				content: `<p>是否对设备进行${pstate == 2 ? _this.$t('smartElectricity.smarElectricity.218347-95') : _this.$t('smartElectricity.smarElectricity.218347-96')}操作</p>`,
				onOk: () => {
					api({
						//这里是你自己的请求方式、url和data参数
						method: 'get',
						url: `api/YhjDevice/ProcessUserDeviceAbnormalDeviceCode?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&deviceCode=${deviceCode}&abCreateTime=${abCreateTime}&pstate=${pstate}`,
						data: {},
						//假设后台需要的是表单数据这里你就可以更改
						headers: {
							"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
							"Authorization": Cookies.get('Token')
						}
					}, 'yhj').then(function (res) {
						if (res.Success) {
							_this.$Message['success']({
								background: true,
								content: res.Message
							});
							_this.alarmState = false;
							_this.GetNavDataYHJ();

							clearInterval(_this.timerID);

							// 根据集团 公司 部门获取设备异常（yhj）
							_this.GetDeviceAbnormalPageListWith3Code();

							if (_this.userListHideMsg == 108 || _this.userListHideMsg == 109) {
								_this.GetDeviceAbnormalPages();
							} else {
								_this.GetDeviceAbnormalPageList(); // 设备异常记录（yhj）
								_this.GetDeviceAbnormalPageListWith3CodeListpage(state ? _this
									.getNowFormatDate(new Date()) : '');
							}


						} else {
							_this.$Message['error']({
								background: true,
								content: res.Message
							});
						}
					}).catch(function (err) {
						// _this.$Message['error']({
						//   background: true,
						//   content: _this.$t('smartElectricity.smarElectricity.218347-506')
						// });
					});
				},
				onCancel: () => {

				}
			});

		},
		// 获取导航栏数据
		GetNavData() {
			let _this = this;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/Device/GetNavData`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {

					_this.GetNavDatas = res.Data;

				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				// if (err.data.Code == -9 || err.data.Code == -1) {
				// 	_this.$router.push({
				// 		name: 'login'
				// 	})
				// }
			});
		},
		// 获取导航栏数据（yhj）
		GetNavDataYHJ() {

			if (!Cookies.get('AdminData')) {
				return;
			}

			let _this = this,
				AdminData = JSON.parse(Cookies.get('AdminData'));

			_this.TittleName = AdminData.TittleName;
			_this.TittleNameEN = AdminData.TittleNameEN;
			_this.ImageUrl = AdminData.ImageUrl;

			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/CommElecDevice/GetNavData?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&isAdmin=${AdminData.IsAdmin}`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				if (res.Success) {

					_this.GetNavDataYHJs = res.Data;

				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			})
		},
		// 判断是否新老协议设备
		GetThreshold() {
			let _this = this;
			// _this.DeviceParameter_New(_this.DeviceDetails.DeviceCode);

			if (_this.DeviceDetails.DeviceItemId == '0b4550c8-bbaa-43bb-9bf4-d8f6cd02766c') { // 集中器 V3

				// 获取 modbus v3的结构参数（yhj）
				_this.GetDeviceParameterModbusV3_struct();

			}

			_this.GetDeviceParameter(_this.DeviceDetails.DeviceCode);

			// if (_this.DeviceDetails.ConnectDevice == 4) {
			// 	_this.DeviceParameter_New(_this.DeviceDetails.DeviceCode);
			// } else {
			// 	_this.DeviceParameter(_this.DeviceDetails.DeviceCode);
			// }
		},
		// 获取 modbus v3的结构参数（yhj）
		GetDeviceParameterModbusV3_struct() {
			console.log("🚀 ~ res:", '1111')
			let _this = this;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/YhjDevice/GetDeviceParameterModbusV3_struct?all=1`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				_this.GetDeviceParameterModbusV3Struct = res;
				
			}).catch(function (err) {
				_this.$Message['error']({
					background: true,
					content: _this.$t('smartElectricity.smarElectricity.218347-506')
				});
			});
		},
		// 获取设备参数（yhj）
		GetDeviceParameter(deviceCode) {
			let _this = this;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/YhjDevice/GetDeviceParameter?deviceCode=${deviceCode}`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {

				if (res.Success) {

					if (res.Data) {
						_this.formThreshold = res.Data;
					} else {
						_this.formThreshold = {};
					}

				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}

			}).catch(function (err) {
				_this.$Message['error']({
					background: true,
					content: _this.$t('smartElectricity.smarElectricity.218347-506')
				});
			});
		},
		// 获取设备参数信息(新协议)
		DeviceParameter_New(DeviceCode) {
			let _this = this;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/Device/DeviceParameter_New?sn=${DeviceCode}`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {

					if (res.Data) {
						_this.formThreshold = res.Data;
					} else {
						_this.formThreshold = {};
					}

				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 获取设备参数信息(老版本)
		DeviceParameter(DeviceCode) {
			let _this = this;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/Device/DeviceParameter?sn=${DeviceCode}`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {

					// console.log(res)

				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 判断初始化数据
		initDataThreshold() {
			let _this = this;
			// v-2.17版本新协议参数初始化（旧接口）
			// _this.HYDeviceParameter_New();
			//
		},
		// 参数初始化（新协议）（旧接口）
		HYDeviceParameter_New() {
			let _this = this;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/Device/HYDeviceParameter_New`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {

					_this.formThreshold = res.Data;

				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 设置阈值判断
		setThreshold() {
			let _this = this;
			// 新协议
			// _this.SetDeviceParameter();

			// 配置阈值（yhj）
			_this.formThreshold.SN = _this.DeviceDetails.DeviceCode;

			if (_this.DeviceDetails.DeviceItemId == '0b4550c8-bbaa-43bb-9bf4-d8f6cd02766c') { // 集中器 V3
				_this.SetFZ_ModbusV3_2(); // 设置 modbus v3第2组参数
			} else {
				_this.EditDeviceParameterNew(); // 其它新协议设备
			}

		},
		// 设置 modbus v3第2组参数
		SetFZ_ModbusV3_2() {
			let _this = this;
			_this.spinMsg = true;
			_this.spinTitle = _this.$t('smartElectricity.smarElectricity.218347-516');
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: `api/YhjDevice/SetFZ_ModbusV3_2`,
				data: _this.formThreshold,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				_this.spinMsg = false;
				_this.spinTitle = '';
				if (res.Success) {

					_this.$Message['success']({
						background: true,
						content: res.Message
					});

				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}

			}).catch(function (err) {
				_this.spinMsg = false;
				_this.spinTitle = '';
				_this.$Message['error']({
					background: true,
					content: _this.$t('smartElectricity.smarElectricity.218347-506')
				});
			});
		},
		// 其它新协议设备
		EditDeviceParameterNew() {
			let _this = this;
			_this.spinMsg = true;
			_this.spinTitle = _this.$t('smartElectricity.smarElectricity.218347-516');
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: `api/YhjDevice/EditDeviceParameterNew`,
				data: _this.formThreshold,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				_this.spinMsg = false;
				_this.spinTitle = '';
				if (res.Success) {

					_this.$Message['success']({
						background: true,
						content: res.Message
					});

				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}

			}).catch(function (err) {
				_this.spinMsg = false;
				_this.spinTitle = '';
				_this.$Message['error']({
					background: true,
					content: _this.$t('smartElectricity.smarElectricity.218347-506')
				});
			});
		},
		// 老设备设置阈值
		SetDeviceParameter() {
			let _this = this;
			_this.formThreshold.SN = _this.DeviceDetails.DeviceCode
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: `api/Device/SetDeviceParameter`,
				data: _this.formThreshold,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {

					_this.$Message['success']({
						background: true,
						content: res.Message
					});

				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 设备读写，根据召测类型（NB/集中器）
		DeviceRWByType(type = 0) {
			let _this = this;
			_this.spinMsg = true;
			_this.spinTitle = _this.$t('smartElectricity.smarElectricity.218347-516');
			let typeUrl = '';
			if (type != 0) {
				typeUrl = `&type=${type}`
			}
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/YhjDevice/DeviceRWByType?deviceCode=${_this.DeviceDetails.DeviceCode}&zcType=23` +
					typeUrl,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				_this.spinMsg = false;
				_this.spinTitle = '';
				if (res.Success) {

					_this.$Message['success']({
						background: true,
						content: res.Message
					});

					setTimeout(() => {
						_this.GetDeviceParameter(_this.DeviceDetails.DeviceCode);
					}, 2000)

				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}

			}).catch(function (err) {
				_this.spinMsg = false;
				_this.spinTitle = '';
				_this.$Message['error']({
					background: true,
					content: _this.$t('smartElectricity.smarElectricity.218347-506')
				});
			});
		},
		/*============================================================================================*/

		/**
		 * ==============================================商户费用模块============================================
		 * */
		//获取商户费用接口
		GetMerchantFeeTemplateList() {
			let _this = this;
			_this.GetBusinessMoneyMsg = false
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/YhjAdmin/GetMerchantFeeTemplateList?PageIndex=${_this.MoneyPageIndex}&PageSize=${_this.MoneyPageSize}`,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				_this.GetBusinessMoneyMsg = true
				if (res.Success) {
					console.log(res, _this.$t('smartElectricity.smarElectricity.218347-524'))
					_this.GetbusinessMoneylists = res.Data;
					_this.BusinessMoneyTotalCount = res.TotalCount;
				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				_this.GetBusinessMoneyMsg = true
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		BusinessMoneyChange(e) {
			console.log(e, 'BusinessMoneyChange')
			let _this = this;
			_this.MoneyPageIndex = e;
			_this.GetMerchantFeeTemplateList()
		},
		BusinessMoneySizeChange(e) {
			console.log(e, 'BusinessMoneySizeChange')
			let _this = this;
			_this.MoneyPageIndex = 1;
			_this.MoneyPageSize = e;
			_this.GetMerchantFeeTemplateList()
		},
		submit136() {
			let _this = this;
			if (!Cookies.get('AdminData')) {
				return;
			}
			let AdminData = JSON.parse(Cookies.get('AdminData'));
			let data = {
				Status: 1,     // 1 有效 , -1 无效 ,
				uid: AdminData.Uid,
				..._this.Merchants
			}
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: 'api/YhjAdmin/AddMerchantFeeTemplate',
				data: data,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				if (res.Success) {
					console.log(res, _this.$t('smartElectricity.smarElectricity.218347-525'))
					_this.$Message['success']({
						background: true,
						content: res.Message
					});
					_this.userListHide(true, 135)
				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				_this.GetBusinessMoneyMsg = true
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});

		},
		cancel136() {
			let _this = this;
			_this.Merchants = {}
		},
		ModifybusinessMoney(value, item) {
			let _this = this;
			_this.MerchantsData = {
				...item
			}
			_this.userListHide(true, 188)
			//  _this.MerchantsData.BuyPrice = item.BuyPrice
			// _this.MerchantsData.BuyType = item.BuyType
			// MerchantscityList

			console.log(_this.MerchantsData, _this.$t('smartElectricity.smarElectricity.218347-526'))
		},
		//修改
		EditMerchantFeeTemplate() {
			let _this = this;

			if (!Cookies.get('AdminData')) {
				return;
			}
			let AdminData = JSON.parse(Cookies.get('AdminData'));

			let data = {
				Status: 1,     // 1 有效 , -1 无效 ,
				uid: AdminData.Uid,
				Id: _this.MerchantsData.Id,
				BuyType: _this.MerchantsData.BuyType,
				BuyPrice: _this.MerchantsData.BuyPrice
			}
			console.log(data, _this.$t('smartElectricity.smarElectricity.218347-527'))
			api({
				//这里是你自己的请求方式、url和data参数/api/YhjAdmin/EditMerchantFeeTemplate
				method: 'post',
				url: 'api/YhjAdmin/EditMerchantFeeTemplate',
				data: data,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				if (res.Success) {
					console.log(res, _this.$t('smartElectricity.smarElectricity.218347-528'))
					_this.$Message['success']({
						background: true,
						content: res.Message
					});
					_this.userListHide(true, 135)
				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				_this.GetBusinessMoneyMsg = true
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		//删除费用模板
		DeletebusinessMoney(item) {
			let _this = this;
			if (!Cookies.get('AdminData')) {
				return;
			}
			let AdminData = JSON.parse(Cookies.get('AdminData'));
			console.log(item, _this.$t('smartElectricity.smarElectricity.218347-529'))
			console.log(AdminData.Uid, _this.$t('smartElectricity.smarElectricity.218347-530'))


			_this.$Modal.confirm({
				title: _this.$t('smartElectricity.smarElectricity.218347-483'),
				content: '<p>是否删除？</p>',
				onOk: () => {
					api({
						//这里是你自己的请求方式、url和data参数
						method: 'get',
						url: `api/YhjAdmin/DelMerchantFeeTemplate/${item}?uid=${AdminData.Uid}`,
						//假设后台需要的是表单数据这里你就可以更改
						headers: {
							"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
							"Authorization": Cookies.get('Token')
						}
					}, 'yhj').then(function (res) {
						if (res.Success) {
							console.log(res, _this.$t('smartElectricity.smarElectricity.218347-532'))
							_this.$Message['success']({
								background: true,
								content: res.Message
							});
							_this.GetMerchantFeeTemplateList();
						} else {
							if (res.Code == -9) {
								if (window.location.host == 'xed.hxpwr.com') {
									this.$router.push({
										name: 'xed_login'
									})
								} else {
									this.$router.push({
										name: 'login'
									})
								}
							} else {
								_this.$Message['error']({
									background: true,
									content: res.Message
								});
							}
						}
					}).catch(function (err) {
						_this.GetBusinessMoneyMsg = true
						if (err.data.Code == -9 || err.data.Code == -1) {
							_this.$store.dispatch("setUserState", true);
							if (window.location.host == 'xed.hxpwr.com') {
								this.$router.push({
									name: 'xed_login'
								})
							} else {
								this.$router.push({
									name: 'login'
								})
							}
						}
					});
				},
				onCancel: () => {

				}
			});




		},
		/*=====================================================================================================*/

		/**
		 * ======================================用户接口模块==========================================
		 */
		// 加载用户列表
		LoaderUserList() {
			let _this = this;
			let data = {
				pageIndex: _this.UserPageIndex,
				pageSize: _this.UserPageSize,
			}
			_this.LoaderUserListsMsg = false;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: 'api/User/GetSysUserList',
				data: data,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				_this.LoaderUserListsMsg = true;
				if (res.Success) {
					_this.UserTotalCount = res.TotalCount;
					_this.LoaderUserLists = res.Data;
				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				_this.LoaderUserListsMsg = true;
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 删除用户
		DeleteUser(Id) {
			let _this = this;
			_this.$Modal.confirm({
				title: _this.$t('smartElectricity.smarElectricity.218347-483'),
				content: '<p>是否删除此用户？</p>',
				onOk: () => {
					let data = {
						Id: Id
					}
					api({
						//这里是你自己的请求方式、url和data参数
						method: 'post',
						url: `api/User/DeleteSysUser`,
						data: data,
						//假设后台需要的是表单数据这里你就可以更改
						headers: {
							"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
							"Authorization": Cookies.get('Token')
						}
					}).then(function (res) {
						if (res.Success) {
							_this.$Message['success']({
								background: true,
								content: res.Message
							});
							_this.LoaderUserList();
						} else {
							_this.$Message['error']({
								background: true,
								content: res.Message
							});
						}
					}).catch(function (err) {
						if (err.data.Code == -9 || err.data.Code == -1) {
							if (window.location.host == 'xed.hxpwr.com') {
								this.$router.push({
									name: 'xed_login'
								})
							} else {
								this.$router.push({
									name: 'login'
								})
							}
						}
					});
				},
				onCancel: () => {

				}
			});
		},
		// 集团（不分页）
		GroupCodeList() {
			let _this = this;
			let data = {
				pageIndex: 1,
				pageSize: 100,
			}
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: 'api/User/GetSysGroupList',
				data: data,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					_this.GroupCodeLists = res.Data;
				}
			})
		},
		// 公司（不分页）
		CompanyCodeList() {
			let _this = this;
			let data = {
				pageIndex: 1,
				pageSize: 100,
			}
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: 'api/User/GetCompanylist',
				data: data,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					_this.CompanyCodeLists = res.Data;
				}
			})
		},
		// 部门（不分页）
		DepartmentCodeList() {
			let _this = this;

			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/User/GetDepartlist?pageIndex=${1}&pageSize=${100}`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					_this.DepartmentCodeLists = res.Data;
				}
			})
		},
		// 根据集团编号查询公司
		changeGroupCode(value, type = false) {
			let _this = this;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/User/GetCompanyListnew?GroupCode=${value}`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				_this.CompanyCodes = [];

				if (res.Success) {
					if (!type) {
						_this.formUser.CompanyCode = '';
						_this.formUser.DepartmentCode = '';
						_this.DepartmentCodes = [];
					}
					_this.CompanyCodeLists = res.Data;
					_this.CompanyCodes = res.Data;
				}
			})
		},
		// 根据集团编号,公司编号获取部门
		changeCompanyCode(value, type = false) {
			let _this = this;
			if (!value) return;

			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/User/GetDeptListnew?GroupCode=${_this.formUser.GroupCode}&CompanyCode=${value}`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				_this.DepartmentCodes = [];
				if (res.Success) {
					if (!type) {
						_this.formUser.DepartmentCode = '';
					}
					_this.DepartmentCodes = res.Data;
				}
			})
		},
		// 添加用户提交
		submit6() {
			let _this = this;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: 'api/User/AddSysUser',
				data: _this.formUser,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					_this.$Message['success']({
						background: true,
						content: res.Message
					});
					// _this.GetCompanylist();
					_this.userListHide(true, _this.userListHideMsg - 4)
				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 清除提交数据
		cancel6() {
			let _this = this;
			_this.formUser = {};
		},
		submit10() {
			let _this = this;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: 'api/User/EditSysUser',
				data: _this.formUser,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					_this.$Message['success']({
						background: true,
						content: res.Message
					});
					// _this.GetCompanylist();
					_this.formUser = {};
					_this.userListHide(true, _this.userListHideMsg - 8)
				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		userChange(e) {
			let _this = this;
			_this.UserPageIndex = e;
			_this.LoaderUserList()
		},
		userSizeChange(e) {
			let _this = this;
			_this.UserPageIndex = 1;
			_this.UserPageSize = e;
			_this.LoaderUserList()
		},
		/*============================================================================================*/


		/**
		 * =======================================部门事件以及请求============================================
		 */
		// 加载部门列表
		GetDepartlist() {
			let _this = this;
			_this.GetDepartlistsMsg = false;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/User/GetDepartlist?pageIndex=${_this.DepartPageIndex}&pageSize=${_this.DepartPageSize}`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				_this.GetDepartlistsMsg = true;
				if (res.Success) {
					_this.GetDepartlists = res.Data;
					_this.DepartTotalCount = res.TotalCount;
				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				_this.GetDepartlistsMsg = true;
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 添加提交
		submit7() {
			let _this = this;

			if (!_this.formDepart.DepartmentCode) {
				_this.$Message['error']({
					background: true,
					content: _this.$t('smartElectricity.smarElectricity.218347-533')
				});
				return;
			}
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: `api/User/AddDepartment`,
				data: _this.formDepart,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					_this.$Message['success']({
						background: true,
						content: res.Message
					});
					// _this.GetCompanylist();
					_this.userListHide(true, _this.userListHideMsg - 4)
				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 清除数据
		cancel7() {
			let _this = this;
			_this.formDepart = {};
		},
		// 修改部门
		submit11() {
			let _this = this;

			if (!_this.formDepart.DepartmentCode) {
				_this.$Message['error']({
					background: true,
					content: _this.$t('smartElectricity.smarElectricity.218347-533')
				});
				return;
			}
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: `api/User/EditDepartment`,
				data: _this.formDepart,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					_this.$Message['success']({
						background: true,
						content: res.Message
					});
					// _this.GetCompanylist();
					_this.userListHide(true, _this.userListHideMsg - 8)
				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 编辑，新增获取部门信息
		GetViOrBtnOrUserData(item) {
			let _this = this;

			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/User/GetViOrBtnOrUserData?departmentCode=${item.DepartmentCode}&groupCode=${item.GroupCode}&companyCode=${item.CompanyCode}`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {

					_this.GetViOrBtnOrUserDatas = res.Data;

				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 编辑城市权限信息
		GetViOrBtnOrUserData_New(item) {
			let _this = this;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/User/GetViOrBtnOrUserData_New?departmentCode=${item.DepartmentCode}&groupCode=${item.GroupCode}&companyCode=${item.CompanyCode}`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {

					_this.Communitylists = [...res.Data.Communitylist];
					_this.CommunityDatas = [];

					_this.CommunityDatas = res.Data.Communitylist.map(item => {
						return {
							...item,
							title: item.CommunityName,
							expand: true,
							children: (item.VillageList || []).map(list => {
								return {
									...list,
									title: list.Vname,
									checked: list.SVillageList && list.SVillageList.length ? false : list.Isopen,
									expand: true,
									children: (list.SVillageList || []).map(list2 => {
										return {
											...list2,
											title: list2.Sname,
											checked: list2.ZVillageList && list2.ZVillageList.length ? false : list2.Isopen,
											expand: true,
											children: (list2.ZVillageList || []).map(list3 => {
												return {
													...list3,
													title: list3.Zname,
													checked: list3.Isopen
												}
											})
										}
									})
								}
							})
						}
					})

				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 分配区域
		FenPeiVillage() {
			let _this = this;

			// console.log(_this.CommunityDatas);

			// _this.CommunityDatas.forEach((item, index) => {
			// 	let Villages = _this.Communitylists[index];
			// 	Villages.Isopen = item.checked ? item.checked : (item.indeterminate ? item.indeterminate :
			// 		false)
			// 	item.children.forEach((msg, count) => {
			// 		Villages.VillageList[count].Isopen = msg.checked;
			// 	})
			// 	_this.Communitylists[index] = Villages;
			// })

			let VillCode = [],
				CommunityCode = [],
				SVillCode = [],
				ZVillCode = [];
			_this.CommunityDatas.forEach((item, index) => {
				if (item.checked || item.indeterminate) {
					CommunityCode.push(item.CommunityCode);
				}
				(item.children || []).forEach((msg, count) => {
					if (msg.checked || msg.indeterminate) {
						VillCode.push(msg.Vcode);
					}
					(msg.children || []).forEach((lisk, count) => {
						if (lisk.checked || lisk.indeterminate) {
							SVillCode.push(lisk.Scode);
						}
						(lisk.children || []).forEach((lisk1, count) => {
							if (lisk1.checked) {
								ZVillCode.push(lisk1.Zcode);
							}
						})
					})
				})
			})

			let data = {
				DepartmentCode: _this.DepartmentItem.DepartmentCode,
				GroupCode: _this.DepartmentItem.GroupCode,
				CompanyCode: _this.DepartmentItem.CompanyCode,
				CommunityCode,
				VillCode,
				SVillCode,
				ZVillCode
			}

			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: `api/User/FenPeiVillage`,
				data: data,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					_this.$Message['success']({
						background: true,
						content: res.Message
					});
					// _this.GetCompanylist();
					_this.userListHide(true, _this.userListHideMsg - 12)
				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 选中城市
		handleCheckCommunity(data) {
			let _this = this;
			// console.log(data);
		},
		// 分配权限
		QxFenPei() {
			let _this = this;
			let MenuCode = [],
				Btnlist = [];
			_this.GetViOrBtnOrUserDatas.menulist.forEach(item => {
				if (item.Isopen) {
					MenuCode.push(item.MenuCode)
				}
			})
			_this.GetViOrBtnOrUserDatas.btnlist.forEach(item => {
				if (item.Isopen) {
					Btnlist.push(item)
				}
			})
			let data = {
				DepartmentCode: _this.DepartmentItem.DepartmentCode,
				GroupCode: _this.DepartmentItem.GroupCode,
				CompanyCode: _this.DepartmentItem.CompanyCode,
				Btnlist: Btnlist,
				MenuCode: MenuCode
			}
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: `api/User/QxFenPei`,
				data: data,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					_this.$Message['success']({
						background: true,
						content: res.Message
					});
					// _this.GetCompanylist();
					_this.userListHide(true, _this.userListHideMsg - 16)
				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 删除部门
		DeleteDepartment(Id, departCode) {
			let _this = this;
			_this.$Modal.confirm({
				title: _this.$t('smartElectricity.smarElectricity.218347-483'),
				content: '<p>是否删除此部门？</p>',
				onOk: () => {
					api({
						//这里是你自己的请求方式、url和data参数
						method: 'get',
						url: `api/User/DeleteDepartment/${Id}?departCode=${departCode}`,
						data: {},
						//假设后台需要的是表单数据这里你就可以更改
						headers: {
							"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
							"Authorization": Cookies.get('Token')
						}
					}).then(function (res) {
						if (res.Success) {
							_this.$Message['success']({
								background: true,
								content: res.Message
							});
							_this.GetDepartlist();
						} else {
							_this.$Message['error']({
								background: true,
								content: res.Message
							});
						}
					}).catch(function (err) {
						if (err.data.Code == -9 || err.data.Code == -1) {
							if (window.location.host == 'xed.hxpwr.com') {
								this.$router.push({
									name: 'xed_login'
								})
							} else {
								this.$router.push({
									name: 'login'
								})
							}
						}
					});
				},
				onCancel: () => {

				}
			});
		},
		departChange(e) {
			let _this = this;
			_this.DepartPageIndex = e;
			_this.GetDepartlist()
		},
		departSizeChange(e) {
			let _this = this;
			_this.DepartPageIndex = 1;
			_this.DepartPageSize = e;
			_this.GetDepartlist()
		},
		/**
		 * =======================================公司事件以及请求============================================
		 */
		// 加载公司列表
		GetCompanylist() {
			let _this = this;
			_this.GetCompanylistsMsg = false
			let data = {
				pageIndex: _this.CompanyPageIndex,
				pageSize: _this.CompanyPageSize,
			}
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: 'api/User/GetCompanylist',
				data: data,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				_this.GetCompanylistsMsg = true
				if (res.Success) {
					_this.GetCompanylists = res.Data;
					_this.CompanyTotalCount = res.TotalCount;
				} else {
					if (res.Code == -9) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}
			}).catch(function (err) {
				_this.GetCompanylistsMsg = true
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 添加提交
		submit8() {
			let _this = this;
			if (!_this.formCompany1.CompanyCode) {
				_this.$Message['error']({
					background: true,
					content: _this.$t('smartElectricity.smarElectricity.218347-535')
				});
				return;
			}
			if (this.uploadList.length > 0) {
				let ImageUrl = '/' + this.uploadList[0].split('/').slice(3).join('/');
				_this.formCompany1.ImageUrl = ImageUrl;
			}
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: `api/User/AddCompany`,
				data: _this.formCompany1,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					_this.$Message['success']({
						background: true,
						content: res.Message
					});
					_this.uploadList = [];
					// _this.GetCompanylist();
					_this.userListHide(true, _this.userListHideMsg - 4)
				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 添加集团取消数据
		cancel8() {
			let _this = this;
			_this.formCompany1 = {};
			_this.uploadList = [];
		},
		// 删除公司
		DeleteCompany(Id) {
			let _this = this;
			_this.$Modal.confirm({
				title: _this.$t('smartElectricity.smarElectricity.218347-483'),
				content: '<p>是否删除此公司？</p>',
				onOk: () => {
					api({
						//这里是你自己的请求方式、url和data参数
						method: 'get',
						url: `api/User/DeleteCompany/${Id}`,
						data: {},
						//假设后台需要的是表单数据这里你就可以更改
						headers: {
							"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
							"Authorization": Cookies.get('Token')
						}
					}).then(function (res) {
						if (res.Success) {
							_this.$Message['success']({
								background: true,
								content: res.Message
							});
							_this.GetCompanylist();
						} else {
							_this.$Message['error']({
								background: true,
								content: res.Message
							});
						}
					}).catch(function (err) {
						if (err.data.Code == -9 || err.data.Code == -1) {
							if (window.location.host == 'xed.hxpwr.com') {
								this.$router.push({
									name: 'xed_login'
								})
							} else {
								this.$router.push({
									name: 'login'
								})
							}
						}
					});
				},
				onCancel: () => {

				}
			});
		},
		// 编辑公司
		submit12() {
			let _this = this;
			if (!_this.formCompany.CompanyCode) {
				_this.$Message['error']({
					background: true,
					content: _this.$t('smartElectricity.smarElectricity.218347-535')
				});
				return;
			}
			if (this.uploadList.length > 0) {
				let ImageUrl = '/' + this.uploadList[0].split('/').slice(3).join('/');
				_this.formCompany.ImageUrl = ImageUrl;
			} else {
				_this.formCompany.ImageUrl = '';
			}
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: `api/User/EditCompany`,
				data: _this.formCompany,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					_this.$Message['success']({
						background: true,
						content: res.Message
					});
					_this.formCompany = {};
					_this.userListHide(true, _this.userListHideMsg - 8)
				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		companyChange(e) {
			let _this = this;
			_this.CompanyPageIndex = e;
			_this.GetCompanylist()
		},
		companySizeChange(e) {
			let _this = this;
			_this.CompanyPageIndex = 1;
			_this.CompanyPageSize = e;
			_this.GetCompanylist()
		},
		/*==================================================================================================*/

		/**
		 * =======================================集团事件以及请求============================================
		 * */
		// 加载集团列表
		GetSysGroupList() {
			let _this = this;
			_this.GetSysGroupListsMsg = false
			let data = {
				pageIndex: _this.GroupPageIndex,
				pageSize: _this.GroupPageSize,
			}
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: 'api/User/GetSysGroupList',
				data: data,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				_this.GetSysGroupListsMsg = true
				if (res.Success) {
					_this.GetSysGroupLists = res.Data;
					_this.GroupTotalCount = res.TotalCount;
				} else {
					if (res.Code == -9 || err.data.Code == -1) {
						if (window.location.host == 'xed.hxpwr.com') {
							this.$router.push({
								name: 'xed_login'
							})
						} else {
							this.$router.push({
								name: 'login'
							})
						}
					}
				}
			}).catch(function (err) {
				_this.GetSysGroupListsMsg = true
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 添加集团取消数据
		cancel9(data) {
			let _this = this;
			_this.formGroup = {};
		},
		// 添加集团提交
		submit9() {
			let _this = this;
			if (!_this.formGroup.GroupCode) {
				_this.$Message['error']({
					background: true,
					content: _this.$t('smartElectricity.smarElectricity.218347-537')
				});
				return;
			}
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: `api/User/AddSysGroup`,
				data: _this.formGroup,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					_this.$Message['success']({
						background: true,
						content: res.Message
					});
					// _this.GetSysGroupList();
					_this.userListHide(true, _this.userListHideMsg - 4)
				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 编辑集团
		submit13() {
			let _this = this;
			if (!_this.formGroup.GroupCode) {
				_this.$Message['error']({
					background: true,
					content: _this.$t('smartElectricity.smarElectricity.218347-537')
				});
				return;
			}
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: `api/User/EditSysGroup`,
				data: _this.formGroup,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}).then(function (res) {
				if (res.Success) {
					_this.$Message['success']({
						background: true,
						content: res.Message
					});
					// _this.GetSysGroupList();
					_this.formGroup = {};
					_this.userListHide(true, _this.userListHideMsg - 8)
				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {
				if (err.data.Code == -9 || err.data.Code == -1) {
					_this.$store.dispatch("setUserState", true);
					if (window.location.host == 'xed.hxpwr.com') {
						this.$router.push({
							name: 'xed_login'
						})
					} else {
						this.$router.push({
							name: 'login'
						})
					}
				}
			});
		},
		// 删除集团
		DeleteGroup(Id) {
			let _this = this;
			_this.$Modal.confirm({
				title: _this.$t('smartElectricity.smarElectricity.218347-483'),
				content: '<p>是否删除此集团？</p>',
				onOk: () => {
					api({
						//这里是你自己的请求方式、url和data参数
						method: 'post',
						url: `api/User/DeleteGroup/${Id}`,
						data: {},
						//假设后台需要的是表单数据这里你就可以更改
						headers: {
							"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
							"Authorization": Cookies.get('Token')
						}
					}).then(function (res) {
						if (res.Success) {
							_this.$Message['success']({
								background: true,
								content: res.Message
							});
							_this.GetSysGroupList();
						} else {
							_this.$Message['error']({
								background: true,
								content: res.Message
							});
						}
					}).catch(function (err) {
						if (err.data.Code == -9 || err.data.Code == -1) {
							if (window.location.host == 'xed.hxpwr.com') {
								this.$router.push({
									name: 'xed_login'
								})
							} else {
								this.$router.push({
									name: 'login'
								})
							}
						}
					});
				},
				onCancel: () => {

				}
			});
		},
		groupChange(e) {
			let _this = this;
			_this.GroupPageIndex = e;
			_this.GetSysGroupList()
		},
		groupSizeChange(e) {
			let _this = this;
			_this.GroupPageIndex = 1;
			_this.GroupPageSize = e;
			_this.GetSysGroupList()
		},
		/*=====================================================================================================*/

		/**
		 * =======================================财务事件以及请求============================================
		 * */
		// 结算申请列表
		getSettlementsHide() {
			let _this = this;
			_this.userListHide(true, 115);
			_this.GetUserSettlements();
		},
		// 切换财务状态 0 待结算，1已结算，-1结算取消
		getSettlements(state) {
			let _this = this;
			if (_this.stateIndex == state) return;
			_this.stateIndex = state;
			_this.settlementPageIndex = 1;
			_this.GetUserSettlements();
		},
		// 获取房东的结算申请列表
		GetUserSettlements() {
			let _this = this;
			const { GroupCode, DepartmentCode, CompanyCode } = JSON.parse(
				Cookies.get("AdminData")
			);
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/CommElecDevice/GetUserSettlements?groupCode=${GroupCode}&companyCode=${CompanyCode}&departmentCode=${DepartmentCode}&pageIndex=${_this.settlementPageIndex}&pageSize=${_this.settlementPageSize}&state=${_this.stateIndex}`,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				if (res.Success) {

					_this.settlementLists = res.Data;
					_this.settlementTotalCount = res.TotalCount;

				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {

			});
		},
		settlementIndexChange(e) {
			let _this = this;
			_this.settlementPageIndex = e;
			_this.GetUserSettlements();
		},
		settlementSizeChange(e) {
			let _this = this;
			_this.settlementPageIndex = 1;
			_this.settlementPageSize = e;
			_this.GetUserSettlements();
		},

		// 设置平台结算费率
		submit116() {
			let _this = this;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: `api/CommElecDevice/SetPlatformFeePercent`,
				data: {
					platformFeePercent: _this.platformFeePercent / 100
				},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				if (res.Success) {
					_this.$Message['success']({
						background: true,
						content: res.Message
					});
					_this.userListHide(false);
				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {

			});

		},
		// 设置费率展开
		getPlatformFeePercentHide() {
			let _this = this;
			_this.userListHide(true, 116);
			_this.GetPlatformFeePercent();
		},
		// 获取平台结算费率
		GetPlatformFeePercent() {
			let _this = this;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/CommElecDevice/GetPlatformFeePercent`,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				if (res.Success) {
					_this.platformFeePercent = res.Data.PlatformFeePercent * 100;
				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {

			});
		},
		// 结算展开
		dealOneSettlementHand(item) {
			let _this = this;
			_this.calSettlementAmount = item.SettlementAmount;
			_this.finAccountId = '';
			_this.settlementOrderCode = item.SettlementOrderCode;
			_this.GetPlatformFeePercent();
			_this.GetUserFinAccountList(item.UserId);
			_this.userListHide(true, _this.userListHideMsg - 16);
		},
		// 获取房东的财务卡号列表（用于财务向其打款）
		GetUserFinAccountList(uid) {
			let _this = this;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/CommElecDevice/GetUserFinAccountList?uid=${uid}`,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				if (res.Success) {
					_this.FinAccountLists = res.Data;
				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {

			});
		},
		// 结算申请列表 取消
		DealCancelSettlement(item) {
			let _this = this;
			_this.$Modal.confirm({
				title: _this.$t('smartElectricity.smarElectricity.218347-483'),
				render: (h) => {
					return h('Input', {
						props: {
							value: this.inputRemark,
							autofocus: true,
							placeholder: _this.$t('smartElectricity.smarElectricity.218347-199')
						},
						on: {
							input: (val) => {
								this.inputRemark = val;
							}
						}
					})
				},
				content: `<p>是否取消编号为“${item.SettlementOrderCode}”的结算</p>`,
				onOk: () => {
					api({
						//这里是你自己的请求方式、url和data参数
						method: 'post',
						url: 'api/CommElecDevice/DealCancelSettlement',
						data: {
							settlementOrderCode: item.SettlementOrderCode,
							remark: this.inputRemark
						},
						//假设后台需要的是表单数据这里你就可以更改
						headers: {
							"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
							"Authorization": Cookies.get('Token')
						}
					}, 2).then(function (res) {
						if (res.Success) {
							_this.unfoldMsg = true;
							_this.GetUserSettlements();
						} else {
							_this.$Message['error']({
								background: true,
								content: res.Message
							});
						}
					}).catch(function (err) {

					});
				},
				onCancel: () => {

				}
			});
		},
		// 处理结算
		submit99() {
			let _this = this;
			let data = {
				finAccountId: _this.finAccountId,
				settlementOrderCode: _this.settlementOrderCode,
				platformFeePercent: _this.platformFeePercent / 100,
				remark: _this.remark,
			}
			if (!data.platformFeePercent) {
				_this.$Message['error']({
					background: true,
					content: _this.$t('smartElectricity.smarElectricity.218347-541')
				});
				return;
			}
			if (!data.finAccountId) {
				_this.$Message['error']({
					background: true,
					content: _this.$t('smartElectricity.smarElectricity.218347-542')
				});
				return;
			}
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: `api/CommElecDevice/DealOneSettlement`,
				data,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				if (res.Success) {
					_this.$Message['success']({
						background: true,
						content: res.Message
					});
					_this.GetUserSettlements();
					_this.userListHide(true, _this.userListHideMsg + 16);
				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {

			});
		},
		// 展开订单列表
		getUserSettlementOrderBillsHide(item) {
			let _this = this;
			this.remark = '';
			_this.settlementOrderCode = item.SettlementOrderCode;
			_this.userListHide(true, _this.userListHideMsg + 16);
			// 根据结算单号获取对应的订单列表
			_this.GetUserSettlement_OrderBills();
		},
		// 根据结算单号获取对应的订单列表
		GetUserSettlement_OrderBills() {
			let _this = this;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/CommElecDevice/GetUserSettlement_OrderBills?settlementOrderCode=${_this.settlementOrderCode}&pageIndex=${_this.OrderBillPageIndex}&pageSize=${_this.OrderBillPageSize}`,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				if (res.Success) {
					_this.DeviceOrderBillLists = res.Data;
					_this.OrderBillTotalCount = res.TotalCount;
				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {

			});
		},
		OrderBillIndexChange(e) {
			let _this = this;
			_this.OrderBillPageIndex = e;
			_this.GetUserSettlement_OrderBills();
		},
		OrderBillSizeChange(e) {
			let _this = this;
			_this.OrderBillPageIndex = 1;
			_this.OrderBillPageSize = e;
			_this.GetUserSettlement_OrderBills();
		},

		// 获取用户模块使用授权列表
		getAuthModuleCodeList() {
			let _this = this;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/YhjAdmin/GetAuthModuleCodeList?PageIndex=${_this.AuthModuleCodePageIndex}&PageSize=${_this.AuthModuleCodePageSize}`,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				if (res.Success) {
					_this.AuthModuleCodeLists = res.Data;
					_this.AuthModuleCodeTotalCount = res.TotalCount;
				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {

			});
		},
		// 获取模块
		getModuleList() {
			let _this = this;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/YhjAdmin/GetModuleList`,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				if (res.Success) {

					_this.ModuleItemList = res.Data[0].Modules;
					_this.ModuleIndex = res.Data[0].ModuleType;

					res.Data.unshift({
						ModuleType: 99,
						ModuleTypeName: _this.$t('smartElectricity.smarElectricity.218347-543')
					})
					_this.ModuleLists = res.Data;

					if (_this.AuthModelState == 2) {
						// 根据授权的模块值反解析模块权限列表
						let value = _this.ModuleSelectedLists.length > 0 ? _this.ModuleSelectedLists.join(
							'|') : _this.AuthModelValue;
						_this.ReverseAuthModule(value);
					}

				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {

			});
		},
		// 选择模块
		selectModule() {
			let _this = this;
			_this.getModuleList(); // 获取模块
			_this.userListHide(true, _this.userListHideMsg + 16);
		},
		// 展开模块
		UnfoldModule(item) {
			let _this = this;
			if (item.ModuleType != 99) {
				_this.ModuleItemList = item.Modules;
				_this.ModuleIndex = item.ModuleType;
			}
		},
		// 单个全选
		ModuleItemAll(list, type) {
			let _this = this;
			if (type == 99) {
				if (_this.ModuleSelectedHeadLists.indexOf(type) < 0) {
					_this.ModuleSelectedHeadLists.push(type);
				} else {
					_this.ModuleSelectedHeadLists.splice(_this.ModuleSelectedHeadLists.indexOf(type), 1);
				}
				return;
			}
			let ModuleSelectedLists = _this.ModuleSelectedLists;
			if (_this.ModuleSelectedHeadLists.indexOf(type) < 0) {
				list.forEach(item => {
					ModuleSelectedLists.push(item.ModuleValue);
				})
				_this.ModuleSelectedLists = Array.from(new Set(ModuleSelectedLists));
				_this.ModuleSelectedHeadLists.push(type);
			} else {
				_this.ModuleSelectedHeadLists.splice(_this.ModuleSelectedHeadLists.indexOf(type), 1);
				list.forEach(item => {
					if (ModuleSelectedLists.indexOf(item.ModuleValue) >= 0) {
						ModuleSelectedLists.splice(ModuleSelectedLists.indexOf(item.ModuleValue), 1);
					}
				})
				_this.ModuleSelectedLists = ModuleSelectedLists;
			}
		},
		// 单个选中
		ModuleItemClick(item) {
			let _this = this;
			let ModuleLists = _this.ModuleLists;
			let ModuleSelectedLists = _this.ModuleSelectedLists;
			if (ModuleSelectedLists.indexOf(item.ModuleValue) < 0) {
				ModuleSelectedLists.push(item.ModuleValue)
			} else {
				ModuleSelectedLists.splice(ModuleSelectedLists.indexOf(item.ModuleValue), 1);
			}
			_this.ModuleSelectedLists = ModuleSelectedLists;

			let data = ModuleLists.find(list => {
				return list.ModuleType === item.ModuleType;
			})
			let Modules = data.Modules.map(list => list.ModuleValue);

			if (_this.includes(ModuleSelectedLists, Modules)) {
				_this.ModuleSelectedHeadLists.push(data.ModuleType);
			} else {
				if (_this.ModuleSelectedHeadLists.indexOf(data.ModuleType) > -1) {
					_this.ModuleSelectedHeadLists.splice(_this.ModuleSelectedHeadLists.indexOf(data.ModuleType), 1);
				}
			}

		},

		includes(arr1, arr2) {
			return arr2.every(val => arr1.includes(val));
		},

		// 保存选择的模块
		saveModule() {
			let _this = this;
			_this.userListHide(true, _this.userListHideMsg - 16);
			if (_this.ModuleSelectedHeadLists.indexOf(99) >= 0) {
				_this.AuthModelValue = 99;
				_this.AuthModelTitle = _this.$t('smartElectricity.smarElectricity.218347-481');
				return;
			}
			_this.AuthModelValue = 0;
			_this.AuthModelLists = _this.ModuleSelectedLists;
			_this.AuthModelTitle = _this.$t('smartElectricity.smarElectricity.218347-482', [_this.ModuleSelectedLists.length]);
		},

		// 为逸慧家用户添加/修改模块使用授权
		setAuthModuleCode() {
			let _this = this;

			if (_this.AuthModelValue == 99) {
				_this.AuthModel.AuthModuleValues = 99;
			} else {
				_this.AuthModel.AuthModuleValues = _this.AuthModelLists.join('|');
			}

			let ValidDateTimeStart = _this.formDate(_this.AuthModel.ValidDateTimeStart).split(' ');
			let ValidDateTimeEnd = _this.formDate(_this.AuthModel.ValidDateTimeEnd).split(' ');

			_this.AuthModel.ValidDateTimeStart = ValidDateTimeStart[0];
			_this.AuthModel.ValidDateTimeEnd = ValidDateTimeEnd[0];
			_this.AuthModel.AdminLoginCode = Cookies.get('UserLogin');

			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: `api/YhjAdmin/AuthModuleCode`,
				data: _this.AuthModel,
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				if (res.Success) {
					_this.$Message['success']({
						background: true,
						content: res.Message
					});
					_this.AuthModel = {};
					_this.AuthModuleCodePageIndex = 1;
					_this.AuthModuleCodePageSize = 10;
					_this.userListHide(true, _this.userListHideMsg - 16);
				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {

			});
		},
		// 根据授权的模块值反解析模块权限列表
		ReverseAuthModule(value) {
			let _this = this;
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: `api/YhjAdmin/ReverseAuthModule`,
				data: {
					AuthModuleValues: value
				},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				if (res.Success) {
					let ModuleLists = _this.ModuleLists,
						ModuleSelectedHeadLists = [];
					if (res.Data) {
						res.Data.forEach((item, index) => {
							let ModuleItem = ModuleLists.find(msg => {
								return msg.ModuleType === item.ModuleType;
							});
							if (ModuleItem.Modules.length == item.Modules.length) {
								ModuleSelectedHeadLists.push(item.ModuleType);
							}
						})
					} else {
						ModuleSelectedHeadLists.push(99);
					};
					_this.ModuleSelectedHeadLists = ModuleSelectedHeadLists;

				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) {

			});
		},
		// 删除一个用户模块使用授权
		DelOneAuthModuleCode(Id) {
			let _this = this;
			_this.$Modal.confirm({
				title: _this.$t('smartElectricity.smarElectricity.218347-483'),
				content: '<p>是否删除此用户授权？</p>',
				onOk: () => {
					api({
						//这里是你自己的请求方式、url和data参数
						method: 'get',
						url: `api/YhjAdmin/DelOneAuthModuleCode/${Id}`,
						//假设后台需要的是表单数据这里你就可以更改
						headers: {
							"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
							"Authorization": Cookies.get('Token')
						}
					}, 'yhj').then(function (res) {
						if (res.Success) {
							_this.$Message['success']({
								background: true,
								content: res.Message
							});
							_this.getAuthModuleCodeList();
						} else {
							_this.$Message['error']({
								background: true,
								content: res.Message
							});
						}
					}).catch(function (err) {
						if (err.data.Code == -9 || err.data.Code == -1) {
							if (window.location.host == 'xed.hxpwr.com') {
								this.$router.push({
									name: 'xed_login'
								})
							} else {
								if (window.location.host == 'xed.hxpwr.com') {
									this.$router.push({
										name: 'xed_login'
									})
								} else {
									this.$router.push({
										name: 'login'
									})
								}
							}
						}
					});
				},
				onCancel: () => {

				}
			});
		},
		AuthModuleCodeIndexChange(e) {
			let _this = this;
			_this.AuthModuleCodePageIndex = e;
			_this.getAuthModuleCodeList();
		},
		AuthModuleCodeSizeChange(e) {
			let _this = this;
			_this.AuthModuleCodePageIndex = 1;
			_this.AuthModuleCodePageSize = e;
			_this.getAuthModuleCodeList();
		},
		/*=====================================================================================================*/



		mapParameters(item, type) {
			let _this = this;
			// let point = 
			_this.map.centerAndZoom(new BMap.Point(item.Jd, item.Wd), 20);
			_this.map.clearOverlays(); //清除地图覆盖物
			var myIcon = new BMap.Icon(require("../../assets/electricity/greenmaker1.png"), new BMap.Size(100, 100));
			var marker2 = new BMap.Marker(point, {
				icon: myIcon
			}); // 创建标注
			_this.map.addOverlay(marker2);

			var opts = {
				position: point, // 指定文本标注所在的地理位置
				offset: new BMap.Size(30, -30) //设置文本偏移量
			}
			if (type == 'msg') {
				var label = new BMap.Label(item.Vname, opts); // 创建文本标注对象
			} else if (type == 'list') {
				var label = new BMap.Label(item.Sname, opts); // 创建文本标注对象
			} else if (type === 'lisk') {
				var label = new BMap.Label(item.Zname, opts); // 创建文本标注对象
			}

			label.setStyle({
				color: "#ffffff",
				fontSize: "0.6vw",
				height: "1.5vw",
				padding: "0 0.5vw",
				marginTop: "-1.25vw",
				borderRadius: "0.25vw",
				border: "0.05vw solid rgba(15,72,151,0.7)",
				backgroundColor: "rgba(15,72,151,0.7)",
				marginLeft: "-2vw",
				lineHeight: "1.35vw",
				fontFamily: _this.$t('smartElectricity.smarElectricity.218347-545')
			});
			_this.map.addOverlay(label);
		},

		// 地图
		mapData() {
			let _this = this;
			// 百度地图API功能
			_this.map = new BMap.Map("allmap", {
				mapType: BMAP_HYBRID_MAP
			}); // 创建Map实例
			// var cityName = _this.cityName;
			// _this.map.centerAndZoom(cityName, 12); // 初始化地图,设置中心点坐标和地图级别。    map.addControl(new BMap.ScaleControl());                    // 添加比例尺控件
			// map.addControl(new BMap.OverviewMapControl());              //添加缩略地图控件
			//添加地图类型控件
			_this.map.addControl(new BMap.MapTypeControl({
				offset: new BMap.Size(20, 157),
				mapTypes: [
					BMAP_NORMAL_MAP,
					BMAP_HYBRID_MAP
				]
			}));
			_this.map.centerAndZoom(new BMap.Point(120.58, 28.08), 8);
			_this.map.enableScrollWheelZoom();
			_this.map.disableDoubleClickZoom();
		},

		// 获取区域列表展示地图信息
		initMapData() {
			console.log('0f')
			let _this = this;
			var mapPoints = _this.MapVillagelists;
			var i = 0;
			var changeIcon1 = new BMap.Icon(require("../../assets/electricity/greenmaker1.png"), new BMap.Size(100,
				100));
			var changeIcon2 = new BMap.Icon(require("../../assets/electricity/greenmaker1.png"), new BMap.Size(100,
				100));
			var changeIcon3 = new BMap.Icon(require("../../assets/electricity/greenmaker1.png"), new BMap.Size(100,
				100));
			_this.map.clearOverlays(); //清除地图覆盖物

			for (let i = 0; i < mapPoints.length; i++) {
				var points = new BMap.Point(mapPoints[i].Longitude, mapPoints[i].Latitude); //创建坐标点
				var opts = {
					width: 400,
					height: 200,
					title: mapPoints[i].UserDeviceName
				};
				var label = new BMap.Label(mapPoints[i].UserDeviceName, {
					offset: new BMap.Size(25, 5)
				});

				label.setStyle({
					color: "#ffffff",
					fontSize: "0.6vw",
					height: "1.5vw",
					padding: "0 0.5vw",
					marginTop: "-0.5vw",
					borderRadius: "0.25vw",
					border: "0.05vw solid rgba(15,72,151,0.7)",
					backgroundColor: "rgba(15,72,151,0.7)",
					marginLeft: "0.5vw",
					lineHeight: "1.35vw",
					fontFamily: _this.$t('smartElectricity.smarElectricity.218347-545')
				});


				_this.markerFun(points, label, null, changeIcon1, mapPoints[i]);
			}

			// var cityName = _this.cityName;
			// var bdary = new BMap.Boundary();
			// bdary.get(cityName, function(rs) { //获取行政区域

			// 	//for循环都删除掉了，只剩下这个
			// 	//网上查了下，东西经南北纬的范围
			// 	var EN_JW = "180, 90;"; //东北角
			// 	var NW_JW = "-180,  90;"; //西北角
			// 	var WS_JW = "-180, -90;"; //西南角
			// 	var SE_JW = "180, -90;"; //东南角

			// 	//4.添加环形遮罩层
			// 	var ply1 = new BMap.Polygon(rs.boundaries[0] + SE_JW + SE_JW + WS_JW + NW_JW + EN_JW + SE_JW, {
			// 		strokeColor: "none",
			// 		fillColor: "rgba(0,0,0,0.6)",
			// 		fillOpacity: 1,
			// 		strokeOpacity: 0.5
			// 	}); //建立多边形覆盖物
			// 	_this.map.addOverlay(ply1);
			// 	//5. 给目标行政区划添加边框，其实就是给目标行政区划添加一个没有填充物的遮罩层
			// 	var ply = new BMap.Polygon(rs.boundaries[0], {
			// 		strokeWeight: 2,
			// 		strokeColor: "rgba(0,0,0,0.5)",
			// 		fillColor: ""
			// 	});
			// 	_this.map.addOverlay(ply);
			// 	_this.map.setViewport(ply.getPath()); //调整视野


			// });


		},

		markerFun(points, label, infoWindows, ico, data) {
			let _this = this;
			var markers = new BMap.Marker(points, {
				icon: ico
			});

			_this.map.addOverlay(markers);
			markers.setLabel(label);
			markers.addEventListener('click', function () {
				_this.deviceDetails(data);
			})
		},

		// 点击设备图标
		deviceDetails(item) {
			let _this = this,
				AdminData = JSON.parse(Cookies.get('AdminData'));
			api({
				//这里是你自己的请求方式、url和data参数
				method: 'get',
				url: `api/YhjStatic/GetDeviceVCR?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&deviceCode=${item.DeviceCode}`,
				data: {},
				//假设后台需要的是表单数据这里你就可以更改
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
					"Authorization": Cookies.get('Token')
				}
			}, 'yhj').then(function (res) {
				if (res.Success) {
					_this.cmmModel = res.Data.cmmModel;
					_this.villModel = res.Data.villModel;
					_this.roomModel = res.Data.roomModel;
					_this.elecFixModel = res.Data.elecFixModel;
					_this.markerDeviceCode = item.DeviceCode;
				} else {
					_this.$Message['error']({
						background: true,
						content: res.Message
					});
				}
			}).catch(function (err) { });
			_this.doubleState = true;
		},

		formatNumber(n) {
			n = n.toString()
			return n[1] ? n : '0' + n
		},

		goBack() {
			if (this.$route.query.flag) {
				console.log(this.$route.query.flag, 88);
				this.$router.push({
					name: 'homebak1'
				})
			} else {
				console.log(111);
				this.$router.push({
					name: 'home'
				});
			}
		},

		handleView(name) {
			this.imgName = name;
			this.visible = true;
		},
		handleRemove(file) {
			this.uploadList = [];
		},
		handleSuccess(res, file) {
			this.uploadList.push(res.Data);
		},
		handleFormatError(file) {
			this.$Notice.warning({
				title: _this.$t('smartElectricity.smarElectricity.218347-546'),
				desc: _this.$t('smartElectricity.smarElectricity.218347-547')
			});
		},
		handleMaxSize(file) {
			this.$Notice.warning({
				title: _this.$t('smartElectricity.smarElectricity.218347-483'),
				desc: _this.$t('smartElectricity.smarElectricity.218347-548')
			});
		},
		handleBeforeUpload() {
			const check = this.uploadList.length < 1;
			if (!check) {
				this.$Notice.warning({
					title: 'You can upload at most one photo.'
				});
			}
			return check;
		},


	},

	beforeDestroy() {
		if (this.timer) {
			clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
		}
	},
}
</script>

<style scoped="scoped" lang="scss">
@import url("./index.css");
@import "./smart_electricity_default.scss";
@import "./smart_electricity.scss";

.outline-view1 {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 1000;
	background-color: rgba(12, 63, 136, 0.7);
}

.outline-top1 {
	position: absolute;
	top: 6.5vw;
	left: 4%;
	right: 4%;
	height: calc(80% - 0.25vw);
	-webkit-transition: 0.7s;
	transition: 0.7s;
	background-size: 100% 100%;
	z-index: 1000;
	overflow: hidden;

	transform: scale(0);
	animation-name: outlineTop;
	animation-duration: 0.4s;
	animation-timing-function: linear;
	animation-fill-mode: forwards;
}

.outline-remove {
	position: absolute;
	right: 1vw;
	top: 1.5vw;
	width: 1.5vw;
	height: 1.5vw;
	cursor: pointer;
	overflow: hidden;
}

.outline-remove>img {
	width: 0.5vw;
	height: 0.5vw;
	margin: 0.5vw;
}

.outline-mode {
	position: absolute;
	top: 3vw;
	right: 1vw;
	left: 1vw;
	bottom: 1vw;
}

.add-community-view-input-div-lists {
	/* width: 100%; */
	overflow-y: scroll;
	height: calc(100% - 0.75vw);
	padding-left: 1.6vw;
}

.add-community-view-input-div-lists::-webkit-scrollbar {
	display: none;
	/* Chrome Safari */
}

/*兼容火狐*/
.add-community-view-input-div-lists {
	scrollbar-width: none;
}

/* 兼容IE10+ */
.add-community-view-input-div-lists {
	-ms-overflow-style: none;
}

.add-community-view-input-div-lists>>>.ivu-input,
.add-community-view-input-div-lists>>>.ivu-input-group-append,
.add-community-view-input-div-lists>>>.ivu-select-selection {
	background-color: unset;
	border: 0.05vw solid #3753af;
	color: hsla(0, 0%, 100%, 0.8);
	font-size: 0.6vw;
}

.add-community-view-input-div-lists>>>.ivu-input {
	height: 1.7vw;
}

@keyframes outlineTop {
	from {
		transform: scale(0);
	}

	to {
		transform: scale(1);
	}
}
</style>



// WEBPACK FOOTER //
// src/components/smartElectricity/smarElectricity.vue